import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import React__default, { forwardRef, Children, isValidElement, cloneElement, useRef, useLayoutEffect, useEffect, useState, useMemo, Fragment as Fragment$1, createContext, useContext, createElement } from 'react';
import './assets/src/styles/sprinkles/border-radius.css.ts.vanilla-4012f620.css';
import './assets/src/styles/sprinkles/border.css.ts.vanilla-0460f523.css';
import './assets/src/styles/sprinkles/color.css.ts.vanilla-974b0ca2.css';
import './assets/src/styles/sprinkles/flex.css.ts.vanilla-333f6a05.css';
import './assets/src/styles/sprinkles/space.css.ts.vanilla-fd5c5b92.css';
import './assets/src/styles/sprinkles/text.css.ts.vanilla-9024db46.css';
import './assets/src/styles/utils/text-ellipsis.css.ts.vanilla-697e2137.css';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { createPortal } from 'react-dom';
import './assets/src/components/Mask/Mask.css.ts.vanilla-1858d32f.css';
import './assets/src/components/Input/Input.css.ts.vanilla-3c2bc28e.css';
import './assets/src/components/Select/Select.css.ts.vanilla-b1da7f4a.css';
import './assets/src/components/Spinner/Spinner.css.ts.vanilla-af8a110f.css';
import './assets/src/components/Select/SelectButton/SelectButton.css.ts.vanilla-7585ad87.css';
import './assets/src/components/Select/SelectEmpty/SelectEmpty.css.ts.vanilla-ecb28012.css';
import './assets/src/components/Select/SelectTags/SelectTagsButton.css.ts.vanilla-f0d8c91b.css';
import './assets/src/components/Checkbox/Checkbox.css.ts.vanilla-88c39f58.css';
import './assets/src/components/Switch/Switch.css.ts.vanilla-15d10ee4.css';
import './assets/src/components/Radio/Radio.css.ts.vanilla-6df48c71.css';
import './assets/src/components/Button/styles.css.ts.vanilla-699aaff3.css';
import './assets/src/components/Tag/Tag.css.ts.vanilla-999aab40.css';
import './assets/src/components/Modal/styles.css.ts.vanilla-44c42a61.css';
import './assets/src/components/Dialog/Dialog.css.ts.vanilla-9282d169.css';
import './assets/src/components/Popover/styles.css.ts.vanilla-e28af22d.css';
import './assets/src/components/Popconfirm/Popconfirm.css.ts.vanilla-46d31b56.css';
import './assets/src/components/Avatar/Avatar.css.ts.vanilla-a3150cea.css';
import './assets/src/components/Result/Result.css.ts.vanilla-aebae1bd.css';
import './assets/src/components/Tooltip/Tooltip.css.ts.vanilla-e867c13e.css';
import './assets/src/components/Pagination/Pagination.css.ts.vanilla-74a75227.css';
import './assets/src/components/Toast/Toast.css.ts.vanilla-c6da58e5.css';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$1 = function () {
  __assign$1 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
function __rest$1(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

function toPrimitive$1(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey$1(t) {
  var i = toPrimitive$1(t, "string");
  return "symbol" == typeof i ? i : String(i);
}

function _defineProperty$1(obj, key, value) {
  key = toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

var createSprinkles$1 = composeStyles => function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var sprinklesStyles = Object.assign({}, ...args.map(a => a.styles));
  var sprinklesKeys = Object.keys(sprinklesStyles);
  var shorthandNames = sprinklesKeys.filter(property => 'mappings' in sprinklesStyles[property]);
  var sprinklesFn = props => {
    var classNames = [];
    var shorthands = {};
    var nonShorthands = _objectSpread2$1({}, props);
    var hasShorthands = false;
    for (var shorthand of shorthandNames) {
      var value = props[shorthand];
      if (value != null) {
        var sprinkle = sprinklesStyles[shorthand];
        hasShorthands = true;
        for (var propMapping of sprinkle.mappings) {
          shorthands[propMapping] = value;
          if (nonShorthands[propMapping] == null) {
            delete nonShorthands[propMapping];
          }
        }
      }
    }
    var finalProps = hasShorthands ? _objectSpread2$1(_objectSpread2$1({}, shorthands), nonShorthands) : props;
    var _loop = function _loop() {
      var propValue = finalProps[prop];
      var sprinkle = sprinklesStyles[prop];
      try {
        if (sprinkle.mappings) {
          // Skip shorthands
          return 1; // continue
        }
        if (typeof propValue === 'string' || typeof propValue === 'number') {
          if (process.env.NODE_ENV !== 'production') {
            if (!sprinkle.values[propValue].defaultClass) {
              throw new Error();
            }
          }
          classNames.push(sprinkle.values[propValue].defaultClass);
        } else if (Array.isArray(propValue)) {
          for (var responsiveIndex = 0; responsiveIndex < propValue.length; responsiveIndex++) {
            var responsiveValue = propValue[responsiveIndex];
            if (responsiveValue != null) {
              var conditionName = sprinkle.responsiveArray[responsiveIndex];
              if (process.env.NODE_ENV !== 'production') {
                if (!sprinkle.values[responsiveValue].conditions[conditionName]) {
                  throw new Error();
                }
              }
              classNames.push(sprinkle.values[responsiveValue].conditions[conditionName]);
            }
          }
        } else {
          for (var _conditionName in propValue) {
            // Conditional style
            var _value = propValue[_conditionName];
            if (_value != null) {
              if (process.env.NODE_ENV !== 'production') {
                if (!sprinkle.values[_value].conditions[_conditionName]) {
                  throw new Error();
                }
              }
              classNames.push(sprinkle.values[_value].conditions[_conditionName]);
            }
          }
        }
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          class SprinklesError extends Error {
            constructor(message) {
              super(message);
              this.name = 'SprinklesError';
            }
          }
          var format = v => typeof v === 'string' ? "\"".concat(v, "\"") : v;
          var invalidPropValue = (prop, value, possibleValues) => {
            throw new SprinklesError("\"".concat(prop, "\" has no value ").concat(format(value), ". Possible values are ").concat(Object.keys(possibleValues).map(format).join(', ')));
          };
          if (!sprinkle) {
            throw new SprinklesError("\"".concat(prop, "\" is not a valid sprinkle"));
          }
          if (typeof propValue === 'string' || typeof propValue === 'number') {
            if (!(propValue in sprinkle.values)) {
              invalidPropValue(prop, propValue, sprinkle.values);
            }
            if (!sprinkle.values[propValue].defaultClass) {
              throw new SprinklesError("\"".concat(prop, "\" has no default condition. You must specify which conditions to target explicitly. Possible options are ").concat(Object.keys(sprinkle.values[propValue].conditions).map(format).join(', ')));
            }
          }
          if (typeof propValue === 'object') {
            if (!('conditions' in sprinkle.values[Object.keys(sprinkle.values)[0]])) {
              throw new SprinklesError("\"".concat(prop, "\" is not a conditional property"));
            }
            if (Array.isArray(propValue)) {
              if (!('responsiveArray' in sprinkle)) {
                throw new SprinklesError("\"".concat(prop, "\" does not support responsive arrays"));
              }
              var breakpointCount = sprinkle.responsiveArray.length;
              if (breakpointCount < propValue.length) {
                throw new SprinklesError("\"".concat(prop, "\" only supports up to ").concat(breakpointCount, " breakpoints. You passed ").concat(propValue.length));
              }
              for (var _responsiveValue of propValue) {
                if (!sprinkle.values[_responsiveValue]) {
                  invalidPropValue(prop, _responsiveValue, sprinkle.values);
                }
              }
            } else {
              for (var _conditionName2 in propValue) {
                var _value2 = propValue[_conditionName2];
                if (_value2 != null) {
                  if (!sprinkle.values[_value2]) {
                    invalidPropValue(prop, _value2, sprinkle.values);
                  }
                  if (!sprinkle.values[_value2].conditions[_conditionName2]) {
                    throw new SprinklesError("\"".concat(prop, "\" has no condition named ").concat(format(_conditionName2), ". Possible values are ").concat(Object.keys(sprinkle.values[_value2].conditions).map(format).join(', ')));
                  }
                }
              }
            }
          }
        }
        throw e;
      }
    };
    for (var prop in finalProps) {
      if (_loop()) continue;
    }
    return composeStyles(classNames.join(' '));
  };
  return Object.assign(sprinklesFn, {
    properties: new Set(sprinklesKeys)
  });
};

var composeStyles = classList => classList;
var createSprinkles = function createSprinkles() {
  return createSprinkles$1(composeStyles)(...arguments);
};

var sprinkles = createSprinkles({
  conditions: undefined,
  styles: {
    direction: {
      mappings: ['flexDirection']
    },
    justify: {
      mappings: ['justifyContent']
    },
    align: {
      mappings: ['alignItems']
    },
    placeItems: {
      mappings: ['justifyContent', 'alignItems']
    },
    fd: {
      mappings: ['flexDirection']
    },
    jc: {
      mappings: ['justifyContent']
    },
    ai: {
      mappings: ['alignItems']
    },
    flex: {
      values: {
        '1': {
          defaultClass: 'flex_flex_1__1fkd8a52'
        },
        none: {
          defaultClass: 'flex_flex_none__1fkd8a50'
        },
        auto: {
          defaultClass: 'flex_flex_auto__1fkd8a51'
        },
        '0 0 auto': {
          defaultClass: 'flex_flex_0_0_auto__1fkd8a53'
        }
      }
    },
    flexDirection: {
      values: {
        row: {
          defaultClass: 'flex_flexDirection_row__1fkd8a54'
        },
        column: {
          defaultClass: 'flex_flexDirection_column__1fkd8a55'
        },
        'row-reverse': {
          defaultClass: 'flex_flexDirection_row-reverse__1fkd8a56'
        },
        'column-reverse': {
          defaultClass: 'flex_flexDirection_column-reverse__1fkd8a57'
        }
      }
    },
    justifyContent: {
      values: {
        stretch: {
          defaultClass: 'flex_justifyContent_stretch__1fkd8a58'
        },
        'flex-start': {
          defaultClass: 'flex_justifyContent_flex-start__1fkd8a59'
        },
        center: {
          defaultClass: 'flex_justifyContent_center__1fkd8a5a'
        },
        'flex-end': {
          defaultClass: 'flex_justifyContent_flex-end__1fkd8a5b'
        },
        'space-around': {
          defaultClass: 'flex_justifyContent_space-around__1fkd8a5c'
        },
        'space-between': {
          defaultClass: 'flex_justifyContent_space-between__1fkd8a5d'
        }
      }
    },
    alignItems: {
      values: {
        stretch: {
          defaultClass: 'flex_alignItems_stretch__1fkd8a5e'
        },
        'flex-start': {
          defaultClass: 'flex_alignItems_flex-start__1fkd8a5f'
        },
        center: {
          defaultClass: 'flex_alignItems_center__1fkd8a5g'
        },
        'flex-end': {
          defaultClass: 'flex_alignItems_flex-end__1fkd8a5h'
        },
        'space-around': {
          defaultClass: 'flex_alignItems_space-around__1fkd8a5i'
        },
        'space-between': {
          defaultClass: 'flex_alignItems_space-between__1fkd8a5j'
        }
      }
    },
    flexWrap: {
      values: {
        wrap: {
          defaultClass: 'flex_flexWrap_wrap__1fkd8a5k'
        },
        nowrap: {
          defaultClass: 'flex_flexWrap_nowrap__1fkd8a5l'
        },
        'wrap-reverse': {
          defaultClass: 'flex_flexWrap_wrap-reverse__1fkd8a5m'
        }
      }
    },
    gap: {
      values: {
        '2': {
          defaultClass: 'flex_gap_2__1fkd8a5n'
        },
        '4': {
          defaultClass: 'flex_gap_4__1fkd8a5o'
        },
        '8': {
          defaultClass: 'flex_gap_8__1fkd8a5p'
        },
        '10': {
          defaultClass: 'flex_gap_10__1fkd8a5q'
        },
        '12': {
          defaultClass: 'flex_gap_12__1fkd8a5r'
        },
        '14': {
          defaultClass: 'flex_gap_14__1fkd8a5s'
        },
        '16': {
          defaultClass: 'flex_gap_16__1fkd8a5t'
        },
        '18': {
          defaultClass: 'flex_gap_18__1fkd8a5u'
        },
        '20': {
          defaultClass: 'flex_gap_20__1fkd8a5v'
        },
        '24': {
          defaultClass: 'flex_gap_24__1fkd8a5w'
        },
        '32': {
          defaultClass: 'flex_gap_32__1fkd8a5x'
        },
        '48': {
          defaultClass: 'flex_gap_48__1fkd8a5y'
        },
        '64': {
          defaultClass: 'flex_gap_64__1fkd8a5z'
        },
        xs: {
          defaultClass: 'flex_gap_xs__1fkd8a510'
        },
        sm: {
          defaultClass: 'flex_gap_sm__1fkd8a511'
        },
        md: {
          defaultClass: 'flex_gap_md__1fkd8a512'
        },
        lg: {
          defaultClass: 'flex_gap_lg__1fkd8a513'
        },
        xl: {
          defaultClass: 'flex_gap_xl__1fkd8a514'
        },
        xxl: {
          defaultClass: 'flex_gap_xxl__1fkd8a515'
        }
      }
    }
  }
}, {
  conditions: undefined,
  styles: {
    padding: {
      mappings: ['paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight']
    },
    p: {
      mappings: ['paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight']
    },
    px: {
      mappings: ['paddingLeft', 'paddingRight']
    },
    py: {
      mappings: ['paddingTop', 'paddingBottom']
    },
    pt: {
      mappings: ['paddingTop']
    },
    pl: {
      mappings: ['paddingLeft']
    },
    pr: {
      mappings: ['paddingRight']
    },
    pb: {
      mappings: ['paddingBottom']
    },
    margin: {
      mappings: ['marginTop', 'marginBottom', 'marginLeft', 'marginRight']
    },
    m: {
      mappings: ['marginTop', 'marginBottom', 'marginLeft', 'marginRight']
    },
    mx: {
      mappings: ['marginLeft', 'marginRight']
    },
    my: {
      mappings: ['marginTop', 'marginBottom']
    },
    mt: {
      mappings: ['marginTop']
    },
    ml: {
      mappings: ['marginLeft']
    },
    mr: {
      mappings: ['marginRight']
    },
    mb: {
      mappings: ['marginBottom']
    },
    display: {
      values: {
        none: {
          defaultClass: 'space_display_none__kl7vcz0'
        },
        flex: {
          defaultClass: 'space_display_flex__kl7vcz1'
        },
        block: {
          defaultClass: 'space_display_block__kl7vcz2'
        },
        inline: {
          defaultClass: 'space_display_inline__kl7vcz3'
        },
        'inline-block': {
          defaultClass: 'space_display_inline-block__kl7vcz4'
        },
        'inline-flex': {
          defaultClass: 'space_display_inline-flex__kl7vcz5'
        },
        grid: {
          defaultClass: 'space_display_grid__kl7vcz6'
        }
      }
    },
    paddingTop: {
      values: {
        '2': {
          defaultClass: 'space_paddingTop_2__kl7vcz7'
        },
        '4': {
          defaultClass: 'space_paddingTop_4__kl7vcz8'
        },
        '8': {
          defaultClass: 'space_paddingTop_8__kl7vcz9'
        },
        '10': {
          defaultClass: 'space_paddingTop_10__kl7vcza'
        },
        '12': {
          defaultClass: 'space_paddingTop_12__kl7vczb'
        },
        '14': {
          defaultClass: 'space_paddingTop_14__kl7vczc'
        },
        '16': {
          defaultClass: 'space_paddingTop_16__kl7vczd'
        },
        '18': {
          defaultClass: 'space_paddingTop_18__kl7vcze'
        },
        '20': {
          defaultClass: 'space_paddingTop_20__kl7vczf'
        },
        '24': {
          defaultClass: 'space_paddingTop_24__kl7vczg'
        },
        '32': {
          defaultClass: 'space_paddingTop_32__kl7vczh'
        },
        '48': {
          defaultClass: 'space_paddingTop_48__kl7vczi'
        },
        '64': {
          defaultClass: 'space_paddingTop_64__kl7vczj'
        },
        xs: {
          defaultClass: 'space_paddingTop_xs__kl7vczk'
        },
        sm: {
          defaultClass: 'space_paddingTop_sm__kl7vczl'
        },
        md: {
          defaultClass: 'space_paddingTop_md__kl7vczm'
        },
        lg: {
          defaultClass: 'space_paddingTop_lg__kl7vczn'
        },
        xl: {
          defaultClass: 'space_paddingTop_xl__kl7vczo'
        },
        xxl: {
          defaultClass: 'space_paddingTop_xxl__kl7vczp'
        }
      }
    },
    paddingBottom: {
      values: {
        '2': {
          defaultClass: 'space_paddingBottom_2__kl7vczq'
        },
        '4': {
          defaultClass: 'space_paddingBottom_4__kl7vczr'
        },
        '8': {
          defaultClass: 'space_paddingBottom_8__kl7vczs'
        },
        '10': {
          defaultClass: 'space_paddingBottom_10__kl7vczt'
        },
        '12': {
          defaultClass: 'space_paddingBottom_12__kl7vczu'
        },
        '14': {
          defaultClass: 'space_paddingBottom_14__kl7vczv'
        },
        '16': {
          defaultClass: 'space_paddingBottom_16__kl7vczw'
        },
        '18': {
          defaultClass: 'space_paddingBottom_18__kl7vczx'
        },
        '20': {
          defaultClass: 'space_paddingBottom_20__kl7vczy'
        },
        '24': {
          defaultClass: 'space_paddingBottom_24__kl7vczz'
        },
        '32': {
          defaultClass: 'space_paddingBottom_32__kl7vcz10'
        },
        '48': {
          defaultClass: 'space_paddingBottom_48__kl7vcz11'
        },
        '64': {
          defaultClass: 'space_paddingBottom_64__kl7vcz12'
        },
        xs: {
          defaultClass: 'space_paddingBottom_xs__kl7vcz13'
        },
        sm: {
          defaultClass: 'space_paddingBottom_sm__kl7vcz14'
        },
        md: {
          defaultClass: 'space_paddingBottom_md__kl7vcz15'
        },
        lg: {
          defaultClass: 'space_paddingBottom_lg__kl7vcz16'
        },
        xl: {
          defaultClass: 'space_paddingBottom_xl__kl7vcz17'
        },
        xxl: {
          defaultClass: 'space_paddingBottom_xxl__kl7vcz18'
        }
      }
    },
    paddingLeft: {
      values: {
        '2': {
          defaultClass: 'space_paddingLeft_2__kl7vcz19'
        },
        '4': {
          defaultClass: 'space_paddingLeft_4__kl7vcz1a'
        },
        '8': {
          defaultClass: 'space_paddingLeft_8__kl7vcz1b'
        },
        '10': {
          defaultClass: 'space_paddingLeft_10__kl7vcz1c'
        },
        '12': {
          defaultClass: 'space_paddingLeft_12__kl7vcz1d'
        },
        '14': {
          defaultClass: 'space_paddingLeft_14__kl7vcz1e'
        },
        '16': {
          defaultClass: 'space_paddingLeft_16__kl7vcz1f'
        },
        '18': {
          defaultClass: 'space_paddingLeft_18__kl7vcz1g'
        },
        '20': {
          defaultClass: 'space_paddingLeft_20__kl7vcz1h'
        },
        '24': {
          defaultClass: 'space_paddingLeft_24__kl7vcz1i'
        },
        '32': {
          defaultClass: 'space_paddingLeft_32__kl7vcz1j'
        },
        '48': {
          defaultClass: 'space_paddingLeft_48__kl7vcz1k'
        },
        '64': {
          defaultClass: 'space_paddingLeft_64__kl7vcz1l'
        },
        xs: {
          defaultClass: 'space_paddingLeft_xs__kl7vcz1m'
        },
        sm: {
          defaultClass: 'space_paddingLeft_sm__kl7vcz1n'
        },
        md: {
          defaultClass: 'space_paddingLeft_md__kl7vcz1o'
        },
        lg: {
          defaultClass: 'space_paddingLeft_lg__kl7vcz1p'
        },
        xl: {
          defaultClass: 'space_paddingLeft_xl__kl7vcz1q'
        },
        xxl: {
          defaultClass: 'space_paddingLeft_xxl__kl7vcz1r'
        }
      }
    },
    paddingRight: {
      values: {
        '2': {
          defaultClass: 'space_paddingRight_2__kl7vcz1s'
        },
        '4': {
          defaultClass: 'space_paddingRight_4__kl7vcz1t'
        },
        '8': {
          defaultClass: 'space_paddingRight_8__kl7vcz1u'
        },
        '10': {
          defaultClass: 'space_paddingRight_10__kl7vcz1v'
        },
        '12': {
          defaultClass: 'space_paddingRight_12__kl7vcz1w'
        },
        '14': {
          defaultClass: 'space_paddingRight_14__kl7vcz1x'
        },
        '16': {
          defaultClass: 'space_paddingRight_16__kl7vcz1y'
        },
        '18': {
          defaultClass: 'space_paddingRight_18__kl7vcz1z'
        },
        '20': {
          defaultClass: 'space_paddingRight_20__kl7vcz20'
        },
        '24': {
          defaultClass: 'space_paddingRight_24__kl7vcz21'
        },
        '32': {
          defaultClass: 'space_paddingRight_32__kl7vcz22'
        },
        '48': {
          defaultClass: 'space_paddingRight_48__kl7vcz23'
        },
        '64': {
          defaultClass: 'space_paddingRight_64__kl7vcz24'
        },
        xs: {
          defaultClass: 'space_paddingRight_xs__kl7vcz25'
        },
        sm: {
          defaultClass: 'space_paddingRight_sm__kl7vcz26'
        },
        md: {
          defaultClass: 'space_paddingRight_md__kl7vcz27'
        },
        lg: {
          defaultClass: 'space_paddingRight_lg__kl7vcz28'
        },
        xl: {
          defaultClass: 'space_paddingRight_xl__kl7vcz29'
        },
        xxl: {
          defaultClass: 'space_paddingRight_xxl__kl7vcz2a'
        }
      }
    },
    marginTop: {
      values: {
        '2': {
          defaultClass: 'space_marginTop_2__kl7vcz2b'
        },
        '4': {
          defaultClass: 'space_marginTop_4__kl7vcz2c'
        },
        '8': {
          defaultClass: 'space_marginTop_8__kl7vcz2d'
        },
        '10': {
          defaultClass: 'space_marginTop_10__kl7vcz2e'
        },
        '12': {
          defaultClass: 'space_marginTop_12__kl7vcz2f'
        },
        '14': {
          defaultClass: 'space_marginTop_14__kl7vcz2g'
        },
        '16': {
          defaultClass: 'space_marginTop_16__kl7vcz2h'
        },
        '18': {
          defaultClass: 'space_marginTop_18__kl7vcz2i'
        },
        '20': {
          defaultClass: 'space_marginTop_20__kl7vcz2j'
        },
        '24': {
          defaultClass: 'space_marginTop_24__kl7vcz2k'
        },
        '32': {
          defaultClass: 'space_marginTop_32__kl7vcz2l'
        },
        '48': {
          defaultClass: 'space_marginTop_48__kl7vcz2m'
        },
        '64': {
          defaultClass: 'space_marginTop_64__kl7vcz2n'
        },
        xs: {
          defaultClass: 'space_marginTop_xs__kl7vcz2o'
        },
        sm: {
          defaultClass: 'space_marginTop_sm__kl7vcz2p'
        },
        md: {
          defaultClass: 'space_marginTop_md__kl7vcz2q'
        },
        lg: {
          defaultClass: 'space_marginTop_lg__kl7vcz2r'
        },
        xl: {
          defaultClass: 'space_marginTop_xl__kl7vcz2s'
        },
        xxl: {
          defaultClass: 'space_marginTop_xxl__kl7vcz2t'
        }
      }
    },
    marginBottom: {
      values: {
        '2': {
          defaultClass: 'space_marginBottom_2__kl7vcz2u'
        },
        '4': {
          defaultClass: 'space_marginBottom_4__kl7vcz2v'
        },
        '8': {
          defaultClass: 'space_marginBottom_8__kl7vcz2w'
        },
        '10': {
          defaultClass: 'space_marginBottom_10__kl7vcz2x'
        },
        '12': {
          defaultClass: 'space_marginBottom_12__kl7vcz2y'
        },
        '14': {
          defaultClass: 'space_marginBottom_14__kl7vcz2z'
        },
        '16': {
          defaultClass: 'space_marginBottom_16__kl7vcz30'
        },
        '18': {
          defaultClass: 'space_marginBottom_18__kl7vcz31'
        },
        '20': {
          defaultClass: 'space_marginBottom_20__kl7vcz32'
        },
        '24': {
          defaultClass: 'space_marginBottom_24__kl7vcz33'
        },
        '32': {
          defaultClass: 'space_marginBottom_32__kl7vcz34'
        },
        '48': {
          defaultClass: 'space_marginBottom_48__kl7vcz35'
        },
        '64': {
          defaultClass: 'space_marginBottom_64__kl7vcz36'
        },
        xs: {
          defaultClass: 'space_marginBottom_xs__kl7vcz37'
        },
        sm: {
          defaultClass: 'space_marginBottom_sm__kl7vcz38'
        },
        md: {
          defaultClass: 'space_marginBottom_md__kl7vcz39'
        },
        lg: {
          defaultClass: 'space_marginBottom_lg__kl7vcz3a'
        },
        xl: {
          defaultClass: 'space_marginBottom_xl__kl7vcz3b'
        },
        xxl: {
          defaultClass: 'space_marginBottom_xxl__kl7vcz3c'
        }
      }
    },
    marginLeft: {
      values: {
        '2': {
          defaultClass: 'space_marginLeft_2__kl7vcz3d'
        },
        '4': {
          defaultClass: 'space_marginLeft_4__kl7vcz3e'
        },
        '8': {
          defaultClass: 'space_marginLeft_8__kl7vcz3f'
        },
        '10': {
          defaultClass: 'space_marginLeft_10__kl7vcz3g'
        },
        '12': {
          defaultClass: 'space_marginLeft_12__kl7vcz3h'
        },
        '14': {
          defaultClass: 'space_marginLeft_14__kl7vcz3i'
        },
        '16': {
          defaultClass: 'space_marginLeft_16__kl7vcz3j'
        },
        '18': {
          defaultClass: 'space_marginLeft_18__kl7vcz3k'
        },
        '20': {
          defaultClass: 'space_marginLeft_20__kl7vcz3l'
        },
        '24': {
          defaultClass: 'space_marginLeft_24__kl7vcz3m'
        },
        '32': {
          defaultClass: 'space_marginLeft_32__kl7vcz3n'
        },
        '48': {
          defaultClass: 'space_marginLeft_48__kl7vcz3o'
        },
        '64': {
          defaultClass: 'space_marginLeft_64__kl7vcz3p'
        },
        xs: {
          defaultClass: 'space_marginLeft_xs__kl7vcz3q'
        },
        sm: {
          defaultClass: 'space_marginLeft_sm__kl7vcz3r'
        },
        md: {
          defaultClass: 'space_marginLeft_md__kl7vcz3s'
        },
        lg: {
          defaultClass: 'space_marginLeft_lg__kl7vcz3t'
        },
        xl: {
          defaultClass: 'space_marginLeft_xl__kl7vcz3u'
        },
        xxl: {
          defaultClass: 'space_marginLeft_xxl__kl7vcz3v'
        }
      }
    },
    marginRight: {
      values: {
        '2': {
          defaultClass: 'space_marginRight_2__kl7vcz3w'
        },
        '4': {
          defaultClass: 'space_marginRight_4__kl7vcz3x'
        },
        '8': {
          defaultClass: 'space_marginRight_8__kl7vcz3y'
        },
        '10': {
          defaultClass: 'space_marginRight_10__kl7vcz3z'
        },
        '12': {
          defaultClass: 'space_marginRight_12__kl7vcz40'
        },
        '14': {
          defaultClass: 'space_marginRight_14__kl7vcz41'
        },
        '16': {
          defaultClass: 'space_marginRight_16__kl7vcz42'
        },
        '18': {
          defaultClass: 'space_marginRight_18__kl7vcz43'
        },
        '20': {
          defaultClass: 'space_marginRight_20__kl7vcz44'
        },
        '24': {
          defaultClass: 'space_marginRight_24__kl7vcz45'
        },
        '32': {
          defaultClass: 'space_marginRight_32__kl7vcz46'
        },
        '48': {
          defaultClass: 'space_marginRight_48__kl7vcz47'
        },
        '64': {
          defaultClass: 'space_marginRight_64__kl7vcz48'
        },
        xs: {
          defaultClass: 'space_marginRight_xs__kl7vcz49'
        },
        sm: {
          defaultClass: 'space_marginRight_sm__kl7vcz4a'
        },
        md: {
          defaultClass: 'space_marginRight_md__kl7vcz4b'
        },
        lg: {
          defaultClass: 'space_marginRight_lg__kl7vcz4c'
        },
        xl: {
          defaultClass: 'space_marginRight_xl__kl7vcz4d'
        },
        xxl: {
          defaultClass: 'space_marginRight_xxl__kl7vcz4e'
        }
      }
    }
  }
}, {
  conditions: undefined,
  styles: {
    border: {
      mappings: ['borderTop', 'borderLeft', 'borderRight', 'borderBottom']
    },
    b: {
      mappings: ['borderTop', 'borderLeft', 'borderRight', 'borderBottom']
    },
    bx: {
      mappings: ['borderLeft', 'borderRight']
    },
    by: {
      mappings: ['borderTop', 'borderBottom']
    },
    bt: {
      mappings: ['borderTop']
    },
    bl: {
      mappings: ['borderLeft']
    },
    br: {
      mappings: ['borderRight']
    },
    bb: {
      mappings: ['borderBottom']
    },
    borderTop: {
      values: {
        muted: {
          defaultClass: 'border_borderTop_muted__1o6mwja0'
        },
        normal: {
          defaultClass: 'border_borderTop_normal__1o6mwja1'
        },
        bold: {
          defaultClass: 'border_borderTop_bold__1o6mwja2'
        }
      }
    },
    borderLeft: {
      values: {
        muted: {
          defaultClass: 'border_borderLeft_muted__1o6mwja3'
        },
        normal: {
          defaultClass: 'border_borderLeft_normal__1o6mwja4'
        },
        bold: {
          defaultClass: 'border_borderLeft_bold__1o6mwja5'
        }
      }
    },
    borderRight: {
      values: {
        muted: {
          defaultClass: 'border_borderRight_muted__1o6mwja6'
        },
        normal: {
          defaultClass: 'border_borderRight_normal__1o6mwja7'
        },
        bold: {
          defaultClass: 'border_borderRight_bold__1o6mwja8'
        }
      }
    },
    borderBottom: {
      values: {
        muted: {
          defaultClass: 'border_borderBottom_muted__1o6mwja9'
        },
        normal: {
          defaultClass: 'border_borderBottom_normal__1o6mwjaa'
        },
        bold: {
          defaultClass: 'border_borderBottom_bold__1o6mwjab'
        }
      }
    }
  }
}, {
  conditions: {
    defaultCondition: 'lightMode',
    conditionNames: ['lightMode', 'darkMode'],
    responsiveArray: undefined
  },
  styles: {
    c: {
      mappings: ['color']
    },
    bg: {
      mappings: ['background']
    },
    bc: {
      mappings: ['borderColor']
    },
    color: {
      values: {
        'gray.50': {
          conditions: {
            lightMode: 'color_color_gray.50_lightMode__1q1dxs80',
            darkMode: 'color_color_gray.50_darkMode__1q1dxs81'
          },
          defaultClass: 'color_color_gray.50_lightMode__1q1dxs80'
        },
        'gray.80': {
          conditions: {
            lightMode: 'color_color_gray.80_lightMode__1q1dxs82',
            darkMode: 'color_color_gray.80_darkMode__1q1dxs83'
          },
          defaultClass: 'color_color_gray.80_lightMode__1q1dxs82'
        },
        'gray.100': {
          conditions: {
            lightMode: 'color_color_gray.100_lightMode__1q1dxs84',
            darkMode: 'color_color_gray.100_darkMode__1q1dxs85'
          },
          defaultClass: 'color_color_gray.100_lightMode__1q1dxs84'
        },
        'gray.200': {
          conditions: {
            lightMode: 'color_color_gray.200_lightMode__1q1dxs86',
            darkMode: 'color_color_gray.200_darkMode__1q1dxs87'
          },
          defaultClass: 'color_color_gray.200_lightMode__1q1dxs86'
        },
        'gray.300': {
          conditions: {
            lightMode: 'color_color_gray.300_lightMode__1q1dxs88',
            darkMode: 'color_color_gray.300_darkMode__1q1dxs89'
          },
          defaultClass: 'color_color_gray.300_lightMode__1q1dxs88'
        },
        'gray.400': {
          conditions: {
            lightMode: 'color_color_gray.400_lightMode__1q1dxs8a',
            darkMode: 'color_color_gray.400_darkMode__1q1dxs8b'
          },
          defaultClass: 'color_color_gray.400_lightMode__1q1dxs8a'
        },
        'gray.500': {
          conditions: {
            lightMode: 'color_color_gray.500_lightMode__1q1dxs8c',
            darkMode: 'color_color_gray.500_darkMode__1q1dxs8d'
          },
          defaultClass: 'color_color_gray.500_lightMode__1q1dxs8c'
        },
        'gray.600': {
          conditions: {
            lightMode: 'color_color_gray.600_lightMode__1q1dxs8e',
            darkMode: 'color_color_gray.600_darkMode__1q1dxs8f'
          },
          defaultClass: 'color_color_gray.600_lightMode__1q1dxs8e'
        },
        'gray.700': {
          conditions: {
            lightMode: 'color_color_gray.700_lightMode__1q1dxs8g',
            darkMode: 'color_color_gray.700_darkMode__1q1dxs8h'
          },
          defaultClass: 'color_color_gray.700_lightMode__1q1dxs8g'
        },
        'gray.750': {
          conditions: {
            lightMode: 'color_color_gray.750_lightMode__1q1dxs8i',
            darkMode: 'color_color_gray.750_darkMode__1q1dxs8j'
          },
          defaultClass: 'color_color_gray.750_lightMode__1q1dxs8i'
        },
        'gray.800': {
          conditions: {
            lightMode: 'color_color_gray.800_lightMode__1q1dxs8k',
            darkMode: 'color_color_gray.800_darkMode__1q1dxs8l'
          },
          defaultClass: 'color_color_gray.800_lightMode__1q1dxs8k'
        },
        'gray.900': {
          conditions: {
            lightMode: 'color_color_gray.900_lightMode__1q1dxs8m',
            darkMode: 'color_color_gray.900_darkMode__1q1dxs8n'
          },
          defaultClass: 'color_color_gray.900_lightMode__1q1dxs8m'
        },
        'zinc.50': {
          conditions: {
            lightMode: 'color_color_zinc.50_lightMode__1q1dxs8o',
            darkMode: 'color_color_zinc.50_darkMode__1q1dxs8p'
          },
          defaultClass: 'color_color_zinc.50_lightMode__1q1dxs8o'
        },
        'zinc.100': {
          conditions: {
            lightMode: 'color_color_zinc.100_lightMode__1q1dxs8q',
            darkMode: 'color_color_zinc.100_darkMode__1q1dxs8r'
          },
          defaultClass: 'color_color_zinc.100_lightMode__1q1dxs8q'
        },
        'zinc.200': {
          conditions: {
            lightMode: 'color_color_zinc.200_lightMode__1q1dxs8s',
            darkMode: 'color_color_zinc.200_darkMode__1q1dxs8t'
          },
          defaultClass: 'color_color_zinc.200_lightMode__1q1dxs8s'
        },
        'zinc.300': {
          conditions: {
            lightMode: 'color_color_zinc.300_lightMode__1q1dxs8u',
            darkMode: 'color_color_zinc.300_darkMode__1q1dxs8v'
          },
          defaultClass: 'color_color_zinc.300_lightMode__1q1dxs8u'
        },
        'zinc.400': {
          conditions: {
            lightMode: 'color_color_zinc.400_lightMode__1q1dxs8w',
            darkMode: 'color_color_zinc.400_darkMode__1q1dxs8x'
          },
          defaultClass: 'color_color_zinc.400_lightMode__1q1dxs8w'
        },
        'zinc.500': {
          conditions: {
            lightMode: 'color_color_zinc.500_lightMode__1q1dxs8y',
            darkMode: 'color_color_zinc.500_darkMode__1q1dxs8z'
          },
          defaultClass: 'color_color_zinc.500_lightMode__1q1dxs8y'
        },
        'zinc.600': {
          conditions: {
            lightMode: 'color_color_zinc.600_lightMode__1q1dxs810',
            darkMode: 'color_color_zinc.600_darkMode__1q1dxs811'
          },
          defaultClass: 'color_color_zinc.600_lightMode__1q1dxs810'
        },
        'zinc.700': {
          conditions: {
            lightMode: 'color_color_zinc.700_lightMode__1q1dxs812',
            darkMode: 'color_color_zinc.700_darkMode__1q1dxs813'
          },
          defaultClass: 'color_color_zinc.700_lightMode__1q1dxs812'
        },
        'zinc.800': {
          conditions: {
            lightMode: 'color_color_zinc.800_lightMode__1q1dxs814',
            darkMode: 'color_color_zinc.800_darkMode__1q1dxs815'
          },
          defaultClass: 'color_color_zinc.800_lightMode__1q1dxs814'
        },
        'zinc.900': {
          conditions: {
            lightMode: 'color_color_zinc.900_lightMode__1q1dxs816',
            darkMode: 'color_color_zinc.900_darkMode__1q1dxs817'
          },
          defaultClass: 'color_color_zinc.900_lightMode__1q1dxs816'
        },
        'zinc.950': {
          conditions: {
            lightMode: 'color_color_zinc.950_lightMode__1q1dxs818',
            darkMode: 'color_color_zinc.950_darkMode__1q1dxs819'
          },
          defaultClass: 'color_color_zinc.950_lightMode__1q1dxs818'
        },
        'primary.50': {
          conditions: {
            lightMode: 'color_color_primary.50_lightMode__1q1dxs81a',
            darkMode: 'color_color_primary.50_darkMode__1q1dxs81b'
          },
          defaultClass: 'color_color_primary.50_lightMode__1q1dxs81a'
        },
        'primary.100': {
          conditions: {
            lightMode: 'color_color_primary.100_lightMode__1q1dxs81c',
            darkMode: 'color_color_primary.100_darkMode__1q1dxs81d'
          },
          defaultClass: 'color_color_primary.100_lightMode__1q1dxs81c'
        },
        'primary.200': {
          conditions: {
            lightMode: 'color_color_primary.200_lightMode__1q1dxs81e',
            darkMode: 'color_color_primary.200_darkMode__1q1dxs81f'
          },
          defaultClass: 'color_color_primary.200_lightMode__1q1dxs81e'
        },
        'primary.300': {
          conditions: {
            lightMode: 'color_color_primary.300_lightMode__1q1dxs81g',
            darkMode: 'color_color_primary.300_darkMode__1q1dxs81h'
          },
          defaultClass: 'color_color_primary.300_lightMode__1q1dxs81g'
        },
        'primary.400': {
          conditions: {
            lightMode: 'color_color_primary.400_lightMode__1q1dxs81i',
            darkMode: 'color_color_primary.400_darkMode__1q1dxs81j'
          },
          defaultClass: 'color_color_primary.400_lightMode__1q1dxs81i'
        },
        'primary.500': {
          conditions: {
            lightMode: 'color_color_primary.500_lightMode__1q1dxs81k',
            darkMode: 'color_color_primary.500_darkMode__1q1dxs81l'
          },
          defaultClass: 'color_color_primary.500_lightMode__1q1dxs81k'
        },
        'primary.600': {
          conditions: {
            lightMode: 'color_color_primary.600_lightMode__1q1dxs81m',
            darkMode: 'color_color_primary.600_darkMode__1q1dxs81n'
          },
          defaultClass: 'color_color_primary.600_lightMode__1q1dxs81m'
        },
        'primary.700': {
          conditions: {
            lightMode: 'color_color_primary.700_lightMode__1q1dxs81o',
            darkMode: 'color_color_primary.700_darkMode__1q1dxs81p'
          },
          defaultClass: 'color_color_primary.700_lightMode__1q1dxs81o'
        },
        'primary.800': {
          conditions: {
            lightMode: 'color_color_primary.800_lightMode__1q1dxs81q',
            darkMode: 'color_color_primary.800_darkMode__1q1dxs81r'
          },
          defaultClass: 'color_color_primary.800_lightMode__1q1dxs81q'
        },
        'primary.900': {
          conditions: {
            lightMode: 'color_color_primary.900_lightMode__1q1dxs81s',
            darkMode: 'color_color_primary.900_darkMode__1q1dxs81t'
          },
          defaultClass: 'color_color_primary.900_lightMode__1q1dxs81s'
        },
        'primary.950': {
          conditions: {
            lightMode: 'color_color_primary.950_lightMode__1q1dxs81u',
            darkMode: 'color_color_primary.950_darkMode__1q1dxs81v'
          },
          defaultClass: 'color_color_primary.950_lightMode__1q1dxs81u'
        },
        'red.50': {
          conditions: {
            lightMode: 'color_color_red.50_lightMode__1q1dxs81w',
            darkMode: 'color_color_red.50_darkMode__1q1dxs81x'
          },
          defaultClass: 'color_color_red.50_lightMode__1q1dxs81w'
        },
        'red.100': {
          conditions: {
            lightMode: 'color_color_red.100_lightMode__1q1dxs81y',
            darkMode: 'color_color_red.100_darkMode__1q1dxs81z'
          },
          defaultClass: 'color_color_red.100_lightMode__1q1dxs81y'
        },
        'red.200': {
          conditions: {
            lightMode: 'color_color_red.200_lightMode__1q1dxs820',
            darkMode: 'color_color_red.200_darkMode__1q1dxs821'
          },
          defaultClass: 'color_color_red.200_lightMode__1q1dxs820'
        },
        'red.300': {
          conditions: {
            lightMode: 'color_color_red.300_lightMode__1q1dxs822',
            darkMode: 'color_color_red.300_darkMode__1q1dxs823'
          },
          defaultClass: 'color_color_red.300_lightMode__1q1dxs822'
        },
        'red.400': {
          conditions: {
            lightMode: 'color_color_red.400_lightMode__1q1dxs824',
            darkMode: 'color_color_red.400_darkMode__1q1dxs825'
          },
          defaultClass: 'color_color_red.400_lightMode__1q1dxs824'
        },
        'red.500': {
          conditions: {
            lightMode: 'color_color_red.500_lightMode__1q1dxs826',
            darkMode: 'color_color_red.500_darkMode__1q1dxs827'
          },
          defaultClass: 'color_color_red.500_lightMode__1q1dxs826'
        },
        'red.600': {
          conditions: {
            lightMode: 'color_color_red.600_lightMode__1q1dxs828',
            darkMode: 'color_color_red.600_darkMode__1q1dxs829'
          },
          defaultClass: 'color_color_red.600_lightMode__1q1dxs828'
        },
        'red.700': {
          conditions: {
            lightMode: 'color_color_red.700_lightMode__1q1dxs82a',
            darkMode: 'color_color_red.700_darkMode__1q1dxs82b'
          },
          defaultClass: 'color_color_red.700_lightMode__1q1dxs82a'
        },
        'red.800': {
          conditions: {
            lightMode: 'color_color_red.800_lightMode__1q1dxs82c',
            darkMode: 'color_color_red.800_darkMode__1q1dxs82d'
          },
          defaultClass: 'color_color_red.800_lightMode__1q1dxs82c'
        },
        'red.900': {
          conditions: {
            lightMode: 'color_color_red.900_lightMode__1q1dxs82e',
            darkMode: 'color_color_red.900_darkMode__1q1dxs82f'
          },
          defaultClass: 'color_color_red.900_lightMode__1q1dxs82e'
        },
        'red.950': {
          conditions: {
            lightMode: 'color_color_red.950_lightMode__1q1dxs82g',
            darkMode: 'color_color_red.950_darkMode__1q1dxs82h'
          },
          defaultClass: 'color_color_red.950_lightMode__1q1dxs82g'
        },
        'yellow.50': {
          conditions: {
            lightMode: 'color_color_yellow.50_lightMode__1q1dxs82i',
            darkMode: 'color_color_yellow.50_darkMode__1q1dxs82j'
          },
          defaultClass: 'color_color_yellow.50_lightMode__1q1dxs82i'
        },
        'yellow.100': {
          conditions: {
            lightMode: 'color_color_yellow.100_lightMode__1q1dxs82k',
            darkMode: 'color_color_yellow.100_darkMode__1q1dxs82l'
          },
          defaultClass: 'color_color_yellow.100_lightMode__1q1dxs82k'
        },
        'yellow.200': {
          conditions: {
            lightMode: 'color_color_yellow.200_lightMode__1q1dxs82m',
            darkMode: 'color_color_yellow.200_darkMode__1q1dxs82n'
          },
          defaultClass: 'color_color_yellow.200_lightMode__1q1dxs82m'
        },
        'yellow.300': {
          conditions: {
            lightMode: 'color_color_yellow.300_lightMode__1q1dxs82o',
            darkMode: 'color_color_yellow.300_darkMode__1q1dxs82p'
          },
          defaultClass: 'color_color_yellow.300_lightMode__1q1dxs82o'
        },
        'yellow.400': {
          conditions: {
            lightMode: 'color_color_yellow.400_lightMode__1q1dxs82q',
            darkMode: 'color_color_yellow.400_darkMode__1q1dxs82r'
          },
          defaultClass: 'color_color_yellow.400_lightMode__1q1dxs82q'
        },
        'yellow.500': {
          conditions: {
            lightMode: 'color_color_yellow.500_lightMode__1q1dxs82s',
            darkMode: 'color_color_yellow.500_darkMode__1q1dxs82t'
          },
          defaultClass: 'color_color_yellow.500_lightMode__1q1dxs82s'
        },
        'yellow.600': {
          conditions: {
            lightMode: 'color_color_yellow.600_lightMode__1q1dxs82u',
            darkMode: 'color_color_yellow.600_darkMode__1q1dxs82v'
          },
          defaultClass: 'color_color_yellow.600_lightMode__1q1dxs82u'
        },
        'yellow.700': {
          conditions: {
            lightMode: 'color_color_yellow.700_lightMode__1q1dxs82w',
            darkMode: 'color_color_yellow.700_darkMode__1q1dxs82x'
          },
          defaultClass: 'color_color_yellow.700_lightMode__1q1dxs82w'
        },
        'yellow.800': {
          conditions: {
            lightMode: 'color_color_yellow.800_lightMode__1q1dxs82y',
            darkMode: 'color_color_yellow.800_darkMode__1q1dxs82z'
          },
          defaultClass: 'color_color_yellow.800_lightMode__1q1dxs82y'
        },
        'yellow.900': {
          conditions: {
            lightMode: 'color_color_yellow.900_lightMode__1q1dxs830',
            darkMode: 'color_color_yellow.900_darkMode__1q1dxs831'
          },
          defaultClass: 'color_color_yellow.900_lightMode__1q1dxs830'
        },
        'yellow.950': {
          conditions: {
            lightMode: 'color_color_yellow.950_lightMode__1q1dxs832',
            darkMode: 'color_color_yellow.950_darkMode__1q1dxs833'
          },
          defaultClass: 'color_color_yellow.950_lightMode__1q1dxs832'
        },
        'green.50': {
          conditions: {
            lightMode: 'color_color_green.50_lightMode__1q1dxs834',
            darkMode: 'color_color_green.50_darkMode__1q1dxs835'
          },
          defaultClass: 'color_color_green.50_lightMode__1q1dxs834'
        },
        'green.100': {
          conditions: {
            lightMode: 'color_color_green.100_lightMode__1q1dxs836',
            darkMode: 'color_color_green.100_darkMode__1q1dxs837'
          },
          defaultClass: 'color_color_green.100_lightMode__1q1dxs836'
        },
        'green.200': {
          conditions: {
            lightMode: 'color_color_green.200_lightMode__1q1dxs838',
            darkMode: 'color_color_green.200_darkMode__1q1dxs839'
          },
          defaultClass: 'color_color_green.200_lightMode__1q1dxs838'
        },
        'green.300': {
          conditions: {
            lightMode: 'color_color_green.300_lightMode__1q1dxs83a',
            darkMode: 'color_color_green.300_darkMode__1q1dxs83b'
          },
          defaultClass: 'color_color_green.300_lightMode__1q1dxs83a'
        },
        'green.400': {
          conditions: {
            lightMode: 'color_color_green.400_lightMode__1q1dxs83c',
            darkMode: 'color_color_green.400_darkMode__1q1dxs83d'
          },
          defaultClass: 'color_color_green.400_lightMode__1q1dxs83c'
        },
        'green.500': {
          conditions: {
            lightMode: 'color_color_green.500_lightMode__1q1dxs83e',
            darkMode: 'color_color_green.500_darkMode__1q1dxs83f'
          },
          defaultClass: 'color_color_green.500_lightMode__1q1dxs83e'
        },
        'green.600': {
          conditions: {
            lightMode: 'color_color_green.600_lightMode__1q1dxs83g',
            darkMode: 'color_color_green.600_darkMode__1q1dxs83h'
          },
          defaultClass: 'color_color_green.600_lightMode__1q1dxs83g'
        },
        'green.700': {
          conditions: {
            lightMode: 'color_color_green.700_lightMode__1q1dxs83i',
            darkMode: 'color_color_green.700_darkMode__1q1dxs83j'
          },
          defaultClass: 'color_color_green.700_lightMode__1q1dxs83i'
        },
        'green.800': {
          conditions: {
            lightMode: 'color_color_green.800_lightMode__1q1dxs83k',
            darkMode: 'color_color_green.800_darkMode__1q1dxs83l'
          },
          defaultClass: 'color_color_green.800_lightMode__1q1dxs83k'
        },
        'green.900': {
          conditions: {
            lightMode: 'color_color_green.900_lightMode__1q1dxs83m',
            darkMode: 'color_color_green.900_darkMode__1q1dxs83n'
          },
          defaultClass: 'color_color_green.900_lightMode__1q1dxs83m'
        },
        'green.950': {
          conditions: {
            lightMode: 'color_color_green.950_lightMode__1q1dxs83o',
            darkMode: 'color_color_green.950_darkMode__1q1dxs83p'
          },
          defaultClass: 'color_color_green.950_lightMode__1q1dxs83o'
        },
        'blue.50': {
          conditions: {
            lightMode: 'color_color_blue.50_lightMode__1q1dxs83q',
            darkMode: 'color_color_blue.50_darkMode__1q1dxs83r'
          },
          defaultClass: 'color_color_blue.50_lightMode__1q1dxs83q'
        },
        'blue.100': {
          conditions: {
            lightMode: 'color_color_blue.100_lightMode__1q1dxs83s',
            darkMode: 'color_color_blue.100_darkMode__1q1dxs83t'
          },
          defaultClass: 'color_color_blue.100_lightMode__1q1dxs83s'
        },
        'blue.200': {
          conditions: {
            lightMode: 'color_color_blue.200_lightMode__1q1dxs83u',
            darkMode: 'color_color_blue.200_darkMode__1q1dxs83v'
          },
          defaultClass: 'color_color_blue.200_lightMode__1q1dxs83u'
        },
        'blue.300': {
          conditions: {
            lightMode: 'color_color_blue.300_lightMode__1q1dxs83w',
            darkMode: 'color_color_blue.300_darkMode__1q1dxs83x'
          },
          defaultClass: 'color_color_blue.300_lightMode__1q1dxs83w'
        },
        'blue.400': {
          conditions: {
            lightMode: 'color_color_blue.400_lightMode__1q1dxs83y',
            darkMode: 'color_color_blue.400_darkMode__1q1dxs83z'
          },
          defaultClass: 'color_color_blue.400_lightMode__1q1dxs83y'
        },
        'blue.500': {
          conditions: {
            lightMode: 'color_color_blue.500_lightMode__1q1dxs840',
            darkMode: 'color_color_blue.500_darkMode__1q1dxs841'
          },
          defaultClass: 'color_color_blue.500_lightMode__1q1dxs840'
        },
        'blue.600': {
          conditions: {
            lightMode: 'color_color_blue.600_lightMode__1q1dxs842',
            darkMode: 'color_color_blue.600_darkMode__1q1dxs843'
          },
          defaultClass: 'color_color_blue.600_lightMode__1q1dxs842'
        },
        'blue.700': {
          conditions: {
            lightMode: 'color_color_blue.700_lightMode__1q1dxs844',
            darkMode: 'color_color_blue.700_darkMode__1q1dxs845'
          },
          defaultClass: 'color_color_blue.700_lightMode__1q1dxs844'
        },
        'blue.800': {
          conditions: {
            lightMode: 'color_color_blue.800_lightMode__1q1dxs846',
            darkMode: 'color_color_blue.800_darkMode__1q1dxs847'
          },
          defaultClass: 'color_color_blue.800_lightMode__1q1dxs846'
        },
        'blue.900': {
          conditions: {
            lightMode: 'color_color_blue.900_lightMode__1q1dxs848',
            darkMode: 'color_color_blue.900_darkMode__1q1dxs849'
          },
          defaultClass: 'color_color_blue.900_lightMode__1q1dxs848'
        },
        'blue.950': {
          conditions: {
            lightMode: 'color_color_blue.950_lightMode__1q1dxs84a',
            darkMode: 'color_color_blue.950_darkMode__1q1dxs84b'
          },
          defaultClass: 'color_color_blue.950_lightMode__1q1dxs84a'
        },
        'purple.50': {
          conditions: {
            lightMode: 'color_color_purple.50_lightMode__1q1dxs84c',
            darkMode: 'color_color_purple.50_darkMode__1q1dxs84d'
          },
          defaultClass: 'color_color_purple.50_lightMode__1q1dxs84c'
        },
        'purple.100': {
          conditions: {
            lightMode: 'color_color_purple.100_lightMode__1q1dxs84e',
            darkMode: 'color_color_purple.100_darkMode__1q1dxs84f'
          },
          defaultClass: 'color_color_purple.100_lightMode__1q1dxs84e'
        },
        'purple.200': {
          conditions: {
            lightMode: 'color_color_purple.200_lightMode__1q1dxs84g',
            darkMode: 'color_color_purple.200_darkMode__1q1dxs84h'
          },
          defaultClass: 'color_color_purple.200_lightMode__1q1dxs84g'
        },
        'purple.300': {
          conditions: {
            lightMode: 'color_color_purple.300_lightMode__1q1dxs84i',
            darkMode: 'color_color_purple.300_darkMode__1q1dxs84j'
          },
          defaultClass: 'color_color_purple.300_lightMode__1q1dxs84i'
        },
        'purple.400': {
          conditions: {
            lightMode: 'color_color_purple.400_lightMode__1q1dxs84k',
            darkMode: 'color_color_purple.400_darkMode__1q1dxs84l'
          },
          defaultClass: 'color_color_purple.400_lightMode__1q1dxs84k'
        },
        'purple.500': {
          conditions: {
            lightMode: 'color_color_purple.500_lightMode__1q1dxs84m',
            darkMode: 'color_color_purple.500_darkMode__1q1dxs84n'
          },
          defaultClass: 'color_color_purple.500_lightMode__1q1dxs84m'
        },
        'purple.600': {
          conditions: {
            lightMode: 'color_color_purple.600_lightMode__1q1dxs84o',
            darkMode: 'color_color_purple.600_darkMode__1q1dxs84p'
          },
          defaultClass: 'color_color_purple.600_lightMode__1q1dxs84o'
        },
        'purple.700': {
          conditions: {
            lightMode: 'color_color_purple.700_lightMode__1q1dxs84q',
            darkMode: 'color_color_purple.700_darkMode__1q1dxs84r'
          },
          defaultClass: 'color_color_purple.700_lightMode__1q1dxs84q'
        },
        'purple.800': {
          conditions: {
            lightMode: 'color_color_purple.800_lightMode__1q1dxs84s',
            darkMode: 'color_color_purple.800_darkMode__1q1dxs84t'
          },
          defaultClass: 'color_color_purple.800_lightMode__1q1dxs84s'
        },
        'purple.900': {
          conditions: {
            lightMode: 'color_color_purple.900_lightMode__1q1dxs84u',
            darkMode: 'color_color_purple.900_darkMode__1q1dxs84v'
          },
          defaultClass: 'color_color_purple.900_lightMode__1q1dxs84u'
        },
        'purple.950': {
          conditions: {
            lightMode: 'color_color_purple.950_lightMode__1q1dxs84w',
            darkMode: 'color_color_purple.950_darkMode__1q1dxs84x'
          },
          defaultClass: 'color_color_purple.950_lightMode__1q1dxs84w'
        },
        'feedback.danger': {
          conditions: {
            lightMode: 'color_color_feedback.danger_lightMode__1q1dxs84y',
            darkMode: 'color_color_feedback.danger_darkMode__1q1dxs84z'
          },
          defaultClass: 'color_color_feedback.danger_lightMode__1q1dxs84y'
        },
        'feedback.warning': {
          conditions: {
            lightMode: 'color_color_feedback.warning_lightMode__1q1dxs850',
            darkMode: 'color_color_feedback.warning_darkMode__1q1dxs851'
          },
          defaultClass: 'color_color_feedback.warning_lightMode__1q1dxs850'
        },
        'feedback.success': {
          conditions: {
            lightMode: 'color_color_feedback.success_lightMode__1q1dxs852',
            darkMode: 'color_color_feedback.success_darkMode__1q1dxs853'
          },
          defaultClass: 'color_color_feedback.success_lightMode__1q1dxs852'
        },
        'feedback.info': {
          conditions: {
            lightMode: 'color_color_feedback.info_lightMode__1q1dxs854',
            darkMode: 'color_color_feedback.info_darkMode__1q1dxs855'
          },
          defaultClass: 'color_color_feedback.info_lightMode__1q1dxs854'
        },
        'feedback.neutral': {
          conditions: {
            lightMode: 'color_color_feedback.neutral_lightMode__1q1dxs856',
            darkMode: 'color_color_feedback.neutral_darkMode__1q1dxs857'
          },
          defaultClass: 'color_color_feedback.neutral_lightMode__1q1dxs856'
        },
        'text.300': {
          conditions: {
            lightMode: 'color_color_text.300_lightMode__1q1dxs858',
            darkMode: 'color_color_text.300_darkMode__1q1dxs859'
          },
          defaultClass: 'color_color_text.300_lightMode__1q1dxs858'
        },
        'text.500': {
          conditions: {
            lightMode: 'color_color_text.500_lightMode__1q1dxs85a',
            darkMode: 'color_color_text.500_darkMode__1q1dxs85b'
          },
          defaultClass: 'color_color_text.500_lightMode__1q1dxs85a'
        },
        'text.600': {
          conditions: {
            lightMode: 'color_color_text.600_lightMode__1q1dxs85c',
            darkMode: 'color_color_text.600_darkMode__1q1dxs85d'
          },
          defaultClass: 'color_color_text.600_lightMode__1q1dxs85c'
        },
        'text.700': {
          conditions: {
            lightMode: 'color_color_text.700_lightMode__1q1dxs85e',
            darkMode: 'color_color_text.700_darkMode__1q1dxs85f'
          },
          defaultClass: 'color_color_text.700_lightMode__1q1dxs85e'
        },
        'text.800': {
          conditions: {
            lightMode: 'color_color_text.800_lightMode__1q1dxs85g',
            darkMode: 'color_color_text.800_darkMode__1q1dxs85h'
          },
          defaultClass: 'color_color_text.800_lightMode__1q1dxs85g'
        },
        'text.primary': {
          conditions: {
            lightMode: 'color_color_text.primary_lightMode__1q1dxs85i',
            darkMode: 'color_color_text.primary_darkMode__1q1dxs85j'
          },
          defaultClass: 'color_color_text.primary_lightMode__1q1dxs85i'
        },
        'text.secondary': {
          conditions: {
            lightMode: 'color_color_text.secondary_lightMode__1q1dxs85k',
            darkMode: 'color_color_text.secondary_darkMode__1q1dxs85l'
          },
          defaultClass: 'color_color_text.secondary_lightMode__1q1dxs85k'
        },
        'text.caption': {
          conditions: {
            lightMode: 'color_color_text.caption_lightMode__1q1dxs85m',
            darkMode: 'color_color_text.caption_darkMode__1q1dxs85n'
          },
          defaultClass: 'color_color_text.caption_lightMode__1q1dxs85m'
        },
        'text.description': {
          conditions: {
            lightMode: 'color_color_text.description_lightMode__1q1dxs85o',
            darkMode: 'color_color_text.description_darkMode__1q1dxs85p'
          },
          defaultClass: 'color_color_text.description_lightMode__1q1dxs85o'
        },
        'text.description2': {
          conditions: {
            lightMode: 'color_color_text.description2_lightMode__1q1dxs85q',
            darkMode: 'color_color_text.description2_darkMode__1q1dxs85r'
          },
          defaultClass: 'color_color_text.description2_lightMode__1q1dxs85q'
        },
        'text.disabled': {
          conditions: {
            lightMode: 'color_color_text.disabled_lightMode__1q1dxs85s',
            darkMode: 'color_color_text.disabled_darkMode__1q1dxs85t'
          },
          defaultClass: 'color_color_text.disabled_lightMode__1q1dxs85s'
        },
        'text.translation': {
          conditions: {
            lightMode: 'color_color_text.translation_lightMode__1q1dxs85u',
            darkMode: 'color_color_text.translation_darkMode__1q1dxs85v'
          },
          defaultClass: 'color_color_text.translation_lightMode__1q1dxs85u'
        },
        'text.info': {
          conditions: {
            lightMode: 'color_color_text.info_lightMode__1q1dxs85w',
            darkMode: 'color_color_text.info_darkMode__1q1dxs85x'
          },
          defaultClass: 'color_color_text.info_lightMode__1q1dxs85w'
        },
        'text.success': {
          conditions: {
            lightMode: 'color_color_text.success_lightMode__1q1dxs85y',
            darkMode: 'color_color_text.success_darkMode__1q1dxs85z'
          },
          defaultClass: 'color_color_text.success_lightMode__1q1dxs85y'
        },
        'text.danger': {
          conditions: {
            lightMode: 'color_color_text.danger_lightMode__1q1dxs860',
            darkMode: 'color_color_text.danger_darkMode__1q1dxs861'
          },
          defaultClass: 'color_color_text.danger_lightMode__1q1dxs860'
        },
        'text.01': {
          conditions: {
            lightMode: 'color_color_text.01_lightMode__1q1dxs862',
            darkMode: 'color_color_text.01_darkMode__1q1dxs863'
          },
          defaultClass: 'color_color_text.01_lightMode__1q1dxs862'
        },
        'text.02': {
          conditions: {
            lightMode: 'color_color_text.02_lightMode__1q1dxs864',
            darkMode: 'color_color_text.02_darkMode__1q1dxs865'
          },
          defaultClass: 'color_color_text.02_lightMode__1q1dxs864'
        },
        'text.03': {
          conditions: {
            lightMode: 'color_color_text.03_lightMode__1q1dxs866',
            darkMode: 'color_color_text.03_darkMode__1q1dxs867'
          },
          defaultClass: 'color_color_text.03_lightMode__1q1dxs866'
        },
        'background.gray': {
          conditions: {
            lightMode: 'color_color_background.gray_lightMode__1q1dxs868',
            darkMode: 'color_color_background.gray_darkMode__1q1dxs869'
          },
          defaultClass: 'color_color_background.gray_lightMode__1q1dxs868'
        },
        'background.grayBold': {
          conditions: {
            lightMode: 'color_color_background.grayBold_lightMode__1q1dxs86a',
            darkMode: 'color_color_background.grayBold_darkMode__1q1dxs86b'
          },
          defaultClass: 'color_color_background.grayBold_lightMode__1q1dxs86a'
        },
        'background.disabled': {
          conditions: {
            lightMode: 'color_color_background.disabled_lightMode__1q1dxs86c',
            darkMode: 'color_color_background.disabled_darkMode__1q1dxs86d'
          },
          defaultClass: 'color_color_background.disabled_lightMode__1q1dxs86c'
        },
        'border.muted': {
          conditions: {
            lightMode: 'color_color_border.muted_lightMode__1q1dxs86e',
            darkMode: 'color_color_border.muted_darkMode__1q1dxs86f'
          },
          defaultClass: 'color_color_border.muted_lightMode__1q1dxs86e'
        },
        'border.normal': {
          conditions: {
            lightMode: 'color_color_border.normal_lightMode__1q1dxs86g',
            darkMode: 'color_color_border.normal_darkMode__1q1dxs86h'
          },
          defaultClass: 'color_color_border.normal_lightMode__1q1dxs86g'
        },
        'border.bold': {
          conditions: {
            lightMode: 'color_color_border.bold_lightMode__1q1dxs86i',
            darkMode: 'color_color_border.bold_darkMode__1q1dxs86j'
          },
          defaultClass: 'color_color_border.bold_lightMode__1q1dxs86i'
        }
      }
    },
    background: {
      values: {
        'gray.50': {
          conditions: {
            lightMode: 'color_background_gray.50_lightMode__1q1dxs86k',
            darkMode: 'color_background_gray.50_darkMode__1q1dxs86l'
          },
          defaultClass: 'color_background_gray.50_lightMode__1q1dxs86k'
        },
        'gray.80': {
          conditions: {
            lightMode: 'color_background_gray.80_lightMode__1q1dxs86m',
            darkMode: 'color_background_gray.80_darkMode__1q1dxs86n'
          },
          defaultClass: 'color_background_gray.80_lightMode__1q1dxs86m'
        },
        'gray.100': {
          conditions: {
            lightMode: 'color_background_gray.100_lightMode__1q1dxs86o',
            darkMode: 'color_background_gray.100_darkMode__1q1dxs86p'
          },
          defaultClass: 'color_background_gray.100_lightMode__1q1dxs86o'
        },
        'gray.200': {
          conditions: {
            lightMode: 'color_background_gray.200_lightMode__1q1dxs86q',
            darkMode: 'color_background_gray.200_darkMode__1q1dxs86r'
          },
          defaultClass: 'color_background_gray.200_lightMode__1q1dxs86q'
        },
        'gray.300': {
          conditions: {
            lightMode: 'color_background_gray.300_lightMode__1q1dxs86s',
            darkMode: 'color_background_gray.300_darkMode__1q1dxs86t'
          },
          defaultClass: 'color_background_gray.300_lightMode__1q1dxs86s'
        },
        'gray.400': {
          conditions: {
            lightMode: 'color_background_gray.400_lightMode__1q1dxs86u',
            darkMode: 'color_background_gray.400_darkMode__1q1dxs86v'
          },
          defaultClass: 'color_background_gray.400_lightMode__1q1dxs86u'
        },
        'gray.500': {
          conditions: {
            lightMode: 'color_background_gray.500_lightMode__1q1dxs86w',
            darkMode: 'color_background_gray.500_darkMode__1q1dxs86x'
          },
          defaultClass: 'color_background_gray.500_lightMode__1q1dxs86w'
        },
        'gray.600': {
          conditions: {
            lightMode: 'color_background_gray.600_lightMode__1q1dxs86y',
            darkMode: 'color_background_gray.600_darkMode__1q1dxs86z'
          },
          defaultClass: 'color_background_gray.600_lightMode__1q1dxs86y'
        },
        'gray.700': {
          conditions: {
            lightMode: 'color_background_gray.700_lightMode__1q1dxs870',
            darkMode: 'color_background_gray.700_darkMode__1q1dxs871'
          },
          defaultClass: 'color_background_gray.700_lightMode__1q1dxs870'
        },
        'gray.750': {
          conditions: {
            lightMode: 'color_background_gray.750_lightMode__1q1dxs872',
            darkMode: 'color_background_gray.750_darkMode__1q1dxs873'
          },
          defaultClass: 'color_background_gray.750_lightMode__1q1dxs872'
        },
        'gray.800': {
          conditions: {
            lightMode: 'color_background_gray.800_lightMode__1q1dxs874',
            darkMode: 'color_background_gray.800_darkMode__1q1dxs875'
          },
          defaultClass: 'color_background_gray.800_lightMode__1q1dxs874'
        },
        'gray.900': {
          conditions: {
            lightMode: 'color_background_gray.900_lightMode__1q1dxs876',
            darkMode: 'color_background_gray.900_darkMode__1q1dxs877'
          },
          defaultClass: 'color_background_gray.900_lightMode__1q1dxs876'
        },
        'zinc.50': {
          conditions: {
            lightMode: 'color_background_zinc.50_lightMode__1q1dxs878',
            darkMode: 'color_background_zinc.50_darkMode__1q1dxs879'
          },
          defaultClass: 'color_background_zinc.50_lightMode__1q1dxs878'
        },
        'zinc.100': {
          conditions: {
            lightMode: 'color_background_zinc.100_lightMode__1q1dxs87a',
            darkMode: 'color_background_zinc.100_darkMode__1q1dxs87b'
          },
          defaultClass: 'color_background_zinc.100_lightMode__1q1dxs87a'
        },
        'zinc.200': {
          conditions: {
            lightMode: 'color_background_zinc.200_lightMode__1q1dxs87c',
            darkMode: 'color_background_zinc.200_darkMode__1q1dxs87d'
          },
          defaultClass: 'color_background_zinc.200_lightMode__1q1dxs87c'
        },
        'zinc.300': {
          conditions: {
            lightMode: 'color_background_zinc.300_lightMode__1q1dxs87e',
            darkMode: 'color_background_zinc.300_darkMode__1q1dxs87f'
          },
          defaultClass: 'color_background_zinc.300_lightMode__1q1dxs87e'
        },
        'zinc.400': {
          conditions: {
            lightMode: 'color_background_zinc.400_lightMode__1q1dxs87g',
            darkMode: 'color_background_zinc.400_darkMode__1q1dxs87h'
          },
          defaultClass: 'color_background_zinc.400_lightMode__1q1dxs87g'
        },
        'zinc.500': {
          conditions: {
            lightMode: 'color_background_zinc.500_lightMode__1q1dxs87i',
            darkMode: 'color_background_zinc.500_darkMode__1q1dxs87j'
          },
          defaultClass: 'color_background_zinc.500_lightMode__1q1dxs87i'
        },
        'zinc.600': {
          conditions: {
            lightMode: 'color_background_zinc.600_lightMode__1q1dxs87k',
            darkMode: 'color_background_zinc.600_darkMode__1q1dxs87l'
          },
          defaultClass: 'color_background_zinc.600_lightMode__1q1dxs87k'
        },
        'zinc.700': {
          conditions: {
            lightMode: 'color_background_zinc.700_lightMode__1q1dxs87m',
            darkMode: 'color_background_zinc.700_darkMode__1q1dxs87n'
          },
          defaultClass: 'color_background_zinc.700_lightMode__1q1dxs87m'
        },
        'zinc.800': {
          conditions: {
            lightMode: 'color_background_zinc.800_lightMode__1q1dxs87o',
            darkMode: 'color_background_zinc.800_darkMode__1q1dxs87p'
          },
          defaultClass: 'color_background_zinc.800_lightMode__1q1dxs87o'
        },
        'zinc.900': {
          conditions: {
            lightMode: 'color_background_zinc.900_lightMode__1q1dxs87q',
            darkMode: 'color_background_zinc.900_darkMode__1q1dxs87r'
          },
          defaultClass: 'color_background_zinc.900_lightMode__1q1dxs87q'
        },
        'zinc.950': {
          conditions: {
            lightMode: 'color_background_zinc.950_lightMode__1q1dxs87s',
            darkMode: 'color_background_zinc.950_darkMode__1q1dxs87t'
          },
          defaultClass: 'color_background_zinc.950_lightMode__1q1dxs87s'
        },
        'primary.50': {
          conditions: {
            lightMode: 'color_background_primary.50_lightMode__1q1dxs87u',
            darkMode: 'color_background_primary.50_darkMode__1q1dxs87v'
          },
          defaultClass: 'color_background_primary.50_lightMode__1q1dxs87u'
        },
        'primary.100': {
          conditions: {
            lightMode: 'color_background_primary.100_lightMode__1q1dxs87w',
            darkMode: 'color_background_primary.100_darkMode__1q1dxs87x'
          },
          defaultClass: 'color_background_primary.100_lightMode__1q1dxs87w'
        },
        'primary.200': {
          conditions: {
            lightMode: 'color_background_primary.200_lightMode__1q1dxs87y',
            darkMode: 'color_background_primary.200_darkMode__1q1dxs87z'
          },
          defaultClass: 'color_background_primary.200_lightMode__1q1dxs87y'
        },
        'primary.300': {
          conditions: {
            lightMode: 'color_background_primary.300_lightMode__1q1dxs880',
            darkMode: 'color_background_primary.300_darkMode__1q1dxs881'
          },
          defaultClass: 'color_background_primary.300_lightMode__1q1dxs880'
        },
        'primary.400': {
          conditions: {
            lightMode: 'color_background_primary.400_lightMode__1q1dxs882',
            darkMode: 'color_background_primary.400_darkMode__1q1dxs883'
          },
          defaultClass: 'color_background_primary.400_lightMode__1q1dxs882'
        },
        'primary.500': {
          conditions: {
            lightMode: 'color_background_primary.500_lightMode__1q1dxs884',
            darkMode: 'color_background_primary.500_darkMode__1q1dxs885'
          },
          defaultClass: 'color_background_primary.500_lightMode__1q1dxs884'
        },
        'primary.600': {
          conditions: {
            lightMode: 'color_background_primary.600_lightMode__1q1dxs886',
            darkMode: 'color_background_primary.600_darkMode__1q1dxs887'
          },
          defaultClass: 'color_background_primary.600_lightMode__1q1dxs886'
        },
        'primary.700': {
          conditions: {
            lightMode: 'color_background_primary.700_lightMode__1q1dxs888',
            darkMode: 'color_background_primary.700_darkMode__1q1dxs889'
          },
          defaultClass: 'color_background_primary.700_lightMode__1q1dxs888'
        },
        'primary.800': {
          conditions: {
            lightMode: 'color_background_primary.800_lightMode__1q1dxs88a',
            darkMode: 'color_background_primary.800_darkMode__1q1dxs88b'
          },
          defaultClass: 'color_background_primary.800_lightMode__1q1dxs88a'
        },
        'primary.900': {
          conditions: {
            lightMode: 'color_background_primary.900_lightMode__1q1dxs88c',
            darkMode: 'color_background_primary.900_darkMode__1q1dxs88d'
          },
          defaultClass: 'color_background_primary.900_lightMode__1q1dxs88c'
        },
        'primary.950': {
          conditions: {
            lightMode: 'color_background_primary.950_lightMode__1q1dxs88e',
            darkMode: 'color_background_primary.950_darkMode__1q1dxs88f'
          },
          defaultClass: 'color_background_primary.950_lightMode__1q1dxs88e'
        },
        'red.50': {
          conditions: {
            lightMode: 'color_background_red.50_lightMode__1q1dxs88g',
            darkMode: 'color_background_red.50_darkMode__1q1dxs88h'
          },
          defaultClass: 'color_background_red.50_lightMode__1q1dxs88g'
        },
        'red.100': {
          conditions: {
            lightMode: 'color_background_red.100_lightMode__1q1dxs88i',
            darkMode: 'color_background_red.100_darkMode__1q1dxs88j'
          },
          defaultClass: 'color_background_red.100_lightMode__1q1dxs88i'
        },
        'red.200': {
          conditions: {
            lightMode: 'color_background_red.200_lightMode__1q1dxs88k',
            darkMode: 'color_background_red.200_darkMode__1q1dxs88l'
          },
          defaultClass: 'color_background_red.200_lightMode__1q1dxs88k'
        },
        'red.300': {
          conditions: {
            lightMode: 'color_background_red.300_lightMode__1q1dxs88m',
            darkMode: 'color_background_red.300_darkMode__1q1dxs88n'
          },
          defaultClass: 'color_background_red.300_lightMode__1q1dxs88m'
        },
        'red.400': {
          conditions: {
            lightMode: 'color_background_red.400_lightMode__1q1dxs88o',
            darkMode: 'color_background_red.400_darkMode__1q1dxs88p'
          },
          defaultClass: 'color_background_red.400_lightMode__1q1dxs88o'
        },
        'red.500': {
          conditions: {
            lightMode: 'color_background_red.500_lightMode__1q1dxs88q',
            darkMode: 'color_background_red.500_darkMode__1q1dxs88r'
          },
          defaultClass: 'color_background_red.500_lightMode__1q1dxs88q'
        },
        'red.600': {
          conditions: {
            lightMode: 'color_background_red.600_lightMode__1q1dxs88s',
            darkMode: 'color_background_red.600_darkMode__1q1dxs88t'
          },
          defaultClass: 'color_background_red.600_lightMode__1q1dxs88s'
        },
        'red.700': {
          conditions: {
            lightMode: 'color_background_red.700_lightMode__1q1dxs88u',
            darkMode: 'color_background_red.700_darkMode__1q1dxs88v'
          },
          defaultClass: 'color_background_red.700_lightMode__1q1dxs88u'
        },
        'red.800': {
          conditions: {
            lightMode: 'color_background_red.800_lightMode__1q1dxs88w',
            darkMode: 'color_background_red.800_darkMode__1q1dxs88x'
          },
          defaultClass: 'color_background_red.800_lightMode__1q1dxs88w'
        },
        'red.900': {
          conditions: {
            lightMode: 'color_background_red.900_lightMode__1q1dxs88y',
            darkMode: 'color_background_red.900_darkMode__1q1dxs88z'
          },
          defaultClass: 'color_background_red.900_lightMode__1q1dxs88y'
        },
        'red.950': {
          conditions: {
            lightMode: 'color_background_red.950_lightMode__1q1dxs890',
            darkMode: 'color_background_red.950_darkMode__1q1dxs891'
          },
          defaultClass: 'color_background_red.950_lightMode__1q1dxs890'
        },
        'yellow.50': {
          conditions: {
            lightMode: 'color_background_yellow.50_lightMode__1q1dxs892',
            darkMode: 'color_background_yellow.50_darkMode__1q1dxs893'
          },
          defaultClass: 'color_background_yellow.50_lightMode__1q1dxs892'
        },
        'yellow.100': {
          conditions: {
            lightMode: 'color_background_yellow.100_lightMode__1q1dxs894',
            darkMode: 'color_background_yellow.100_darkMode__1q1dxs895'
          },
          defaultClass: 'color_background_yellow.100_lightMode__1q1dxs894'
        },
        'yellow.200': {
          conditions: {
            lightMode: 'color_background_yellow.200_lightMode__1q1dxs896',
            darkMode: 'color_background_yellow.200_darkMode__1q1dxs897'
          },
          defaultClass: 'color_background_yellow.200_lightMode__1q1dxs896'
        },
        'yellow.300': {
          conditions: {
            lightMode: 'color_background_yellow.300_lightMode__1q1dxs898',
            darkMode: 'color_background_yellow.300_darkMode__1q1dxs899'
          },
          defaultClass: 'color_background_yellow.300_lightMode__1q1dxs898'
        },
        'yellow.400': {
          conditions: {
            lightMode: 'color_background_yellow.400_lightMode__1q1dxs89a',
            darkMode: 'color_background_yellow.400_darkMode__1q1dxs89b'
          },
          defaultClass: 'color_background_yellow.400_lightMode__1q1dxs89a'
        },
        'yellow.500': {
          conditions: {
            lightMode: 'color_background_yellow.500_lightMode__1q1dxs89c',
            darkMode: 'color_background_yellow.500_darkMode__1q1dxs89d'
          },
          defaultClass: 'color_background_yellow.500_lightMode__1q1dxs89c'
        },
        'yellow.600': {
          conditions: {
            lightMode: 'color_background_yellow.600_lightMode__1q1dxs89e',
            darkMode: 'color_background_yellow.600_darkMode__1q1dxs89f'
          },
          defaultClass: 'color_background_yellow.600_lightMode__1q1dxs89e'
        },
        'yellow.700': {
          conditions: {
            lightMode: 'color_background_yellow.700_lightMode__1q1dxs89g',
            darkMode: 'color_background_yellow.700_darkMode__1q1dxs89h'
          },
          defaultClass: 'color_background_yellow.700_lightMode__1q1dxs89g'
        },
        'yellow.800': {
          conditions: {
            lightMode: 'color_background_yellow.800_lightMode__1q1dxs89i',
            darkMode: 'color_background_yellow.800_darkMode__1q1dxs89j'
          },
          defaultClass: 'color_background_yellow.800_lightMode__1q1dxs89i'
        },
        'yellow.900': {
          conditions: {
            lightMode: 'color_background_yellow.900_lightMode__1q1dxs89k',
            darkMode: 'color_background_yellow.900_darkMode__1q1dxs89l'
          },
          defaultClass: 'color_background_yellow.900_lightMode__1q1dxs89k'
        },
        'yellow.950': {
          conditions: {
            lightMode: 'color_background_yellow.950_lightMode__1q1dxs89m',
            darkMode: 'color_background_yellow.950_darkMode__1q1dxs89n'
          },
          defaultClass: 'color_background_yellow.950_lightMode__1q1dxs89m'
        },
        'green.50': {
          conditions: {
            lightMode: 'color_background_green.50_lightMode__1q1dxs89o',
            darkMode: 'color_background_green.50_darkMode__1q1dxs89p'
          },
          defaultClass: 'color_background_green.50_lightMode__1q1dxs89o'
        },
        'green.100': {
          conditions: {
            lightMode: 'color_background_green.100_lightMode__1q1dxs89q',
            darkMode: 'color_background_green.100_darkMode__1q1dxs89r'
          },
          defaultClass: 'color_background_green.100_lightMode__1q1dxs89q'
        },
        'green.200': {
          conditions: {
            lightMode: 'color_background_green.200_lightMode__1q1dxs89s',
            darkMode: 'color_background_green.200_darkMode__1q1dxs89t'
          },
          defaultClass: 'color_background_green.200_lightMode__1q1dxs89s'
        },
        'green.300': {
          conditions: {
            lightMode: 'color_background_green.300_lightMode__1q1dxs89u',
            darkMode: 'color_background_green.300_darkMode__1q1dxs89v'
          },
          defaultClass: 'color_background_green.300_lightMode__1q1dxs89u'
        },
        'green.400': {
          conditions: {
            lightMode: 'color_background_green.400_lightMode__1q1dxs89w',
            darkMode: 'color_background_green.400_darkMode__1q1dxs89x'
          },
          defaultClass: 'color_background_green.400_lightMode__1q1dxs89w'
        },
        'green.500': {
          conditions: {
            lightMode: 'color_background_green.500_lightMode__1q1dxs89y',
            darkMode: 'color_background_green.500_darkMode__1q1dxs89z'
          },
          defaultClass: 'color_background_green.500_lightMode__1q1dxs89y'
        },
        'green.600': {
          conditions: {
            lightMode: 'color_background_green.600_lightMode__1q1dxs8a0',
            darkMode: 'color_background_green.600_darkMode__1q1dxs8a1'
          },
          defaultClass: 'color_background_green.600_lightMode__1q1dxs8a0'
        },
        'green.700': {
          conditions: {
            lightMode: 'color_background_green.700_lightMode__1q1dxs8a2',
            darkMode: 'color_background_green.700_darkMode__1q1dxs8a3'
          },
          defaultClass: 'color_background_green.700_lightMode__1q1dxs8a2'
        },
        'green.800': {
          conditions: {
            lightMode: 'color_background_green.800_lightMode__1q1dxs8a4',
            darkMode: 'color_background_green.800_darkMode__1q1dxs8a5'
          },
          defaultClass: 'color_background_green.800_lightMode__1q1dxs8a4'
        },
        'green.900': {
          conditions: {
            lightMode: 'color_background_green.900_lightMode__1q1dxs8a6',
            darkMode: 'color_background_green.900_darkMode__1q1dxs8a7'
          },
          defaultClass: 'color_background_green.900_lightMode__1q1dxs8a6'
        },
        'green.950': {
          conditions: {
            lightMode: 'color_background_green.950_lightMode__1q1dxs8a8',
            darkMode: 'color_background_green.950_darkMode__1q1dxs8a9'
          },
          defaultClass: 'color_background_green.950_lightMode__1q1dxs8a8'
        },
        'blue.50': {
          conditions: {
            lightMode: 'color_background_blue.50_lightMode__1q1dxs8aa',
            darkMode: 'color_background_blue.50_darkMode__1q1dxs8ab'
          },
          defaultClass: 'color_background_blue.50_lightMode__1q1dxs8aa'
        },
        'blue.100': {
          conditions: {
            lightMode: 'color_background_blue.100_lightMode__1q1dxs8ac',
            darkMode: 'color_background_blue.100_darkMode__1q1dxs8ad'
          },
          defaultClass: 'color_background_blue.100_lightMode__1q1dxs8ac'
        },
        'blue.200': {
          conditions: {
            lightMode: 'color_background_blue.200_lightMode__1q1dxs8ae',
            darkMode: 'color_background_blue.200_darkMode__1q1dxs8af'
          },
          defaultClass: 'color_background_blue.200_lightMode__1q1dxs8ae'
        },
        'blue.300': {
          conditions: {
            lightMode: 'color_background_blue.300_lightMode__1q1dxs8ag',
            darkMode: 'color_background_blue.300_darkMode__1q1dxs8ah'
          },
          defaultClass: 'color_background_blue.300_lightMode__1q1dxs8ag'
        },
        'blue.400': {
          conditions: {
            lightMode: 'color_background_blue.400_lightMode__1q1dxs8ai',
            darkMode: 'color_background_blue.400_darkMode__1q1dxs8aj'
          },
          defaultClass: 'color_background_blue.400_lightMode__1q1dxs8ai'
        },
        'blue.500': {
          conditions: {
            lightMode: 'color_background_blue.500_lightMode__1q1dxs8ak',
            darkMode: 'color_background_blue.500_darkMode__1q1dxs8al'
          },
          defaultClass: 'color_background_blue.500_lightMode__1q1dxs8ak'
        },
        'blue.600': {
          conditions: {
            lightMode: 'color_background_blue.600_lightMode__1q1dxs8am',
            darkMode: 'color_background_blue.600_darkMode__1q1dxs8an'
          },
          defaultClass: 'color_background_blue.600_lightMode__1q1dxs8am'
        },
        'blue.700': {
          conditions: {
            lightMode: 'color_background_blue.700_lightMode__1q1dxs8ao',
            darkMode: 'color_background_blue.700_darkMode__1q1dxs8ap'
          },
          defaultClass: 'color_background_blue.700_lightMode__1q1dxs8ao'
        },
        'blue.800': {
          conditions: {
            lightMode: 'color_background_blue.800_lightMode__1q1dxs8aq',
            darkMode: 'color_background_blue.800_darkMode__1q1dxs8ar'
          },
          defaultClass: 'color_background_blue.800_lightMode__1q1dxs8aq'
        },
        'blue.900': {
          conditions: {
            lightMode: 'color_background_blue.900_lightMode__1q1dxs8as',
            darkMode: 'color_background_blue.900_darkMode__1q1dxs8at'
          },
          defaultClass: 'color_background_blue.900_lightMode__1q1dxs8as'
        },
        'blue.950': {
          conditions: {
            lightMode: 'color_background_blue.950_lightMode__1q1dxs8au',
            darkMode: 'color_background_blue.950_darkMode__1q1dxs8av'
          },
          defaultClass: 'color_background_blue.950_lightMode__1q1dxs8au'
        },
        'purple.50': {
          conditions: {
            lightMode: 'color_background_purple.50_lightMode__1q1dxs8aw',
            darkMode: 'color_background_purple.50_darkMode__1q1dxs8ax'
          },
          defaultClass: 'color_background_purple.50_lightMode__1q1dxs8aw'
        },
        'purple.100': {
          conditions: {
            lightMode: 'color_background_purple.100_lightMode__1q1dxs8ay',
            darkMode: 'color_background_purple.100_darkMode__1q1dxs8az'
          },
          defaultClass: 'color_background_purple.100_lightMode__1q1dxs8ay'
        },
        'purple.200': {
          conditions: {
            lightMode: 'color_background_purple.200_lightMode__1q1dxs8b0',
            darkMode: 'color_background_purple.200_darkMode__1q1dxs8b1'
          },
          defaultClass: 'color_background_purple.200_lightMode__1q1dxs8b0'
        },
        'purple.300': {
          conditions: {
            lightMode: 'color_background_purple.300_lightMode__1q1dxs8b2',
            darkMode: 'color_background_purple.300_darkMode__1q1dxs8b3'
          },
          defaultClass: 'color_background_purple.300_lightMode__1q1dxs8b2'
        },
        'purple.400': {
          conditions: {
            lightMode: 'color_background_purple.400_lightMode__1q1dxs8b4',
            darkMode: 'color_background_purple.400_darkMode__1q1dxs8b5'
          },
          defaultClass: 'color_background_purple.400_lightMode__1q1dxs8b4'
        },
        'purple.500': {
          conditions: {
            lightMode: 'color_background_purple.500_lightMode__1q1dxs8b6',
            darkMode: 'color_background_purple.500_darkMode__1q1dxs8b7'
          },
          defaultClass: 'color_background_purple.500_lightMode__1q1dxs8b6'
        },
        'purple.600': {
          conditions: {
            lightMode: 'color_background_purple.600_lightMode__1q1dxs8b8',
            darkMode: 'color_background_purple.600_darkMode__1q1dxs8b9'
          },
          defaultClass: 'color_background_purple.600_lightMode__1q1dxs8b8'
        },
        'purple.700': {
          conditions: {
            lightMode: 'color_background_purple.700_lightMode__1q1dxs8ba',
            darkMode: 'color_background_purple.700_darkMode__1q1dxs8bb'
          },
          defaultClass: 'color_background_purple.700_lightMode__1q1dxs8ba'
        },
        'purple.800': {
          conditions: {
            lightMode: 'color_background_purple.800_lightMode__1q1dxs8bc',
            darkMode: 'color_background_purple.800_darkMode__1q1dxs8bd'
          },
          defaultClass: 'color_background_purple.800_lightMode__1q1dxs8bc'
        },
        'purple.900': {
          conditions: {
            lightMode: 'color_background_purple.900_lightMode__1q1dxs8be',
            darkMode: 'color_background_purple.900_darkMode__1q1dxs8bf'
          },
          defaultClass: 'color_background_purple.900_lightMode__1q1dxs8be'
        },
        'purple.950': {
          conditions: {
            lightMode: 'color_background_purple.950_lightMode__1q1dxs8bg',
            darkMode: 'color_background_purple.950_darkMode__1q1dxs8bh'
          },
          defaultClass: 'color_background_purple.950_lightMode__1q1dxs8bg'
        },
        'feedback.danger': {
          conditions: {
            lightMode: 'color_background_feedback.danger_lightMode__1q1dxs8bi',
            darkMode: 'color_background_feedback.danger_darkMode__1q1dxs8bj'
          },
          defaultClass: 'color_background_feedback.danger_lightMode__1q1dxs8bi'
        },
        'feedback.warning': {
          conditions: {
            lightMode: 'color_background_feedback.warning_lightMode__1q1dxs8bk',
            darkMode: 'color_background_feedback.warning_darkMode__1q1dxs8bl'
          },
          defaultClass: 'color_background_feedback.warning_lightMode__1q1dxs8bk'
        },
        'feedback.success': {
          conditions: {
            lightMode: 'color_background_feedback.success_lightMode__1q1dxs8bm',
            darkMode: 'color_background_feedback.success_darkMode__1q1dxs8bn'
          },
          defaultClass: 'color_background_feedback.success_lightMode__1q1dxs8bm'
        },
        'feedback.info': {
          conditions: {
            lightMode: 'color_background_feedback.info_lightMode__1q1dxs8bo',
            darkMode: 'color_background_feedback.info_darkMode__1q1dxs8bp'
          },
          defaultClass: 'color_background_feedback.info_lightMode__1q1dxs8bo'
        },
        'feedback.neutral': {
          conditions: {
            lightMode: 'color_background_feedback.neutral_lightMode__1q1dxs8bq',
            darkMode: 'color_background_feedback.neutral_darkMode__1q1dxs8br'
          },
          defaultClass: 'color_background_feedback.neutral_lightMode__1q1dxs8bq'
        },
        'text.300': {
          conditions: {
            lightMode: 'color_background_text.300_lightMode__1q1dxs8bs',
            darkMode: 'color_background_text.300_darkMode__1q1dxs8bt'
          },
          defaultClass: 'color_background_text.300_lightMode__1q1dxs8bs'
        },
        'text.500': {
          conditions: {
            lightMode: 'color_background_text.500_lightMode__1q1dxs8bu',
            darkMode: 'color_background_text.500_darkMode__1q1dxs8bv'
          },
          defaultClass: 'color_background_text.500_lightMode__1q1dxs8bu'
        },
        'text.600': {
          conditions: {
            lightMode: 'color_background_text.600_lightMode__1q1dxs8bw',
            darkMode: 'color_background_text.600_darkMode__1q1dxs8bx'
          },
          defaultClass: 'color_background_text.600_lightMode__1q1dxs8bw'
        },
        'text.700': {
          conditions: {
            lightMode: 'color_background_text.700_lightMode__1q1dxs8by',
            darkMode: 'color_background_text.700_darkMode__1q1dxs8bz'
          },
          defaultClass: 'color_background_text.700_lightMode__1q1dxs8by'
        },
        'text.800': {
          conditions: {
            lightMode: 'color_background_text.800_lightMode__1q1dxs8c0',
            darkMode: 'color_background_text.800_darkMode__1q1dxs8c1'
          },
          defaultClass: 'color_background_text.800_lightMode__1q1dxs8c0'
        },
        'text.primary': {
          conditions: {
            lightMode: 'color_background_text.primary_lightMode__1q1dxs8c2',
            darkMode: 'color_background_text.primary_darkMode__1q1dxs8c3'
          },
          defaultClass: 'color_background_text.primary_lightMode__1q1dxs8c2'
        },
        'text.secondary': {
          conditions: {
            lightMode: 'color_background_text.secondary_lightMode__1q1dxs8c4',
            darkMode: 'color_background_text.secondary_darkMode__1q1dxs8c5'
          },
          defaultClass: 'color_background_text.secondary_lightMode__1q1dxs8c4'
        },
        'text.caption': {
          conditions: {
            lightMode: 'color_background_text.caption_lightMode__1q1dxs8c6',
            darkMode: 'color_background_text.caption_darkMode__1q1dxs8c7'
          },
          defaultClass: 'color_background_text.caption_lightMode__1q1dxs8c6'
        },
        'text.description': {
          conditions: {
            lightMode: 'color_background_text.description_lightMode__1q1dxs8c8',
            darkMode: 'color_background_text.description_darkMode__1q1dxs8c9'
          },
          defaultClass: 'color_background_text.description_lightMode__1q1dxs8c8'
        },
        'text.description2': {
          conditions: {
            lightMode: 'color_background_text.description2_lightMode__1q1dxs8ca',
            darkMode: 'color_background_text.description2_darkMode__1q1dxs8cb'
          },
          defaultClass: 'color_background_text.description2_lightMode__1q1dxs8ca'
        },
        'text.disabled': {
          conditions: {
            lightMode: 'color_background_text.disabled_lightMode__1q1dxs8cc',
            darkMode: 'color_background_text.disabled_darkMode__1q1dxs8cd'
          },
          defaultClass: 'color_background_text.disabled_lightMode__1q1dxs8cc'
        },
        'text.translation': {
          conditions: {
            lightMode: 'color_background_text.translation_lightMode__1q1dxs8ce',
            darkMode: 'color_background_text.translation_darkMode__1q1dxs8cf'
          },
          defaultClass: 'color_background_text.translation_lightMode__1q1dxs8ce'
        },
        'text.info': {
          conditions: {
            lightMode: 'color_background_text.info_lightMode__1q1dxs8cg',
            darkMode: 'color_background_text.info_darkMode__1q1dxs8ch'
          },
          defaultClass: 'color_background_text.info_lightMode__1q1dxs8cg'
        },
        'text.success': {
          conditions: {
            lightMode: 'color_background_text.success_lightMode__1q1dxs8ci',
            darkMode: 'color_background_text.success_darkMode__1q1dxs8cj'
          },
          defaultClass: 'color_background_text.success_lightMode__1q1dxs8ci'
        },
        'text.danger': {
          conditions: {
            lightMode: 'color_background_text.danger_lightMode__1q1dxs8ck',
            darkMode: 'color_background_text.danger_darkMode__1q1dxs8cl'
          },
          defaultClass: 'color_background_text.danger_lightMode__1q1dxs8ck'
        },
        'text.01': {
          conditions: {
            lightMode: 'color_background_text.01_lightMode__1q1dxs8cm',
            darkMode: 'color_background_text.01_darkMode__1q1dxs8cn'
          },
          defaultClass: 'color_background_text.01_lightMode__1q1dxs8cm'
        },
        'text.02': {
          conditions: {
            lightMode: 'color_background_text.02_lightMode__1q1dxs8co',
            darkMode: 'color_background_text.02_darkMode__1q1dxs8cp'
          },
          defaultClass: 'color_background_text.02_lightMode__1q1dxs8co'
        },
        'text.03': {
          conditions: {
            lightMode: 'color_background_text.03_lightMode__1q1dxs8cq',
            darkMode: 'color_background_text.03_darkMode__1q1dxs8cr'
          },
          defaultClass: 'color_background_text.03_lightMode__1q1dxs8cq'
        },
        'background.gray': {
          conditions: {
            lightMode: 'color_background_background.gray_lightMode__1q1dxs8cs',
            darkMode: 'color_background_background.gray_darkMode__1q1dxs8ct'
          },
          defaultClass: 'color_background_background.gray_lightMode__1q1dxs8cs'
        },
        'background.grayBold': {
          conditions: {
            lightMode: 'color_background_background.grayBold_lightMode__1q1dxs8cu',
            darkMode: 'color_background_background.grayBold_darkMode__1q1dxs8cv'
          },
          defaultClass: 'color_background_background.grayBold_lightMode__1q1dxs8cu'
        },
        'background.disabled': {
          conditions: {
            lightMode: 'color_background_background.disabled_lightMode__1q1dxs8cw',
            darkMode: 'color_background_background.disabled_darkMode__1q1dxs8cx'
          },
          defaultClass: 'color_background_background.disabled_lightMode__1q1dxs8cw'
        },
        'border.muted': {
          conditions: {
            lightMode: 'color_background_border.muted_lightMode__1q1dxs8cy',
            darkMode: 'color_background_border.muted_darkMode__1q1dxs8cz'
          },
          defaultClass: 'color_background_border.muted_lightMode__1q1dxs8cy'
        },
        'border.normal': {
          conditions: {
            lightMode: 'color_background_border.normal_lightMode__1q1dxs8d0',
            darkMode: 'color_background_border.normal_darkMode__1q1dxs8d1'
          },
          defaultClass: 'color_background_border.normal_lightMode__1q1dxs8d0'
        },
        'border.bold': {
          conditions: {
            lightMode: 'color_background_border.bold_lightMode__1q1dxs8d2',
            darkMode: 'color_background_border.bold_darkMode__1q1dxs8d3'
          },
          defaultClass: 'color_background_border.bold_lightMode__1q1dxs8d2'
        }
      }
    },
    borderColor: {
      values: {
        'gray.50': {
          conditions: {
            lightMode: 'color_borderColor_gray.50_lightMode__1q1dxs8d4',
            darkMode: 'color_borderColor_gray.50_darkMode__1q1dxs8d5'
          },
          defaultClass: 'color_borderColor_gray.50_lightMode__1q1dxs8d4'
        },
        'gray.80': {
          conditions: {
            lightMode: 'color_borderColor_gray.80_lightMode__1q1dxs8d6',
            darkMode: 'color_borderColor_gray.80_darkMode__1q1dxs8d7'
          },
          defaultClass: 'color_borderColor_gray.80_lightMode__1q1dxs8d6'
        },
        'gray.100': {
          conditions: {
            lightMode: 'color_borderColor_gray.100_lightMode__1q1dxs8d8',
            darkMode: 'color_borderColor_gray.100_darkMode__1q1dxs8d9'
          },
          defaultClass: 'color_borderColor_gray.100_lightMode__1q1dxs8d8'
        },
        'gray.200': {
          conditions: {
            lightMode: 'color_borderColor_gray.200_lightMode__1q1dxs8da',
            darkMode: 'color_borderColor_gray.200_darkMode__1q1dxs8db'
          },
          defaultClass: 'color_borderColor_gray.200_lightMode__1q1dxs8da'
        },
        'gray.300': {
          conditions: {
            lightMode: 'color_borderColor_gray.300_lightMode__1q1dxs8dc',
            darkMode: 'color_borderColor_gray.300_darkMode__1q1dxs8dd'
          },
          defaultClass: 'color_borderColor_gray.300_lightMode__1q1dxs8dc'
        },
        'gray.400': {
          conditions: {
            lightMode: 'color_borderColor_gray.400_lightMode__1q1dxs8de',
            darkMode: 'color_borderColor_gray.400_darkMode__1q1dxs8df'
          },
          defaultClass: 'color_borderColor_gray.400_lightMode__1q1dxs8de'
        },
        'gray.500': {
          conditions: {
            lightMode: 'color_borderColor_gray.500_lightMode__1q1dxs8dg',
            darkMode: 'color_borderColor_gray.500_darkMode__1q1dxs8dh'
          },
          defaultClass: 'color_borderColor_gray.500_lightMode__1q1dxs8dg'
        },
        'gray.600': {
          conditions: {
            lightMode: 'color_borderColor_gray.600_lightMode__1q1dxs8di',
            darkMode: 'color_borderColor_gray.600_darkMode__1q1dxs8dj'
          },
          defaultClass: 'color_borderColor_gray.600_lightMode__1q1dxs8di'
        },
        'gray.700': {
          conditions: {
            lightMode: 'color_borderColor_gray.700_lightMode__1q1dxs8dk',
            darkMode: 'color_borderColor_gray.700_darkMode__1q1dxs8dl'
          },
          defaultClass: 'color_borderColor_gray.700_lightMode__1q1dxs8dk'
        },
        'gray.750': {
          conditions: {
            lightMode: 'color_borderColor_gray.750_lightMode__1q1dxs8dm',
            darkMode: 'color_borderColor_gray.750_darkMode__1q1dxs8dn'
          },
          defaultClass: 'color_borderColor_gray.750_lightMode__1q1dxs8dm'
        },
        'gray.800': {
          conditions: {
            lightMode: 'color_borderColor_gray.800_lightMode__1q1dxs8do',
            darkMode: 'color_borderColor_gray.800_darkMode__1q1dxs8dp'
          },
          defaultClass: 'color_borderColor_gray.800_lightMode__1q1dxs8do'
        },
        'gray.900': {
          conditions: {
            lightMode: 'color_borderColor_gray.900_lightMode__1q1dxs8dq',
            darkMode: 'color_borderColor_gray.900_darkMode__1q1dxs8dr'
          },
          defaultClass: 'color_borderColor_gray.900_lightMode__1q1dxs8dq'
        },
        'zinc.50': {
          conditions: {
            lightMode: 'color_borderColor_zinc.50_lightMode__1q1dxs8ds',
            darkMode: 'color_borderColor_zinc.50_darkMode__1q1dxs8dt'
          },
          defaultClass: 'color_borderColor_zinc.50_lightMode__1q1dxs8ds'
        },
        'zinc.100': {
          conditions: {
            lightMode: 'color_borderColor_zinc.100_lightMode__1q1dxs8du',
            darkMode: 'color_borderColor_zinc.100_darkMode__1q1dxs8dv'
          },
          defaultClass: 'color_borderColor_zinc.100_lightMode__1q1dxs8du'
        },
        'zinc.200': {
          conditions: {
            lightMode: 'color_borderColor_zinc.200_lightMode__1q1dxs8dw',
            darkMode: 'color_borderColor_zinc.200_darkMode__1q1dxs8dx'
          },
          defaultClass: 'color_borderColor_zinc.200_lightMode__1q1dxs8dw'
        },
        'zinc.300': {
          conditions: {
            lightMode: 'color_borderColor_zinc.300_lightMode__1q1dxs8dy',
            darkMode: 'color_borderColor_zinc.300_darkMode__1q1dxs8dz'
          },
          defaultClass: 'color_borderColor_zinc.300_lightMode__1q1dxs8dy'
        },
        'zinc.400': {
          conditions: {
            lightMode: 'color_borderColor_zinc.400_lightMode__1q1dxs8e0',
            darkMode: 'color_borderColor_zinc.400_darkMode__1q1dxs8e1'
          },
          defaultClass: 'color_borderColor_zinc.400_lightMode__1q1dxs8e0'
        },
        'zinc.500': {
          conditions: {
            lightMode: 'color_borderColor_zinc.500_lightMode__1q1dxs8e2',
            darkMode: 'color_borderColor_zinc.500_darkMode__1q1dxs8e3'
          },
          defaultClass: 'color_borderColor_zinc.500_lightMode__1q1dxs8e2'
        },
        'zinc.600': {
          conditions: {
            lightMode: 'color_borderColor_zinc.600_lightMode__1q1dxs8e4',
            darkMode: 'color_borderColor_zinc.600_darkMode__1q1dxs8e5'
          },
          defaultClass: 'color_borderColor_zinc.600_lightMode__1q1dxs8e4'
        },
        'zinc.700': {
          conditions: {
            lightMode: 'color_borderColor_zinc.700_lightMode__1q1dxs8e6',
            darkMode: 'color_borderColor_zinc.700_darkMode__1q1dxs8e7'
          },
          defaultClass: 'color_borderColor_zinc.700_lightMode__1q1dxs8e6'
        },
        'zinc.800': {
          conditions: {
            lightMode: 'color_borderColor_zinc.800_lightMode__1q1dxs8e8',
            darkMode: 'color_borderColor_zinc.800_darkMode__1q1dxs8e9'
          },
          defaultClass: 'color_borderColor_zinc.800_lightMode__1q1dxs8e8'
        },
        'zinc.900': {
          conditions: {
            lightMode: 'color_borderColor_zinc.900_lightMode__1q1dxs8ea',
            darkMode: 'color_borderColor_zinc.900_darkMode__1q1dxs8eb'
          },
          defaultClass: 'color_borderColor_zinc.900_lightMode__1q1dxs8ea'
        },
        'zinc.950': {
          conditions: {
            lightMode: 'color_borderColor_zinc.950_lightMode__1q1dxs8ec',
            darkMode: 'color_borderColor_zinc.950_darkMode__1q1dxs8ed'
          },
          defaultClass: 'color_borderColor_zinc.950_lightMode__1q1dxs8ec'
        },
        'primary.50': {
          conditions: {
            lightMode: 'color_borderColor_primary.50_lightMode__1q1dxs8ee',
            darkMode: 'color_borderColor_primary.50_darkMode__1q1dxs8ef'
          },
          defaultClass: 'color_borderColor_primary.50_lightMode__1q1dxs8ee'
        },
        'primary.100': {
          conditions: {
            lightMode: 'color_borderColor_primary.100_lightMode__1q1dxs8eg',
            darkMode: 'color_borderColor_primary.100_darkMode__1q1dxs8eh'
          },
          defaultClass: 'color_borderColor_primary.100_lightMode__1q1dxs8eg'
        },
        'primary.200': {
          conditions: {
            lightMode: 'color_borderColor_primary.200_lightMode__1q1dxs8ei',
            darkMode: 'color_borderColor_primary.200_darkMode__1q1dxs8ej'
          },
          defaultClass: 'color_borderColor_primary.200_lightMode__1q1dxs8ei'
        },
        'primary.300': {
          conditions: {
            lightMode: 'color_borderColor_primary.300_lightMode__1q1dxs8ek',
            darkMode: 'color_borderColor_primary.300_darkMode__1q1dxs8el'
          },
          defaultClass: 'color_borderColor_primary.300_lightMode__1q1dxs8ek'
        },
        'primary.400': {
          conditions: {
            lightMode: 'color_borderColor_primary.400_lightMode__1q1dxs8em',
            darkMode: 'color_borderColor_primary.400_darkMode__1q1dxs8en'
          },
          defaultClass: 'color_borderColor_primary.400_lightMode__1q1dxs8em'
        },
        'primary.500': {
          conditions: {
            lightMode: 'color_borderColor_primary.500_lightMode__1q1dxs8eo',
            darkMode: 'color_borderColor_primary.500_darkMode__1q1dxs8ep'
          },
          defaultClass: 'color_borderColor_primary.500_lightMode__1q1dxs8eo'
        },
        'primary.600': {
          conditions: {
            lightMode: 'color_borderColor_primary.600_lightMode__1q1dxs8eq',
            darkMode: 'color_borderColor_primary.600_darkMode__1q1dxs8er'
          },
          defaultClass: 'color_borderColor_primary.600_lightMode__1q1dxs8eq'
        },
        'primary.700': {
          conditions: {
            lightMode: 'color_borderColor_primary.700_lightMode__1q1dxs8es',
            darkMode: 'color_borderColor_primary.700_darkMode__1q1dxs8et'
          },
          defaultClass: 'color_borderColor_primary.700_lightMode__1q1dxs8es'
        },
        'primary.800': {
          conditions: {
            lightMode: 'color_borderColor_primary.800_lightMode__1q1dxs8eu',
            darkMode: 'color_borderColor_primary.800_darkMode__1q1dxs8ev'
          },
          defaultClass: 'color_borderColor_primary.800_lightMode__1q1dxs8eu'
        },
        'primary.900': {
          conditions: {
            lightMode: 'color_borderColor_primary.900_lightMode__1q1dxs8ew',
            darkMode: 'color_borderColor_primary.900_darkMode__1q1dxs8ex'
          },
          defaultClass: 'color_borderColor_primary.900_lightMode__1q1dxs8ew'
        },
        'primary.950': {
          conditions: {
            lightMode: 'color_borderColor_primary.950_lightMode__1q1dxs8ey',
            darkMode: 'color_borderColor_primary.950_darkMode__1q1dxs8ez'
          },
          defaultClass: 'color_borderColor_primary.950_lightMode__1q1dxs8ey'
        },
        'red.50': {
          conditions: {
            lightMode: 'color_borderColor_red.50_lightMode__1q1dxs8f0',
            darkMode: 'color_borderColor_red.50_darkMode__1q1dxs8f1'
          },
          defaultClass: 'color_borderColor_red.50_lightMode__1q1dxs8f0'
        },
        'red.100': {
          conditions: {
            lightMode: 'color_borderColor_red.100_lightMode__1q1dxs8f2',
            darkMode: 'color_borderColor_red.100_darkMode__1q1dxs8f3'
          },
          defaultClass: 'color_borderColor_red.100_lightMode__1q1dxs8f2'
        },
        'red.200': {
          conditions: {
            lightMode: 'color_borderColor_red.200_lightMode__1q1dxs8f4',
            darkMode: 'color_borderColor_red.200_darkMode__1q1dxs8f5'
          },
          defaultClass: 'color_borderColor_red.200_lightMode__1q1dxs8f4'
        },
        'red.300': {
          conditions: {
            lightMode: 'color_borderColor_red.300_lightMode__1q1dxs8f6',
            darkMode: 'color_borderColor_red.300_darkMode__1q1dxs8f7'
          },
          defaultClass: 'color_borderColor_red.300_lightMode__1q1dxs8f6'
        },
        'red.400': {
          conditions: {
            lightMode: 'color_borderColor_red.400_lightMode__1q1dxs8f8',
            darkMode: 'color_borderColor_red.400_darkMode__1q1dxs8f9'
          },
          defaultClass: 'color_borderColor_red.400_lightMode__1q1dxs8f8'
        },
        'red.500': {
          conditions: {
            lightMode: 'color_borderColor_red.500_lightMode__1q1dxs8fa',
            darkMode: 'color_borderColor_red.500_darkMode__1q1dxs8fb'
          },
          defaultClass: 'color_borderColor_red.500_lightMode__1q1dxs8fa'
        },
        'red.600': {
          conditions: {
            lightMode: 'color_borderColor_red.600_lightMode__1q1dxs8fc',
            darkMode: 'color_borderColor_red.600_darkMode__1q1dxs8fd'
          },
          defaultClass: 'color_borderColor_red.600_lightMode__1q1dxs8fc'
        },
        'red.700': {
          conditions: {
            lightMode: 'color_borderColor_red.700_lightMode__1q1dxs8fe',
            darkMode: 'color_borderColor_red.700_darkMode__1q1dxs8ff'
          },
          defaultClass: 'color_borderColor_red.700_lightMode__1q1dxs8fe'
        },
        'red.800': {
          conditions: {
            lightMode: 'color_borderColor_red.800_lightMode__1q1dxs8fg',
            darkMode: 'color_borderColor_red.800_darkMode__1q1dxs8fh'
          },
          defaultClass: 'color_borderColor_red.800_lightMode__1q1dxs8fg'
        },
        'red.900': {
          conditions: {
            lightMode: 'color_borderColor_red.900_lightMode__1q1dxs8fi',
            darkMode: 'color_borderColor_red.900_darkMode__1q1dxs8fj'
          },
          defaultClass: 'color_borderColor_red.900_lightMode__1q1dxs8fi'
        },
        'red.950': {
          conditions: {
            lightMode: 'color_borderColor_red.950_lightMode__1q1dxs8fk',
            darkMode: 'color_borderColor_red.950_darkMode__1q1dxs8fl'
          },
          defaultClass: 'color_borderColor_red.950_lightMode__1q1dxs8fk'
        },
        'yellow.50': {
          conditions: {
            lightMode: 'color_borderColor_yellow.50_lightMode__1q1dxs8fm',
            darkMode: 'color_borderColor_yellow.50_darkMode__1q1dxs8fn'
          },
          defaultClass: 'color_borderColor_yellow.50_lightMode__1q1dxs8fm'
        },
        'yellow.100': {
          conditions: {
            lightMode: 'color_borderColor_yellow.100_lightMode__1q1dxs8fo',
            darkMode: 'color_borderColor_yellow.100_darkMode__1q1dxs8fp'
          },
          defaultClass: 'color_borderColor_yellow.100_lightMode__1q1dxs8fo'
        },
        'yellow.200': {
          conditions: {
            lightMode: 'color_borderColor_yellow.200_lightMode__1q1dxs8fq',
            darkMode: 'color_borderColor_yellow.200_darkMode__1q1dxs8fr'
          },
          defaultClass: 'color_borderColor_yellow.200_lightMode__1q1dxs8fq'
        },
        'yellow.300': {
          conditions: {
            lightMode: 'color_borderColor_yellow.300_lightMode__1q1dxs8fs',
            darkMode: 'color_borderColor_yellow.300_darkMode__1q1dxs8ft'
          },
          defaultClass: 'color_borderColor_yellow.300_lightMode__1q1dxs8fs'
        },
        'yellow.400': {
          conditions: {
            lightMode: 'color_borderColor_yellow.400_lightMode__1q1dxs8fu',
            darkMode: 'color_borderColor_yellow.400_darkMode__1q1dxs8fv'
          },
          defaultClass: 'color_borderColor_yellow.400_lightMode__1q1dxs8fu'
        },
        'yellow.500': {
          conditions: {
            lightMode: 'color_borderColor_yellow.500_lightMode__1q1dxs8fw',
            darkMode: 'color_borderColor_yellow.500_darkMode__1q1dxs8fx'
          },
          defaultClass: 'color_borderColor_yellow.500_lightMode__1q1dxs8fw'
        },
        'yellow.600': {
          conditions: {
            lightMode: 'color_borderColor_yellow.600_lightMode__1q1dxs8fy',
            darkMode: 'color_borderColor_yellow.600_darkMode__1q1dxs8fz'
          },
          defaultClass: 'color_borderColor_yellow.600_lightMode__1q1dxs8fy'
        },
        'yellow.700': {
          conditions: {
            lightMode: 'color_borderColor_yellow.700_lightMode__1q1dxs8g0',
            darkMode: 'color_borderColor_yellow.700_darkMode__1q1dxs8g1'
          },
          defaultClass: 'color_borderColor_yellow.700_lightMode__1q1dxs8g0'
        },
        'yellow.800': {
          conditions: {
            lightMode: 'color_borderColor_yellow.800_lightMode__1q1dxs8g2',
            darkMode: 'color_borderColor_yellow.800_darkMode__1q1dxs8g3'
          },
          defaultClass: 'color_borderColor_yellow.800_lightMode__1q1dxs8g2'
        },
        'yellow.900': {
          conditions: {
            lightMode: 'color_borderColor_yellow.900_lightMode__1q1dxs8g4',
            darkMode: 'color_borderColor_yellow.900_darkMode__1q1dxs8g5'
          },
          defaultClass: 'color_borderColor_yellow.900_lightMode__1q1dxs8g4'
        },
        'yellow.950': {
          conditions: {
            lightMode: 'color_borderColor_yellow.950_lightMode__1q1dxs8g6',
            darkMode: 'color_borderColor_yellow.950_darkMode__1q1dxs8g7'
          },
          defaultClass: 'color_borderColor_yellow.950_lightMode__1q1dxs8g6'
        },
        'green.50': {
          conditions: {
            lightMode: 'color_borderColor_green.50_lightMode__1q1dxs8g8',
            darkMode: 'color_borderColor_green.50_darkMode__1q1dxs8g9'
          },
          defaultClass: 'color_borderColor_green.50_lightMode__1q1dxs8g8'
        },
        'green.100': {
          conditions: {
            lightMode: 'color_borderColor_green.100_lightMode__1q1dxs8ga',
            darkMode: 'color_borderColor_green.100_darkMode__1q1dxs8gb'
          },
          defaultClass: 'color_borderColor_green.100_lightMode__1q1dxs8ga'
        },
        'green.200': {
          conditions: {
            lightMode: 'color_borderColor_green.200_lightMode__1q1dxs8gc',
            darkMode: 'color_borderColor_green.200_darkMode__1q1dxs8gd'
          },
          defaultClass: 'color_borderColor_green.200_lightMode__1q1dxs8gc'
        },
        'green.300': {
          conditions: {
            lightMode: 'color_borderColor_green.300_lightMode__1q1dxs8ge',
            darkMode: 'color_borderColor_green.300_darkMode__1q1dxs8gf'
          },
          defaultClass: 'color_borderColor_green.300_lightMode__1q1dxs8ge'
        },
        'green.400': {
          conditions: {
            lightMode: 'color_borderColor_green.400_lightMode__1q1dxs8gg',
            darkMode: 'color_borderColor_green.400_darkMode__1q1dxs8gh'
          },
          defaultClass: 'color_borderColor_green.400_lightMode__1q1dxs8gg'
        },
        'green.500': {
          conditions: {
            lightMode: 'color_borderColor_green.500_lightMode__1q1dxs8gi',
            darkMode: 'color_borderColor_green.500_darkMode__1q1dxs8gj'
          },
          defaultClass: 'color_borderColor_green.500_lightMode__1q1dxs8gi'
        },
        'green.600': {
          conditions: {
            lightMode: 'color_borderColor_green.600_lightMode__1q1dxs8gk',
            darkMode: 'color_borderColor_green.600_darkMode__1q1dxs8gl'
          },
          defaultClass: 'color_borderColor_green.600_lightMode__1q1dxs8gk'
        },
        'green.700': {
          conditions: {
            lightMode: 'color_borderColor_green.700_lightMode__1q1dxs8gm',
            darkMode: 'color_borderColor_green.700_darkMode__1q1dxs8gn'
          },
          defaultClass: 'color_borderColor_green.700_lightMode__1q1dxs8gm'
        },
        'green.800': {
          conditions: {
            lightMode: 'color_borderColor_green.800_lightMode__1q1dxs8go',
            darkMode: 'color_borderColor_green.800_darkMode__1q1dxs8gp'
          },
          defaultClass: 'color_borderColor_green.800_lightMode__1q1dxs8go'
        },
        'green.900': {
          conditions: {
            lightMode: 'color_borderColor_green.900_lightMode__1q1dxs8gq',
            darkMode: 'color_borderColor_green.900_darkMode__1q1dxs8gr'
          },
          defaultClass: 'color_borderColor_green.900_lightMode__1q1dxs8gq'
        },
        'green.950': {
          conditions: {
            lightMode: 'color_borderColor_green.950_lightMode__1q1dxs8gs',
            darkMode: 'color_borderColor_green.950_darkMode__1q1dxs8gt'
          },
          defaultClass: 'color_borderColor_green.950_lightMode__1q1dxs8gs'
        },
        'blue.50': {
          conditions: {
            lightMode: 'color_borderColor_blue.50_lightMode__1q1dxs8gu',
            darkMode: 'color_borderColor_blue.50_darkMode__1q1dxs8gv'
          },
          defaultClass: 'color_borderColor_blue.50_lightMode__1q1dxs8gu'
        },
        'blue.100': {
          conditions: {
            lightMode: 'color_borderColor_blue.100_lightMode__1q1dxs8gw',
            darkMode: 'color_borderColor_blue.100_darkMode__1q1dxs8gx'
          },
          defaultClass: 'color_borderColor_blue.100_lightMode__1q1dxs8gw'
        },
        'blue.200': {
          conditions: {
            lightMode: 'color_borderColor_blue.200_lightMode__1q1dxs8gy',
            darkMode: 'color_borderColor_blue.200_darkMode__1q1dxs8gz'
          },
          defaultClass: 'color_borderColor_blue.200_lightMode__1q1dxs8gy'
        },
        'blue.300': {
          conditions: {
            lightMode: 'color_borderColor_blue.300_lightMode__1q1dxs8h0',
            darkMode: 'color_borderColor_blue.300_darkMode__1q1dxs8h1'
          },
          defaultClass: 'color_borderColor_blue.300_lightMode__1q1dxs8h0'
        },
        'blue.400': {
          conditions: {
            lightMode: 'color_borderColor_blue.400_lightMode__1q1dxs8h2',
            darkMode: 'color_borderColor_blue.400_darkMode__1q1dxs8h3'
          },
          defaultClass: 'color_borderColor_blue.400_lightMode__1q1dxs8h2'
        },
        'blue.500': {
          conditions: {
            lightMode: 'color_borderColor_blue.500_lightMode__1q1dxs8h4',
            darkMode: 'color_borderColor_blue.500_darkMode__1q1dxs8h5'
          },
          defaultClass: 'color_borderColor_blue.500_lightMode__1q1dxs8h4'
        },
        'blue.600': {
          conditions: {
            lightMode: 'color_borderColor_blue.600_lightMode__1q1dxs8h6',
            darkMode: 'color_borderColor_blue.600_darkMode__1q1dxs8h7'
          },
          defaultClass: 'color_borderColor_blue.600_lightMode__1q1dxs8h6'
        },
        'blue.700': {
          conditions: {
            lightMode: 'color_borderColor_blue.700_lightMode__1q1dxs8h8',
            darkMode: 'color_borderColor_blue.700_darkMode__1q1dxs8h9'
          },
          defaultClass: 'color_borderColor_blue.700_lightMode__1q1dxs8h8'
        },
        'blue.800': {
          conditions: {
            lightMode: 'color_borderColor_blue.800_lightMode__1q1dxs8ha',
            darkMode: 'color_borderColor_blue.800_darkMode__1q1dxs8hb'
          },
          defaultClass: 'color_borderColor_blue.800_lightMode__1q1dxs8ha'
        },
        'blue.900': {
          conditions: {
            lightMode: 'color_borderColor_blue.900_lightMode__1q1dxs8hc',
            darkMode: 'color_borderColor_blue.900_darkMode__1q1dxs8hd'
          },
          defaultClass: 'color_borderColor_blue.900_lightMode__1q1dxs8hc'
        },
        'blue.950': {
          conditions: {
            lightMode: 'color_borderColor_blue.950_lightMode__1q1dxs8he',
            darkMode: 'color_borderColor_blue.950_darkMode__1q1dxs8hf'
          },
          defaultClass: 'color_borderColor_blue.950_lightMode__1q1dxs8he'
        },
        'purple.50': {
          conditions: {
            lightMode: 'color_borderColor_purple.50_lightMode__1q1dxs8hg',
            darkMode: 'color_borderColor_purple.50_darkMode__1q1dxs8hh'
          },
          defaultClass: 'color_borderColor_purple.50_lightMode__1q1dxs8hg'
        },
        'purple.100': {
          conditions: {
            lightMode: 'color_borderColor_purple.100_lightMode__1q1dxs8hi',
            darkMode: 'color_borderColor_purple.100_darkMode__1q1dxs8hj'
          },
          defaultClass: 'color_borderColor_purple.100_lightMode__1q1dxs8hi'
        },
        'purple.200': {
          conditions: {
            lightMode: 'color_borderColor_purple.200_lightMode__1q1dxs8hk',
            darkMode: 'color_borderColor_purple.200_darkMode__1q1dxs8hl'
          },
          defaultClass: 'color_borderColor_purple.200_lightMode__1q1dxs8hk'
        },
        'purple.300': {
          conditions: {
            lightMode: 'color_borderColor_purple.300_lightMode__1q1dxs8hm',
            darkMode: 'color_borderColor_purple.300_darkMode__1q1dxs8hn'
          },
          defaultClass: 'color_borderColor_purple.300_lightMode__1q1dxs8hm'
        },
        'purple.400': {
          conditions: {
            lightMode: 'color_borderColor_purple.400_lightMode__1q1dxs8ho',
            darkMode: 'color_borderColor_purple.400_darkMode__1q1dxs8hp'
          },
          defaultClass: 'color_borderColor_purple.400_lightMode__1q1dxs8ho'
        },
        'purple.500': {
          conditions: {
            lightMode: 'color_borderColor_purple.500_lightMode__1q1dxs8hq',
            darkMode: 'color_borderColor_purple.500_darkMode__1q1dxs8hr'
          },
          defaultClass: 'color_borderColor_purple.500_lightMode__1q1dxs8hq'
        },
        'purple.600': {
          conditions: {
            lightMode: 'color_borderColor_purple.600_lightMode__1q1dxs8hs',
            darkMode: 'color_borderColor_purple.600_darkMode__1q1dxs8ht'
          },
          defaultClass: 'color_borderColor_purple.600_lightMode__1q1dxs8hs'
        },
        'purple.700': {
          conditions: {
            lightMode: 'color_borderColor_purple.700_lightMode__1q1dxs8hu',
            darkMode: 'color_borderColor_purple.700_darkMode__1q1dxs8hv'
          },
          defaultClass: 'color_borderColor_purple.700_lightMode__1q1dxs8hu'
        },
        'purple.800': {
          conditions: {
            lightMode: 'color_borderColor_purple.800_lightMode__1q1dxs8hw',
            darkMode: 'color_borderColor_purple.800_darkMode__1q1dxs8hx'
          },
          defaultClass: 'color_borderColor_purple.800_lightMode__1q1dxs8hw'
        },
        'purple.900': {
          conditions: {
            lightMode: 'color_borderColor_purple.900_lightMode__1q1dxs8hy',
            darkMode: 'color_borderColor_purple.900_darkMode__1q1dxs8hz'
          },
          defaultClass: 'color_borderColor_purple.900_lightMode__1q1dxs8hy'
        },
        'purple.950': {
          conditions: {
            lightMode: 'color_borderColor_purple.950_lightMode__1q1dxs8i0',
            darkMode: 'color_borderColor_purple.950_darkMode__1q1dxs8i1'
          },
          defaultClass: 'color_borderColor_purple.950_lightMode__1q1dxs8i0'
        },
        'feedback.danger': {
          conditions: {
            lightMode: 'color_borderColor_feedback.danger_lightMode__1q1dxs8i2',
            darkMode: 'color_borderColor_feedback.danger_darkMode__1q1dxs8i3'
          },
          defaultClass: 'color_borderColor_feedback.danger_lightMode__1q1dxs8i2'
        },
        'feedback.warning': {
          conditions: {
            lightMode: 'color_borderColor_feedback.warning_lightMode__1q1dxs8i4',
            darkMode: 'color_borderColor_feedback.warning_darkMode__1q1dxs8i5'
          },
          defaultClass: 'color_borderColor_feedback.warning_lightMode__1q1dxs8i4'
        },
        'feedback.success': {
          conditions: {
            lightMode: 'color_borderColor_feedback.success_lightMode__1q1dxs8i6',
            darkMode: 'color_borderColor_feedback.success_darkMode__1q1dxs8i7'
          },
          defaultClass: 'color_borderColor_feedback.success_lightMode__1q1dxs8i6'
        },
        'feedback.info': {
          conditions: {
            lightMode: 'color_borderColor_feedback.info_lightMode__1q1dxs8i8',
            darkMode: 'color_borderColor_feedback.info_darkMode__1q1dxs8i9'
          },
          defaultClass: 'color_borderColor_feedback.info_lightMode__1q1dxs8i8'
        },
        'feedback.neutral': {
          conditions: {
            lightMode: 'color_borderColor_feedback.neutral_lightMode__1q1dxs8ia',
            darkMode: 'color_borderColor_feedback.neutral_darkMode__1q1dxs8ib'
          },
          defaultClass: 'color_borderColor_feedback.neutral_lightMode__1q1dxs8ia'
        },
        'text.300': {
          conditions: {
            lightMode: 'color_borderColor_text.300_lightMode__1q1dxs8ic',
            darkMode: 'color_borderColor_text.300_darkMode__1q1dxs8id'
          },
          defaultClass: 'color_borderColor_text.300_lightMode__1q1dxs8ic'
        },
        'text.500': {
          conditions: {
            lightMode: 'color_borderColor_text.500_lightMode__1q1dxs8ie',
            darkMode: 'color_borderColor_text.500_darkMode__1q1dxs8if'
          },
          defaultClass: 'color_borderColor_text.500_lightMode__1q1dxs8ie'
        },
        'text.600': {
          conditions: {
            lightMode: 'color_borderColor_text.600_lightMode__1q1dxs8ig',
            darkMode: 'color_borderColor_text.600_darkMode__1q1dxs8ih'
          },
          defaultClass: 'color_borderColor_text.600_lightMode__1q1dxs8ig'
        },
        'text.700': {
          conditions: {
            lightMode: 'color_borderColor_text.700_lightMode__1q1dxs8ii',
            darkMode: 'color_borderColor_text.700_darkMode__1q1dxs8ij'
          },
          defaultClass: 'color_borderColor_text.700_lightMode__1q1dxs8ii'
        },
        'text.800': {
          conditions: {
            lightMode: 'color_borderColor_text.800_lightMode__1q1dxs8ik',
            darkMode: 'color_borderColor_text.800_darkMode__1q1dxs8il'
          },
          defaultClass: 'color_borderColor_text.800_lightMode__1q1dxs8ik'
        },
        'text.primary': {
          conditions: {
            lightMode: 'color_borderColor_text.primary_lightMode__1q1dxs8im',
            darkMode: 'color_borderColor_text.primary_darkMode__1q1dxs8in'
          },
          defaultClass: 'color_borderColor_text.primary_lightMode__1q1dxs8im'
        },
        'text.secondary': {
          conditions: {
            lightMode: 'color_borderColor_text.secondary_lightMode__1q1dxs8io',
            darkMode: 'color_borderColor_text.secondary_darkMode__1q1dxs8ip'
          },
          defaultClass: 'color_borderColor_text.secondary_lightMode__1q1dxs8io'
        },
        'text.caption': {
          conditions: {
            lightMode: 'color_borderColor_text.caption_lightMode__1q1dxs8iq',
            darkMode: 'color_borderColor_text.caption_darkMode__1q1dxs8ir'
          },
          defaultClass: 'color_borderColor_text.caption_lightMode__1q1dxs8iq'
        },
        'text.description': {
          conditions: {
            lightMode: 'color_borderColor_text.description_lightMode__1q1dxs8is',
            darkMode: 'color_borderColor_text.description_darkMode__1q1dxs8it'
          },
          defaultClass: 'color_borderColor_text.description_lightMode__1q1dxs8is'
        },
        'text.description2': {
          conditions: {
            lightMode: 'color_borderColor_text.description2_lightMode__1q1dxs8iu',
            darkMode: 'color_borderColor_text.description2_darkMode__1q1dxs8iv'
          },
          defaultClass: 'color_borderColor_text.description2_lightMode__1q1dxs8iu'
        },
        'text.disabled': {
          conditions: {
            lightMode: 'color_borderColor_text.disabled_lightMode__1q1dxs8iw',
            darkMode: 'color_borderColor_text.disabled_darkMode__1q1dxs8ix'
          },
          defaultClass: 'color_borderColor_text.disabled_lightMode__1q1dxs8iw'
        },
        'text.translation': {
          conditions: {
            lightMode: 'color_borderColor_text.translation_lightMode__1q1dxs8iy',
            darkMode: 'color_borderColor_text.translation_darkMode__1q1dxs8iz'
          },
          defaultClass: 'color_borderColor_text.translation_lightMode__1q1dxs8iy'
        },
        'text.info': {
          conditions: {
            lightMode: 'color_borderColor_text.info_lightMode__1q1dxs8j0',
            darkMode: 'color_borderColor_text.info_darkMode__1q1dxs8j1'
          },
          defaultClass: 'color_borderColor_text.info_lightMode__1q1dxs8j0'
        },
        'text.success': {
          conditions: {
            lightMode: 'color_borderColor_text.success_lightMode__1q1dxs8j2',
            darkMode: 'color_borderColor_text.success_darkMode__1q1dxs8j3'
          },
          defaultClass: 'color_borderColor_text.success_lightMode__1q1dxs8j2'
        },
        'text.danger': {
          conditions: {
            lightMode: 'color_borderColor_text.danger_lightMode__1q1dxs8j4',
            darkMode: 'color_borderColor_text.danger_darkMode__1q1dxs8j5'
          },
          defaultClass: 'color_borderColor_text.danger_lightMode__1q1dxs8j4'
        },
        'text.01': {
          conditions: {
            lightMode: 'color_borderColor_text.01_lightMode__1q1dxs8j6',
            darkMode: 'color_borderColor_text.01_darkMode__1q1dxs8j7'
          },
          defaultClass: 'color_borderColor_text.01_lightMode__1q1dxs8j6'
        },
        'text.02': {
          conditions: {
            lightMode: 'color_borderColor_text.02_lightMode__1q1dxs8j8',
            darkMode: 'color_borderColor_text.02_darkMode__1q1dxs8j9'
          },
          defaultClass: 'color_borderColor_text.02_lightMode__1q1dxs8j8'
        },
        'text.03': {
          conditions: {
            lightMode: 'color_borderColor_text.03_lightMode__1q1dxs8ja',
            darkMode: 'color_borderColor_text.03_darkMode__1q1dxs8jb'
          },
          defaultClass: 'color_borderColor_text.03_lightMode__1q1dxs8ja'
        },
        'background.gray': {
          conditions: {
            lightMode: 'color_borderColor_background.gray_lightMode__1q1dxs8jc',
            darkMode: 'color_borderColor_background.gray_darkMode__1q1dxs8jd'
          },
          defaultClass: 'color_borderColor_background.gray_lightMode__1q1dxs8jc'
        },
        'background.grayBold': {
          conditions: {
            lightMode: 'color_borderColor_background.grayBold_lightMode__1q1dxs8je',
            darkMode: 'color_borderColor_background.grayBold_darkMode__1q1dxs8jf'
          },
          defaultClass: 'color_borderColor_background.grayBold_lightMode__1q1dxs8je'
        },
        'background.disabled': {
          conditions: {
            lightMode: 'color_borderColor_background.disabled_lightMode__1q1dxs8jg',
            darkMode: 'color_borderColor_background.disabled_darkMode__1q1dxs8jh'
          },
          defaultClass: 'color_borderColor_background.disabled_lightMode__1q1dxs8jg'
        },
        'border.muted': {
          conditions: {
            lightMode: 'color_borderColor_border.muted_lightMode__1q1dxs8ji',
            darkMode: 'color_borderColor_border.muted_darkMode__1q1dxs8jj'
          },
          defaultClass: 'color_borderColor_border.muted_lightMode__1q1dxs8ji'
        },
        'border.normal': {
          conditions: {
            lightMode: 'color_borderColor_border.normal_lightMode__1q1dxs8jk',
            darkMode: 'color_borderColor_border.normal_darkMode__1q1dxs8jl'
          },
          defaultClass: 'color_borderColor_border.normal_lightMode__1q1dxs8jk'
        },
        'border.bold': {
          conditions: {
            lightMode: 'color_borderColor_border.bold_lightMode__1q1dxs8jm',
            darkMode: 'color_borderColor_border.bold_darkMode__1q1dxs8jn'
          },
          defaultClass: 'color_borderColor_border.bold_lightMode__1q1dxs8jm'
        }
      }
    }
  }
}, {
  conditions: undefined,
  styles: {
    fs: {
      mappings: ['fontSize']
    },
    fw: {
      mappings: ['fontWeight']
    },
    lh: {
      mappings: ['lineHeight']
    },
    ta: {
      mappings: ['textAlign']
    },
    fontSize: {
      values: {
        '8': {
          defaultClass: 'text_fontSize_8__civj2k0'
        },
        '10': {
          defaultClass: 'text_fontSize_10__civj2k1'
        },
        '12': {
          defaultClass: 'text_fontSize_12__civj2k2'
        },
        '13': {
          defaultClass: 'text_fontSize_13__civj2k3'
        },
        '14': {
          defaultClass: 'text_fontSize_14__civj2k4'
        },
        '15': {
          defaultClass: 'text_fontSize_15__civj2k5'
        },
        '16': {
          defaultClass: 'text_fontSize_16__civj2k6'
        },
        '18': {
          defaultClass: 'text_fontSize_18__civj2k7'
        },
        '20': {
          defaultClass: 'text_fontSize_20__civj2k8'
        },
        '22': {
          defaultClass: 'text_fontSize_22__civj2k9'
        },
        '24': {
          defaultClass: 'text_fontSize_24__civj2ka'
        },
        '32': {
          defaultClass: 'text_fontSize_32__civj2kb'
        },
        '48': {
          defaultClass: 'text_fontSize_48__civj2kc'
        },
        xs: {
          defaultClass: 'text_fontSize_xs__civj2kd'
        },
        sm: {
          defaultClass: 'text_fontSize_sm__civj2ke'
        },
        md: {
          defaultClass: 'text_fontSize_md__civj2kf'
        },
        lg: {
          defaultClass: 'text_fontSize_lg__civj2kg'
        },
        xl: {
          defaultClass: 'text_fontSize_xl__civj2kh'
        },
        xxl: {
          defaultClass: 'text_fontSize_xxl__civj2ki'
        }
      }
    },
    fontWeight: {
      values: {
        '300': {
          defaultClass: 'text_fontWeight_300__civj2kj'
        },
        '400': {
          defaultClass: 'text_fontWeight_400__civj2kk'
        },
        '500': {
          defaultClass: 'text_fontWeight_500__civj2kl'
        },
        '600': {
          defaultClass: 'text_fontWeight_600__civj2km'
        },
        '700': {
          defaultClass: 'text_fontWeight_700__civj2kn'
        }
      }
    },
    lineHeight: {
      values: {
        normal: {
          defaultClass: 'text_lineHeight_normal__civj2ko'
        },
        '100%': {
          defaultClass: 'text_lineHeight_100%__civj2kp'
        },
        '120%': {
          defaultClass: 'text_lineHeight_120%__civj2kq'
        },
        '130%': {
          defaultClass: 'text_lineHeight_130%__civj2kr'
        }
      }
    },
    textAlign: {
      values: {
        left: {
          defaultClass: 'text_textAlign_left__civj2ks'
        },
        center: {
          defaultClass: 'text_textAlign_center__civj2kt'
        },
        right: {
          defaultClass: 'text_textAlign_right__civj2ku'
        }
      }
    }
  }
}, {
  conditions: undefined,
  styles: {
    borderRadius: {
      mappings: ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius']
    },
    borderTopLeftRadius: {
      values: {
        sm: {
          defaultClass: 'border-radius_borderTopLeftRadius_sm__3yqt4k0'
        },
        md: {
          defaultClass: 'border-radius_borderTopLeftRadius_md__3yqt4k1'
        },
        lg: {
          defaultClass: 'border-radius_borderTopLeftRadius_lg__3yqt4k2'
        },
        xl: {
          defaultClass: 'border-radius_borderTopLeftRadius_xl__3yqt4k3'
        }
      }
    },
    borderTopRightRadius: {
      values: {
        sm: {
          defaultClass: 'border-radius_borderTopRightRadius_sm__3yqt4k4'
        },
        md: {
          defaultClass: 'border-radius_borderTopRightRadius_md__3yqt4k5'
        },
        lg: {
          defaultClass: 'border-radius_borderTopRightRadius_lg__3yqt4k6'
        },
        xl: {
          defaultClass: 'border-radius_borderTopRightRadius_xl__3yqt4k7'
        }
      }
    },
    borderBottomLeftRadius: {
      values: {
        sm: {
          defaultClass: 'border-radius_borderBottomLeftRadius_sm__3yqt4k8'
        },
        md: {
          defaultClass: 'border-radius_borderBottomLeftRadius_md__3yqt4k9'
        },
        lg: {
          defaultClass: 'border-radius_borderBottomLeftRadius_lg__3yqt4ka'
        },
        xl: {
          defaultClass: 'border-radius_borderBottomLeftRadius_xl__3yqt4kb'
        }
      }
    },
    borderBottomRightRadius: {
      values: {
        sm: {
          defaultClass: 'border-radius_borderBottomRightRadius_sm__3yqt4kc'
        },
        md: {
          defaultClass: 'border-radius_borderBottomRightRadius_md__3yqt4kd'
        },
        lg: {
          defaultClass: 'border-radius_borderBottomRightRadius_lg__3yqt4ke'
        },
        xl: {
          defaultClass: 'border-radius_borderBottomRightRadius_xl__3yqt4kf'
        }
      }
    }
  }
});

var flex = {
  conditions: undefined,
  styles: {
    direction: {
      mappings: ['flexDirection']
    },
    justify: {
      mappings: ['justifyContent']
    },
    align: {
      mappings: ['alignItems']
    },
    placeItems: {
      mappings: ['justifyContent', 'alignItems']
    },
    fd: {
      mappings: ['flexDirection']
    },
    jc: {
      mappings: ['justifyContent']
    },
    ai: {
      mappings: ['alignItems']
    },
    flex: {
      values: {
        '1': {
          defaultClass: 'flex_flex_1__1fkd8a52'
        },
        none: {
          defaultClass: 'flex_flex_none__1fkd8a50'
        },
        auto: {
          defaultClass: 'flex_flex_auto__1fkd8a51'
        },
        '0 0 auto': {
          defaultClass: 'flex_flex_0_0_auto__1fkd8a53'
        }
      }
    },
    flexDirection: {
      values: {
        row: {
          defaultClass: 'flex_flexDirection_row__1fkd8a54'
        },
        column: {
          defaultClass: 'flex_flexDirection_column__1fkd8a55'
        },
        'row-reverse': {
          defaultClass: 'flex_flexDirection_row-reverse__1fkd8a56'
        },
        'column-reverse': {
          defaultClass: 'flex_flexDirection_column-reverse__1fkd8a57'
        }
      }
    },
    justifyContent: {
      values: {
        stretch: {
          defaultClass: 'flex_justifyContent_stretch__1fkd8a58'
        },
        'flex-start': {
          defaultClass: 'flex_justifyContent_flex-start__1fkd8a59'
        },
        center: {
          defaultClass: 'flex_justifyContent_center__1fkd8a5a'
        },
        'flex-end': {
          defaultClass: 'flex_justifyContent_flex-end__1fkd8a5b'
        },
        'space-around': {
          defaultClass: 'flex_justifyContent_space-around__1fkd8a5c'
        },
        'space-between': {
          defaultClass: 'flex_justifyContent_space-between__1fkd8a5d'
        }
      }
    },
    alignItems: {
      values: {
        stretch: {
          defaultClass: 'flex_alignItems_stretch__1fkd8a5e'
        },
        'flex-start': {
          defaultClass: 'flex_alignItems_flex-start__1fkd8a5f'
        },
        center: {
          defaultClass: 'flex_alignItems_center__1fkd8a5g'
        },
        'flex-end': {
          defaultClass: 'flex_alignItems_flex-end__1fkd8a5h'
        },
        'space-around': {
          defaultClass: 'flex_alignItems_space-around__1fkd8a5i'
        },
        'space-between': {
          defaultClass: 'flex_alignItems_space-between__1fkd8a5j'
        }
      }
    },
    flexWrap: {
      values: {
        wrap: {
          defaultClass: 'flex_flexWrap_wrap__1fkd8a5k'
        },
        nowrap: {
          defaultClass: 'flex_flexWrap_nowrap__1fkd8a5l'
        },
        'wrap-reverse': {
          defaultClass: 'flex_flexWrap_wrap-reverse__1fkd8a5m'
        }
      }
    },
    gap: {
      values: {
        '2': {
          defaultClass: 'flex_gap_2__1fkd8a5n'
        },
        '4': {
          defaultClass: 'flex_gap_4__1fkd8a5o'
        },
        '8': {
          defaultClass: 'flex_gap_8__1fkd8a5p'
        },
        '10': {
          defaultClass: 'flex_gap_10__1fkd8a5q'
        },
        '12': {
          defaultClass: 'flex_gap_12__1fkd8a5r'
        },
        '14': {
          defaultClass: 'flex_gap_14__1fkd8a5s'
        },
        '16': {
          defaultClass: 'flex_gap_16__1fkd8a5t'
        },
        '18': {
          defaultClass: 'flex_gap_18__1fkd8a5u'
        },
        '20': {
          defaultClass: 'flex_gap_20__1fkd8a5v'
        },
        '24': {
          defaultClass: 'flex_gap_24__1fkd8a5w'
        },
        '32': {
          defaultClass: 'flex_gap_32__1fkd8a5x'
        },
        '48': {
          defaultClass: 'flex_gap_48__1fkd8a5y'
        },
        '64': {
          defaultClass: 'flex_gap_64__1fkd8a5z'
        },
        xs: {
          defaultClass: 'flex_gap_xs__1fkd8a510'
        },
        sm: {
          defaultClass: 'flex_gap_sm__1fkd8a511'
        },
        md: {
          defaultClass: 'flex_gap_md__1fkd8a512'
        },
        lg: {
          defaultClass: 'flex_gap_lg__1fkd8a513'
        },
        xl: {
          defaultClass: 'flex_gap_xl__1fkd8a514'
        },
        xxl: {
          defaultClass: 'flex_gap_xxl__1fkd8a515'
        }
      }
    }
  }
};

var space = {
  conditions: undefined,
  styles: {
    padding: {
      mappings: ['paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight']
    },
    p: {
      mappings: ['paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight']
    },
    px: {
      mappings: ['paddingLeft', 'paddingRight']
    },
    py: {
      mappings: ['paddingTop', 'paddingBottom']
    },
    pt: {
      mappings: ['paddingTop']
    },
    pl: {
      mappings: ['paddingLeft']
    },
    pr: {
      mappings: ['paddingRight']
    },
    pb: {
      mappings: ['paddingBottom']
    },
    margin: {
      mappings: ['marginTop', 'marginBottom', 'marginLeft', 'marginRight']
    },
    m: {
      mappings: ['marginTop', 'marginBottom', 'marginLeft', 'marginRight']
    },
    mx: {
      mappings: ['marginLeft', 'marginRight']
    },
    my: {
      mappings: ['marginTop', 'marginBottom']
    },
    mt: {
      mappings: ['marginTop']
    },
    ml: {
      mappings: ['marginLeft']
    },
    mr: {
      mappings: ['marginRight']
    },
    mb: {
      mappings: ['marginBottom']
    },
    display: {
      values: {
        none: {
          defaultClass: 'space_display_none__kl7vcz0'
        },
        flex: {
          defaultClass: 'space_display_flex__kl7vcz1'
        },
        block: {
          defaultClass: 'space_display_block__kl7vcz2'
        },
        inline: {
          defaultClass: 'space_display_inline__kl7vcz3'
        },
        'inline-block': {
          defaultClass: 'space_display_inline-block__kl7vcz4'
        },
        'inline-flex': {
          defaultClass: 'space_display_inline-flex__kl7vcz5'
        },
        grid: {
          defaultClass: 'space_display_grid__kl7vcz6'
        }
      }
    },
    paddingTop: {
      values: {
        '2': {
          defaultClass: 'space_paddingTop_2__kl7vcz7'
        },
        '4': {
          defaultClass: 'space_paddingTop_4__kl7vcz8'
        },
        '8': {
          defaultClass: 'space_paddingTop_8__kl7vcz9'
        },
        '10': {
          defaultClass: 'space_paddingTop_10__kl7vcza'
        },
        '12': {
          defaultClass: 'space_paddingTop_12__kl7vczb'
        },
        '14': {
          defaultClass: 'space_paddingTop_14__kl7vczc'
        },
        '16': {
          defaultClass: 'space_paddingTop_16__kl7vczd'
        },
        '18': {
          defaultClass: 'space_paddingTop_18__kl7vcze'
        },
        '20': {
          defaultClass: 'space_paddingTop_20__kl7vczf'
        },
        '24': {
          defaultClass: 'space_paddingTop_24__kl7vczg'
        },
        '32': {
          defaultClass: 'space_paddingTop_32__kl7vczh'
        },
        '48': {
          defaultClass: 'space_paddingTop_48__kl7vczi'
        },
        '64': {
          defaultClass: 'space_paddingTop_64__kl7vczj'
        },
        xs: {
          defaultClass: 'space_paddingTop_xs__kl7vczk'
        },
        sm: {
          defaultClass: 'space_paddingTop_sm__kl7vczl'
        },
        md: {
          defaultClass: 'space_paddingTop_md__kl7vczm'
        },
        lg: {
          defaultClass: 'space_paddingTop_lg__kl7vczn'
        },
        xl: {
          defaultClass: 'space_paddingTop_xl__kl7vczo'
        },
        xxl: {
          defaultClass: 'space_paddingTop_xxl__kl7vczp'
        }
      }
    },
    paddingBottom: {
      values: {
        '2': {
          defaultClass: 'space_paddingBottom_2__kl7vczq'
        },
        '4': {
          defaultClass: 'space_paddingBottom_4__kl7vczr'
        },
        '8': {
          defaultClass: 'space_paddingBottom_8__kl7vczs'
        },
        '10': {
          defaultClass: 'space_paddingBottom_10__kl7vczt'
        },
        '12': {
          defaultClass: 'space_paddingBottom_12__kl7vczu'
        },
        '14': {
          defaultClass: 'space_paddingBottom_14__kl7vczv'
        },
        '16': {
          defaultClass: 'space_paddingBottom_16__kl7vczw'
        },
        '18': {
          defaultClass: 'space_paddingBottom_18__kl7vczx'
        },
        '20': {
          defaultClass: 'space_paddingBottom_20__kl7vczy'
        },
        '24': {
          defaultClass: 'space_paddingBottom_24__kl7vczz'
        },
        '32': {
          defaultClass: 'space_paddingBottom_32__kl7vcz10'
        },
        '48': {
          defaultClass: 'space_paddingBottom_48__kl7vcz11'
        },
        '64': {
          defaultClass: 'space_paddingBottom_64__kl7vcz12'
        },
        xs: {
          defaultClass: 'space_paddingBottom_xs__kl7vcz13'
        },
        sm: {
          defaultClass: 'space_paddingBottom_sm__kl7vcz14'
        },
        md: {
          defaultClass: 'space_paddingBottom_md__kl7vcz15'
        },
        lg: {
          defaultClass: 'space_paddingBottom_lg__kl7vcz16'
        },
        xl: {
          defaultClass: 'space_paddingBottom_xl__kl7vcz17'
        },
        xxl: {
          defaultClass: 'space_paddingBottom_xxl__kl7vcz18'
        }
      }
    },
    paddingLeft: {
      values: {
        '2': {
          defaultClass: 'space_paddingLeft_2__kl7vcz19'
        },
        '4': {
          defaultClass: 'space_paddingLeft_4__kl7vcz1a'
        },
        '8': {
          defaultClass: 'space_paddingLeft_8__kl7vcz1b'
        },
        '10': {
          defaultClass: 'space_paddingLeft_10__kl7vcz1c'
        },
        '12': {
          defaultClass: 'space_paddingLeft_12__kl7vcz1d'
        },
        '14': {
          defaultClass: 'space_paddingLeft_14__kl7vcz1e'
        },
        '16': {
          defaultClass: 'space_paddingLeft_16__kl7vcz1f'
        },
        '18': {
          defaultClass: 'space_paddingLeft_18__kl7vcz1g'
        },
        '20': {
          defaultClass: 'space_paddingLeft_20__kl7vcz1h'
        },
        '24': {
          defaultClass: 'space_paddingLeft_24__kl7vcz1i'
        },
        '32': {
          defaultClass: 'space_paddingLeft_32__kl7vcz1j'
        },
        '48': {
          defaultClass: 'space_paddingLeft_48__kl7vcz1k'
        },
        '64': {
          defaultClass: 'space_paddingLeft_64__kl7vcz1l'
        },
        xs: {
          defaultClass: 'space_paddingLeft_xs__kl7vcz1m'
        },
        sm: {
          defaultClass: 'space_paddingLeft_sm__kl7vcz1n'
        },
        md: {
          defaultClass: 'space_paddingLeft_md__kl7vcz1o'
        },
        lg: {
          defaultClass: 'space_paddingLeft_lg__kl7vcz1p'
        },
        xl: {
          defaultClass: 'space_paddingLeft_xl__kl7vcz1q'
        },
        xxl: {
          defaultClass: 'space_paddingLeft_xxl__kl7vcz1r'
        }
      }
    },
    paddingRight: {
      values: {
        '2': {
          defaultClass: 'space_paddingRight_2__kl7vcz1s'
        },
        '4': {
          defaultClass: 'space_paddingRight_4__kl7vcz1t'
        },
        '8': {
          defaultClass: 'space_paddingRight_8__kl7vcz1u'
        },
        '10': {
          defaultClass: 'space_paddingRight_10__kl7vcz1v'
        },
        '12': {
          defaultClass: 'space_paddingRight_12__kl7vcz1w'
        },
        '14': {
          defaultClass: 'space_paddingRight_14__kl7vcz1x'
        },
        '16': {
          defaultClass: 'space_paddingRight_16__kl7vcz1y'
        },
        '18': {
          defaultClass: 'space_paddingRight_18__kl7vcz1z'
        },
        '20': {
          defaultClass: 'space_paddingRight_20__kl7vcz20'
        },
        '24': {
          defaultClass: 'space_paddingRight_24__kl7vcz21'
        },
        '32': {
          defaultClass: 'space_paddingRight_32__kl7vcz22'
        },
        '48': {
          defaultClass: 'space_paddingRight_48__kl7vcz23'
        },
        '64': {
          defaultClass: 'space_paddingRight_64__kl7vcz24'
        },
        xs: {
          defaultClass: 'space_paddingRight_xs__kl7vcz25'
        },
        sm: {
          defaultClass: 'space_paddingRight_sm__kl7vcz26'
        },
        md: {
          defaultClass: 'space_paddingRight_md__kl7vcz27'
        },
        lg: {
          defaultClass: 'space_paddingRight_lg__kl7vcz28'
        },
        xl: {
          defaultClass: 'space_paddingRight_xl__kl7vcz29'
        },
        xxl: {
          defaultClass: 'space_paddingRight_xxl__kl7vcz2a'
        }
      }
    },
    marginTop: {
      values: {
        '2': {
          defaultClass: 'space_marginTop_2__kl7vcz2b'
        },
        '4': {
          defaultClass: 'space_marginTop_4__kl7vcz2c'
        },
        '8': {
          defaultClass: 'space_marginTop_8__kl7vcz2d'
        },
        '10': {
          defaultClass: 'space_marginTop_10__kl7vcz2e'
        },
        '12': {
          defaultClass: 'space_marginTop_12__kl7vcz2f'
        },
        '14': {
          defaultClass: 'space_marginTop_14__kl7vcz2g'
        },
        '16': {
          defaultClass: 'space_marginTop_16__kl7vcz2h'
        },
        '18': {
          defaultClass: 'space_marginTop_18__kl7vcz2i'
        },
        '20': {
          defaultClass: 'space_marginTop_20__kl7vcz2j'
        },
        '24': {
          defaultClass: 'space_marginTop_24__kl7vcz2k'
        },
        '32': {
          defaultClass: 'space_marginTop_32__kl7vcz2l'
        },
        '48': {
          defaultClass: 'space_marginTop_48__kl7vcz2m'
        },
        '64': {
          defaultClass: 'space_marginTop_64__kl7vcz2n'
        },
        xs: {
          defaultClass: 'space_marginTop_xs__kl7vcz2o'
        },
        sm: {
          defaultClass: 'space_marginTop_sm__kl7vcz2p'
        },
        md: {
          defaultClass: 'space_marginTop_md__kl7vcz2q'
        },
        lg: {
          defaultClass: 'space_marginTop_lg__kl7vcz2r'
        },
        xl: {
          defaultClass: 'space_marginTop_xl__kl7vcz2s'
        },
        xxl: {
          defaultClass: 'space_marginTop_xxl__kl7vcz2t'
        }
      }
    },
    marginBottom: {
      values: {
        '2': {
          defaultClass: 'space_marginBottom_2__kl7vcz2u'
        },
        '4': {
          defaultClass: 'space_marginBottom_4__kl7vcz2v'
        },
        '8': {
          defaultClass: 'space_marginBottom_8__kl7vcz2w'
        },
        '10': {
          defaultClass: 'space_marginBottom_10__kl7vcz2x'
        },
        '12': {
          defaultClass: 'space_marginBottom_12__kl7vcz2y'
        },
        '14': {
          defaultClass: 'space_marginBottom_14__kl7vcz2z'
        },
        '16': {
          defaultClass: 'space_marginBottom_16__kl7vcz30'
        },
        '18': {
          defaultClass: 'space_marginBottom_18__kl7vcz31'
        },
        '20': {
          defaultClass: 'space_marginBottom_20__kl7vcz32'
        },
        '24': {
          defaultClass: 'space_marginBottom_24__kl7vcz33'
        },
        '32': {
          defaultClass: 'space_marginBottom_32__kl7vcz34'
        },
        '48': {
          defaultClass: 'space_marginBottom_48__kl7vcz35'
        },
        '64': {
          defaultClass: 'space_marginBottom_64__kl7vcz36'
        },
        xs: {
          defaultClass: 'space_marginBottom_xs__kl7vcz37'
        },
        sm: {
          defaultClass: 'space_marginBottom_sm__kl7vcz38'
        },
        md: {
          defaultClass: 'space_marginBottom_md__kl7vcz39'
        },
        lg: {
          defaultClass: 'space_marginBottom_lg__kl7vcz3a'
        },
        xl: {
          defaultClass: 'space_marginBottom_xl__kl7vcz3b'
        },
        xxl: {
          defaultClass: 'space_marginBottom_xxl__kl7vcz3c'
        }
      }
    },
    marginLeft: {
      values: {
        '2': {
          defaultClass: 'space_marginLeft_2__kl7vcz3d'
        },
        '4': {
          defaultClass: 'space_marginLeft_4__kl7vcz3e'
        },
        '8': {
          defaultClass: 'space_marginLeft_8__kl7vcz3f'
        },
        '10': {
          defaultClass: 'space_marginLeft_10__kl7vcz3g'
        },
        '12': {
          defaultClass: 'space_marginLeft_12__kl7vcz3h'
        },
        '14': {
          defaultClass: 'space_marginLeft_14__kl7vcz3i'
        },
        '16': {
          defaultClass: 'space_marginLeft_16__kl7vcz3j'
        },
        '18': {
          defaultClass: 'space_marginLeft_18__kl7vcz3k'
        },
        '20': {
          defaultClass: 'space_marginLeft_20__kl7vcz3l'
        },
        '24': {
          defaultClass: 'space_marginLeft_24__kl7vcz3m'
        },
        '32': {
          defaultClass: 'space_marginLeft_32__kl7vcz3n'
        },
        '48': {
          defaultClass: 'space_marginLeft_48__kl7vcz3o'
        },
        '64': {
          defaultClass: 'space_marginLeft_64__kl7vcz3p'
        },
        xs: {
          defaultClass: 'space_marginLeft_xs__kl7vcz3q'
        },
        sm: {
          defaultClass: 'space_marginLeft_sm__kl7vcz3r'
        },
        md: {
          defaultClass: 'space_marginLeft_md__kl7vcz3s'
        },
        lg: {
          defaultClass: 'space_marginLeft_lg__kl7vcz3t'
        },
        xl: {
          defaultClass: 'space_marginLeft_xl__kl7vcz3u'
        },
        xxl: {
          defaultClass: 'space_marginLeft_xxl__kl7vcz3v'
        }
      }
    },
    marginRight: {
      values: {
        '2': {
          defaultClass: 'space_marginRight_2__kl7vcz3w'
        },
        '4': {
          defaultClass: 'space_marginRight_4__kl7vcz3x'
        },
        '8': {
          defaultClass: 'space_marginRight_8__kl7vcz3y'
        },
        '10': {
          defaultClass: 'space_marginRight_10__kl7vcz3z'
        },
        '12': {
          defaultClass: 'space_marginRight_12__kl7vcz40'
        },
        '14': {
          defaultClass: 'space_marginRight_14__kl7vcz41'
        },
        '16': {
          defaultClass: 'space_marginRight_16__kl7vcz42'
        },
        '18': {
          defaultClass: 'space_marginRight_18__kl7vcz43'
        },
        '20': {
          defaultClass: 'space_marginRight_20__kl7vcz44'
        },
        '24': {
          defaultClass: 'space_marginRight_24__kl7vcz45'
        },
        '32': {
          defaultClass: 'space_marginRight_32__kl7vcz46'
        },
        '48': {
          defaultClass: 'space_marginRight_48__kl7vcz47'
        },
        '64': {
          defaultClass: 'space_marginRight_64__kl7vcz48'
        },
        xs: {
          defaultClass: 'space_marginRight_xs__kl7vcz49'
        },
        sm: {
          defaultClass: 'space_marginRight_sm__kl7vcz4a'
        },
        md: {
          defaultClass: 'space_marginRight_md__kl7vcz4b'
        },
        lg: {
          defaultClass: 'space_marginRight_lg__kl7vcz4c'
        },
        xl: {
          defaultClass: 'space_marginRight_xl__kl7vcz4d'
        },
        xxl: {
          defaultClass: 'space_marginRight_xxl__kl7vcz4e'
        }
      }
    }
  }
};

var text = {
  conditions: undefined,
  styles: {
    fs: {
      mappings: ['fontSize']
    },
    fw: {
      mappings: ['fontWeight']
    },
    lh: {
      mappings: ['lineHeight']
    },
    ta: {
      mappings: ['textAlign']
    },
    fontSize: {
      values: {
        '8': {
          defaultClass: 'text_fontSize_8__civj2k0'
        },
        '10': {
          defaultClass: 'text_fontSize_10__civj2k1'
        },
        '12': {
          defaultClass: 'text_fontSize_12__civj2k2'
        },
        '13': {
          defaultClass: 'text_fontSize_13__civj2k3'
        },
        '14': {
          defaultClass: 'text_fontSize_14__civj2k4'
        },
        '15': {
          defaultClass: 'text_fontSize_15__civj2k5'
        },
        '16': {
          defaultClass: 'text_fontSize_16__civj2k6'
        },
        '18': {
          defaultClass: 'text_fontSize_18__civj2k7'
        },
        '20': {
          defaultClass: 'text_fontSize_20__civj2k8'
        },
        '22': {
          defaultClass: 'text_fontSize_22__civj2k9'
        },
        '24': {
          defaultClass: 'text_fontSize_24__civj2ka'
        },
        '32': {
          defaultClass: 'text_fontSize_32__civj2kb'
        },
        '48': {
          defaultClass: 'text_fontSize_48__civj2kc'
        },
        xs: {
          defaultClass: 'text_fontSize_xs__civj2kd'
        },
        sm: {
          defaultClass: 'text_fontSize_sm__civj2ke'
        },
        md: {
          defaultClass: 'text_fontSize_md__civj2kf'
        },
        lg: {
          defaultClass: 'text_fontSize_lg__civj2kg'
        },
        xl: {
          defaultClass: 'text_fontSize_xl__civj2kh'
        },
        xxl: {
          defaultClass: 'text_fontSize_xxl__civj2ki'
        }
      }
    },
    fontWeight: {
      values: {
        '300': {
          defaultClass: 'text_fontWeight_300__civj2kj'
        },
        '400': {
          defaultClass: 'text_fontWeight_400__civj2kk'
        },
        '500': {
          defaultClass: 'text_fontWeight_500__civj2kl'
        },
        '600': {
          defaultClass: 'text_fontWeight_600__civj2km'
        },
        '700': {
          defaultClass: 'text_fontWeight_700__civj2kn'
        }
      }
    },
    lineHeight: {
      values: {
        normal: {
          defaultClass: 'text_lineHeight_normal__civj2ko'
        },
        '100%': {
          defaultClass: 'text_lineHeight_100%__civj2kp'
        },
        '120%': {
          defaultClass: 'text_lineHeight_120%__civj2kq'
        },
        '130%': {
          defaultClass: 'text_lineHeight_130%__civj2kr'
        }
      }
    },
    textAlign: {
      values: {
        left: {
          defaultClass: 'text_textAlign_left__civj2ks'
        },
        center: {
          defaultClass: 'text_textAlign_center__civj2kt'
        },
        right: {
          defaultClass: 'text_textAlign_right__civj2ku'
        }
      }
    }
  }
};

var border = {
  conditions: undefined,
  styles: {
    border: {
      mappings: ['borderTop', 'borderLeft', 'borderRight', 'borderBottom']
    },
    b: {
      mappings: ['borderTop', 'borderLeft', 'borderRight', 'borderBottom']
    },
    bx: {
      mappings: ['borderLeft', 'borderRight']
    },
    by: {
      mappings: ['borderTop', 'borderBottom']
    },
    bt: {
      mappings: ['borderTop']
    },
    bl: {
      mappings: ['borderLeft']
    },
    br: {
      mappings: ['borderRight']
    },
    bb: {
      mappings: ['borderBottom']
    },
    borderTop: {
      values: {
        muted: {
          defaultClass: 'border_borderTop_muted__1o6mwja0'
        },
        normal: {
          defaultClass: 'border_borderTop_normal__1o6mwja1'
        },
        bold: {
          defaultClass: 'border_borderTop_bold__1o6mwja2'
        }
      }
    },
    borderLeft: {
      values: {
        muted: {
          defaultClass: 'border_borderLeft_muted__1o6mwja3'
        },
        normal: {
          defaultClass: 'border_borderLeft_normal__1o6mwja4'
        },
        bold: {
          defaultClass: 'border_borderLeft_bold__1o6mwja5'
        }
      }
    },
    borderRight: {
      values: {
        muted: {
          defaultClass: 'border_borderRight_muted__1o6mwja6'
        },
        normal: {
          defaultClass: 'border_borderRight_normal__1o6mwja7'
        },
        bold: {
          defaultClass: 'border_borderRight_bold__1o6mwja8'
        }
      }
    },
    borderBottom: {
      values: {
        muted: {
          defaultClass: 'border_borderBottom_muted__1o6mwja9'
        },
        normal: {
          defaultClass: 'border_borderBottom_normal__1o6mwjaa'
        },
        bold: {
          defaultClass: 'border_borderBottom_bold__1o6mwjab'
        }
      }
    }
  }
};

var borderRadius = {
  conditions: undefined,
  styles: {
    borderRadius: {
      mappings: ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius']
    },
    borderTopLeftRadius: {
      values: {
        sm: {
          defaultClass: 'border-radius_borderTopLeftRadius_sm__3yqt4k0'
        },
        md: {
          defaultClass: 'border-radius_borderTopLeftRadius_md__3yqt4k1'
        },
        lg: {
          defaultClass: 'border-radius_borderTopLeftRadius_lg__3yqt4k2'
        },
        xl: {
          defaultClass: 'border-radius_borderTopLeftRadius_xl__3yqt4k3'
        }
      }
    },
    borderTopRightRadius: {
      values: {
        sm: {
          defaultClass: 'border-radius_borderTopRightRadius_sm__3yqt4k4'
        },
        md: {
          defaultClass: 'border-radius_borderTopRightRadius_md__3yqt4k5'
        },
        lg: {
          defaultClass: 'border-radius_borderTopRightRadius_lg__3yqt4k6'
        },
        xl: {
          defaultClass: 'border-radius_borderTopRightRadius_xl__3yqt4k7'
        }
      }
    },
    borderBottomLeftRadius: {
      values: {
        sm: {
          defaultClass: 'border-radius_borderBottomLeftRadius_sm__3yqt4k8'
        },
        md: {
          defaultClass: 'border-radius_borderBottomLeftRadius_md__3yqt4k9'
        },
        lg: {
          defaultClass: 'border-radius_borderBottomLeftRadius_lg__3yqt4ka'
        },
        xl: {
          defaultClass: 'border-radius_borderBottomLeftRadius_xl__3yqt4kb'
        }
      }
    },
    borderBottomRightRadius: {
      values: {
        sm: {
          defaultClass: 'border-radius_borderBottomRightRadius_sm__3yqt4kc'
        },
        md: {
          defaultClass: 'border-radius_borderBottomRightRadius_md__3yqt4kd'
        },
        lg: {
          defaultClass: 'border-radius_borderBottomRightRadius_lg__3yqt4ke'
        },
        xl: {
          defaultClass: 'border-radius_borderBottomRightRadius_xl__3yqt4kf'
        }
      }
    }
  }
};

var contract = {
  spacing: {
    '2': '2px',
    '4': '4px',
    '8': '8px',
    '10': '10px',
    '12': '12px',
    '14': '14px',
    '16': '16px',
    '18': '18px',
    '20': '20px',
    '24': '24px',
    '32': '32px',
    '48': '48px',
    '64': '64px',
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.25rem',
    xxl: '1.5rem'
  },
  color: {
    gray: {
      '50': '#FAFAFA',
      '80': '#F9F9F9',
      '100': '#F5F5F5',
      '200': '#EEEEEE',
      '300': '#D9D9D9',
      '400': '#9E9E9E',
      '500': '#777777',
      '600': '#666666',
      '700': '#505050',
      '750': '#404040',
      '800': '#262626',
      '900': '#191919'
    },
    primary: {
      '50': 'rgba(24,144,255,0.05)',
      '100': 'rgba(24,144,255,0.2)',
      '200': 'rgba(24,144,255,0.5)',
      '300': 'rgba(24,144,255,0.7)',
      '400': 'rgba(24,144,255,0.9)',
      '500': '#1890ff',
      '600': '#147cdd',
      '700': '#0f5ea6',
      '800': '#0b467d',
      '900': '#08355e',
      '950': '#072b4c'
    },
    zinc: {
      '50': '#f9fafb',
      '100': '#f3f4f6',
      '200': '#e5e7eb',
      '300': '#d1d5db',
      '400': '#9ca3af',
      '500': '#6b7280',
      '600': '#4b5563',
      '700': '#374151',
      '800': '#1f2937',
      '900': '#111827',
      '950': '#030712'
    },
    red: {
      '50': 'rgba(255,102,97,0.05)',
      '100': 'rgba(255,102,97,0.2)',
      '200': 'rgba(255,102,97,0.5)',
      '300': 'rgba(255,102,97,0.7)',
      '400': 'rgba(255,102,97,0.9)',
      '500': '#ff6661',
      '600': '#dd5854',
      '700': '#a6423f',
      '800': '#7d322f',
      '900': '#5e2524',
      '950': '#4c1e1d'
    },
    yellow: {
      '50': 'rgba(252,186,22,0.05)',
      '100': 'rgba(252,186,22,0.2)',
      '200': 'rgba(252,186,22,0.5)',
      '300': 'rgba(252,186,22,0.7)',
      '400': 'rgba(252,186,22,0.9)',
      '500': '#fcba16',
      '600': '#daa113',
      '700': '#a5790e',
      '800': '#7b5b0a',
      '900': '#5d4508',
      '950': '#4b3706'
    },
    green: {
      '50': 'rgba(96,202,33,0.05)',
      '100': 'rgba(96,202,33,0.2)',
      '200': 'rgba(96,202,33,0.5)',
      '300': 'rgba(96,202,33,0.7)',
      '400': 'rgba(96,202,33,0.9)',
      '500': '#60ca21',
      '600': '#53af1c',
      '700': '#3e8415',
      '800': '#2f6310',
      '900': '#234b0c',
      '950': '#1c3c09'
    },
    blue: {
      '50': 'rgba(24,144,255,0.05)',
      '100': 'rgba(24,144,255,0.2)',
      '200': 'rgba(24,144,255,0.5)',
      '300': 'rgba(24,144,255,0.7)',
      '400': 'rgba(24,144,255,0.9)',
      '500': '#1890ff',
      '600': '#147cdd',
      '700': '#0f5ea6',
      '800': '#0b467d',
      '900': '#08355e',
      '950': '#072b4c'
    },
    purple: {
      '50': 'rgba(177,69,255,0.05)',
      '100': 'rgba(177,69,255,0.2)',
      '200': 'rgba(177,69,255,0.5)',
      '300': 'rgba(177,69,255,0.7)',
      '400': 'rgba(177,69,255,0.9)',
      '500': '#b145ff',
      '600': '#993bdd',
      '700': '#732da6',
      '800': '#56217d',
      '900': '#41195e',
      '950': '#35144c'
    },
    text: {
      '300': '#C5C9CD',
      '500': '#7F8892',
      '600': '#5E6774',
      '700': '#414C5C',
      '800': '#2C384A',
      primary: '#2C384A',
      secondary: '#414C5C',
      caption: '#5E6774',
      description: '#7F8892',
      description2: '#C5C9CD',
      disabled: '#bfbfbf',
      translation: '#096DD9',
      info: 'var(--color-feedback-info)',
      success: 'var(--color-feedback-success)',
      danger: 'var(--color-feedback-danger)',
      '01': '#E0E0E0',
      '02': '#BFBFBF',
      '03': '#939393'
    },
    feedback: {
      danger: '#FF6661',
      warning: '#FCBA16',
      success: '#60CA21',
      info: '#1890FF',
      neutral: '#EEEEEE'
    },
    button: {
      red: 'var(--color-feedback-danger)',
      yellow: 'var(--color-feedback-warning)',
      green: 'var(--color-feedback-success)',
      primary: 'var(--color-primary-500)',
      blue: 'var(--color-blue-500)',
      neutral: 'var(--color-feedback-neutral)',
      white: 'white',
      mint: '#06D6A6'
    },
    background: {
      gray: 'var(--color-gray-50)',
      grayBold: 'var(--color-gray-100)',
      disabled: 'var(--color-gray-200)'
    },
    border: {
      muted: 'var(--color-zinc-100)',
      normal: 'var(--color-zinc-200)',
      bold: 'var(--color-zinc-300)'
    }
  },
  font: {
    body: '\'Pretendard\', \'Pretendard Variable\', \'Spoqa Han Sans Neo\', -apple-system, Roboto, BlinkMacSystemFont, \'Noto Sans KR\', sans-serif, Arial',
    size: {
      '8': '0.5rem',
      '10': '0.625rem',
      '12': '0.75rem',
      '13': '0.8125rem',
      '14': '0.875rem',
      '15': '0.9375rem',
      '16': '1rem',
      '18': '1.125rem',
      '20': '1.25rem',
      '22': '1.375rem',
      '24': '1.5rem',
      '32': '2rem',
      '48': '3rem',
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem'
    }
  },
  borderRadius: {
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px'
  },
  input: {
    size: {
      sm: '2rem',
      md: '2.5rem',
      lg: '2.875rem'
    }
  }
};

function toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function mapValues(input, fn) {
  var result = {};
  for (var _key in input) {
    result[_key] = fn(input[_key], _key);
  }
  return result;
}

var shouldApplyCompound = (compoundCheck, selections, defaultVariants) => {
  for (var key of Object.keys(compoundCheck)) {
    var _selections$key;
    if (compoundCheck[key] !== ((_selections$key = selections[key]) !== null && _selections$key !== void 0 ? _selections$key : defaultVariants[key])) {
      return false;
    }
  }
  return true;
};
var createRuntimeFn = config => {
  var runtimeFn = options => {
    var className = config.defaultClassName;
    var selections = _objectSpread2(_objectSpread2({}, config.defaultVariants), options);
    for (var variantName in selections) {
      var _selections$variantNa;
      var variantSelection = (_selections$variantNa = selections[variantName]) !== null && _selections$variantNa !== void 0 ? _selections$variantNa : config.defaultVariants[variantName];
      if (variantSelection != null) {
        var selection = variantSelection;
        if (typeof selection === 'boolean') {
          // @ts-expect-error
          selection = selection === true ? 'true' : 'false';
        }
        var selectionClassName =
        // @ts-expect-error
        config.variantClassNames[variantName][selection];
        if (selectionClassName) {
          className += ' ' + selectionClassName;
        }
      }
    }
    for (var [compoundCheck, compoundClassName] of config.compoundVariants) {
      if (shouldApplyCompound(compoundCheck, selections, config.defaultVariants)) {
        className += ' ' + compoundClassName;
      }
    }
    return className;
  };
  runtimeFn.variants = () => Object.keys(config.variantClassNames);
  runtimeFn.classNames = {
    get base() {
      return config.defaultClassName.split(' ')[0];
    },
    get variants() {
      return mapValues(config.variantClassNames, classNames => mapValues(classNames, className => className.split(' ')[0]));
    }
  };
  return runtimeFn;
};

var textEllipsis = createRuntimeFn({
  defaultClassName: 'text-ellipsis_textEllipsis__2ntx330',
  variantClassNames: {
    lineCamp: {
      '1': 'text-ellipsis_textEllipsis_lineCamp_1__2ntx331',
      '2': 'text-ellipsis_textEllipsis_lineCamp_2__2ntx332',
      '3': 'text-ellipsis_textEllipsis_lineCamp_3__2ntx333',
      '4': 'text-ellipsis_textEllipsis_lineCamp_4__2ntx334',
      '5': 'text-ellipsis_textEllipsis_lineCamp_5__2ntx335'
    }
  },
  defaultVariants: {
    lineCamp: 1
  },
  compoundVariants: []
});

function filterProps(props) {
  return Object.keys(props).reduce(function (acc, key) {
    if (props[key] !== undefined) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
}

function extractSprinklesProps(others) {
  var display = others.display,
    flex = others.flex,
    flexDirection = others.flexDirection,
    direction = others.direction,
    flexWrap = others.flexWrap,
    justifyContent = others.justifyContent,
    justify = others.justify,
    alignItems = others.alignItems,
    align = others.align,
    gap = others.gap,
    placeItems = others.placeItems,
    fd = others.fd,
    jc = others.jc,
    ai = others.ai,
    m = others.m,
    mx = others.mx,
    my = others.my,
    mt = others.mt,
    mb = others.mb,
    ml = others.ml,
    mr = others.mr,
    margin = others.margin,
    marginTop = others.marginTop,
    marginBottom = others.marginBottom,
    marginLeft = others.marginLeft,
    marginRight = others.marginRight,
    p = others.p,
    px = others.px,
    py = others.py,
    pt = others.pt,
    pb = others.pb,
    pl = others.pl,
    pr = others.pr,
    padding = others.padding,
    paddingBottom = others.paddingBottom,
    paddingLeft = others.paddingLeft,
    paddingRight = others.paddingRight,
    paddingTop = others.paddingTop,
    fs = others.fs,
    fw = others.fw,
    lh = others.lh,
    ta = others.ta,
    fontSize = others.fontSize,
    fontWeight = others.fontWeight,
    lineHeight = others.lineHeight,
    textAlign = others.textAlign,
    b = others.b,
    bt = others.bt,
    bl = others.bl,
    br = others.br,
    bb = others.bb,
    bx = others.bx,
    by = others.by,
    border = others.border,
    borderTop = others.borderTop,
    borderLeft = others.borderLeft,
    borderRight = others.borderRight,
    borderBottom = others.borderBottom,
    c = others.c,
    bg = others.bg,
    bc = others.bc,
    color = others.color,
    background = others.background,
    borderColor = others.borderColor,
    borderRadius = others.borderRadius,
    rest = __rest$1(others, ["display", "flex", "flexDirection", "direction", "flexWrap", "justifyContent", "justify", "alignItems", "align", "gap", "placeItems", "fd", "jc", "ai", "m", "mx", "my", "mt", "mb", "ml", "mr", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "p", "px", "py", "pt", "pb", "pl", "pr", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "fs", "fw", "lh", "ta", "fontSize", "fontWeight", "lineHeight", "textAlign", "b", "bt", "bl", "br", "bb", "bx", "by", "border", "borderTop", "borderLeft", "borderRight", "borderBottom", "c", "bg", "bc", "color", "background", "borderColor", "borderRadius"]);
  var sprinklesProps = filterProps({
    display: display,
    flex: flex,
    flexDirection: flexDirection,
    direction: direction,
    flexWrap: flexWrap,
    justifyContent: justifyContent,
    justify: justify,
    alignItems: alignItems,
    align: align,
    gap: gap,
    placeItems: placeItems,
    fd: fd,
    jc: jc,
    ai: ai,
    m: m,
    mx: mx,
    my: my,
    mt: mt,
    mb: mb,
    ml: ml,
    mr: mr,
    margin: margin,
    marginTop: marginTop,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    p: p,
    px: px,
    py: py,
    pt: pt,
    pb: pb,
    pl: pl,
    pr: pr,
    padding: padding,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingTop: paddingTop,
    fs: fs,
    fw: fw,
    lh: lh,
    ta: ta,
    fontSize: fontSize,
    fontWeight: fontWeight,
    lineHeight: lineHeight,
    textAlign: textAlign,
    b: b,
    bt: bt,
    bl: bl,
    br: br,
    bb: bb,
    bx: bx,
    by: by,
    border: border,
    borderTop: borderTop,
    borderLeft: borderLeft,
    borderRight: borderRight,
    borderBottom: borderBottom,
    c: c,
    bg: bg,
    bc: bc,
    color: color,
    background: background,
    borderColor: borderColor,
    borderRadius: borderRadius
  });
  return {
    sprinklesProps: sprinklesProps,
    rest: rest
  };
}

var Box = forwardRef(function (props, ref) {
  var children = props.children,
    _a = props.as,
    Comp = _a === void 0 ? 'div' : _a,
    className = props.className,
    style = props.style,
    others = __rest$1(props, ["children", "as", "className", "style"]);
  var _b = extractSprinklesProps(others),
    sprinklesProps = _b.sprinklesProps,
    rest = _b.rest;
  return jsx(Comp, __assign$1({
    ref: ref,
    className: clsx(sprinkles(__assign$1({}, sprinklesProps)), className),
    style: style
  }, rest, {
    children: children
  }));
});

/**
 * @deprecated Use `Box` instead
 */
var Flex = function (props) {
  var children = props.children,
    component = props.component,
    direction = props.direction,
    justify = props.justify,
    align = props.align,
    wrap = props.wrap,
    gap = props.gap,
    color = props.color,
    borderColor = props.borderColor,
    background = props.background,
    fontSize = props.fontSize,
    fontWeight = props.fontWeight,
    lineHeight = props.lineHeight,
    style = props.style,
    args = __rest$1(props, ["children", "component", "direction", "justify", "align", "wrap", "gap", "color", "borderColor", "background", "fontSize", "fontWeight", "lineHeight", "style"]);
  var Element = component || 'div';
  return jsx(Element, __assign$1({
    className: sprinkles({
      display: 'flex',
      flexDirection: direction,
      justifyContent: justify,
      alignItems: align,
      flexWrap: wrap,
      gap: gap,
      color: color,
      borderColor: borderColor,
      background: background,
      fontSize: fontSize,
      fontWeight: fontWeight,
      lineHeight: lineHeight
    }),
    style: style
  }, args, {
    children: children
  }));
};

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function getAugmentedNamespace(n) {
  var f = n.default;
	if (typeof f == "function") {
		var a = function () {
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}

var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  (function (module) {

    if (process.env.NODE_ENV === 'production') {
      module.exports = requireReactIs_production_min();
    } else {
      module.exports = requireReactIs_development();
    }
  })(reactIs);
  return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has = requireHas();
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {/**/}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (!manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.exports.oneOfType([propTypes.exports.number, propTypes.exports.shape({
  enter: propTypes.exports.number,
  exit: propTypes.exports.number,
  appear: propTypes.exports.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.shape({
  enter: propTypes.exports.string,
  exit: propTypes.exports.string,
  active: propTypes.exports.string
}), propTypes.exports.shape({
  enter: propTypes.exports.string,
  enterDone: propTypes.exports.string,
  enterActive: propTypes.exports.string,
  exit: propTypes.exports.string,
  exitDone: propTypes.exports.string,
  exitActive: propTypes.exports.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);
  function Transition(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;
    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }
    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function () {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props,
      children = _this$props.children;
      _this$props.in;
      _this$props.mountOnEnter;
      _this$props.unmountOnExit;
      _this$props.appear;
      _this$props.enter;
      _this$props.exit;
      _this$props.timeout;
      _this$props.addEndListener;
      _this$props.onEnter;
      _this$props.onEntering;
      _this$props.onEntered;
      _this$props.onExit;
      _this$props.onExiting;
      _this$props.onExited;
      _this$props.nodeRef;
      var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /*#__PURE__*/(
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };
  return Transition;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: propTypes.exports.shape({
    current: typeof Element === 'undefined' ? propTypes.exports.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return propTypes.exports.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: propTypes.exports.oneOfType([propTypes.exports.func.isRequired, propTypes.exports.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: propTypes.exports.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: propTypes.exports.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: propTypes.exports.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: propTypes.exports.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: propTypes.exports.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: propTypes.exports.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: propTypes.exports.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: propTypes.exports.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.exports.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: propTypes.exports.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: propTypes.exports.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: propTypes.exports.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: propTypes.exports.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */

var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);
  function CSSTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument[0],
        appearing = _this$resolveArgument[1];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument2[0],
        appearing = _this$resolveArgument2[1];
      var type = appearing ? 'appear' : 'enter';
      _this.addClass(node, type, 'active');
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument3[0],
        appearing = _this$resolveArgument3[1];
      var type = appearing ? 'appear' : 'enter';
      _this.removeClasses(node, type);
      _this.addClass(node, type, 'done');
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument4[0];
      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      _this.addClass(node, 'exit', 'base');
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument5[0];
      _this.addClass(node, 'exit', 'active');
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument6[0];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, 'exit', 'done');
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition.prototype;
  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames('enter'),
      doneClassName = _this$getClassNames.doneClassName;
    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.

    if (phase === 'active') {
      if (node) forceReflow(node);
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node, className);
    }
  };
  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
      baseClassName = _this$appliedClasses$.base,
      activeClassName = _this$appliedClasses$.active,
      doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass(node, baseClassName);
    }
    if (activeClassName) {
      removeClass(node, activeClassName);
    }
    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props;
      _this$props.classNames;
      var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
    return /*#__PURE__*/React__default.createElement(Transition, _extends$1({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition;
}(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$1({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: propTypes.exports.func
}) : {};

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextKeysPending = Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);
  function TransitionGroup(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear

    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
      handleExited = _ref.handleExited,
      firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$1({}, state.children);
        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      Component = _this$props.component,
      childFactory = _this$props.childFactory,
      props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };
  return TransitionGroup;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: propTypes.exports.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: propTypes.exports.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: propTypes.exports.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: propTypes.exports.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: propTypes.exports.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: propTypes.exports.func
} : {};
TransitionGroup.defaultProps = defaultProps;

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);
  function ReplaceTransition() {
    var _this;
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return _this.handleLifecycle('onEnter', 0, args);
    };
    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return _this.handleLifecycle('onEntering', 0, args);
    };
    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return _this.handleLifecycle('onEntered', 0, args);
    };
    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return _this.handleLifecycle('onExit', 1, args);
    };
    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      return _this.handleLifecycle('onExiting', 1, args);
    };
    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      return _this.handleLifecycle('onExited', 1, args);
    };
    return _this;
  }
  var _proto = ReplaceTransition.prototype;
  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;
    var children = this.props.children;
    var child = React__default.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      inProp = _this$props.in,
      props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
    var _React$Children$toArr = React__default.Children.toArray(children),
      first = _React$Children$toArr[0],
      second = _React$Children$toArr[1];
    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/React__default.createElement(TransitionGroup, props, inProp ? React__default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : React__default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };
  return ReplaceTransition;
}(React__default.Component);
ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  in: propTypes.exports.bool.isRequired,
  children: function children(props, propName) {
    if (React__default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};

var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;
  if (React__default.isValidElement(oldChildren) && React__default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }
  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */

var modes = {
  out: 'out-in',
  in: 'in-out'
};
var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;
    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
    changeState = _ref.changeState;
  return React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
    changeState = _ref2.changeState,
    children = _ref2.children;
  return [current, React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
    changeState = _ref3.changeState;
  return React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, React__default.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
    children = _ref4.children,
    changeState = _ref4.changeState;
  return [React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, React__default.cloneElement(children, {
        in: true
      }));
    })
  }), React__default.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);
  function SwitchTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;
    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }
      _this.setState({
        status: status,
        current: current
      });
    };
    return _this;
  }
  var _proto = SwitchTransition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };
  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }
    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }
    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }
    return {
      current: React__default.cloneElement(props.children, {
        in: true
      })
    };
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      mode = _this$props.mode,
      _this$state = this.state,
      status = _this$state.status,
      current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;
    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;
      case EXITING:
        component = leaveRenders[mode](data);
        break;
      case ENTERED:
        component = current;
    }
    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };
  return SwitchTransition;
}(React__default.Component);
SwitchTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: propTypes.exports.oneOf([modes.in, modes.out]),
  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: propTypes.exports.oneOfType([propTypes.exports.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};

var mask$1 = 'Mask_mask__109tv4x1 Mask_filled__109tv4x0';
var maskAriaButton = 'Mask_maskAriaButton__109tv4x2 Mask_filled__109tv4x0';
var maskContent = 'Mask_maskContent__109tv4x3';

var Mask = function (props) {
  var open = props.open,
    children = props.children,
    className = props.className,
    style = props.style,
    onMaskClick = props.onMaskClick,
    onDestroyed = props.onDestroyed;
  var nodeRef = useRef(null);
  var root = document.body;
  return createPortal(jsx(CSSTransition, {
    nodeRef: nodeRef,
    in: open,
    timeout: 250,
    onExited: onDestroyed,
    classNames: "mask",
    unmountOnExit: true,
    children: jsxs("div", {
      ref: nodeRef,
      className: clsx(mask$1, className),
      style: style,
      children: [jsx("button", {
        type: "button",
        className: maskAriaButton,
        onClick: onMaskClick
      }), jsx("div", {
        className: maskContent,
        children: children
      })]
    })
  }), root);
};

var IconsManifest = [{
  "id": "fa",
  "name": "Font Awesome",
  "projectUrl": "https://fontawesome.com/",
  "license": "CC BY 4.0 License",
  "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
}, {
  "id": "io",
  "name": "Ionicons 4",
  "projectUrl": "https://ionicons.com/",
  "license": "MIT",
  "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
}, {
  "id": "io5",
  "name": "Ionicons 5",
  "projectUrl": "https://ionicons.com/",
  "license": "MIT",
  "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
}, {
  "id": "md",
  "name": "Material Design icons",
  "projectUrl": "http://google.github.io/material-design-icons/",
  "license": "Apache License Version 2.0",
  "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
}, {
  "id": "ti",
  "name": "Typicons",
  "projectUrl": "http://s-ings.com/typicons/",
  "license": "CC BY-SA 3.0",
  "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
}, {
  "id": "go",
  "name": "Github Octicons icons",
  "projectUrl": "https://octicons.github.com/",
  "license": "MIT",
  "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
}, {
  "id": "fi",
  "name": "Feather",
  "projectUrl": "https://feathericons.com/",
  "license": "MIT",
  "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
}, {
  "id": "gi",
  "name": "Game Icons",
  "projectUrl": "https://game-icons.net/",
  "license": "CC BY 3.0",
  "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
}, {
  "id": "wi",
  "name": "Weather Icons",
  "projectUrl": "https://erikflowers.github.io/weather-icons/",
  "license": "SIL OFL 1.1",
  "licenseUrl": "http://scripts.sil.org/OFL"
}, {
  "id": "di",
  "name": "Devicons",
  "projectUrl": "https://vorillaz.github.io/devicons/",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "ai",
  "name": "Ant Design Icons",
  "projectUrl": "https://github.com/ant-design/ant-design-icons",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "bs",
  "name": "Bootstrap Icons",
  "projectUrl": "https://github.com/twbs/icons",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "ri",
  "name": "Remix Icon",
  "projectUrl": "https://github.com/Remix-Design/RemixIcon",
  "license": "Apache License Version 2.0",
  "licenseUrl": "http://www.apache.org/licenses/"
}, {
  "id": "fc",
  "name": "Flat Color Icons",
  "projectUrl": "https://github.com/icons8/flat-color-icons",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "gr",
  "name": "Grommet-Icons",
  "projectUrl": "https://github.com/grommet/grommet-icons",
  "license": "Apache License Version 2.0",
  "licenseUrl": "http://www.apache.org/licenses/"
}, {
  "id": "hi",
  "name": "Heroicons",
  "projectUrl": "https://github.com/refactoringui/heroicons",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "si",
  "name": "Simple Icons",
  "projectUrl": "https://simpleicons.org/",
  "license": "CC0 1.0 Universal",
  "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
}, {
  "id": "im",
  "name": "IcoMoon Free",
  "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
  "license": "CC BY 4.0 License"
}, {
  "id": "bi",
  "name": "BoxIcons",
  "projectUrl": "https://github.com/atisawd/boxicons",
  "license": "CC BY 4.0 License"
}, {
  "id": "cg",
  "name": "css.gg",
  "projectUrl": "https://github.com/astrit/css.gg",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "vsc",
  "name": "VS Code Icons",
  "projectUrl": "https://github.com/microsoft/vscode-codicons",
  "license": "CC BY 4.0",
  "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
}];

var DefaultContext$1 = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext$1 = React__default.createContext && React__default.createContext(DefaultContext$1);

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return React__default.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon$2(data) {
  return function (props) {
    return React__default.createElement(IconBase$1, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase$1(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return React__default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React__default.createElement("title", null, title), props.children);
  };
  return IconContext$1 !== undefined ? React__default.createElement(IconContext$1.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext$1);
}

var esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    IconsManifest: IconsManifest,
    GenIcon: GenIcon$2,
    IconBase: IconBase$1,
    DefaultContext: DefaultContext$1,
    IconContext: IconContext$1
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(esm);

// THIS FILE IS AUTO GENERATED
var GenIcon$1 = require$$0.GenIcon;
var IoCloseCircleSharp_1 = function IoCloseCircleSharp(props) {
  return GenIcon$1({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm86.63 272L320 342.63l-64-64-64 64L169.37 320l64-64-64-64L192 169.37l64 64 64-64L342.63 192l-64 64z"
      }
    }]
  })(props);
};

var clearButton = 'Input_clearButton__1qghtxmb';
var input = 'Input_input__1qghtxma';
var inputLabel = 'Input_inputLabel__1qghtxmd';
var inputWrapper = createRuntimeFn({
  defaultClassName: 'Input_inputWrapper__1qghtxm3',
  variantClassNames: {
    size: {
      small: 'Input_inputWrapper_size_small__1qghtxm4',
      medium: 'Input_inputWrapper_size_medium__1qghtxm5',
      large: 'Input_inputWrapper_size_large__1qghtxm6'
    },
    block: {
      true: 'Input_inputWrapper_block_true__1qghtxm7'
    },
    error: {
      true: 'Input_inputWrapper_error_true__1qghtxm8'
    },
    disabled: {
      true: 'Input_inputWrapper_disabled_true__1qghtxm9'
    }
  },
  defaultVariants: {
    size: 'medium'
  },
  compoundVariants: []
});
var unitSpan = 'Input_unitSpan__1qghtxmc';

var Input = forwardRef(function (props, ref) {
  var value = props.value,
    block = props.block,
    _a = props.size,
    size = _a === void 0 ? 'medium' : _a,
    error = props.error,
    label = props.label,
    prefix = props.prefix,
    suffix = props.suffix,
    style = props.style,
    inputStyle = props.inputStyle,
    disabled = props.disabled,
    onChange = props.onChange,
    onClear = props.onClear,
    className = props.className,
    args = __rest$1(props, ["value", "block", "size", "error", "label", "prefix", "suffix", "style", "inputStyle", "disabled", "onChange", "onClear", "className"]);
  return jsxs(Fragment, {
    children: [!!label && jsx("div", {
      className: inputLabel,
      children: label
    }), jsxs("div", {
      className: clsx(inputWrapper({
        block: block,
        disabled: disabled,
        size: size,
        error: error || props['aria-invalid'] === 'true'
      }), className),
      style: style,
      children: [!!prefix && jsx("span", {
        className: unitSpan,
        children: prefix
      }), jsx("input", __assign$1({
        ref: ref,
        className: input,
        value: value || '',
        style: inputStyle,
        onChange: onChange,
        disabled: disabled
      }, args)), !!onClear && !!value && jsx("button", {
        className: clearButton,
        type: "button",
        onClick: onClear,
        style: {
          margin: suffix ? '0 4px' : undefined
        },
        children: jsx(IoCloseCircleSharp_1, {})
      }), !!suffix && jsx("span", {
        className: unitSpan,
        children: suffix
      })]
    })]
  });
});

function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$1(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

function activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null) {
    var _activeElement;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode && child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
// Avoid Chrome DevTools blue warning.
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
  // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
  // Try to find a workaround for this. `react-aria` source still has the check.
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  if (isAndroid() && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const re = /android/i;
  return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}
function isRootElement(element) {
  return element.matches('html,body');
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}
function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function isTypeableCombobox(element) {
  if (!element) return false;
  return element.getAttribute('role') === 'combobox' && isTypeableElement(element);
}

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$2 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const overflowAvailableHeight = height - overflow[heightSide];
      const overflowAvailableWidth = width - overflow[widthSide];
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        const maximumClippingWidth = width - overflow.left - overflow.right;
        availableWidth = alignment || noShift ? min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        availableHeight = alignment || noShift ? min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow(element);
  if (!isHTMLElement(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

const getElementRects = async function (_ref) {
  let {
    reference,
    floating,
    strategy
  } = _ref;
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(floating))
    }
  };
};

function isRTL(element) {
  return getComputedStyle$1(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    clearTimeout(timeoutId);
    io && io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          resizeObserver && resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo && cleanupIo();
    resizeObserver && resizeObserver.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = shift$1;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = flip$1;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = size$1;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = arrow$2;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$1({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      } else if (element) {
        return arrow$1({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

var index$1 = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length, i, keys;
  if (a && b && typeof a == 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef$1(value) {
  const ref = React.useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback(node => {
    if (node != referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, [_setReference]);
  const setFloating = React.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, [_setFloating]);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const whileElementsMountedRef = useLatestRef$1(whileElementsMounted);
  const platformRef = useLatestRef$1(platform);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index$1(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$1(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      } else {
        update();
      }
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};

/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */
var hasTabIndex = function hasTabIndex(node) {
  return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};

/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */
var getTabIndex = function getTabIndex(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};

/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */
var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};

// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const useInsertionEffect = React[/*#__PURE__*/'useInsertionEffect'.toString()];
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = React.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error('Cannot call an event handler while rendering.');
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
function isDifferentRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function getMinIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    disabledIndices
  });
}
function getMaxIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
function findNonDisabledIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  const list = listRef.current;
  const isDisabledIndex = disabledIndices ? index => disabledIndices.includes(index) : index => {
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
  };
  let index = startingIndex;
  do {
    index += decrement ? -amount : amount;
  } while (index >= 0 && index <= list.length - 1 && isDisabledIndex(index));
  return index;
}
function getGridNavigatedIndex(elementsRef, _ref) {
  let {
    event,
    orientation,
    loop,
    cols,
    disabledIndices,
    minIndex,
    maxIndex,
    prevIndex,
    stopEvent: stop = false
  } = _ref;
  let nextIndex = prevIndex;
  if (event.key === ARROW_UP) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = maxIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: nextIndex,
        amount: cols,
        decrement: true,
        disabledIndices
      });
      if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
        const col = prevIndex % cols;
        const maxCol = maxIndex % cols;
        const offset = maxIndex - (maxCol - col);
        if (maxCol === col) {
          nextIndex = maxIndex;
        } else {
          nextIndex = maxCol > col ? offset : offset - cols;
        }
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (event.key === ARROW_DOWN) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = minIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: prevIndex,
        amount: cols,
        disabledIndices
      });
      if (loop && prevIndex + cols > maxIndex) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex % cols - cols,
          amount: cols,
          disabledIndices
        });
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }

  // Remains on the same row/column.
  if (orientation === 'both') {
    const prevRow = floor(prevIndex / cols);
    if (event.key === ARROW_RIGHT) {
      stop && stopEvent(event);
      if (prevIndex % cols !== cols - 1) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === ARROW_LEFT) {
      stop && stopEvent(event);
      if (prevIndex % cols !== 0) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          disabledIndices,
          decrement: true
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    const lastRow = floor(maxIndex / cols) === prevRow;
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      if (loop && lastRow) {
        nextIndex = event.key === ARROW_LEFT ? maxIndex : findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}

/** For each cell index, gets the item index that occupies that cell */
function buildCellMap(sizes, cols, dense) {
  const cellMap = [];
  let startIndex = 0;
  sizes.forEach((_ref2, index) => {
    let {
      width,
      height
    } = _ref2;
    if (width > cols) {
      if (process.env.NODE_ENV !== "production") {
        throw new Error("[Floating UI]: Invalid grid - item width at index " + index + " is greater than grid columns");
      }
    }
    let itemPlaced = false;
    if (dense) {
      startIndex = 0;
    }
    while (!itemPlaced) {
      const targetCells = [];
      for (let i = 0; i < width; i++) {
        for (let j = 0; j < height; j++) {
          targetCells.push(startIndex + i + j * cols);
        }
      }
      if (startIndex % cols + width <= cols && targetCells.every(cell => cellMap[cell] === undefined)) {
        targetCells.forEach(cell => cellMap[cell] = index);
        itemPlaced = true;
      } else {
        startIndex++;
      }
    }
  });

  // convert into a non-sparse array
  return [...cellMap];
}

/** Gets cell index of an item's corner or -1 when index is -1. */
function getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
  if (index === -1) return -1;
  const firstCellIndex = cellMap.indexOf(index);
  switch (corner) {
    case 'tl':
      return firstCellIndex;
    case 'tr':
      return firstCellIndex + sizes[index].width - 1;
    case 'bl':
      return firstCellIndex + (sizes[index].height - 1) * cols;
    case 'br':
      return cellMap.lastIndexOf(index);
  }
}

/** Gets all cell indices that correspond to the specified indices */
function getCellIndices(indices, cellMap) {
  return cellMap.flatMap((index, cellIndex) => indices.includes(index) ? [cellIndex] : []);
}

let rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}

var index = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

let serverHandoffComplete = false;
let count = 0;
const genId = () => "floating-ui-" + count++;
function useFloatingId() {
  const [id, setId] = React.useState(() => serverHandoffComplete ? genId() : undefined);
  index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
}

// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const useReactId = React[/*#__PURE__*/'useId'.toString()];

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */
const useId = useReactId || useFloatingId;

/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */
const FloatingArrow = /*#__PURE__*/React.forwardRef(function FloatingArrow(_ref, ref) {
  let {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    if (!ref) {
      console.warn('Floating UI: The `ref` prop is required for the `FloatingArrow`', 'component.');
    }
  }
  const clipPathId = useId();
  if (!floating) {
    return null;
  }

  // Strokes must be double the border width, this ensures the stroke's width
  // works as you'd expect.
  strokeWidth *= 2;
  const halfStrokeWidth = strokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const [side, alignment] = placement.split('-');
  const isRTL = platform.isRTL(floating);
  const isCustomShape = !!d;
  const isVerticalSide = side === 'top' || side === 'bottom';
  const yOffsetProp = staticOffset && alignment === 'end' ? 'bottom' : 'top';
  let xOffsetProp = staticOffset && alignment === 'end' ? 'right' : 'left';
  if (staticOffset && isRTL) {
    xOffsetProp = alignment === 'end' ? 'left' : 'right';
  }
  const arrowX = (arrow == null ? void 0 : arrow.x) != null ? staticOffset || arrow.x : '';
  const arrowY = (arrow == null ? void 0 : arrow.y) != null ? staticOffset || arrow.y : '';
  const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
  const rotation = {
    top: isCustomShape ? 'rotate(180deg)' : '',
    left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
    bottom: isCustomShape ? '' : 'rotate(180deg)',
    right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
  }[side];
  return /*#__PURE__*/React.createElement("svg", _extends({}, rest, {
    "aria-hidden": true,
    ref: ref,
    width: isCustomShape ? width : width + strokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + strokeWidth / 2 + "px)",
      transform: "" + rotation + (transform != null ? transform : ''),
      ...restStyle
    }
  }), strokeWidth > 0 && /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke: stroke
    // Account for the stroke on the fill path rendered below.
    ,
    strokeWidth: strokeWidth + (d ? 0 : 1),
    d: dValue
  }), /*#__PURE__*/React.createElement("path", {
    stroke: strokeWidth && !d ? rest.fill : 'none',
    d: dValue
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width + strokeWidth,
    height: width
  })));
});

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(l => l !== listener)) || []);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/React.createContext(null);
const FloatingTreeContext = /*#__PURE__*/React.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React.useContext(FloatingTreeContext);

function createAttribute(name) {
  return "data-floating-ui-" + name;
}

function useLatestRef(value) {
  const ref = useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

const safePolygonIdentifier = /*#__PURE__*/createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements: {
      domReference,
      floating
    },
    refs
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = useLatestRef(handleClose);
  const delayRef = useLatestRef(delay);
  const pointerTypeRef = React.useRef();
  const timeoutRef = React.useRef();
  const handlerRef = React.useRef();
  const restTimeoutRef = React.useRef();
  const blockMouseMoveRef = React.useRef(true);
  const performedPointerEventsMutationRef = React.useRef(false);
  const unbindMouseMoveRef = React.useRef(() => {});
  const isHoverOpen = React.useCallback(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  }, [dataRef]);

  // When closing before opening, clear the delay timeouts to cancel it
  // from showing.
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onOpenChange(_ref) {
      let {
        open
      } = _ref;
      if (!open) {
        clearTimeout(timeoutRef.current);
        clearTimeout(restTimeoutRef.current);
        blockMouseMoveRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [enabled, events]);
  React.useEffect(() => {
    if (!enabled || !handleCloseRef.current || !open) {
      return;
    }
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event, 'hover');
      }
    }
    const html = getDocument(floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [floating, open, onOpenChange, enabled, handleCloseRef, dataRef, isHoverOpen]);
  const closeWithDelay = React.useCallback(function (event, runElseBranch, reason) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    if (reason === void 0) {
      reason = 'hover';
    }
    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => onOpenChange(false, event, reason), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false, event, reason);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = React.useCallback(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  }, []);
  const clearPointerEvents = React.useCallback(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument(refs.floating.current).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  }, [refs]);

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    function isClickLikeOpenEvent() {
      return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
    }
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && getDelay(delayRef.current, 'open') === 0) {
        return;
      }
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = setTimeout(() => {
          onOpenChange(true, event, 'hover');
        }, openDelay);
      } else {
        onOpenChange(true, event, 'hover');
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      unbindMouseMoveRef.current();
      const doc = getDocument(floating);
      clearTimeout(restTimeoutRef.current);
      if (handleCloseRef.current) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current({
          ...context,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            closeWithDelay(event, true, 'safe-polygon');
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }

      // Allow interactivity without `safePolygon` on touch devices. With a
      // pointer, a short close delay is an alternative, so it should work
      // consistently.
      const shouldClose = pointerTypeRef.current === 'touch' ? !contains(floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      handleCloseRef.current == null || handleCloseRef.current({
        ...context,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          closeWithDelay(event);
        }
      })(event);
    }
    if (isElement(domReference)) {
      const ref = domReference;
      open && ref.addEventListener('mouseleave', onScrollMouseLeave);
      floating == null || floating.addEventListener('mouseleave', onScrollMouseLeave);
      move && ref.addEventListener('mousemove', onMouseEnter, {
        once: true
      });
      ref.addEventListener('mouseenter', onMouseEnter);
      ref.addEventListener('mouseleave', onMouseLeave);
      return () => {
        open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
        floating == null || floating.removeEventListener('mouseleave', onScrollMouseLeave);
        move && ref.removeEventListener('mousemove', onMouseEnter);
        ref.removeEventListener('mouseenter', onMouseEnter);
        ref.removeEventListener('mouseleave', onMouseLeave);
      };
    }
  }, [domReference, floating, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, tree, delayRef, handleCloseRef, dataRef]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  index(() => {
    var _handleCloseRef$curre;
    if (!enabled) {
      return;
    }
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      const body = getDocument(floating).body;
      body.setAttribute(safePolygonIdentifier, '');
      body.style.pointerEvents = 'none';
      performedPointerEventsMutationRef.current = true;
      if (isElement(domReference) && floating) {
        var _tree$nodesRef$curren;
        const ref = domReference;
        const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        ref.style.pointerEvents = 'auto';
        floating.style.pointerEvents = 'auto';
        return () => {
          ref.style.pointerEvents = '';
          floating.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, floating, domReference, tree, handleCloseRef, dataRef, isHoverOpen]);
  index(() => {
    if (!open) {
      pointerTypeRef.current = undefined;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  React.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, domReference, cleanupMouseMoveHandler, clearPointerEvents]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      reference: {
        onPointerDown: setPointerRef,
        onPointerEnter: setPointerRef,
        onMouseMove(event) {
          if (open || restMs === 0) {
            return;
          }
          clearTimeout(restTimeoutRef.current);
          restTimeoutRef.current = setTimeout(() => {
            if (!blockMouseMoveRef.current) {
              onOpenChange(true, event.nativeEvent, 'hover');
            }
          }, restMs);
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(timeoutRef.current);
        },
        onMouseLeave(event) {
          closeWithDelay(event.nativeEvent, false);
        }
      }
    };
  }, [enabled, restMs, open, onOpenChange, closeWithDelay]);
}

function getAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}

function getChildren(nodes, id) {
  let allChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(node => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
function getDeepestNode(nodes, id) {
  let deepestNodeId;
  let maxDepth = -1;
  function findDeepest(nodeId, depth) {
    if (depth > maxDepth) {
      deepestNodeId = nodeId;
      maxDepth = depth;
    }
    const children = getChildren(nodes, nodeId);
    children.forEach(child => {
      findDeepest(child.id, depth + 1);
    });
  }
  findDeepest(id, 0);
  return nodes.find(node => node.id === deepestNodeId);
}

// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let counterMap = /*#__PURE__*/new WeakMap();
let uncontrolledElementsSet = /*#__PURE__*/new WeakSet();
let markerMap = {};
let lockCount = 0;
const supportsInert = () => typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const unwrapHost = node => node && (node.host || unwrapHost(node.parentNode));
const correctElements = (parent, targets) => targets.map(target => {
  if (parent.contains(target)) {
    return target;
  }
  const correctedTarget = unwrapHost(target);
  if (parent.contains(correctedTarget)) {
    return correctedTarget;
  }
  return null;
}).filter(x => x != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
  const markerName = 'data-floating-ui-inert';
  const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
  const avoidElements = correctElements(body, uncorrectedAvoidElements);
  const elementsToKeep = new Set();
  const elementsToStop = new Set(avoidElements);
  const hiddenElements = [];
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  const markerCounter = markerMap[markerName];
  avoidElements.forEach(keep);
  deep(body);
  elementsToKeep.clear();
  function keep(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    el.parentNode && keep(el.parentNode);
  }
  function deep(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, node => {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
        const alreadyHidden = attr !== null && attr !== 'false';
        const counterValue = (counterMap.get(node) || 0) + 1;
        const markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenElements.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledElementsSet.add(node);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, '');
        }
        if (!alreadyHidden && controlAttribute) {
          node.setAttribute(controlAttribute, 'true');
        }
      }
    });
  }
  lockCount++;
  return () => {
    hiddenElements.forEach(element => {
      const counterValue = (counterMap.get(element) || 0) - 1;
      const markerValue = (markerCounter.get(element) || 0) - 1;
      counterMap.set(element, counterValue);
      markerCounter.set(element, markerValue);
      if (!counterValue) {
        if (!uncontrolledElementsSet.has(element) && controlAttribute) {
          element.removeAttribute(controlAttribute);
        }
        uncontrolledElementsSet.delete(element);
      }
      if (!markerValue) {
        element.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = new WeakMap();
      counterMap = new WeakMap();
      uncontrolledElementsSet = new WeakSet();
      markerMap = {};
    }
  };
}
function markOthers(avoidElements, ariaHidden, inert) {
  if (ariaHidden === void 0) {
    ariaHidden = false;
  }
  if (inert === void 0) {
    inert = false;
  }
  const body = getDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}

const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === 'prev') {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, 'next');
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, 'prev');
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx

const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
let timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === 'Tab') {
    event.target;
    clearTimeout(timeoutId);
  }
}
const FocusGuard = /*#__PURE__*/React.forwardRef(function FocusGuard(props, ref) {
  const [role, setRole] = React.useState();
  index(() => {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
    document.addEventListener('keydown', setActiveElementOnTab);
    return () => {
      document.removeEventListener('keydown', setActiveElementOnTab);
    };
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    'aria-hidden': role ? undefined : true,
    [createAttribute('focus-guard')]: '',
    style: HIDDEN_STYLES
  };
  return /*#__PURE__*/React.createElement("span", _extends({}, props, restProps));
});

const PortalContext = /*#__PURE__*/React.createContext(null);
function useFloatingPortalNode(_temp) {
  let {
    id,
    root
  } = _temp === void 0 ? {} : _temp;
  const [portalNode, setPortalNode] = React.useState(null);
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const data = React.useMemo(() => ({
    id,
    root,
    portalContext,
    uniqueId
  }), [id, root, portalContext, uniqueId]);
  const dataRef = React.useRef();
  index(() => {
    return () => {
      portalNode == null || portalNode.remove();
    };
  }, [portalNode, data]);
  index(() => {
    if (dataRef.current === data) return;
    dataRef.current = data;
    const {
      id,
      root,
      portalContext,
      uniqueId
    } = data;
    const existingIdRoot = id ? document.getElementById(id) : null;
    const attr = createAttribute('portal');
    if (existingIdRoot) {
      const subRoot = document.createElement('div');
      subRoot.id = uniqueId;
      subRoot.setAttribute(attr, '');
      existingIdRoot.appendChild(subRoot);
      setPortalNode(subRoot);
    } else {
      let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
      if (container && !isElement(container)) container = container.current;
      container = container || document.body;
      let idWrapper = null;
      if (id) {
        idWrapper = document.createElement('div');
        idWrapper.id = id;
        container.appendChild(idWrapper);
      }
      const subRoot = document.createElement('div');
      subRoot.id = uniqueId;
      subRoot.setAttribute(attr, '');
      container = idWrapper || container;
      container.appendChild(subRoot);
      setPortalNode(subRoot);
    }
  }, [data]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(_ref) {
  let {
    children,
    id,
    root = null,
    preserveTabOrder = true
  } = _ref;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = React.useState(null);
  const beforeOutsideRef = React.useRef(null);
  const afterOutsideRef = React.useRef(null);
  const beforeInsideRef = React.useRef(null);
  const afterInsideRef = React.useRef(null);
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  React.useEffect(() => {
    if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, focusManagerState == null ? void 0 : focusManagerState.modal]);
  return /*#__PURE__*/React.createElement(PortalContext.Provider, {
    value: React.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
      } else {
        const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null || prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), portalNode && /*#__PURE__*/createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
      } else {
        const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null || nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent));
      }
    }
  }));
}
const usePortalContext = () => React.useContext(PortalContext);

const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function addPreviouslyFocusedElement(element) {
  previouslyFocusedElements = previouslyFocusedElements.filter(el => el.isConnected);
  if (element && getNodeName(element) !== 'body') {
    previouslyFocusedElements.push(element);
    if (previouslyFocusedElements.length > LIST_LIMIT) {
      previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
    }
  }
}
function getPreviouslyFocusedElement() {
  return previouslyFocusedElements.slice().reverse().find(el => el.isConnected);
}
const VisuallyHiddenDismiss = /*#__PURE__*/React.forwardRef(function VisuallyHiddenDismiss(props, ref) {
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    type: "button",
    ref: ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled = false,
    order = ['content'],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true
  } = props;
  const {
    open,
    refs,
    nodeId,
    onOpenChange,
    events,
    dataRef,
    elements: {
      domReference,
      floating
    }
  } = context;
  const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
  // If the reference is a combobox and is typeable (e.g. input/textarea),
  // there are different focus semantics. The guards should not be rendered, but
  // aria-hidden should be applied to all nodes still. Further, the visually
  // hidden dismiss button should only appear at the end of the list, not the
  // start.
  const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;

  // Force the guards to be rendered if the `inert` attribute is not supported.
  const guards = supportsInert() ? _guards : true;
  const orderRef = useLatestRef(order);
  const initialFocusRef = useLatestRef(initialFocus);
  const returnFocusRef = useLatestRef(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const startDismissButtonRef = React.useRef(null);
  const endDismissButtonRef = React.useRef(null);
  const preventReturnFocusRef = React.useRef(false);
  const isPointerDownRef = React.useRef(false);
  const isInsidePortal = portalContext != null;
  const getTabbableContent = React.useCallback(function (container) {
    if (container === void 0) {
      container = floating;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  }, [floating]);
  const getTabbableElements = React.useCallback(container => {
    const content = getTabbableContent(container);
    return orderRef.current.map(type => {
      if (domReference && type === 'reference') {
        return domReference;
      }
      if (floating && type === 'floating') {
        return floating;
      }
      return content;
    }).filter(Boolean).flat();
  }, [domReference, floating, orderRef, getTabbableContent]);
  React.useEffect(() => {
    if (disabled || !modal) return;
    function onKeyDown(event) {
      if (event.key === 'Tab') {
        // The focus guards have nothing to focus, so we need to stop the event.
        if (contains(floating, activeElement(getDocument(floating))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === 'reference' && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === 'floating' && target === floating && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floating);
    doc.addEventListener('keydown', onKeyDown);
    return () => {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [disabled, domReference, floating, modal, orderRef, refs, isUntrappedTypeableCombobox, getTabbableContent, getTabbableElements]);
  React.useEffect(() => {
    if (disabled || !closeOnFocusOut) return;

    // In Safari, buttons lose focus when pressing them.
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      queueMicrotask(() => {
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute('focus-guard')) || tree && (getChildren(tree.nodesRef.current, nodeId).find(node => {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getAncestors(tree.nodesRef.current, nodeId).find(node => {
          var _node$context3, _node$context4;
          return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
        })));

        // Focus did not move inside the floating tree, and there are no tabbable
        // portal guards to handle closing.
        if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current &&
        // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== getPreviouslyFocusedElement()) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event);
        }
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener('focusout', handleFocusOutside);
      domReference.addEventListener('pointerdown', handlePointerDown);
      !modal && floating.addEventListener('focusout', handleFocusOutside);
      return () => {
        domReference.removeEventListener('focusout', handleFocusOutside);
        domReference.removeEventListener('pointerdown', handlePointerDown);
        !modal && floating.removeEventListener('focusout', handleFocusOutside);
      };
    }
  }, [disabled, domReference, floating, modal, nodeId, tree, portalContext, onOpenChange, closeOnFocusOut]);
  React.useEffect(() => {
    var _portalContext$portal;
    if (disabled) return;

    // Don't hide portals nested within the parent portal.
    const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute('portal') + "]")) || []);
    if (floating) {
      const insideElements = [floating, ...portalNodes, startDismissButtonRef.current, endDismissButtonRef.current, orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null].filter(x => x != null);
      const cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, guards, !guards) : markOthers(insideElements);
      return () => {
        cleanup();
      };
    }
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isUntrappedTypeableCombobox, guards]);
  index(() => {
    if (disabled || !floating) return;
    const doc = getDocument(floating);
    const previouslyFocusedElement = activeElement(doc);

    // Wait for any layout effect state setters to execute to set `tabIndex`.
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floating);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floating;
      const focusAlreadyInsideFloatingEl = contains(floating, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floating
        });
      }
    });
  }, [disabled, open, floating, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  index(() => {
    if (disabled || !floating) return;
    let preventReturnFocusScroll = false;
    const doc = getDocument(floating);
    const previouslyFocusedElement = activeElement(doc);
    const contextData = dataRef.current;
    addPreviouslyFocusedElement(previouslyFocusedElement);

    // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.
    function onOpenChange(_ref) {
      let {
        reason,
        event,
        nested
      } = _ref;
      if (reason === 'escape-key' && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      if (reason === 'hover' && event.type === 'mouseleave') {
        preventReturnFocusRef.current = true;
      }
      if (reason !== 'outside-press') return;
      if (nested) {
        preventReturnFocusRef.current = false;
        preventReturnFocusScroll = true;
      } else {
        preventReturnFocusRef.current = !(isVirtualClick(event) || isVirtualPointerEvent(event));
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
      const activeEl = activeElement(doc);
      const isFocusInsideFloatingTree = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
        var _node$context5;
        return contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
      });
      const shouldFocusReference = isFocusInsideFloatingTree || contextData.openEvent && ['click', 'mousedown'].includes(contextData.openEvent.type);
      if (shouldFocusReference && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      const returnElement = getPreviouslyFocusedElement();
      if (
      // eslint-disable-next-line react-hooks/exhaustive-deps
      returnFocusRef.current && !preventReturnFocusRef.current && isHTMLElement(returnElement) && (
      // If the focus moved somewhere else after mount, avoid returning focus
      // since it likely entered a different element which should be
      // respected: https://github.com/floating-ui/floating-ui/issues/2607
      returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) {
        enqueueFocus(returnElement, {
          // When dismissing nested floating elements, by the time the rAF has
          // executed, the menus will all have been unmounted. When they try
          // to get focused, the calls get ignored — leaving the root
          // reference focused as desired.
          cancelPrevious: false,
          preventScroll: preventReturnFocusScroll
        });
      }
    };
  }, [disabled, floating, returnFocusRef, dataRef, refs, events, tree, nodeId]);

  // Synchronize the `context` & `modal` value to the FloatingPortal context.
  // It will decide whether or not it needs to render its own guards.
  index(() => {
    if (disabled || !portalContext) return;
    portalContext.setFocusManagerState({
      modal,
      closeOnFocusOut,
      open,
      onOpenChange,
      refs
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, onOpenChange, refs, closeOnFocusOut]);
  index(() => {
    if (disabled || !floating || typeof MutationObserver !== 'function' || ignoreInitialFocus) {
      return;
    }
    const handleMutation = () => {
      const tabIndex = floating.getAttribute('tabindex');
      if (orderRef.current.includes('floating') || activeElement(getDocument(floating)) !== refs.domReference.current && getTabbableContent().length === 0) {
        if (tabIndex !== '0') {
          floating.setAttribute('tabindex', '0');
        }
      } else if (tabIndex !== '-1') {
        floating.setAttribute('tabindex', '-1');
      }
    };
    handleMutation();
    const observer = new MutationObserver(handleMutation);
    observer.observe(floating, {
      childList: true,
      subtree: true,
      attributes: true
    });
    return () => {
      observer.disconnect();
    };
  }, [disabled, floating, refs, orderRef, getTabbableContent, ignoreInitialFocus]);
  function renderDismissButton(location) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /*#__PURE__*/React.createElement(VisuallyHiddenDismiss, {
      ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
      onClick: event => onOpenChange(false, event.nativeEvent)
    }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
  }
  const shouldRenderGuards = !disabled && guards && (isInsidePortal || modal);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRenderGuards && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
    onFocus: event => {
      if (modal) {
        const els = getTabbableElements();
        enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        preventReturnFocusRef.current = false;
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const nextTabbable = getNextTabbable() || domReference;
          nextTabbable == null || nextTabbable.focus();
        } else {
          var _portalContext$before;
          (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
        }
      }
    }
  }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
    onFocus: event => {
      if (modal) {
        enqueueFocus(getTabbableElements()[0]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        if (closeOnFocusOut) {
          preventReturnFocusRef.current = true;
        }
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const prevTabbable = getPreviousTabbable() || domReference;
          prevTabbable == null || prevTabbable.focus();
        } else {
          var _portalContext$afterO;
          (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
        }
      }
    }
  }));
}

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true
  } = props;
  const pointerTypeRef = React.useRef();
  const didKeyDownRef = React.useRef(false);
  return React.useMemo(() => {
    if (!enabled) return {};
    return {
      reference: {
        onPointerDown(event) {
          pointerTypeRef.current = event.pointerType;
        },
        onMouseDown(event) {
          // Ignore all buttons except for the "main" button.
          // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
          if (event.button !== 0) {
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (eventOption === 'click') {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) {
            onOpenChange(false, event.nativeEvent, 'click');
          } else {
            // Prevent stealing focus from the floating element
            event.preventDefault();
            onOpenChange(true, event.nativeEvent, 'click');
          }
        },
        onClick(event) {
          if (eventOption === 'mousedown' && pointerTypeRef.current) {
            pointerTypeRef.current = undefined;
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) {
            onOpenChange(false, event.nativeEvent, 'click');
          } else {
            onOpenChange(true, event.nativeEvent, 'click');
          }
        },
        onKeyDown(event) {
          pointerTypeRef.current = undefined;
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
            return;
          }
          if (event.key === ' ' && !isSpaceIgnored(domReference)) {
            // Prevent scrolling
            event.preventDefault();
            didKeyDownRef.current = true;
          }
          if (event.key === 'Enter') {
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent, 'click');
            } else {
              onOpenChange(true, event.nativeEvent, 'click');
            }
          }
        },
        onKeyUp(event) {
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
            return;
          }
          if (event.key === ' ' && didKeyDownRef.current) {
            didKeyDownRef.current = false;
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent, 'click');
            } else {
              onOpenChange(true, event.nativeEvent, 'click');
            }
          }
        }
      }
    };
  }, [enabled, dataRef, eventOption, ignoreMouse, keyboardHandlers, domReference, toggle, open, onOpenChange]);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeProp = normalizable => {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    nodeId,
    elements: {
      reference,
      domReference,
      floating
    },
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles,
    capture
  } = props;
  const tree = useFloatingTree();
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = React.useRef(false);
  const endedOrStartedInsideRef = React.useRef(false);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const {
    escapeKey: escapeKeyCapture,
    outsidePress: outsidePressCapture
  } = normalizeProp(capture);
  const closeOnEscapeKeyDown = useEffectEvent(event => {
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, 'escape-key');
  });
  const closeOnEscapeKeyDownCapture = useEffectEvent(event => {
    var _getTarget2;
    const callback = () => {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = getTarget(event)) == null || _getTarget.removeEventListener('keydown', callback);
    };
    (_getTarget2 = getTarget(event)) == null || _getTarget2.addEventListener('keydown', callback);
  });
  const closeOnPressOutside = useEffectEvent(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;

    // When click outside is lazy (`click` event), handle dragging.
    // Don't close if:
    // - The click started inside the floating element.
    // - The click ended inside the floating element.
    const endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === 'click' && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);
    const inertSelector = "[" + createAttribute('inert') + "]";
    const markers = getDocument(floating).querySelectorAll(inertSelector);
    let targetRootAncestor = isElement(target) ? target : null;
    while (targetRootAncestor && !isLastTraversableNode(targetRootAncestor)) {
      const nextParent = getParentNode(targetRootAncestor);
      if (isLastTraversableNode(nextParent) || !isElement(nextParent)) {
        break;
      } else {
        targetRootAncestor = nextParent;
      }
    }

    // Check if the click occurred on a third-party element injected after the
    // floating element rendered.
    if (markers.length && isElement(target) && !isRootElement(target) &&
    // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains(target, floating) &&
    // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every(marker => !contains(targetRootAncestor, marker))) {
      return;
    }

    // Check if the click occurred on the scrollbar
    if (isHTMLElement(target) && floating) {
      // In Firefox, `target.scrollWidth > target.clientWidth` for inline
      // elements.
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;

      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      if (canScrollY) {
        const isRTL = getComputedStyle$1(target).direction === 'rtl';
        if (isRTL) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, floating) || isEventTargetWithin(event, domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, 'outside-press');
  });
  const closeOnPressOutsideCapture = useEffectEvent(event => {
    var _getTarget4;
    const callback = () => {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  React.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onScroll(event) {
      onOpenChange(false, event, 'ancestor-scroll');
    }
    const doc = getDocument(floating);
    escapeKey && doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(domReference)) {
        ancestors = getOverflowAncestors(domReference);
      }
      if (isElement(floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(floating));
      }
      if (!isElement(reference) && reference && reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
    };
  }, [dataRef, floating, domReference, reference, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);
  React.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onKeyDown: closeOnEscapeKeyDown,
        [bubbleHandlerKeys[referencePressEvent]]: event => {
          if (referencePress) {
            onOpenChange(false, event.nativeEvent, 'reference-press');
          }
        }
      },
      floating: {
        onKeyDown: closeOnEscapeKeyDown,
        onMouseDown() {
          endedOrStartedInsideRef.current = true;
        },
        onMouseUp() {
          endedOrStartedInsideRef.current = true;
        },
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, referencePress, outsidePressEvent, referencePressEvent, onOpenChange, closeOnEscapeKeyDown]);
}

let devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /*#__PURE__*/new Set();
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  var _options$elements2;
  if (options === void 0) {
    options = {};
  }
  const {
    open = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options;
  if (process.env.NODE_ENV !== "production") {
    var _options$elements;
    const err = 'Floating UI: Cannot pass a virtual element to the ' + '`elements.reference` option, as it must be a real DOM element. ' + 'Use `refs.setPositionReference` instead.';
    if ((_options$elements = options.elements) != null && _options$elements.reference && !isElement(options.elements.reference)) {
      var _devMessageSet;
      if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(err))) {
        var _devMessageSet2;
        (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(err);
        console.error(err);
      }
    }
  }
  const [_domReference, setDomReference] = React.useState(null);
  const domReference = ((_options$elements2 = options.elements) == null ? void 0 : _options$elements2.reference) || _domReference;
  const position = useFloating$1(options);
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const onOpenChange = useEffectEvent((open, event, reason) => {
    if (open) {
      dataRef.current.openEvent = event;
    }
    events.emit('openchange', {
      open,
      event,
      reason,
      nested
    });
    unstable_onOpenChange == null || unstable_onOpenChange(open, event, reason);
  });
  const domReferenceRef = React.useRef(null);
  const dataRef = React.useRef({});
  const events = React.useState(() => createPubSub())[0];
  const floatingId = useId();
  const setPositionReference = React.useCallback(node => {
    const positionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = React.useCallback(node => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = React.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    floatingId,
    events,
    open,
    onOpenChange
  }), [position, nodeId, floatingId, events, open, onOpenChange, refs, elements]);
  index(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    refs,
    elements: {
      floating,
      domReference
    }
  } = context;
  const {
    enabled = true,
    visibleOnly = true
  } = props;
  const blockFocusRef = React.useRef(false);
  const timeoutRef = React.useRef();
  const keyboardModalityRef = React.useRef(true);
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    const win = getWindow(domReference);

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && isHTMLElement(domReference) && domReference === activeElement(getDocument(domReference))) {
        blockFocusRef.current = true;
      }
    }
    function onKeyDown() {
      keyboardModalityRef.current = true;
    }
    win.addEventListener('blur', onBlur);
    win.addEventListener('keydown', onKeyDown, true);
    return () => {
      win.removeEventListener('blur', onBlur);
      win.removeEventListener('keydown', onKeyDown, true);
    };
  }, [floating, domReference, open, enabled]);
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onOpenChange(_ref) {
      let {
        reason
      } = _ref;
      if (reason === 'reference-press' || reason === 'escape-key') {
        blockFocusRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [events, enabled]);
  React.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onPointerDown(event) {
          if (isVirtualPointerEvent(event.nativeEvent)) return;
          keyboardModalityRef.current = false;
        },
        onMouseLeave() {
          blockFocusRef.current = false;
        },
        onFocus(event) {
          if (blockFocusRef.current) return;
          const target = getTarget(event.nativeEvent);
          if (visibleOnly && isElement(target)) {
            try {
              // Mac Safari unreliably matches `:focus-visible` on the reference
              // if focus was outside the page initially - use the fallback
              // instead.
              if (isSafari() && isMac()) throw Error();
              if (!target.matches(':focus-visible')) return;
            } catch (e) {
              // Old browsers will throw an error when using `:focus-visible`.
              if (!keyboardModalityRef.current && !isTypeableElement(target)) {
                return;
              }
            }
          }
          onOpenChange(true, event.nativeEvent, 'focus');
        },
        onBlur(event) {
          blockFocusRef.current = false;
          const relatedTarget = event.relatedTarget;

          // Hit the non-modal focus management portal guard. Focus will be
          // moved into the floating element immediately after.
          const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';

          // Wait for the window blur listener to fire.
          timeoutRef.current = window.setTimeout(() => {
            const activeEl = activeElement(domReference ? domReference.ownerDocument : document);

            // Focus left the page, keep it open.
            if (!relatedTarget && activeEl === domReference) return;

            // When focusing the reference element (e.g. regular click), then
            // clicking into the floating element, prevent it from hiding.
            // Note: it must be focusable, e.g. `tabindex="-1"`.
            if (contains(refs.floating.current, relatedTarget) || contains(domReference, relatedTarget) || movedToFocusGuard) {
              return;
            }
            onOpenChange(false, event.nativeEvent, 'focus');
          });
        }
      }
    };
  }, [enabled, visibleOnly, domReference, refs, onOpenChange]);
}

const ACTIVE_KEY = 'active';
const SELECTED_KEY = 'selected';
function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  const isItem = elementKey === 'item';
  let domUserProps = userProps;
  if (isItem && userProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {
      [ACTIVE_KEY]: _,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1
    }),
    ...domUserProps,
    ...propsList.map(value => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === 'function') {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}

/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  // The dependencies are a dynamic array, so we can't use the linter's
  // suggestion to add it to the deps array.
  const deps = propsList;
  const getReferenceProps = React.useCallback(userProps => mergeProps(userProps, propsList, 'reference'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getFloatingProps = React.useCallback(userProps => mergeProps(userProps, propsList, 'floating'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getItemProps = React.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // Granularly check for `item` changes, because the `getItemProps` getter
  // should be as referentially stable as possible since it may be passed as
  // a prop to many components. All `item` key values must therefore be
  // memoized.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  propsList.map(key => key == null ? void 0 : key.item));
  return React.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}

let isPreventScrollSupported = false;
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;
    case 'horizontal':
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === ARROW_UP || key === ARROW_DOWN;
  const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === ARROW_DOWN;
  const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key == ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  const horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  const horizontal = key === ARROW_UP;
  return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */
function useListNavigation(context, props) {
  const {
    open,
    onOpenChange,
    refs,
    elements: {
      domReference,
      floating
    }
  } = context;
  const {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {},
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = 'auto',
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = undefined,
    orientation = 'vertical',
    cols = 1,
    scrollItemIntoView = true,
    virtualItemRef,
    itemSizes,
    dense = false
  } = props;
  if (process.env.NODE_ENV !== "production") {
    if (allowEscape) {
      if (!loop) {
        console.warn(['Floating UI: `useListNavigation` looping must be enabled to allow', 'escaping.'].join(' '));
      }
      if (!virtual) {
        console.warn(['Floating UI: `useListNavigation` must be virtual to allow', 'escaping.'].join(' '));
      }
    }
    if (orientation === 'vertical' && cols > 1) {
      console.warn(['Floating UI: In grid list navigation mode (`cols` > 1), the', '`orientation` should be either "horizontal" or "both".'].join(' '));
    }
  }
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  const onNavigate = useEffectEvent(unstable_onNavigate);
  const focusItemOnOpenRef = React.useRef(focusItemOnOpen);
  const indexRef = React.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = React.useRef(null);
  const isPointerModalityRef = React.useRef(true);
  const previousOnNavigateRef = React.useRef(onNavigate);
  const previousMountedRef = React.useRef(!!floating);
  const forceSyncFocus = React.useRef(false);
  const forceScrollIntoViewRef = React.useRef(false);
  const disabledIndicesRef = useLatestRef(disabledIndices);
  const latestOpenRef = useLatestRef(open);
  const scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
  const [activeId, setActiveId] = React.useState();
  const [virtualId, setVirtualId] = React.useState();
  const focusItem = useEffectEvent(function (listRef, indexRef, forceScrollIntoView) {
    if (forceScrollIntoView === void 0) {
      forceScrollIntoView = false;
    }
    const item = listRef.current[indexRef.current];
    if (!item) return;
    if (virtual) {
      setActiveId(item.id);
      tree == null || tree.events.emit('virtualfocus', item);
      if (virtualItemRef) {
        virtualItemRef.current = item;
      }
    } else {
      enqueueFocus(item, {
        preventScroll: true,
        // Mac Safari does not move the virtual cursor unless the focus call
        // is sync. However, for the very first focus call, we need to wait
        // for the position to be ready in order to prevent unwanted
        // scrolling. This means the virtual cursor will not move to the first
        // item when first opening the floating element, but will on
        // subsequent calls. `preventScroll` is supported in modern Safari,
        // so we can use that instead.
        // iOS Safari must be async or the first item will not be focused.
        sync: isMac() && isSafari() ? isPreventScrollSupported || forceSyncFocus.current : false
      });
    }
    requestAnimationFrame(() => {
      const scrollIntoViewOptions = scrollItemIntoViewRef.current;
      const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
        // by all browsers.
        item.scrollIntoView == null || item.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
          block: 'nearest',
          inline: 'nearest'
        } : scrollIntoViewOptions);
      }
    });
  });
  index(() => {
    document.createElement('div').focus({
      get preventScroll() {
        isPreventScrollSupported = true;
        return false;
      }
    });
  }, []);

  // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.
  index(() => {
    if (!enabled) {
      return;
    }
    if (open && floating) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        // Regardless of the pointer modality, we want to ensure the selected
        // item comes into view when the floating element is opened.
        forceScrollIntoViewRef.current = true;
        onNavigate(selectedIndex);
      }
    } else if (previousMountedRef.current) {
      // Since the user can specify `onNavigate` conditionally
      // (onNavigate: open ? setActiveIndex : setSelectedIndex),
      // we store and call the previous function.
      indexRef.current = -1;
      previousOnNavigateRef.current(null);
    }
  }, [enabled, open, floating, selectedIndex, onNavigate]);

  // Sync `activeIndex` to be the focused item while the floating element is
  // open.
  index(() => {
    if (!enabled) {
      return;
    }
    if (open && floating) {
      if (activeIndex == null) {
        forceSyncFocus.current = false;
        if (selectedIndex != null) {
          return;
        }

        // Reset while the floating element was open (e.g. the list changed).
        if (previousMountedRef.current) {
          indexRef.current = -1;
          focusItem(listRef, indexRef);
        }

        // Initial sync.
        if (!previousMountedRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
          let runs = 0;
          const waitForListPopulated = () => {
            if (listRef.current[0] == null) {
              // Avoid letting the browser paint if possible on the first try,
              // otherwise use rAF. Don't try more than twice, since something
              // is wrong otherwise.
              if (runs < 2) {
                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                scheduler(waitForListPopulated);
              }
              runs++;
            } else {
              indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
              keyRef.current = null;
              onNavigate(indexRef.current);
            }
          };
          waitForListPopulated();
        }
      } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
        indexRef.current = activeIndex;
        focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
        forceScrollIntoViewRef.current = false;
      }
    }
  }, [enabled, open, floating, activeIndex, selectedIndex, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);

  // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.
  index(() => {
    var _nodes$find;
    if (!enabled || floating || !tree || virtual || !previousMountedRef.current) {
      return;
    }
    const nodes = tree.nodesRef.current;
    const parent = (_nodes$find = nodes.find(node => node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
    const activeEl = activeElement(getDocument(floating));
    const treeContainsActiveEl = nodes.some(node => node.context && contains(node.context.elements.floating, activeEl));
    if (parent && !treeContainsActiveEl && isPointerModalityRef.current) {
      parent.focus({
        preventScroll: true
      });
    }
  }, [enabled, floating, tree, parentId, virtual]);
  index(() => {
    if (!enabled || !tree || !virtual || parentId) return;
    function handleVirtualFocus(item) {
      setVirtualId(item.id);
      if (virtualItemRef) {
        virtualItemRef.current = item;
      }
    }
    tree.events.on('virtualfocus', handleVirtualFocus);
    return () => {
      tree.events.off('virtualfocus', handleVirtualFocus);
    };
  }, [enabled, tree, virtual, parentId, virtualItemRef]);
  index(() => {
    previousOnNavigateRef.current = onNavigate;
    previousMountedRef.current = !!floating;
  });
  index(() => {
    if (!open) {
      keyRef.current = null;
    }
  }, [open]);
  const hasActiveIndex = activeIndex != null;
  const item = React.useMemo(() => {
    function syncCurrentTarget(currentTarget) {
      if (!open) return;
      const index = listRef.current.indexOf(currentTarget);
      if (index !== -1) {
        onNavigate(index);
      }
    }
    const props = {
      onFocus(_ref) {
        let {
          currentTarget
        } = _ref;
        syncCurrentTarget(currentTarget);
      },
      onClick: _ref2 => {
        let {
          currentTarget
        } = _ref2;
        return currentTarget.focus({
          preventScroll: true
        });
      },
      // Safari
      ...(focusItemOnHover && {
        onMouseMove(_ref3) {
          let {
            currentTarget
          } = _ref3;
          syncCurrentTarget(currentTarget);
        },
        onPointerLeave(_ref4) {
          let {
            pointerType
          } = _ref4;
          if (!isPointerModalityRef.current || pointerType === 'touch') {
            return;
          }
          indexRef.current = -1;
          focusItem(listRef, indexRef);
          onNavigate(null);
          if (!virtual) {
            enqueueFocus(refs.floating.current, {
              preventScroll: true
            });
          }
        }
      })
    };
    return props;
  }, [open, refs, focusItem, focusItemOnHover, listRef, onNavigate, virtual]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    const disabledIndices = disabledIndicesRef.current;
    function onKeyDown(event) {
      isPointerModalityRef.current = false;
      forceSyncFocus.current = true;

      // If the floating element is animating out, ignore navigation. Otherwise,
      // the `activeIndex` gets set to 0 despite not being open so the next time
      // the user ArrowDowns, the first item won't be focused.
      if (!latestOpenRef.current && event.currentTarget === refs.floating.current) {
        return;
      }
      if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
        stopEvent(event);
        onOpenChange(false, event.nativeEvent, 'list-navigation');
        if (isHTMLElement(domReference) && !virtual) {
          domReference.focus();
        }
        return;
      }
      const currentIndex = indexRef.current;
      const minIndex = getMinIndex(listRef, disabledIndices);
      const maxIndex = getMaxIndex(listRef, disabledIndices);
      if (event.key === 'Home') {
        stopEvent(event);
        indexRef.current = minIndex;
        onNavigate(indexRef.current);
      }
      if (event.key === 'End') {
        stopEvent(event);
        indexRef.current = maxIndex;
        onNavigate(indexRef.current);
      }

      // Grid navigation.
      if (cols > 1) {
        const sizes = itemSizes || Array.from({
          length: listRef.current.length
        }, () => ({
          width: 1,
          height: 1
        }));
        // To calculate movements on the grid, we use hypothetical cell indices
        // as if every item was 1x1, then convert back to real indices.
        const cellMap = buildCellMap(sizes, cols, dense);
        const minGridIndex = cellMap.findIndex(index => index != null && !(disabledIndices != null && disabledIndices.includes(index)));
        // last enabled index
        const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !(disabledIndices != null && disabledIndices.includes(index)) ? cellIndex : foundIndex, -1);
        indexRef.current = cellMap[getGridNavigatedIndex({
          current: cellMap.map(itemIndex => itemIndex != null ? listRef.current[itemIndex] : null)
        }, {
          event,
          orientation,
          loop,
          cols,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: getCellIndices([...(disabledIndices || []), undefined], cellMap),
          minIndex: minGridIndex,
          maxIndex: maxGridIndex,
          prevIndex: getCellIndexOfCorner(indexRef.current, sizes, cellMap, cols,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          event.key === ARROW_DOWN ? 'bl' : event.key === ARROW_RIGHT ? 'tr' : 'tl'),
          stopEvent: true
        })]; // navigated cell will never be nullish

        onNavigate(indexRef.current);
        if (orientation === 'both') {
          return;
        }
      }
      if (isMainOrientationKey(event.key, orientation)) {
        stopEvent(event);

        // Reset the index if no item is focused.
        if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
          indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
          onNavigate(indexRef.current);
          return;
        }
        if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
          if (loop) {
            indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            });
          } else {
            indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              disabledIndices
            }));
          }
        } else {
          if (loop) {
            indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            });
          } else {
            indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
              startingIndex: currentIndex,
              decrement: true,
              disabledIndices
            }));
          }
        }
        if (isIndexOutOfBounds(listRef, indexRef.current)) {
          onNavigate(null);
        } else {
          onNavigate(indexRef.current);
        }
      }
    }
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === 'auto' && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      // `pointerdown` fires first, reset the state then perform the checks.
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === 'auto' && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    const ariaActiveDescendantProp = virtual && open && hasActiveIndex && {
      'aria-activedescendant': virtualId || activeId
    };
    const activeItem = listRef.current.find(item => (item == null ? void 0 : item.id) === activeId);
    return {
      reference: {
        ...ariaActiveDescendantProp,
        onKeyDown(event) {
          isPointerModalityRef.current = false;
          const isArrowKey = event.key.indexOf('Arrow') === 0;
          const isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
          const isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl);
          const isMainKey = isMainOrientationKey(event.key, orientation);
          const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
          if (virtual && open) {
            const rootNode = tree == null ? void 0 : tree.nodesRef.current.find(node => node.parentId == null);
            const deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
            if (isArrowKey && deepestNode && virtualItemRef) {
              const eventObject = new KeyboardEvent('keydown', {
                key: event.key,
                bubbles: true
              });
              if (isCrossOpenKey || isCrossCloseKey) {
                var _deepestNode$context, _deepestNode$context2;
                const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? activeItem : null;
                if (dispatchItem) {
                  stopEvent(event);
                  dispatchItem.dispatchEvent(eventObject);
                  setVirtualId(undefined);
                }
              }
              if (isMainKey && deepestNode.context) {
                if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                  var _deepestNode$context$;
                  stopEvent(event);
                  (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                  return;
                }
              }
            }
            return onKeyDown(event);
          }

          // If a floating element should not open on arrow key down, avoid
          // setting `activeIndex` while it's closed.
          if (!open && !openOnArrowKeyDown && isArrowKey) {
            return;
          }
          if (isNavigationKey) {
            keyRef.current = nested && isMainKey ? null : event.key;
          }
          if (nested) {
            if (isCrossOpenKey) {
              stopEvent(event);
              if (open) {
                indexRef.current = getMinIndex(listRef, disabledIndices);
                onNavigate(indexRef.current);
              } else {
                onOpenChange(true, event.nativeEvent, 'list-navigation');
              }
            }
            return;
          }
          if (isMainKey) {
            if (selectedIndex != null) {
              indexRef.current = selectedIndex;
            }
            stopEvent(event);
            if (!open && openOnArrowKeyDown) {
              onOpenChange(true, event.nativeEvent, 'list-navigation');
            } else {
              onKeyDown(event);
            }
            if (open) {
              onNavigate(indexRef.current);
            }
          }
        },
        onFocus() {
          if (open) {
            onNavigate(null);
          }
        },
        onPointerDown: checkVirtualPointer,
        onMouseDown: checkVirtualMouse,
        onClick: checkVirtualMouse
      },
      floating: {
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        ...(!isTypeableCombobox(domReference) && ariaActiveDescendantProp),
        onKeyDown,
        onPointerMove() {
          isPointerModalityRef.current = true;
        }
      },
      item
    };
  }, [domReference, refs, activeId, virtualId, disabledIndicesRef, latestOpenRef, listRef, enabled, orientation, rtl, virtual, open, hasActiveIndex, nested, selectedIndex, openOnArrowKeyDown, allowEscape, cols, loop, focusItemOnOpen, onNavigate, onOpenChange, item, tree, virtualItemRef, itemSizes, dense]);
}

const componentRoleToAriaRoleMap = /*#__PURE__*/new Map([['select', 'listbox'], ['combobox', 'listbox'], ['label', false]]);

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  var _componentRoleToAriaR;
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = 'dialog'
  } = props;
  const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
  const referenceId = useId();
  const parentId = useFloatingParentNodeId();
  const isNested = parentId != null;
  return React.useMemo(() => {
    if (!enabled) return {};
    const floatingProps = {
      id: floatingId,
      ...(ariaRole && {
        role: ariaRole
      })
    };
    if (ariaRole === 'tooltip' || role === 'label') {
      return {
        reference: {
          ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        },
        floating: floatingProps
      };
    }
    return {
      reference: {
        'aria-expanded': open ? 'true' : 'false',
        'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
        'aria-controls': open ? floatingId : undefined,
        ...(ariaRole === 'listbox' && {
          role: 'combobox'
        }),
        ...(ariaRole === 'menu' && {
          id: referenceId
        }),
        ...(ariaRole === 'menu' && isNested && {
          role: 'menuitem'
        }),
        ...(role === 'select' && {
          'aria-autocomplete': 'none'
        }),
        ...(role === 'combobox' && {
          'aria-autocomplete': 'list'
        })
      },
      floating: {
        ...floatingProps,
        ...(ariaRole === 'menu' && {
          'aria-labelledby': referenceId
        })
      },
      item(_ref) {
        let {
          active,
          selected
        } = _ref;
        const commonProps = {
          role: 'option',
          ...(active && {
            id: floatingId + "-option"
          })
        };

        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch (role) {
          case 'select':
            return {
              ...commonProps,
              'aria-selected': active && selected
            };
          case 'combobox':
            {
              return {
                ...commonProps,
                ...(active && {
                  'aria-selected': true
                })
              };
            }
        }
        return {};
      }
    };
  }, [enabled, role, ariaRole, open, floatingId, referenceId, isNested]);
}

// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const camelCaseToKebabCase = str => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = React.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  React.useEffect(() => {
    if (!open) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, durationMs]);
  return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === 'number';
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [initiated, setInitiated] = React.useState(false);
  const [status, setStatus] = React.useState('unmounted');
  const isMounted = useDelayUnmount(open, closeDuration);

  // `initiated` check prevents this `setState` call from breaking
  // <FloatingPortal />. This call is necessary to ensure subsequent opens
  // after the initial one allows the correct side animation to play when the
  // placement has changed.
  index(() => {
    if (initiated && !isMounted) {
      setStatus('unmounted');
    }
  }, [initiated, isMounted]);
  index(() => {
    if (!floating) return;
    if (open) {
      setStatus('initial');
      const frame = requestAnimationFrame(() => {
        setStatus('open');
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    } else {
      setInitiated(true);
      setStatus('close');
    }
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = props;
  const placement = context.placement;
  const side = placement.split('-')[0];
  const fnArgs = React.useMemo(() => ({
    side,
    placement
  }), [side, placement]);
  const isNumberDuration = typeof duration === 'number';
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [styles, setStyles] = React.useState(() => ({
    ...execWithArgsOrReturn(unstable_common, fnArgs),
    ...execWithArgsOrReturn(unstable_initial, fnArgs)
  }));
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = useLatestRef(unstable_initial);
  const openRef = useLatestRef(unstable_open);
  const closeRef = useLatestRef(unstable_close);
  const commonRef = useLatestRef(unstable_common);
  index(() => {
    const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});
    if (status === 'initial') {
      setStyles(styles => ({
        transitionProperty: styles.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === 'open') {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === 'close') {
      const styles = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(','),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles
      });
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted,
    styles
  };
}

function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside = false;
  const length = polygon.length;
  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safePolygon
 */
function safePolygon(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    buffer = 0.5,
    blockPointerEvents = false,
    requireIntent = true
  } = options;
  let timeoutId;
  let hasLanded = false;
  let lastX = null;
  let lastY = null;
  let lastCursorTime = performance.now();
  function getCursorSpeed(x, y) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0) {
      lastX = x;
      lastY = y;
      lastCursorTime = currentTime;
      return null;
    }
    const deltaX = x - lastX;
    const deltaY = y - lastY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const speed = distance / elapsedTime; // px / ms

    lastX = x;
    lastY = y;
    lastCursorTime = currentTime;
    return speed;
  }
  const fn = _ref => {
    let {
      x,
      y,
      placement,
      elements,
      onClose,
      nodeId,
      tree
    } = _ref;
    return function onMouseMove(event) {
      function close() {
        clearTimeout(timeoutId);
        onClose();
      }
      clearTimeout(timeoutId);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      const {
        clientX,
        clientY
      } = event;
      const clientPoint = [clientX, clientY];
      const target = getTarget(event);
      const isLeave = event.type === 'mouseleave';
      const isOverFloatingEl = contains(elements.floating, target);
      const isOverReferenceEl = contains(elements.domReference, target);
      const refRect = elements.domReference.getBoundingClientRect();
      const rect = elements.floating.getBoundingClientRect();
      const side = placement.split('-')[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      const isOverReferenceRect = isInside(clientPoint, refRect);
      const isFloatingWider = rect.width > refRect.width;
      const isFloatingTaller = rect.height > refRect.height;
      const left = (isFloatingWider ? refRect : rect).left;
      const right = (isFloatingWider ? refRect : rect).right;
      const top = (isFloatingTaller ? refRect : rect).top;
      const bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }

      // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910
      if (isLeave && isElement(event.relatedTarget) && contains(elements.floating, event.relatedTarget)) {
        return;
      }

      // If any nested child is open, abort.
      if (tree && getChildren(tree.nodesRef.current, nodeId).some(_ref2 => {
        let {
          context
        } = _ref2;
        return context == null ? void 0 : context.open;
      })) {
        return;
      }

      // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.
      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      }

      // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.
      let rectPoly = [];
      switch (side) {
        case 'top':
          rectPoly = [[left, refRect.top + 1], [left, rect.bottom - 1], [right, rect.bottom - 1], [right, refRect.top + 1]];
          break;
        case 'bottom':
          rectPoly = [[left, rect.top + 1], [left, refRect.bottom - 1], [right, refRect.bottom - 1], [right, rect.top + 1]];
          break;
        case 'left':
          rectPoly = [[rect.right - 1, bottom], [rect.right - 1, top], [refRect.left + 1, top], [refRect.left + 1, bottom]];
          break;
        case 'right':
          rectPoly = [[refRect.right - 1, bottom], [refRect.right - 1, top], [rect.left + 1, top], [rect.left + 1, bottom]];
          break;
      }
      function getPolygon(_ref3) {
        let [x, y] = _ref3;
        switch (side) {
          case 'top':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'bottom':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'left':
            {
              const cursorPointOne = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [...commonPoints, cursorPointOne, cursorPointTwo];
            }
          case 'right':
            {
              const cursorPointOne = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
        }
      }
      if (isPointInPolygon([clientX, clientY], rectPoly)) {
        return;
      } else if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isLeave && requireIntent) {
        const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
        const cursorSpeedThreshold = 0.1;
        if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) {
          return close();
        }
      }
      if (!isPointInPolygon([clientX, clientY], getPolygon([x, y]))) {
        close();
      } else if (!hasLanded && requireIntent) {
        timeoutId = window.setTimeout(close, 40);
      }
    };
  };
  fn.__options = {
    blockPointerEvents
  };
  return fn;
}

var selectFloating = 'Select_selectFloating__ycfr9r0';
var selectItem = createRuntimeFn({
  defaultClassName: 'Select_selectItem__ycfr9re',
  variantClassNames: {
    active: {
      true: 'Select_selectItem_active_true__ycfr9rf'
    },
    selected: {
      true: 'Select_selectItem_selected_true__ycfr9rg'
    },
    disabled: {
      true: 'Select_selectItem_disabled_true__ycfr9rh'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var selectList = 'Select_selectList__ycfr9rd';
var selectMenu = createRuntimeFn({
  defaultClassName: 'Select_selectMenu__ycfr9r1',
  variantClassNames: {
    isTransition: {
      true: 'Select_selectMenu_isTransition_true__ycfr9r2'
    },
    isOpen: {
      true: 'Select_selectMenu_isOpen_true__ycfr9r3',
      false: 'Select_selectMenu_isOpen_false__ycfr9r4'
    },
    placement: {
      top: 'Select_selectMenu_placement_top__ycfr9r5',
      bottom: 'Select_selectMenu_placement_bottom__ycfr9r6',
      left: 'Select_selectMenu_placement_left__ycfr9r7',
      right: 'Select_selectMenu_placement_right__ycfr9r8'
    }
  },
  defaultVariants: {},
  compoundVariants: [[{
    isOpen: false,
    placement: 'top'
  }, 'Select_selectMenu_compound_0__ycfr9r9'], [{
    isOpen: false,
    placement: 'bottom'
  }, 'Select_selectMenu_compound_1__ycfr9ra'], [{
    isOpen: false,
    placement: 'left'
  }, 'Select_selectMenu_compound_2__ycfr9rb'], [{
    isOpen: false,
    placement: 'right'
  }, 'Select_selectMenu_compound_3__ycfr9rc']]
});

var spinner = 'Spinner_spinner__1s5pscb1';

var Spinner = function (props) {
  var className = props.className,
    color = props.color,
    _a = props.size,
    size = _a === void 0 ? '1em' : _a,
    args = __rest$1(props, ["className", "color", "size"]);
  return jsx("svg", __assign$1({
    className: clsx(spinner, sprinkles({
      color: color
    }), className),
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 1024 1024",
    height: size,
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, args, {
    children: jsx("path", {
      d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
    })
  }));
};

var selectChevron$1 = createRuntimeFn({
  defaultClassName: 'SelectButton_selectChevron__m23ek7f',
  variantClassNames: {
    open: {
      true: 'SelectButton_selectChevron_open_true__m23ek7g'
    },
    disabled: {
      true: 'SelectButton_selectChevron_disabled_true__m23ek7h'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var selectIcon$1 = 'SelectButton_selectIcon__m23ek7e';
var selectInput = createRuntimeFn({
  defaultClassName: 'SelectButton_selectInput__m23ek75',
  variantClassNames: {
    block: {
      true: 'SelectButton_selectInput_block_true__m23ek76'
    },
    error: {
      true: 'SelectButton_selectInput_error_true__m23ek77'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var selectInputLabel = createRuntimeFn({
  defaultClassName: 'SelectButton_selectInputLabel__m23ek78',
  variantClassNames: {
    buttonMode: {
      false: 'SelectButton_selectInputLabel_buttonMode_false__m23ek79',
      true: 'SelectButton_selectInputLabel_buttonMode_true__m23ek7a'
    },
    block: {
      true: 'SelectButton_selectInputLabel_block_true__m23ek7b'
    },
    open: {
      true: 'SelectButton_selectInputLabel_open_true__m23ek7c'
    },
    disabled: {
      true: 'SelectButton_selectInputLabel_disabled_true__m23ek7d'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var selectInputWrapper$1 = createRuntimeFn({
  defaultClassName: 'SelectButton_selectInputWrapper__m23ek70',
  variantClassNames: {
    block: {
      true: 'SelectButton_selectInputWrapper_block_true__m23ek71'
    },
    size: {
      small: 'SelectButton_selectInputWrapper_size_small__m23ek72',
      medium: 'SelectButton_selectInputWrapper_size_medium__m23ek73',
      large: 'SelectButton_selectInputWrapper_size_large__m23ek74'
    }
  },
  defaultVariants: {
    block: false,
    size: 'medium'
  },
  compoundVariants: []
});

/**
 * 텍스트 입력을 받는 Select Button 컴포넌트입니다.
 */
var SelectButton = React__default.forwardRef(function (props, ref) {
  var open = props.open,
    children = props.children,
    _a = props.inputType,
    inputType = _a === void 0 ? 'text' : _a,
    block = props.block,
    error = props.error,
    disabled = props.disabled,
    loading = props.loading,
    onlyButton = props.onlyButton,
    _b = props.size,
    size = _b === void 0 ? 'medium' : _b,
    style = props.style,
    className = props.className,
    args = __rest$1(props, ["open", "children", "inputType", "block", "error", "disabled", "loading", "onlyButton", "size", "style", "className"]);
  return jsxs("div", {
    className: clsx(className, selectInputWrapper$1({
      block: block,
      size: size
    })),
    style: style,
    children: [jsx("input", __assign$1({
      ref: ref
    }, args, {
      className: selectInput({
        block: block,
        error: error
      }),
      type: onlyButton ? 'button' : inputType,
      readOnly: onlyButton,
      disabled: disabled
    })), !!children && jsx("div", {
      className: selectInputLabel({
        buttonMode: onlyButton,
        block: block,
        open: open,
        disabled: disabled
      }),
      children: jsx("div", {
        style: {
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        },
        children: children
      })
    }), loading ? jsx("div", {
      className: selectIcon$1,
      children: jsx(Spinner, {})
    }) : jsx("svg", {
      className: selectChevron$1({
        open: open,
        disabled: disabled
      }),
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsx("path", {
        d: "M16 7L10 13L4 7",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    })]
  });
});

var selectEmpty = 'SelectEmpty_selectEmpty__jql5lu0';

var SelectEmpty = function () {
  return jsxs("div", {
    className: selectEmpty,
    children: [jsxs("svg", {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        d: "M30 6.25H10C7.96875 6.25 6.64062 7.34375 6.25 9.375L3.75 21.25V30C3.75289 30.9937 4.1489 31.9458 4.85154 32.6485C5.55417 33.3511 6.50633 33.7471 7.5 33.75H32.5C33.4937 33.7471 34.4458 33.3511 35.1485 32.6485C35.8511 31.9458 36.2471 30.9937 36.25 30V21.25L33.75 9.375C33.3594 7.26562 31.9531 6.25 30 6.25Z",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M3.75 21.25H15C15 22.5761 15.5268 23.8479 16.4645 24.7855C17.4021 25.7232 18.6739 26.25 20 26.25C21.3261 26.25 22.5979 25.7232 23.5355 24.7855C24.4732 23.8479 25 22.5761 25 21.25H36.25",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), jsx("div", {
      children: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
    })]
  });
};

var selectButtonInput = 'SelectTagsButton_selectButtonInput__19k3sovd';
var selectButtonTag = createRuntimeFn({
  defaultClassName: 'SelectTagsButton_selectButtonTag__19k3sov9',
  variantClassNames: {
    size: {
      small: 'SelectTagsButton_selectButtonTag_size_small__19k3sova',
      medium: 'SelectTagsButton_selectButtonTag_size_medium__19k3sovb',
      large: 'SelectTagsButton_selectButtonTag_size_large__19k3sovc'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var selectChevron = createRuntimeFn({
  defaultClassName: 'SelectTagsButton_selectChevron__19k3sovf',
  variantClassNames: {
    open: {
      true: 'SelectTagsButton_selectChevron_open_true__19k3sovg'
    },
    disabled: {
      true: 'SelectTagsButton_selectChevron_disabled_true__19k3sovh'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var selectIcon = 'SelectTagsButton_selectIcon__19k3sove';
var selectInputWrapper = createRuntimeFn({
  defaultClassName: 'SelectTagsButton_selectInputWrapper__19k3sov2',
  variantClassNames: {
    block: {
      true: 'SelectTagsButton_selectInputWrapper_block_true__19k3sov3'
    },
    size: {
      small: 'SelectTagsButton_selectInputWrapper_size_small__19k3sov4',
      medium: 'SelectTagsButton_selectInputWrapper_size_medium__19k3sov5',
      large: 'SelectTagsButton_selectInputWrapper_size_large__19k3sov6'
    },
    disabled: {
      true: 'SelectTagsButton_selectInputWrapper_disabled_true__19k3sov7'
    },
    error: {
      true: 'SelectTagsButton_selectInputWrapper_error_true__19k3sov8'
    }
  },
  defaultVariants: {
    block: false,
    size: 'medium'
  },
  compoundVariants: []
});

var SelectTagsButton = React__default.forwardRef(function (props, ref) {
  var positionRef = props.positionRef,
    open = props.open,
    selectedTags = props.selectedTags,
    block = props.block,
    error = props.error,
    disabled = props.disabled,
    loading = props.loading,
    size = props.size,
    style = props.style,
    className = props.className,
    onOpen = props.onOpen,
    args = __rest$1(props, ["positionRef", "open", "selectedTags", "block", "error", "disabled", "loading", "size", "style", "className", "onOpen"]);
  return jsxs("div", {
    ref: positionRef,
    className: clsx(className, selectInputWrapper({
      block: block,
      size: size,
      disabled: disabled,
      error: error
    })),
    style: style,
    onClick: onOpen,
    children: [selectedTags.map(function (e, index) {
      return jsx("div", {
        className: selectButtonTag({
          size: size
        }),
        children: e === null || e === void 0 ? void 0 : e.label
      }, "".concat(e === null || e === void 0 ? void 0 : e.value, "-").concat(index));
    }), jsx("input", __assign$1({
      ref: ref,
      className: selectButtonInput,
      type: "text",
      disabled: disabled
    }, args)), loading ? jsx("div", {
      className: selectIcon,
      children: jsx(Spinner, {})
    }) : jsx("svg", {
      className: selectChevron({
        open: open,
        disabled: disabled
      }),
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsx("path", {
        d: "M16 7L10 13L4 7",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    })]
  });
});

var SelectTags = function (props) {
  var value = props.value,
    _a = props.placeholder,
    placeholder = _a === void 0 ? '선택' : _a,
    _b = props.inputPlaceholder,
    inputPlaceholder = _b === void 0 ? '선택 또는 직접입력' : _b,
    _c = props.customInputText,
    customInputText = _c === void 0 ? '직접입력' : _c,
    _d = props.options,
    options = _d === void 0 ? [] : _d,
    _e = props.placement,
    placement = _e === void 0 ? 'bottom-start' : _e,
    _f = props.matchWidth,
    matchWidth = _f === void 0 ? true : _f,
    _g = props.block,
    block = _g === void 0 ? false : _g,
    _h = props.disabled,
    disabled = _h === void 0 ? false : _h,
    _j = props.loading,
    loading = _j === void 0 ? false : _j,
    _k = props.error,
    error = _k === void 0 ? false : _k,
    _l = props.size,
    size$1 = _l === void 0 ? 'medium' : _l,
    style = props.style,
    onChange = props.onChange,
    args = __rest$1(props, ["value", "placeholder", "inputPlaceholder", "customInputText", "options", "placement", "matchWidth", "block", "disabled", "loading", "error", "size", "style", "onChange"]);
  var _m = useState(false),
    open = _m[0],
    setOpen = _m[1];
  var _o = useState(''),
    inputValue = _o[0],
    setInputValue = _o[1];
  var _p = useState(null),
    activeIndex = _p[0],
    setActiveIndex = _p[1];
  var _q = useState(false),
    isEntered = _q[0],
    setIsEntered = _q[1];
  var listRef = useRef([]);
  var inputRef = useRef(null);
  /**
   * options에 포함되어 있지 않은 항목을 value에서 추출하여 병합합니다.
   */
  var mergedOptions = useMemo(function () {
    var _a;
    var virtualOptions = (_a = value === null || value === void 0 ? void 0 : value.filter(function (v) {
      return !options.find(function (o) {
        return o.value === v;
      });
    }).map(function (v) {
      return {
        label: v,
        value: v
      };
    })) !== null && _a !== void 0 ? _a : [];
    var mergedOptions = __spreadArray(__spreadArray([], options, true), virtualOptions, true);
    return mergedOptions;
  }, [options, value]);
  /**
   * 입력한 문자열과 일부 텍스트가 일치하는 항목을 필터링합니다.
   * 이 항목들은 실제로 화면 상에 디스플레이되는 데이터로 활용됩니다.
   */
  var items = useMemo(function () {
    return mergedOptions.filter(function (item) {
      var _a, _b;
      /**
       * 시작 문자가 동일하지 않더라도 문자열 내에 찾는
       * 문자열이 있는 경우를 모두 매치하는 방식
       */
      return (_b = (_a = item.label) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(inputValue.toLowerCase());
    });
  }, [mergedOptions, inputValue]);
  /**
   *
   * 입력한 문자열과 완전히 일치하는 항목을 찾고,
   * 없다면 입력한 문자열로 새로운 항목을 생성하는 기능이 활성화합니다.
   */
  var isCreateMode = useMemo(function () {
    if (!inputValue) return false;
    var exactMatchedOptions = mergedOptions.filter(function (option) {
      var _a;
      return ((_a = option.label) === null || _a === void 0 ? void 0 : _a.toString()) === inputValue;
    });
    return !exactMatchedOptions.length;
  }, [mergedOptions, inputValue]);
  /**
   * 선택된 항목의 index를 찾습니다.
   * 이때 index는 '보여지는 항목'들을 기준으로 하며, 복수가 선택되었을 경우
   * 그 중 가장 최상단에 위치한 항목을 선택합니다.
   */
  var selectedIndex = useMemo(function () {
    return items === null || items === void 0 ? void 0 : items.findIndex(function (e) {
      return e.value === (value === null || value === void 0 ? void 0 : value[0]);
    });
  }, [value, items]);
  /**
   * 현재 선택된 항목들을 모두 찾습니다. 이때 보이지 않는 항목들까지 모두 찾습니다.
   * 이 데이터는 SelectButton 영역에 표시됩니다.
   */
  var selectedOptions = useMemo(function () {
    var _a;
    return (_a = value === null || value === void 0 ? void 0 : value.map(function (v) {
      var matchedOption = options.find(function (o) {
        return o.value === v;
      });
      if (!matchedOption) {
        return {
          label: v,
          value: v
        };
      }
      return matchedOption;
    })) !== null && _a !== void 0 ? _a : [];
  }, [value, options]);
  var _r = useFloating({
      open: open,
      onOpenChange: function (value, event, reason) {
        if (!value) {
          setOpen(false);
          setInputValue('');
          return;
        }
        setOpen(true);
      },
      placement: placement,
      middleware: [size({
        apply: function (_a) {
          var rects = _a.rects,
            elements = _a.elements;
          if (!matchWidth) {
            Object.assign(elements.floating.style, {
              minWidth: "".concat(rects.reference.width, "px")
            });
            return;
          }
          /**
           * matchWidth가 true일 경우
           * 드롭다운 메뉴를 레퍼런스 트리거와 일치시킨다.
           */
          Object.assign(elements.floating.style, {
            width: "".concat(rects.reference.width, "px")
          });
        }
      })],
      whileElementsMounted: autoUpdate
    }),
    refs = _r.refs,
    floatingStyles = _r.floatingStyles,
    context = _r.context;
  var role = useRole(context, {
    role: 'listbox'
  });
  var click = useClick(context, {
    keyboardHandlers: false
  });
  var dismiss = useDismiss(context);
  var listNav = useListNavigation(context, {
    listRef: listRef,
    activeIndex: activeIndex,
    selectedIndex: selectedIndex,
    onNavigate: setActiveIndex,
    virtual: true,
    loop: true
  });
  var _s = useInteractions([role, click, dismiss, listNav]),
    getReferenceProps = _s.getReferenceProps,
    getFloatingProps = _s.getFloatingProps,
    getItemProps = _s.getItemProps;
  function handleChange(event) {
    var value = event.target.value;
    setInputValue(value);
    setActiveIndex(0);
  }
  /**
   * 📖 전환 애니메이션 처리
   */
  var _t = useTransitionStatus(context, {
      duration: 200
    }),
    isMounted = _t.isMounted,
    transitionStatus = _t.status;
  var computedPlacement = useMemo(function () {
    switch (placement) {
      case 'top':
      case 'top-end':
      case 'top-start':
        return 'top';
      case 'bottom':
      case 'bottom-end':
      case 'bottom-start':
        return 'bottom';
      case 'left':
      case 'left-end':
      case 'left-start':
        return 'left';
      case 'right':
      case 'right-end':
      case 'right-start':
        return 'right';
    }
  }, [placement]);
  var checkIsSelected = function (optionValue) {
    return !!(value === null || value === void 0 ? void 0 : value.find(function (v) {
      return v === optionValue;
    }));
  };
  var handleSelect = function (option) {
    if (option.single) {
      onChange === null || onChange === void 0 ? void 0 : onChange([option.value]);
      return;
    }
    // 선택한 옵션이 이미 있을 경우 제외
    if (value === null || value === void 0 ? void 0 : value.find(function (e) {
      return e === option.value;
    })) {
      onChange === null || onChange === void 0 ? void 0 : onChange(value.filter(function (v) {
        return v !== option.value;
      }));
      return;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], value || [], true), [option.value], false));
  };
  var renderMenu = function () {
    var menu = jsx(Fragment, {
      children: jsxs("ul", {
        className: selectList,
        children: [isCreateMode && jsxs("li", __assign$1({
          role: "option"
        }, getItemProps({
          ref: function (node) {
            // 목록의 마지막줄에 새로운 listRef를 생성
            listRef.current[0] = node;
          },
          className: selectItem({
            active: activeIndex === 0,
            selected: false
          }),
          onClick: function () {
            onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], value !== null && value !== void 0 ? value : [], true), [inputValue], false));
            setInputValue('');
            setOpen(false);
          }
        }), {
          children: [customInputText, ": ", inputValue]
        })), items.map(function (item, index) {
          var isSelected = checkIsSelected(item.value);
          var currentIndex = isCreateMode ? index + 1 : index;
          return jsx("li", __assign$1({
            role: "option"
          }, getItemProps({
            ref: function (node) {
              listRef.current[currentIndex] = node;
            },
            className: selectItem({
              active: activeIndex === currentIndex,
              selected: isSelected,
              disabled: item.disabled
            }),
            onClick: function () {
              if (item.disabled) return;
              setInputValue('');
              handleSelect(item);
            }
          }), {
            children: item.label
          }), item.value);
        })]
      })
    });
    return menu;
  };
  var getPlaceholder = function () {
    if (open || (value === null || value === void 0 ? void 0 : value.length)) return inputPlaceholder === null || inputPlaceholder === void 0 ? void 0 : inputPlaceholder.toString();
    return placeholder === null || placeholder === void 0 ? void 0 : placeholder.toString();
  };
  return jsxs(Fragment, {
    children: [jsx(SelectTagsButton, __assign$1({
      selectedTags: selectedOptions,
      ref: inputRef,
      positionRef: refs.setReference,
      open: isMounted,
      block: block,
      error: error,
      disabled: disabled,
      loading: loading,
      size: size$1,
      style: style,
      placeholder: getPlaceholder(),
      onChange: handleChange,
      onChangeCapture: function () {
        return setOpen(true);
      },
      value: inputValue,
      onOpen: function () {
        var _a;
        return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      }
    }, getReferenceProps(__assign$1({
      'aria-autocomplete': 'list',
      onKeyDown: function (event) {
        // 입력된 텍스트가 없을 때
        if (inputValue) return;
        // 백스페이스를 누르면
        if (event.key === 'Backspace') {
          if (!(value === null || value === void 0 ? void 0 : value.length) || !onChange) return;
          // 마지막 항목을 삭제
          var removeLastItem = value.filter(function (_, index) {
            if (index === value.length - 1) return false;
            return true;
          });
          onChange(removeLastItem);
        }
      },
      onKeyPress: function (event) {
        var _a;
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
        }
        if (event.key !== 'Enter' || isEntered) return;
        if (event.key === 'Enter' && !open) {
          setOpen(true);
        }
        var currentIndex = isCreateMode ? (activeIndex || 0) - 1 : activeIndex || 0;
        if (activeIndex != null && items[currentIndex]) {
          if ((_a = items[activeIndex]) === null || _a === void 0 ? void 0 : _a.disabled) return;
          setIsEntered(true);
          if (isCreateMode && activeIndex === 0) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], value !== null && value !== void 0 ? value : [], true), [inputValue], false));
          } else {
            handleSelect(items[currentIndex]);
          }
          setInputValue('');
          setActiveIndex(null);
          setIsEntered(false);
        } else if (isCreateMode) {
          setIsEntered(true);
          onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], value !== null && value !== void 0 ? value : [], true), [inputValue], false));
          setInputValue('');
          setActiveIndex(null);
          setIsEntered(false);
        }
      }
    }, args)))), jsx(FloatingPortal, {
      children: isMounted && jsx(FloatingFocusManager, {
        context: context,
        modal: false,
        initialFocus: -1,
        children: jsx("div", __assign$1({
          className: selectFloating,
          ref: refs.setFloating,
          style: __assign$1(__assign$1({}, floatingStyles), {
            zIndex: 4000
          })
        }, getFloatingProps(), {
          children: jsx("div", {
            className: selectMenu({
              isTransition: transitionStatus === 'open' || transitionStatus === 'close',
              isOpen: transitionStatus === 'open',
              placement: computedPlacement
            }),
            "data-placement": placement,
            "data-status": transitionStatus,
            children: renderMenu()
          })
        }))
      })
    })]
  });
};

var Select = function (props) {
  var value = props.value,
    placeholder = props.placeholder,
    _a = props.options,
    options = _a === void 0 ? [] : _a,
    _b = props.placement,
    placement = _b === void 0 ? 'bottom-start' : _b,
    _c = props.matchWidth,
    matchWidth = _c === void 0 ? true : _c,
    _d = props.block,
    block = _d === void 0 ? false : _d,
    _e = props.disabled,
    disabled = _e === void 0 ? false : _e,
    _f = props.multiple,
    multiple = _f === void 0 ? false : _f,
    _g = props.loading,
    loading = _g === void 0 ? false : _g,
    error = props.error,
    showSearch = props.showSearch,
    _h = props.size,
    size$1 = _h === void 0 ? 'medium' : _h,
    style = props.style,
    onChange = props.onChange,
    dropdownRender = props.dropdownRender,
    filterOption = props.filterOption,
    args = __rest$1(props, ["value", "placeholder", "options", "placement", "matchWidth", "block", "disabled", "multiple", "loading", "error", "showSearch", "size", "style", "onChange", "dropdownRender", "filterOption"]);
  var _j = useState(false),
    open = _j[0],
    setOpen = _j[1];
  var _k = useState(''),
    inputValue = _k[0],
    setInputValue = _k[1];
  var _l = useState(null),
    activeIndex = _l[0],
    setActiveIndex = _l[1];
  var _m = useState(false),
    isEntered = _m[0],
    setIsEntered = _m[1];
  var listRef = useRef([]);
  var items = useMemo(function () {
    if (!(options === null || options === void 0 ? void 0 : options.length)) return [];
    if (filterOption) {
      return options.filter(function (item) {
        return filterOption(inputValue, item);
      });
    }
    return options.filter(function (item) {
      var _a, _b;
      /**
       * 시작 문자가 동일하지 않더라도 문자열 내에 찾는
       * 문자열이 있는 경우를 모두 매치하는 방식
       */
      return (_b = (_a = item.label) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(inputValue.toLowerCase());
    });
  }, [options, inputValue, filterOption]);
  var selectedIndex = useMemo(function () {
    if (Array.isArray(value)) {
      return options === null || options === void 0 ? void 0 : options.findIndex(function (e) {
        return e.value === (value === null || value === void 0 ? void 0 : value[0]);
      });
    }
    return options === null || options === void 0 ? void 0 : options.findIndex(function (e) {
      return e.value === value;
    });
  }, [value, options]);
  var selectedOptions = useMemo(function () {
    if (Array.isArray(value)) {
      return options.filter(function (o) {
        return value === null || value === void 0 ? void 0 : value.find(function (v) {
          return v === o.value;
        });
      });
    }
    return [options.find(function (o) {
      return value === o.value;
    })];
  }, [value, options]);
  var _o = useFloating({
      open: open,
      onOpenChange: function (value) {
        if (!value) {
          setOpen(false);
          setInputValue('');
          return;
        }
        setOpen(true);
      },
      placement: placement,
      middleware: [size({
        apply: function (_a) {
          var rects = _a.rects,
            elements = _a.elements;
          if (!matchWidth) {
            Object.assign(elements.floating.style, {
              minWidth: "".concat(rects.reference.width, "px")
            });
            return;
          }
          /**
           * matchWidth가 true일 경우
           * 드롭다운 메뉴를 레퍼런스 트리거와 일치시킨다.
           */
          Object.assign(elements.floating.style, {
            width: "".concat(rects.reference.width, "px")
          });
        }
      })],
      whileElementsMounted: autoUpdate
    }),
    refs = _o.refs,
    floatingStyles = _o.floatingStyles,
    context = _o.context;
  var role = useRole(context, {
    role: 'listbox'
  });
  var click = useClick(context, {
    keyboardHandlers: false
  });
  var dismiss = useDismiss(context);
  var listNav = useListNavigation(context, {
    listRef: listRef,
    activeIndex: activeIndex,
    selectedIndex: selectedIndex,
    onNavigate: setActiveIndex,
    virtual: true,
    loop: true
  });
  var _p = useInteractions([role, click, dismiss, listNav]),
    getReferenceProps = _p.getReferenceProps,
    getFloatingProps = _p.getFloatingProps,
    getItemProps = _p.getItemProps;
  function handleChange(event) {
    var value = event.target.value;
    setInputValue(value);
    setActiveIndex(0);
  }
  /**
   * 📖 전환 애니메이션 처리
   */
  var _q = useTransitionStatus(context, {
      duration: 200
    }),
    isMounted = _q.isMounted,
    transitionStatus = _q.status;
  var computedPlacement = useMemo(function () {
    switch (placement) {
      case 'top':
      case 'top-end':
      case 'top-start':
        return 'top';
      case 'bottom':
      case 'bottom-end':
      case 'bottom-start':
        return 'bottom';
      case 'left':
      case 'left-end':
      case 'left-start':
        return 'left';
      case 'right':
      case 'right-end':
      case 'right-start':
        return 'right';
    }
  }, [placement]);
  var checkIsSelected = function (optionValue) {
    if (!value) return false;
    if (Array.isArray(value)) {
      return !!(value === null || value === void 0 ? void 0 : value.find(function (v) {
        return v === optionValue;
      }));
    }
    return value === optionValue;
  };
  var referenceText = useMemo(function () {
    if (inputValue) return;
    if (!selectedOptions.length || !value) return jsx(Box, {
      c: "gray.400",
      children: placeholder
    });
    return selectedOptions.map(function (e, index) {
      var isLast = selectedOptions.length === index + 1;
      return jsxs(Fragment$1, {
        children: [e === null || e === void 0 ? void 0 : e.label, isLast ? '' : ', ']
      }, "".concat(e === null || e === void 0 ? void 0 : e.value, "-").concat(index));
    });
  }, [value, inputValue, selectedOptions, placeholder]);
  var handleSelect = function (option) {
    setOpen(false);
    if (!multiple) {
      onChange === null || onChange === void 0 ? void 0 : onChange(option.value);
      return;
    }
    if (option.single) {
      onChange === null || onChange === void 0 ? void 0 : onChange([option.value]);
      return;
    }
    // Value가 Array가 아닐 떄
    if (!Array.isArray(value)) {
      onChange === null || onChange === void 0 ? void 0 : onChange([option.value]);
      return;
    }
    // 선택한 옵션이 이미 있을 경우 제외
    if (value === null || value === void 0 ? void 0 : value.find(function (e) {
      return e === option.value;
    })) {
      onChange === null || onChange === void 0 ? void 0 : onChange(value.filter(function (v) {
        return v !== option.value;
      }));
      return;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], value, true), [option.value], false));
  };
  var renderMenu = function () {
    var menu = jsx(Fragment, {
      children: items.length ? jsx("ul", {
        className: selectList,
        children: items.map(function (item, index) {
          var isSelected = checkIsSelected(item.value);
          return jsx("li", __assign$1({
            role: "option"
          }, getItemProps({
            ref: function (node) {
              listRef.current[index] = node;
            },
            className: selectItem({
              active: activeIndex === index,
              selected: isSelected,
              disabled: item.disabled
            }),
            onClick: function () {
              if (item.disabled) return;
              setInputValue('');
              setOpen(false);
              handleSelect(item);
            }
          }), {
            children: item.label
          }), item.value);
        })
      }) : jsx(SelectEmpty, {})
    });
    if (dropdownRender) return dropdownRender(menu);
    return menu;
  };
  return jsxs(Fragment, {
    children: [jsx(SelectButton, __assign$1({
      ref: refs.setReference,
      open: isMounted,
      block: block,
      error: error || props['aria-invalid'] === 'true',
      disabled: disabled,
      loading: loading,
      size: size$1,
      style: style,
      onlyButton: !showSearch
    }, getReferenceProps(__assign$1({
      onChange: handleChange,
      value: inputValue,
      'aria-autocomplete': 'list',
      onChangeCapture: function () {
        setOpen(true);
      },
      onKeyPress: function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
        }
        if (event.key === 'Enter' && !open) {
          setOpen(true);
        }
        if (event.key === 'Enter' && activeIndex != null && items[activeIndex] && !isEntered) {
          if (items[activeIndex].disabled) return;
          setIsEntered(true);
          handleSelect(items[activeIndex]);
          setOpen(false);
          setInputValue('');
          setActiveIndex(null);
          setIsEntered(false);
        }
      }
    }, args)), {
      children: referenceText
    })), jsx(FloatingPortal, {
      children: isMounted && jsx(FloatingFocusManager, {
        context: context,
        modal: false,
        initialFocus: -1,
        children: jsx("div", __assign$1({
          className: selectFloating,
          ref: refs.setFloating,
          style: __assign$1(__assign$1({}, floatingStyles), {
            zIndex: 4000
          })
        }, getFloatingProps(), {
          children: jsx("div", {
            className: selectMenu({
              isTransition: transitionStatus === 'open' || transitionStatus === 'close',
              isOpen: transitionStatus === 'open',
              placement: computedPlacement
            }),
            "data-placement": placement,
            "data-status": transitionStatus,
            children: renderMenu()
          })
        }))
      })
    })]
  });
};
Select.Tags = SelectTags;

var checkboxButton = createRuntimeFn({
  defaultClassName: 'Checkbox_checkboxButton__o8ykd71',
  variantClassNames: {
    checked: {
      true: 'Checkbox_checkboxButton_checked_true__o8ykd72'
    },
    error: {
      true: 'Checkbox_checkboxButton_error_true__o8ykd73'
    },
    disabled: {
      true: 'Checkbox_checkboxButton_disabled_true__o8ykd74'
    }
  },
  defaultVariants: {},
  compoundVariants: [[{
    error: true,
    checked: true
  }, 'Checkbox_checkboxButton_compound_0__o8ykd75'], [{
    checked: true,
    disabled: true
  }, 'Checkbox_checkboxButton_compound_1__o8ykd76']]
});
var checkboxGroup = 'Checkbox_checkboxGroup__o8ykd7a';
var checkboxIcon = 'Checkbox_checkboxIcon__o8ykd78';
var checkboxInput = 'Checkbox_checkboxInput__o8ykd77';
var checkboxLabel = 'Checkbox_checkboxLabel__o8ykd79';
var checkboxRoot = 'Checkbox_checkboxRoot__o8ykd70';

var Checkbox = React__default.forwardRef(function (props, ref) {
  var checked = props.checked,
    error = props.error,
    disabled = props.disabled,
    children = props.children,
    onChange = props.onChange,
    style = props.style;
    props.className;
    var indeterminate = props.indeterminate,
    args = __rest$1(props, ["checked", "error", "disabled", "children", "onChange", "style", "className", "indeterminate"]);
  var _a = React__default.useState(false),
    checkedState = _a[0],
    setCheckedState = _a[1];
  React__default.useEffect(function () {
    setCheckedState(!!checked);
  }, [checked]);
  return jsxs("label", {
    className: checkboxRoot,
    style: style,
    children: [jsxs("div", {
      className: checkboxButton({
        checked: checkedState,
        disabled: disabled,
        error: error || props['aria-invalid'] === 'true'
      }),
      children: [jsx("input", __assign$1({
        ref: ref,
        className: checkboxInput,
        type: "checkbox",
        checked: checkedState,
        disabled: disabled,
        onChange: function (e) {
          if (onChange) {
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
          } else {
            setCheckedState(e.target.checked);
          }
        }
      }, args)), !indeterminate ? jsx("svg", {
        className: checkboxIcon,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: jsx("path", {
          d: "M5 9.61111L8.36134 13.5L15 6.5",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      }) : jsx("svg", {
        className: checkboxIcon,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: jsx("path", {
          d: "M5 10H15",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round"
        })
      })]
    }), !!children && jsx("div", {
      className: checkboxLabel,
      children: children
    })]
  });
});

var CheckboxGroup = function (props) {
  var _a = props.value,
    value = _a === void 0 ? [] : _a,
    options = props.options,
    style = props.style,
    onChange = props.onChange;
  return jsx("div", {
    className: checkboxGroup,
    style: style,
    children: options.map(function (item) {
      var isChecked = !!(value === null || value === void 0 ? void 0 : value.find(function (e) {
        return e === item.value;
      }));
      return jsx(Checkbox, {
        checked: isChecked,
        disabled: item.disabled,
        onChange: function (e) {
          if (!e.target.checked) {
            onChange(value.filter(function (e) {
              return e !== item.value;
            }));
            return;
          }
          onChange(__spreadArray(__spreadArray([], value, true), [item.value], false));
        },
        children: item.label
      }, item.value);
    })
  });
};

var switchButton = createRuntimeFn({
  defaultClassName: 'Switch_switchButton__s7ln8x1',
  variantClassNames: {
    checked: {
      true: 'Switch_switchButton_checked_true__s7ln8x2'
    },
    disabled: {
      true: 'Switch_switchButton_disabled_true__s7ln8x3'
    },
    loading: {
      true: 'Switch_switchButton_loading_true__s7ln8x4'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var switchHandle = createRuntimeFn({
  defaultClassName: 'Switch_switchHandle__s7ln8x5',
  variantClassNames: {
    checked: {
      true: 'Switch_switchHandle_checked_true__s7ln8x6'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var switchInput = 'Switch_switchInput__s7ln8x0';

var Switch = forwardRef(function (props, ref) {
  var checked = props.checked,
    loading = props.loading,
    disabled = props.disabled,
    onChange = props.onChange,
    className = props.className,
    style = props.style,
    args = __rest$1(props, ["checked", "loading", "disabled", "onChange", "className", "style"]);
  var _a = useState(false),
    checkedState = _a[0],
    setCheckedState = _a[1];
  useEffect(function () {
    setCheckedState(!!checked);
  }, [checked]);
  return jsxs("label", __assign$1({
    className: clsx(switchButton({
      checked: checkedState,
      disabled: disabled,
      loading: loading
    }), className)
  }, args, {
    role: "switch",
    "aria-checked": checkedState,
    style: style,
    children: [jsx("input", __assign$1({
      ref: ref,
      type: "checkbox",
      checked: checkedState,
      disabled: disabled,
      className: switchInput,
      onChange: function (e) {
        if (disabled || loading) return;
        if (onChange) {
          onChange === null || onChange === void 0 ? void 0 : onChange(e.target.checked);
        } else {
          setCheckedState(e.target.checked);
        }
      }
    }, args)), jsx("div", {
      className: switchHandle({
        checked: checkedState
      }),
      children: loading && jsx(Spinner, {})
    })]
  }));
});
Switch.displayName = 'Switch';

var radioGroup = 'Radio_radioGroup__1ht37a20';
var radioLabel = createRuntimeFn({
  defaultClassName: 'Radio_radioLabel__1ht37a29',
  variantClassNames: {
    disabled: {
      true: 'Radio_radioLabel_disabled_true__1ht37a2a'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var radioOriginInput = 'Radio_radioOriginInput__1ht37a22';
var radioVirtualInput = createRuntimeFn({
  defaultClassName: 'Radio_radioVirtualInput__1ht37a23',
  variantClassNames: {
    checked: {
      true: 'Radio_radioVirtualInput_checked_true__1ht37a24'
    },
    error: {
      true: 'Radio_radioVirtualInput_error_true__1ht37a25'
    },
    disabled: {
      true: 'Radio_radioVirtualInput_disabled_true__1ht37a26'
    }
  },
  defaultVariants: {},
  compoundVariants: [[{
    checked: true,
    error: true
  }, 'Radio_radioVirtualInput_compound_0__1ht37a27'], [{
    checked: true,
    disabled: true
  }, 'Radio_radioVirtualInput_compound_1__1ht37a28']]
});
var radioWrapper = 'Radio_radioWrapper__1ht37a21';

var RadioGroupContext = createContext({});
var RadioGroup = function (props) {
  var children = props.children,
    value = props.value,
    error = props.error,
    style = props.style,
    onChange = props.onChange,
    args = __rest$1(props, ["children", "value", "error", "style", "onChange"]);
  return jsx("div", __assign$1({
    className: radioGroup,
    style: style
  }, args, {
    children: jsx(RadioGroupContext.Provider, {
      value: {
        value: value,
        error: error || props['aria-invalid'] === 'true',
        onChange: onChange
      },
      children: children
    })
  }));
};

var Radio = function (props) {
  var name = props.name,
    checked = props.checked,
    value = props.value,
    style = props.style,
    error = props.error,
    disabled = props.disabled,
    children = props.children,
    onChange = props.onChange,
    args = __rest$1(props, ["name", "checked", "value", "style", "error", "disabled", "children", "onChange"]);
  var _a = useContext(RadioGroupContext),
    contextValue = _a.value,
    groupError = _a.error,
    contextOnChange = _a.onChange;
  var isChecked = useMemo(function () {
    if (checked) return true;
    return contextValue === value;
  }, [checked, contextValue, value]);
  var isError = useMemo(function () {
    return error || props['aria-invalid'] === 'true' || groupError;
  }, [error, groupError, props['aria-invalid']]);
  return jsxs("label", {
    className: radioWrapper,
    style: style,
    children: [jsx("div", {
      className: radioVirtualInput({
        checked: isChecked,
        error: isError,
        disabled: disabled
      }),
      children: jsx("input", __assign$1({
        type: "radio",
        className: radioOriginInput,
        name: name,
        value: value,
        checked: isChecked,
        disabled: disabled,
        onChange: function (e) {
          onChange && onChange(e);
          contextOnChange && contextOnChange(e.target.value);
        }
      }, args))
    }), !!children && jsx("div", {
      className: radioLabel({
        disabled: disabled
      }),
      children: children
    })]
  });
};
Radio.Group = RadioGroup;

/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node)
        )
    ;
}

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = Children.toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if (Children.count(newElement) > 1) return Children.only(null);
                return /*#__PURE__*/ isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ createElement($5e63c961fc1ce211$var$SlotClone, _extends$1({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ isValidElement(newElement) ? /*#__PURE__*/ cloneElement(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ createElement($5e63c961fc1ce211$var$SlotClone, _extends$1({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ isValidElement(children)) return /*#__PURE__*/ cloneElement(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
    });
    return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ createElement(Fragment$1, null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}

var button = createRuntimeFn({
  defaultClassName: 'styles_button__19xkksx3',
  variantClassNames: {
    block: {
      true: 'styles_button_block_true__19xkksx4'
    },
    variant: {
      filled: 'styles_button_variant_filled__19xkksx5',
      outlined: 'styles_button_variant_outlined__19xkksx6',
      ghost: 'styles_button_variant_ghost__19xkksx7',
      dashed: 'styles_button_variant_dashed__19xkksx8'
    },
    color: {
      'default': 'styles_button_color_default__19xkksx9',
      primary: 'styles_button_color_primary__19xkksxa',
      warning: 'styles_button_color_warning__19xkksxb',
      danger: 'styles_button_color_danger__19xkksxc',
      success: 'styles_button_color_success__19xkksxd',
      custom: 'styles_button_color_custom__19xkksxe'
    },
    size: {
      small: 'styles_button_size_small__19xkksxf',
      medium: 'styles_button_size_medium__19xkksxg',
      large: 'styles_button_size_large__19xkksxh'
    },
    iconOnly: {
      true: 'styles_button_iconOnly_true__19xkksxi'
    },
    disabled: {
      true: 'styles_button_disabled_true__19xkksxj'
    }
  },
  defaultVariants: {
    color: 'default',
    size: 'medium'
  },
  compoundVariants: [[{
    color: 'default',
    variant: 'filled'
  }, 'styles_button_compound_0__19xkksxk'], [{
    color: 'default',
    variant: 'outlined'
  }, 'styles_button_compound_1__19xkksxl'], [{
    color: 'default',
    variant: 'dashed'
  }, 'styles_button_compound_2__19xkksxm'], [{
    variant: 'filled',
    disabled: true
  }, 'styles_button_compound_3__19xkksxn'], [{
    variant: 'outlined',
    disabled: true
  }, 'styles_button_compound_4__19xkksxo'], [{
    variant: 'ghost',
    disabled: true
  }, 'styles_button_compound_5__19xkksxp'], [{
    variant: 'dashed',
    disabled: true
  }, 'styles_button_compound_6__19xkksxq'], [{
    color: 'default',
    variant: 'outlined',
    disabled: true
  }, 'styles_button_compound_7__19xkksxr']]
});
var buttonChildrenForLoading = createRuntimeFn({
  defaultClassName: 'styles_buttonChildrenForLoading__19xkksxs',
  variantClassNames: {
    loading: {
      true: 'styles_buttonChildrenForLoading_loading_true__19xkksxt'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var buttonLoading = createRuntimeFn({
  defaultClassName: 'styles_buttonLoading__19xkksxu',
  variantClassNames: {
    loading: {
      true: 'styles_buttonLoading_loading_true__19xkksxv'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});

var Button = React__default.forwardRef(function (props, ref) {
  var children = props.children,
    _a = props.variant,
    variant = _a === void 0 ? 'outlined' : _a,
    _b = props.size,
    size = _b === void 0 ? 'medium' : _b,
    _c = props.color,
    color = _c === void 0 ? 'default' : _c,
    iconOnly = props.iconOnly,
    block = props.block,
    loading = props.loading,
    disabled = props.disabled,
    className = props.className,
    asChild = props.asChild,
    _d = props.type,
    type = _d === void 0 ? 'button' : _d,
    args = __rest$1(props, ["children", "variant", "size", "color", "iconOnly", "block", "loading", "disabled", "className", "asChild", "type"]);
  var Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : 'button';
  var renderChildren = function () {
    if (loading) {
      return jsxs(Fragment, {
        children: [jsx("span", {
          className: buttonChildrenForLoading({
            loading: loading
          }),
          children: children
        }), jsx("div", {
          className: buttonLoading({
            loading: loading
          }),
          children: jsx(Spinner, {
            style: {
              strokeWidth: 40
            }
          })
        })]
      });
    }
    return children;
  };
  return jsx(Comp, __assign$1({
    ref: ref,
    className: clsx(button({
      block: block,
      variant: variant,
      color: color,
      size: size,
      disabled: disabled,
      iconOnly: iconOnly
    }), className),
    disabled: disabled,
    type: type
  }, args, {
    children: renderChildren()
  }));
});

var tag = createRuntimeFn({
  defaultClassName: 'Tag_tag__xbm0fs1',
  variantClassNames: {
    size: {
      small: 'Tag_tag_size_small__xbm0fs2',
      medium: 'Tag_tag_size_medium__xbm0fs3'
    },
    variant: {
      filled: 'Tag_tag_variant_filled__xbm0fs4',
      outlined: 'Tag_tag_variant_outlined__xbm0fs5',
      plain: 'Tag_tag_variant_plain__xbm0fs6',
      'plain-light': 'Tag_tag_variant_plain-light__xbm0fs7'
    },
    color: {
      blue: 'Tag_tag_color_blue__xbm0fs8',
      green: 'Tag_tag_color_green__xbm0fs9',
      red: 'Tag_tag_color_red__xbm0fsa',
      orange: 'Tag_tag_color_orange__xbm0fsb',
      yellow: 'Tag_tag_color_yellow__xbm0fsc',
      neutral: 'Tag_tag_color_neutral__xbm0fsd',
      teal: 'Tag_tag_color_teal__xbm0fse'
    }
  },
  defaultVariants: {
    variant: 'filled',
    color: 'blue',
    size: 'medium'
  },
  compoundVariants: [[{
    variant: 'plain',
    color: 'blue'
  }, 'Tag_tag_compound_0__xbm0fsf'], [{
    variant: 'plain',
    color: 'neutral'
  }, 'Tag_tag_compound_1__xbm0fsg'], [{
    variant: 'plain',
    color: 'green'
  }, 'Tag_tag_compound_2__xbm0fsh'], [{
    variant: 'plain',
    color: 'red'
  }, 'Tag_tag_compound_3__xbm0fsi'], [{
    variant: 'plain',
    color: 'orange'
  }, 'Tag_tag_compound_4__xbm0fsj'], [{
    variant: 'plain',
    color: 'yellow'
  }, 'Tag_tag_compound_5__xbm0fsk'], [{
    variant: 'plain',
    color: 'teal'
  }, 'Tag_tag_compound_6__xbm0fsl'], [{
    variant: 'plain-light',
    color: 'neutral'
  }, 'Tag_tag_compound_7__xbm0fsm']]
});

var Tag = React__default.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    _a = props.variant,
    variant = _a === void 0 ? 'filled' : _a,
    _b = props.size,
    size = _b === void 0 ? 'medium' : _b,
    _c = props.color,
    color = _c === void 0 ? 'blue' : _c,
    className = props.className,
    args = __rest$1(props, ["children", "variant", "size", "color", "className"]);
  return jsx("div", __assign$1({
    ref: forwardedRef,
    className: clsx(tag({
      variant: variant,
      color: color,
      size: size
    }), className)
  }, args, {
    children: children
  }));
});

function getVarName(variable) {
  var matches = variable.match(/^var\((.*)\)$/);
  if (matches) {
    return matches[1];
  }
  return variable;
}

function get(obj, path) {
  var result = obj;
  for (var key of path) {
    if (!(key in result)) {
      throw new Error("Path ".concat(path.join(' -> '), " does not exist in object"));
    }
    result = result[key];
  }
  return result;
}

function walkObject(obj, fn) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var clone = {};
  for (var key in obj) {
    var _value = obj[key];
    var currentPath = [...path, key];
    if (typeof _value === 'string' || typeof _value === 'number' || _value == null) {
      clone[key] = fn(_value, currentPath);
    } else if (typeof _value === 'object' && !Array.isArray(_value)) {
      clone[key] = walkObject(_value, fn, currentPath);
    } else {
      console.warn("Skipping invalid key \"".concat(currentPath.join('.'), "\". Should be a string, number, null or object. Received: \"").concat(Array.isArray(_value) ? 'Array' : typeof _value, "\""));
    }
  }
  return clone;
}

function assignInlineVars(varsOrContract, tokens) {
  var styles = {};
  if (typeof tokens === 'object') {
    var _contract = varsOrContract;
    walkObject(tokens, (value, path) => {
      if (value == null) {
        return;
      }
      var varName = get(_contract, path);
      styles[getVarName(varName)] = String(value);
    });
  } else {
    var _vars = varsOrContract;
    for (var varName in _vars) {
      var value = _vars[varName];
      if (value == null) {
        continue;
      }
      styles[getVarName(varName)] = value;
    }
  }
  Object.defineProperty(styles, 'toString', {
    value: function value() {
      return Object.keys(this).map(key => "".concat(key, ":").concat(this[key])).join(';');
    },
    writable: false
  });
  return styles;
}

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React.createContext && React.createContext(DefaultContext);

function GenIcon(element) {
  return function (props) {
    var _a;
    return jsx(IconBase, __assign$1({
      attr: __assign$1({}, element.props)
    }, props, {
      children: (_a = element.props) === null || _a === void 0 ? void 0 : _a.children
    }));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      width = props.width,
      height = props.height,
      svgProps = __rest$1(props, ["attr", "size", "title", "width", "height"]);
    var computedSize = size || conf.size || '1em';
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return jsxs("svg", __assign$1({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign$1(__assign$1({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: width || computedSize,
      width: height || computedSize,
      xmlns: "http://www.w3.org/2000/svg",
      children: [title && jsx("title", {
        children: title
      }), props.children]
    }));
  };
  return IconContext !== undefined ? jsx(IconContext.Consumer, {
    children: function (conf) {
      return elem(conf);
    }
  }) : elem(DefaultContext);
}

var IconChevronUp = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M16 13L10 7L4 13",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconChevronDown = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M16 7L10 13L4 7",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconChevronLeft = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M13 4L7 10L13 16",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconChevronRight = GenIcon(jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    d: "M7 4L13 10L7 16",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconRotate = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M17 10.8846C16.7778 12.58 15.9453 14.1362 14.6585 15.262C13.3716 16.3878 11.7186 17.0061 10.0088 17.0009C8.29902 16.9958 6.6497 16.3677 5.3696 15.2343C4.0895 14.1008 3.26638 12.5396 3.0543 10.8429C2.84223 9.14631 3.25575 7.43054 4.21746 6.01681C5.17916 4.60309 6.62313 3.58833 8.27904 3.1625C9.93496 2.73666 11.6893 2.92894 13.2137 3.70334C14.7381 4.47774 15.928 5.78118 16.5606 7.36965M17 2.9759L17 7.36965L12.6064 7.36965",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconMove = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M10 18.7086L10 1.47364M7.6316 16.6316L9.99998 19L12.3684 16.6316M12.3684 3.36838L10 1L7.6316 3.36843M1.47369 10H18.7087M3.36843 7.6316L1 10L3.36838 12.3684M16.6316 12.3684L19 9.99998L16.6316 7.6316",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconSwap = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("path", {
    d: "M4 7.979H16L12.021 4",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M16 11.479L4 11.479L7.979 15.458",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconFullscreen = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M12.4997 7.50016L17.4997 2.50016M7.49967 12.5002L2.49967 17.5002M2.08301 13.7502V17.9167H6.24967M17.9163 6.25008V2.0835H13.7497M17.4997 17.5002L12.4997 12.5002M2.49967 2.50016L7.49967 7.50016M6.24967 2.0835H2.08301V6.25008M13.7497 17.9167H17.9163V13.7502",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconFullscreenExit = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M12.9163 12.9168L17.9163 17.9168M7.08301 7.0835L2.08301 2.0835M3.33301 7.50016L7.49967 7.50016L7.49967 3.33358M16.6663 12.5002H12.4997V16.6668",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconExit = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M7.0957 9.53286C6.73672 9.53286 6.4457 9.82388 6.4457 10.1829C6.4457 10.5418 6.73672 10.8329 7.0957 10.8329L7.0957 9.53286ZM7.0957 10.8329L18.2616 10.8329L18.2616 9.53286L7.0957 9.53286L7.0957 10.8329Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M14.5386 14.3943L18.7495 10.1831L14.5386 5.97186",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M11.3325 1.24976L4.23282 1.24976C2.99942 1.24976 1.99956 2.24962 1.99956 3.48302L1.99956 16.8832C1.99956 18.1166 2.99942 19.1164 4.23282 19.1164L11.3325 19.1164",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  })]
}));

var IconHistory = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M2.5 11.0111C2.73809 12.8275 3.63 14.4949 5.00877 15.7012C6.38755 16.9074 8.15866 17.5698 9.99057 17.5643C11.8225 17.5588 13.5896 16.8859 14.9611 15.6714C16.3327 14.4569 17.2146 12.7842 17.4418 10.9664C17.669 9.14859 17.226 7.31026 16.1956 5.79555C15.1652 4.28084 13.6181 3.1936 11.8439 2.73735C10.0697 2.28109 8.19003 2.4871 6.55677 3.31682C4.92351 4.14654 3.64862 5.54308 2.97075 7.24501M2.91667 3.03108L2.91667 7.24501L6.71875 7.24982M10 6.97608V10.9467L12.6471 12.7114",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconRandom = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M15 2L17.5 5L15 8",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M15 18L17.5 15L15 12",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M2.5 5H5C6.10507 5 7.16488 5.52678 7.94628 6.46447C8.72768 7.40215 9.16667 8.30009 9.16667 10C9.16667 11.9999 9.60565 12.5979 10.3871 13.5355C11.1685 14.4732 12.2283 15 13.3333 15H17.5",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M17.5 5.00001H13.3333C12.4316 4.99841 11.5 5.49994 11 6.49994M7.5 13.4999C7 14.4999 6.5 14.9999 5 15H2.5",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconArrowUp = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M9 17.5C9 18.0523 9.44772 18.5 10 18.5C10.5523 18.5 11 18.0523 11 17.5L9 17.5ZM11 17.5L11 2.5L9 2.5L9 17.5L11 17.5Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M15 7.5L10 2.50034L5 7.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconArrowDown = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M9 2.5C9 1.94772 9.44772 1.5 10 1.5C10.5523 1.5 11 1.94772 11 2.5L9 2.5ZM11 2.5L11 17.5L9 17.5L9 2.5L11 2.5Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M15 12.5L10 17.4997L5 12.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconCheck = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M3 9L7.70588 14L17 5",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconClose = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M4.10742 15.8925L15.8925 4.10742M15.8925 15.8925L4.10742 4.10742",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round"
  })
}));

var IconX = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "icon icon-tabler icons-tabler-outline icon-tabler-x",
  children: [jsx("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), jsx("path", {
    d: "M18 6l-12 12"
  }), jsx("path", {
    d: "M6 6l12 12"
  })]
}));

var IconPlus = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M4 10H16",
    stroke: "currentColor",
    strokeWidth: "1.728",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M10 16L10 4",
    stroke: "currentColor",
    strokeWidth: "1.728",
    strokeLinecap: "round"
  })]
}));

var IconMinus = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H20V20H6C2.68629 20 0 17.3137 0 14V6Z",
    fill: "white"
  }), jsx("path", {
    d: "M5 10H15",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  })]
}));

var IconInfoCircle = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  children: jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 13.3132 21.7413 14.6136 21.2388 15.8268C20.7362 17.0401 19.9997 18.1425 19.0711 19.0711C18.1425 19.9997 17.0401 20.7362 15.8268 21.2388C14.6136 21.7413 13.3132 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C4.00035 18.1425 3.26375 17.0401 2.7612 15.8268C2.25866 14.6136 2 13.3132 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 13.0506 4.20693 14.0909 4.60896 15.0615C5.011 16.0321 5.60028 16.914 6.34315 17.6569C7.08601 18.3997 7.96793 18.989 8.93853 19.391C9.90914 19.7931 10.9494 20 12 20C13.0506 20 14.0909 19.7931 15.0615 19.391C16.0321 18.989 16.914 18.3997 17.6569 17.6569C18.3997 16.914 18.989 16.0321 19.391 15.0615C19.7931 14.0909 20 13.0506 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM11 9C11 8.44772 11.4477 8 12 8H12.01C12.5623 8 13.01 8.44772 13.01 9C13.01 9.55228 12.5623 10 12.01 10H12C11.4477 10 11 9.55228 11 9ZM10 12C10 11.4477 10.4477 11 11 11H12C12.5523 11 13 11.4477 13 12V15C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17H12C11.4477 17 11 16.5523 11 16V13C10.4477 13 10 12.5523 10 12Z",
    fill: "currentColor"
  })
}));

var IconCloseCircle = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M7 7L13 12.9997",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M13 7L7 12.9997",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), jsx("circle", {
    cx: "10",
    cy: "10",
    r: "8.25",
    stroke: "currentColor",
    strokeWidth: "1.5"
  })]
}));

var IconClockCircle = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("circle", {
    cx: "10",
    cy: "10",
    r: "8.25",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), jsx("path", {
    d: "M10 6V10.5L13 12.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconExclamationCircle = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10C1.75 5.44365 5.44365 1.75 10 1.75C14.5563 1.75 18.25 5.44365 18.25 10Z",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), jsx("path", {
    d: "M10 6V10.4",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M10 13L10 13.6",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  })]
}));

var IconStopCircle = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM14.1691 14.8559C13.0492 15.8184 11.5925 16.4 10 16.4C6.46538 16.4 3.6 13.5346 3.6 10C3.6 8.40749 4.18165 6.95083 5.14409 5.83088L14.1691 14.8559ZM15.2447 13.6688L6.33123 4.75528C7.37007 4.02724 8.63514 3.6 10 3.6C13.5346 3.6 16.4 6.46538 16.4 10C16.4 11.3649 15.9728 12.6299 15.2447 13.6688Z",
    fill: "currentColor"
  })
}));

var IconSettings = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("line", {
    x1: "1.65",
    y1: "4.35",
    x2: "18.35",
    y2: "4.35",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "1.65",
    y1: "10.35",
    x2: "18.35",
    y2: "10.35",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "1.65",
    y1: "16.35",
    x2: "18.35",
    y2: "16.35",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("circle", {
    cx: "6.2",
    cy: "4.2",
    r: "2.2",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("circle", {
    cx: "14.2",
    cy: "10.2",
    r: "2.2",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("circle", {
    cx: "9.2",
    cy: "16.2",
    r: "2.2",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1.3"
  })]
}));

var IconDelete = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M4.1665 5.83325H14.9998L14.1665 16.6666H4.99984L4.1665 5.83325Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M7.69238 8.33325L8.1411 14.1666",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M11.2822 8.33325L10.8335 14.1666",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M2.5 5.83325H16.6667",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M13.3335 5.83325V4.16659C13.3335 3.70635 12.9604 3.33325 12.5002 3.33325H6.66683C6.20659 3.33325 5.8335 3.70635 5.8335 4.16659V5.83325",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  })]
}));

var IconMenu = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M2 4H18",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M2 10H18",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M2 16H18",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  })]
}));

var IconMore = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("circle", {
    cx: "10.0004",
    cy: "4.79995",
    r: "1.35",
    fill: "currentColor"
  }), jsx("circle", {
    cx: "10.0004",
    cy: "9.9999",
    r: "1.35",
    fill: "currentColor"
  }), jsx("circle", {
    cx: "10.0004",
    cy: "15.1999",
    r: "1.35",
    fill: "currentColor"
  })]
}));

var IconList = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M3 4H3.00833",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M3 9.77979H3.00833",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M3 15.5596H3.00833",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M7 4H18",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M7 9.77979H18",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M7 15.5593H18",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconGallery = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("rect", {
    x: "2",
    y: "2",
    width: "7",
    height: "7",
    rx: "0.888889",
    fill: "currentColor"
  }), jsx("rect", {
    x: "2",
    y: "11",
    width: "7",
    height: "7",
    rx: "0.888889",
    fill: "currentColor"
  }), jsx("rect", {
    x: "11",
    y: "2",
    width: "7",
    height: "7",
    rx: "0.888889",
    fill: "currentColor"
  }), jsx("rect", {
    x: "11",
    y: "11",
    width: "7",
    height: "7",
    rx: "0.888889",
    fill: "currentColor"
  })]
}));

var IconDashboard = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M7.50016 11.5004C8.05245 11.5004 8.50016 11.9481 8.50016 12.5004V17.1671C8.50016 17.7194 8.05245 18.1671 7.50016 18.1671H2.8335C2.28121 18.1671 1.8335 17.7194 1.8335 17.1671V12.5004C1.8335 11.9481 2.28121 11.5004 2.8335 11.5004H7.50016ZM17.1668 11.5004C17.7191 11.5004 18.1668 11.9481 18.1668 12.5004V17.1671C18.1668 17.7194 17.7191 18.1671 17.1668 18.1671H12.5002C11.9479 18.1671 11.5002 17.7194 11.5002 17.1671V12.5004C11.5002 11.9481 11.9479 11.5004 12.5002 11.5004H17.1668ZM7.50016 1.83374C8.05245 1.83374 8.50016 2.28146 8.50016 2.83374V7.50041C8.50016 8.05269 8.05245 8.50041 7.50016 8.50041H2.8335C2.28121 8.50041 1.8335 8.05269 1.8335 7.50041V2.83374C1.8335 2.28145 2.28121 1.83374 2.8335 1.83374H7.50016ZM17.1668 1.83374C17.7191 1.83374 18.1668 2.28146 18.1668 2.83374V7.50041C18.1668 8.05269 17.7191 8.50041 17.1668 8.50041H12.5002C11.9479 8.50041 11.5002 8.05269 11.5002 7.50041V2.83374C11.5002 2.28145 11.9479 1.83374 12.5002 1.83374H17.1668Z",
    stroke: "currentColor",
    strokeWidth: "1.3"
  })
}));

var IconSend = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M18.3332 1.66675L9.1665 10.8334",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M18.3332 1.66675L12.4998 18.3334L9.1665 10.8334L1.6665 7.50008L18.3332 1.66675Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconShare = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M9.03846 4.5H3.65385C3.08261 4.5 2.53477 4.72692 2.13085 5.13085C1.72692 5.53477 1.5 6.08261 1.5 6.65385V16.3462C1.5 16.9174 1.72692 17.4652 2.13085 17.8692C2.53477 18.2731 3.08261 18.5 3.65385 18.5H13.3462C13.9174 18.5 14.4652 18.2731 14.8692 17.8692C15.2731 17.4652 15.5 16.9174 15.5 16.3462V10.9615",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M8 11.9985L18 1.99854",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M13 1.99854H18V6.99854",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconBell = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M16.9571 12.3867C16.8676 12.2974 16.8173 12.1761 16.8173 12.0497V8.46873C16.8152 6.66473 16.0963 4.93521 14.8182 3.65959C13.5401 2.38397 11.8073 1.6664 9.99984 1.66431C8.19238 1.6664 6.45955 2.38397 5.18148 3.65959C3.90342 4.93521 3.18448 6.66473 3.18238 8.46873V12.0497C3.18238 12.1761 3.13208 12.2974 3.04258 12.3867L1.8063 13.6206C1.7168 13.71 1.6665 13.8312 1.6665 13.9577V14.797C1.6665 15.06 1.8797 15.2731 2.14269 15.2731H17.857C18.12 15.2731 18.3332 15.06 18.3332 14.797V13.9577C18.3332 13.8312 18.2829 13.71 18.1934 13.6206L16.9571 12.3867Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M12.1348 15.2734C12.2325 15.5258 12.2783 15.7952 12.2697 16.0656C12.2697 16.6664 12.0306 17.2427 11.6049 17.6675C11.1792 18.0924 10.6019 18.3311 9.99987 18.3311C9.39787 18.3311 8.82053 18.0924 8.39485 17.6675C7.96917 17.2427 7.73003 16.6664 7.73003 16.0656C7.7214 15.7952 7.76728 15.5258 7.86495 15.2734",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10"
  })]
}));

var IconEdit = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M9.09431 3.85657H4.68892C4.22156 3.85657 3.77335 4.04222 3.44288 4.37269C3.11241 4.70316 2.92676 5.15137 2.92676 5.61872V15.3106C2.92676 15.7779 3.11241 16.2262 3.44288 16.5566C3.77335 16.8871 4.22156 17.0728 4.68892 17.0728H14.3808C14.8481 17.0728 15.2964 16.8871 15.6268 16.5566C15.9573 16.2262 16.1429 15.7779 16.1429 15.3106V10.9052M14.8971 2.61072C15.0597 2.44242 15.2541 2.30817 15.4691 2.21582C15.6841 2.12346 15.9153 2.07485 16.1493 2.07282C16.3833 2.07079 16.6153 2.11537 16.8319 2.20398C17.0484 2.29258 17.2452 2.42342 17.4106 2.58888C17.5761 2.75433 17.7069 2.95108 17.7955 3.16764C17.8841 3.38421 17.9287 3.61625 17.9267 3.85022C17.9247 4.0842 17.876 4.31543 17.7837 4.53042C17.6913 4.74541 17.5571 4.93986 17.3888 5.10241L9.82384 12.6674H7.33215V10.1757L14.8971 2.61072Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconSearch = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M8.5 16C12.6421 16 16 12.6421 16 8.49998C16 4.35785 12.6421 1 8.5 1C4.35786 1 1 4.35785 1 8.49998C1 12.6421 4.35786 16 8.5 16Z",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M19 19L14 14",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconChat = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M10.2332 16.5789C14.8353 16.5789 18.5666 13.3144 18.5666 9.28737C18.5666 5.26037 14.8353 1.99585 10.2332 1.99585C5.63115 1.99585 1.8999 5.26037 1.8999 9.28737C1.8999 11.1207 2.67386 12.7977 3.95199 14.0789C3.85094 15.1373 3.51761 16.2977 3.14886 17.1685C3.06657 17.3622 3.22594 17.5789 3.43324 17.5455C5.78324 17.1601 7.18011 16.5685 7.7874 16.2602C8.58523 16.4729 9.40752 16.5801 10.2332 16.5789Z",
    stroke: "currentColor",
    strokeWidth: "1.3"
  })
}));

var IconReport = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("rect", {
    x: "2.76172",
    y: "1.76343",
    width: "14.0005",
    height: "16.9996",
    rx: "1.19512",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("path", {
    d: "M6.24902 0.762939V3.56376",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M9.74902 0.762939V3.56376",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M13.2495 0.762939V3.56376",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M6.26221 7.51001H13.2625",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M6.26221 11.0103H13.2625",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M6.26221 14.5103H13.2625",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  })]
}));

var IconProjectList = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M14.0001 2.05005H16.6585C16.9346 2.05005 17.1585 2.27391 17.1585 2.55005V18.2501C17.1585 18.5262 16.9346 18.75 16.6585 18.75H3.3418C3.06565 18.75 2.8418 18.5262 2.8418 18.25V2.55005C2.8418 2.27391 3.06565 2.05005 3.3418 2.05005H5.50012",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M13.5 1C13.7761 1 14 1.22386 14 1.5V2.5C13.9972 2.89719 13.7857 3.27752 13.4112 3.55838C13.0367 3.83924 12.5296 3.99794 12 4H8C7.47042 3.99794 6.9633 3.83924 6.58883 3.55838C6.21435 3.27752 6.00275 2.89719 6 2.5V1.5C6 1.22386 6.22386 1 6.5 1H13.5Z",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M6 8.4082H6.3",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M13.7998 8.4082H8.7998",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M6 11.5918H6.3",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M13.7998 11.5918H8.7998",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M6 14.7754H6.3",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M13.7998 14.7754H8.7998",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconLiveChat = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: jsx("path", {
    d: "M6.9508 15.1778C8.21449 16.4164 10.0532 17.1961 12.0998 17.1961C12.7835 17.1971 13.4644 17.1084 14.1251 16.9322C14.6279 17.1875 15.7846 17.6774 17.7304 17.9966C17.9021 18.0242 18.034 17.8447 17.9659 17.6843C17.6605 16.9633 17.3845 16.0024 17.3009 15.1261C18.3592 14.0652 19.0001 12.6766 19.0001 11.1586C19.0001 8.15341 16.4906 5.66107 13.2055 5.19809M13.2055 5.19809C14.2014 6.24466 14.8004 7.59053 14.8004 9.05882C14.8004 12.3933 11.7109 15.0964 7.90021 15.0964C7.2165 15.0974 6.53562 15.0087 5.875 14.8325C5.37215 15.0878 4.2155 15.5777 2.26964 15.8968C2.098 15.9244 1.96603 15.745 2.03417 15.5846C2.3395 14.8635 2.61551 13.9027 2.69918 13.0264C1.64086 11.9655 1 10.5768 1 9.05882C1 5.72435 4.08957 3.02124 7.90021 3.02124C10.0329 3.02124 11.9397 3.86792 13.2055 5.19809Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  })
}));

var IconCompany = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M9.79175 11.6914H10.2917M9.79175 8.4917H10.2917M9.79175 5.2998H10.2917M6.6001 11.6914H7.1001M6.6001 8.4917H7.1001M6.6001 5.2998H7.1001M12.9917 11.6914H13.4917M12.9917 8.4917H13.4917M12.9917 5.2998H13.4917M12.0001 18.1864V15.3C12.0001 15.1343 11.8658 15 11.7001 15H8.30012C8.13444 15 8.00012 15.1343 8.00012 15.3V18.1864M18 19H10M2 19H10M10 19H4.31369C3.86437 19 3.50012 18.6358 3.50012 18.1864V1.81356C3.50012 1.36425 3.86437 1 4.31369 1H15.6866C16.1359 1 16.5001 1.36425 16.5001 1.81356V18.1864C16.5001 18.6358 16.1359 19 15.6866 19H10Z",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconWeather = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M16.8849 12.0063C16.1903 10.9149 14.9743 10.1877 13.5876 10.1756C12.7945 8.11502 10.9172 6.66667 8.72774 6.66667C8.49825 6.66667 8.2722 6.68258 8.05046 6.71344M16.8849 12.0063C17.2742 12.618 17.4997 13.344 17.4997 14.1228C17.4997 16.3028 15.7324 18.0701 13.5523 18.0701H3.46459C1.7102 18.0701 0.833008 16.5467 0.833008 15C0.833008 13.4486 1.98359 12.1661 3.47794 11.959C3.65566 9.24531 5.58637 7.05638 8.05046 6.71344M16.8849 12.0063C18.0274 11.0132 18.7497 9.54929 18.7497 7.91667C18.7497 4.92512 16.3246 2.5 13.333 2.5C10.755 2.5 8.59764 4.30099 8.05046 6.71344",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  })
}));

var IconReceipt = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: jsx("path", {
    d: "M4.43333 7.81276H6.81667M4.43333 10.9961C4.43333 10.9961 8.30858 10.9961 10.7917 10.9961M4.43333 14.1794C6.91642 14.1794 10.7917 14.1794 10.7917 14.1794M16.3667 18.9461H3.63333C3.32035 18.9461 3.01043 18.8844 2.72127 18.7647C2.43211 18.6449 2.16938 18.4693 1.94806 18.248C1.5011 17.8011 1.25 17.1949 1.25 16.5628V2.24609L3.33333 3.83776L5.49167 2.24609L7.60833 3.83776L9.73333 2.24609L11.85 3.83776L13.975 2.24609V16.5628C13.9772 17.1956 14.2302 17.8018 14.6784 18.2485C15.1267 18.6953 15.7338 18.9461 16.3667 18.9461ZM18.75 8.60443V16.665C18.714 17.2816 18.4468 17.861 18.003 18.2847C17.5592 18.7084 16.9724 18.9444 16.3625 18.9444C15.7526 18.9444 15.1658 18.7084 14.722 18.2847C14.2782 17.861 14.011 17.2816 13.975 16.665V8.60443H18.75Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconBulb = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M7.71326 14.4392H12.2953M9.99989 0.886719V2.49801M16.2449 3.29631L15.07 4.47127M18.8296 9.53651H17.0676M2.91258 9.53651C2.40273 9.53651 1.19241 9.53651 1.19241 9.53651M4.93958 4.47127L3.76463 3.29631M6.5376 13.0037C5.85207 12.318 5.38526 11.4444 5.1962 10.4934C5.00713 9.54242 5.1043 8.55671 5.47541 7.66093C5.84652 6.76515 6.47491 5.99952 7.28113 5.46086C8.08734 4.9222 9.03518 4.63469 10.0048 4.63469C10.9744 4.63469 11.9222 4.9222 12.7284 5.46086C13.5347 5.99952 14.163 6.76515 14.5342 7.66093C14.9053 8.55671 15.0024 9.54242 14.8134 10.4934C14.6243 11.4444 14.1575 12.318 13.472 13.0037L12.9346 13.5401C12.6274 13.8473 12.3838 14.2121 12.2176 14.6135C12.0513 15.0149 11.9658 15.4452 11.9659 15.8797V17.8712C11.9659 18.3913 11.7592 18.8901 11.3915 19.2579C11.0509 19.2867 10.5228 19.2867 10.0027 19.2867C9.47862 19.2867 8.95452 19.2867 8.61809 19.2579C8.25032 18.8901 8.04371 18.3913 8.04371 17.8712V15.8797C8.04371 15.0021 7.69463 14.1598 7.07493 13.5401L6.5376 13.0037Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("line", {
    x1: "8",
    y1: "16.35",
    x2: "12.3815",
    y2: "16.35",
    stroke: "currentColor",
    strokeWidth: "1.3"
  })]
}));

var IconBox = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: [jsx("path", {
    d: "M15.7107 1.68148C15.6216 1.52577 15.456 1.42969 15.2766 1.42969H4.72339C4.54402 1.42969 4.37839 1.52577 4.28935 1.68148L1.31596 6.88101C1.27274 6.9566 1.25 7.04215 1.25 7.12922V18.4297C1.25 18.7058 1.47386 18.9297 1.75 18.9297H18.25C18.5261 18.9297 18.75 18.7058 18.75 18.4297V7.12922C18.75 7.04216 18.7273 6.9566 18.684 6.88101L15.7107 1.68148Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M3.6333 15.7463H6.81663",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M10 1.42969V10.1797",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M1.25 6.99634H18.75",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  })]
}));

var IconPoint = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("circle", {
    cx: "10",
    cy: "10",
    r: "9.35",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("path", {
    d: "M6.81177 4.696H9.93377C10.5124 4.696 11.0398 4.752 11.5158 4.864C12.0011 4.96667 12.4164 5.13933 12.7618 5.382C13.1071 5.62467 13.3778 5.94667 13.5738 6.348C13.7698 6.74 13.8678 7.22533 13.8678 7.804C13.8678 8.364 13.7698 8.854 13.5738 9.274C13.3778 9.68467 13.1071 10.0253 12.7618 10.296C12.4258 10.5667 12.0198 10.7673 11.5438 10.898C11.0678 11.0287 10.5498 11.094 9.98977 11.094H8.43577V15H6.81177V4.696ZM9.83577 9.792C10.6851 9.792 11.3011 9.63333 11.6838 9.316C12.0758 8.98933 12.2718 8.48533 12.2718 7.804C12.2718 7.12267 12.0618 6.65133 11.6418 6.39C11.2218 6.12867 10.6011 5.998 9.77977 5.998H8.43577V9.792H9.83577Z",
    fill: "currentColor"
  })]
}));

var IconHome = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M2 7.82934C2 7.68346 2.06742 7.54577 2.18266 7.45632L10.1925 1.23871C10.3711 1.10008 10.6228 1.10747 10.793 1.25633L18.8387 8.29539C18.9412 8.38506 19 8.51461 19 8.65079V18.5278C19 18.7886 18.7886 19 18.5278 19H2.47222C2.21142 19 2 18.7886 2 18.5278V7.82934Z",
    stroke: "currentColor",
    strokeWidth: "1.25"
  }), jsx("path", {
    d: "M13.4995 19.1672V14.167C13.4995 12.5101 12.1564 11.167 10.4995 11.167V11.167C8.84266 11.167 7.49951 12.5101 7.49951 14.167V19.1672",
    stroke: "currentColor",
    strokeWidth: "1.25"
  })]
}));

var IconMaterial = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M0.836426 14.6759V4.33797C0.836426 4.16739 0.943851 4.01528 1.10462 3.95824L9.76909 0.883956C9.85536 0.853347 9.94948 0.853024 10.036 0.88304L18.8936 3.95755C19.0583 4.01472 19.1676 4.17134 19.1643 4.34566L18.9729 14.6812C18.9701 14.835 18.8799 14.9738 18.7405 15.0388L10.0728 19.0838C9.96475 19.1342 9.83997 19.1342 9.73197 19.0838L1.06896 15.041C0.927101 14.9748 0.836426 14.8325 0.836426 14.6759Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M0.836426 4.4563L10.1038 8.4856",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M10.1037 8.68715L18.9681 4.45636",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M10.104 18.9619L10.104 8.68719",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M5.72511 6.33669L14.2807 2.67",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  })]
}));

var IconMoney = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M7.5 1H12.5C12.8978 1 13.2793 1.15804 13.5606 1.43934C13.842 1.72065 14 2.10218 14 2.50001C14 3.42827 13.6312 4.31851 12.9749 4.97489C12.3185 5.63127 11.4282 6.00002 10.5 6.00002H9.49999C8.57174 6.00002 7.6815 5.63127 7.02512 4.97489C6.36875 4.31851 6 3.42827 6 2.50001C6 2.10218 6.15803 1.72065 6.43934 1.43934C6.72064 1.15804 7.10217 1 7.5 1Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M2 15V14C2 11.8783 2.84285 9.84345 4.34314 8.34315C5.84343 6.84286 7.87826 6 9.99999 6C12.1217 6 14.1565 6.84286 15.6568 8.34315C17.1571 9.84345 18 11.8783 18 14V15C18 16.0609 17.5785 17.0783 16.8284 17.8285C16.0783 18.5786 15.0608 19 14 19H5.99999C4.93913 19 3.92171 18.5786 3.17157 17.8285C2.42143 17.0783 2 16.0609 2 15Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconEquipment = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: [jsx("path", {
    d: "M4.9999 17.7859C6.1597 17.7859 7.0999 16.8457 7.0999 15.6859C7.0999 14.5261 6.1597 13.5859 4.9999 13.5859C3.8401 13.5859 2.8999 14.5261 2.8999 15.6859C2.8999 16.8457 3.8401 17.7859 4.9999 17.7859Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M13.3002 17.8108C14.46 17.8108 15.4002 16.8706 15.4002 15.7108C15.4002 14.551 14.46 13.6108 13.3002 13.6108C12.1404 13.6108 11.2002 14.551 11.2002 15.7108C11.2002 16.8706 12.1404 17.8108 13.3002 17.8108Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M15.5 16.1194H19V11.9023V11.0624L16.679 7.11938H13V11.9023",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M16 11.1194H18.3833",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M7.5 16.1191H10H11M2.50098 16.1191H1V11.1191H3.24754H4.00196H7.00393H10.0059H13V13.6191",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M8.15833 10.7109H5.775L1 7.5276L2.59167 1.96094H8.15833C8.57637 1.96094 8.99032 2.04328 9.37654 2.20325C9.76276 2.36323 10.1137 2.59771 10.4093 2.89331C10.7049 3.18891 10.9394 3.53984 11.0993 3.92606C11.2593 4.31228 11.3417 4.72623 11.3417 5.14427V7.5276C11.3417 7.94565 11.2593 8.35959 11.0993 8.74581C10.9394 9.13203 10.7049 9.48296 10.4093 9.77856C10.1137 10.0742 9.76276 10.3086 9.37654 10.4686C8.99032 10.6286 8.57637 10.7109 8.15833 10.7109Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M6.56635 1.96094L4.33301 9.53593",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M9.74954 2.75244L7.36621 10.7108",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconNoticeBoard = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: [jsx("rect", {
    x: "2",
    y: "6.19727",
    width: "16",
    height: "12",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M5.5 9.49731H8.87353M5.5 12.1973H14.5M5.5 14.8973H14.5",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M4 6.19727L8.5 1.69727C8.66667 1.5306 9 1.19727 10 1.19727C11 1.19727 11.3333 1.5306 11.5 1.69727L16 6.19727",
    stroke: "currentColor",
    strokeWidth: "1.3"
  })]
}));

var IconCooperation = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: jsx("path", {
    d: "M1 13.4875H2.48946C2.58586 13.4875 2.6802 13.5153 2.76113 13.5677L6.5 15.9875C7.43785 16.5199 8.50001 16.7565 10 16.4875C12 15.9875 12.1272 15.9422 13.0599 15.4127L14.3366 14.6658C14.5773 14.525 14.6563 14.2145 14.5121 13.9758L11.7547 9.40924C11.6134 9.17529 11.3105 9.09811 11.0745 9.23595L9.41348 10.2061C9.37042 10.2313 9.32389 10.2502 9.27505 10.2603C9.07654 10.3014 8.87424 10.3218 8.67138 10.3212C8.24015 10.3213 7.81477 10.2215 7.42852 10.0298C7.20879 9.92159 7.02481 9.7525 6.89849 9.54267C6.77218 9.33284 6.70886 9.09111 6.71609 8.8463C6.72331 8.60149 6.80078 8.36392 6.93925 8.1619C7.07773 7.95989 7.49995 7.48745 7.99995 6.98745C8.48314 6.50427 10.3671 5.08719 10.4933 4.99242C10.498 4.9889 10.5022 4.98563 10.5068 4.98199C11.1297 4.48705 12.4693 4.43826 13 4.48745C13.5325 4.53682 14 4.48748 15 4.98745C15.6969 5.33593 16.1746 5.68443 16.4001 5.86363C16.4977 5.94116 16.6176 5.98745 16.7422 5.98745H19M17 13.5222L17.3629 13.4875H19.0001M1 6.21828H3.30103C3.39912 6.21828 3.49505 6.18942 3.57687 6.1353L5.09714 5.1297C5.54263 4.8337 6.05462 4.65291 6.58719 4.60354C7.11977 4.55418 7.65627 4.63777 8.14857 4.84684L9.5 5.48745M19 4.48745V14.4875M1 4.48745V14.4875",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconEye = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M12.4517 9.83325C12.4517 10.4963 12.1883 11.1322 11.7194 11.601C11.2506 12.0699 10.6147 12.3333 9.95166 12.3333C9.28862 12.3333 8.65273 12.0699 8.18389 11.601C7.71505 11.1322 7.45166 10.4963 7.45166 9.83325C7.45166 9.17021 7.71505 8.53433 8.18389 8.06548C8.65273 7.59664 9.28862 7.33325 9.95166 7.33325C10.6147 7.33325 11.2506 7.59664 11.7194 8.06548C12.1883 8.53433 12.4517 9.17021 12.4517 9.83325Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M2.21077 10.4249C2.05902 10.0452 2.05902 9.62142 2.21077 9.24176C3.4385 6.17015 6.44216 4 9.95167 4C13.462 4 16.4649 6.17015 17.6926 9.24176C17.8443 9.62142 17.8443 10.0452 17.6926 10.4249C16.4649 13.4965 13.462 15.6667 9.95167 15.6667C6.44216 15.6667 3.4385 13.4965 2.21077 10.4249Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconEyeInvisible = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M17.5 7.5C15.5 9.7225 13 10.8333 10 10.8333C7 10.8333 4.5 9.7225 2.5 7.5",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M2.5 12.4999L4.58333 9.33325",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M17.5 12.4799L15.4233 9.33325",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M7.5 14.1666L7.91667 10.8333",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M12.5002 14.1666L12.0835 10.8333",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconBasket = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M13.4367 8.94995V4.23566C13.4367 2.28294 11.8537 0.699951 9.90095 0.699951C7.94823 0.699951 6.36524 2.28294 6.36524 4.23566V8.94995M4.09533 19.3434H15.7064C16.3008 19.3434 16.796 18.8877 16.8454 18.2954L17.7977 6.86658C17.8533 6.20027 17.3274 5.6288 16.6588 5.6288H3.14295C2.47432 5.6288 1.9485 6.20027 2.00403 6.86658L2.95641 18.2954C3.00577 18.8877 3.50094 19.3434 4.09533 19.3434Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  })
}));

var IconHardHat = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M11.6668 4.75C13.23 5.12576 14.6215 6.01623 15.6175 7.27827C16.6135 8.54031 17.1563 10.1006 17.1585 11.7083V13.3H2.8418V11.7083C2.83958 10.0995 3.38067 8.53696 4.37741 7.27403C5.37414 6.01109 6.76812 5.12171 8.33347 4.75",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M17.1583 13.3H2.84167C1.96261 13.3 1.25 14.0127 1.25 14.8917C1.25 15.7708 1.96261 16.4834 2.84167 16.4834H17.1583C18.0374 16.4834 18.75 15.7708 18.75 14.8917C18.75 14.0127 18.0374 13.3 17.1583 13.3Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M12.3834 13.3H7.6167L8.40837 3.75H11.5917L12.3834 13.3Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  })]
}));

var IconBoardCheck = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M14.1583 2.05H16.8167C17.0928 2.05 17.3167 2.27386 17.3167 2.55V18.25C17.3167 18.5261 17.0928 18.75 16.8167 18.75H3.5C3.22386 18.75 3 18.5261 3 18.25V2.55C3 2.27386 3.22386 2.05 3.5 2.05H5.65833M14.1583 2.5V1.5C14.1583 1.22386 13.9345 1 13.6583 1H6.65833C6.38219 1 6.15833 1.22386 6.15833 1.5V2.5C6.16108 2.89719 6.37268 3.27752 6.74716 3.55838C7.12164 3.83924 7.62875 3.99794 8.15833 4H12.1583C12.6879 3.99794 13.195 3.83924 13.5695 3.55838C13.944 3.27752 14.1556 2.89719 14.1583 2.5Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M7 10.2417L9.24183 12.4834L13.7241 8",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconBoardDolar = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M14.1583 2H16.8167C17.0928 2 17.3167 2.22386 17.3167 2.5V18.2C17.3167 18.4761 17.0928 18.7 16.8167 18.7H3.5C3.22386 18.7 3 18.4761 3 18.2V2.5C3 2.22386 3.22386 2 3.5 2H5.65833",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M13.5 1C13.7761 1 14 1.22386 14 1.5V2.5C13.9972 2.89719 13.7857 3.27752 13.4112 3.55838C13.0367 3.83924 12.5296 3.99794 12 4H8C7.47042 3.99794 6.9633 3.83924 6.58883 3.55838C6.21435 3.27752 6.00275 2.89719 6 2.5V1.5C6 1.22386 6.22386 1 6.5 1H13.5Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M11.9001 8.07446H9.2126C8.78494 8.07446 8.37479 8.24434 8.07239 8.54671C7.76999 8.84909 7.6001 9.2592 7.6001 9.68683C7.6001 10.1145 7.76999 10.5246 8.07239 10.8269C8.37479 11.1293 8.78494 11.2992 9.2126 11.2992H10.2876C10.7153 11.2992 11.1254 11.4691 11.4278 11.7714C11.7302 12.0738 11.9001 12.4839 11.9001 12.9116C11.9001 13.3392 11.7302 13.7493 11.4278 14.0517C11.1254 14.354 10.7153 14.5239 10.2876 14.5239H8.94385H7.6001",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M9.74902 14.5241V15.599M9.74902 6.99976V8.07467",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconDocumentCheck = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("path", {
    d: "M7.90487 18.3346H3.66667C3.02234 18.3346 2.5 17.8123 2.5 17.168V2.83463C2.5 2.1903 3.02233 1.66797 3.66667 1.66797H15C15.6443 1.66797 16.1667 2.1903 16.1667 2.83464V11.668",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M10.7759 16.4102L13.0177 18.6519L17.5 14.1685",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M5.60352 6.92676H13.1035",
    stroke: "currentColor",
    strokeWidth: "1.08333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M5.60352 10.2371H10.6035",
    stroke: "currentColor",
    strokeWidth: "1.08333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconCompanyConfig = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: [jsx("path", {
    d: "M9.79175 12.1787H10.2917M9.79175 8.979H10.2917M9.79175 5.78711H10.2917M6.6001 12.1787H7.1001M6.6001 8.979H7.1001M6.6001 5.78711H7.1001M12.9917 12.1787H13.4917M12.9917 8.979H13.4917M12.9917 5.78711H13.4917M10 19.4873H2M3.50012 19.2873V2.30087C3.50012 1.85155 3.86437 1.4873 4.31369 1.4873H15.6866C16.1359 1.4873 16.5001 1.85155 16.5001 2.30087L16.5001 10.4873",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M19.1656 17.3303C19.1796 17.2183 19.1935 17.1063 19.1935 16.9873C19.1935 16.8683 19.1796 16.7563 19.1656 16.6443L19.9205 16.0703C19.9904 16.0213 20.0044 15.9233 19.9624 15.8463L19.2425 14.6353C19.2005 14.5583 19.1027 14.5303 19.0258 14.5583L18.1311 14.9083C17.9424 14.7683 17.7397 14.6563 17.523 14.5653L17.3832 13.6343C17.3832 13.5503 17.3063 13.4873 17.2154 13.4873H15.7825C15.7398 13.4865 15.6982 13.5008 15.6649 13.5277C15.6317 13.5546 15.609 13.5923 15.6008 13.6343L15.461 14.5583C15.2443 14.6423 15.0416 14.7683 14.8529 14.9013L13.9582 14.5513C13.8743 14.5163 13.7834 14.5513 13.7415 14.6283L13.0215 15.8393C12.9796 15.9233 13.0005 16.0143 13.0704 16.0703L13.8254 16.6443C13.8114 16.7563 13.8044 16.8753 13.8044 16.9873C13.8044 17.1063 13.8184 17.2183 13.8323 17.3303L13.0704 17.9113C13.0005 17.9603 12.9866 18.0583 13.0285 18.1353L13.7485 19.3463C13.7904 19.4233 13.8883 19.4513 13.9651 19.4233L14.8598 19.0733C15.0486 19.2133 15.2513 19.3253 15.468 19.4163L15.6078 20.3403C15.6147 20.4243 15.6916 20.4873 15.7825 20.4873H17.2224C17.3133 20.4873 17.3902 20.4243 17.3972 20.3403L17.537 19.4163C17.7536 19.3323 17.9563 19.2063 18.1451 19.0733L19.0398 19.4233C19.1236 19.4583 19.2145 19.4233 19.2565 19.3463L19.9764 18.1353C20.0183 18.0583 20.0044 17.9673 19.9345 17.9113L19.1656 17.3303ZM16.4955 18.2123C15.8035 18.2123 15.2373 17.6663 15.2373 16.9873C15.2373 16.3083 15.8035 15.7623 16.4955 15.7623C17.1875 15.7623 17.7536 16.3083 17.7536 16.9873C17.7536 17.6663 17.1945 18.2123 16.4955 18.2123Z",
    fill: "currentColor"
  })]
}));

var IconMap = GenIcon(jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    d: "M6.94461 3.98368V10.6925M13.0557 5.81336V8.66165M16.5 14.3759C16.692 14.3 18.8838 13.1931 18.9963 13.0475C19.1089 12.9019 19.1679 12.734 19.1668 12.5629V2.41422C19.1668 2.25831 19.1168 2.10499 19.0217 1.96883C18.9266 1.83266 18.7894 1.71816 18.6233 1.63621C18.4572 1.55425 18.2676 1.50754 18.0725 1.50053C17.8774 1.49352 17.6833 1.52644 17.5087 1.59614L13.565 3.16886C13.406 3.23266 13.2306 3.26588 13.0527 3.26588C12.8747 3.26588 12.6993 3.23266 12.5403 3.16886L7.45387 1.13913C7.29479 1.07565 7.11939 1.0426 6.94155 1.0426C6.76371 1.0426 6.58831 1.07565 6.42924 1.13913L1.46702 3.12089C1.27593 3.19714 1.11535 3.31453 1.0034 3.45981C0.89146 3.60509 0.832612 3.77246 0.833506 3.94302V14.0916C0.833556 14.2475 0.883513 14.4009 0.978635 14.537C1.07376 14.6732 1.21089 14.7877 1.37701 14.8696C1.54313 14.9516 1.73273 14.9983 1.92781 15.0053C2.12289 15.0124 2.31698 14.9794 2.49165 14.9097L6.43535 13.337C6.59431 13.2732 6.76975 13.24 6.94766 13.24C7.12558 13.24 7.30102 13.2732 7.45998 13.337L9.67297 14.0916M14.1833 12.4711C14.1833 12.9971 13.7356 13.4235 13.1833 13.4235C12.6311 13.4235 12.1833 12.9971 12.1833 12.4711C12.1833 11.9451 12.6311 11.5188 13.1833 11.5188C13.7356 11.5188 14.1833 11.9451 14.1833 12.4711ZM16.8806 11.9635C17.0004 15.5369 13.1834 18.1478 13.1834 18.1478C13.1834 18.1478 9.36728 15.5109 9.48612 11.9635C9.50112 11.5155 9.60869 11.0748 9.80267 10.6665C9.99664 10.2581 10.2732 9.89019 10.6166 9.58371C10.96 9.2772 11.3634 9.03819 11.8038 8.8803C12.2443 8.7224 12.713 8.64873 13.1834 8.6635C13.6537 8.64873 14.1225 8.7224 14.5629 8.8803C15.0034 9.03819 15.4068 9.2772 15.7502 9.58371C16.0935 9.89019 16.3701 10.2581 16.5641 10.6665C16.7581 11.0748 16.8656 11.5155 16.8806 11.9635Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconGlobe = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10ZM9.375 1.34625C8.5375 1.60125 7.70625 2.37125 7.01625 3.665C6.8375 4 6.67125 4.365 6.5225 4.755C7.40375 4.95125 8.3625 5.07625 9.375 5.11375V1.34625ZM5.31125 4.42375C5.48875 3.94375 5.69125 3.49375 5.9125 3.07625C6.12863 2.66757 6.37824 2.27749 6.65875 1.91C5.59458 2.351 4.62781 2.9975 3.81375 3.8125C4.26625 4.0425 4.7675 4.2475 5.31125 4.42375ZM4.38625 9.375C4.43125 8.0375 4.62125 6.76625 4.93125 5.615C4.25462 5.39861 3.59969 5.11948 2.975 4.78125C1.97943 6.11794 1.38853 7.71234 1.2725 9.375H4.385H4.38625ZM6.13625 5.94875C5.84156 7.06846 5.67384 8.21777 5.63625 9.375H9.375V6.36375C8.2375 6.32625 7.14625 6.1825 6.13625 5.94875ZM10.625 6.3625V9.375H14.3625C14.3253 8.21782 14.158 7.0685 13.8637 5.94875C12.8537 6.1825 11.7625 6.32375 10.625 6.3625ZM5.6375 10.625C5.68125 11.8588 5.8575 13.0175 6.13625 14.0513C7.20007 13.8098 8.28465 13.6713 9.375 13.6375V10.625H5.6375ZM10.625 10.625V13.6363C11.7625 13.6738 12.8537 13.8175 13.8637 14.0513C14.1425 13.0175 14.3188 11.8588 14.3638 10.625H10.625ZM6.5225 15.245C6.6725 15.635 6.8375 16 7.01625 16.335C7.70625 17.6287 8.53875 18.3975 9.375 18.6538V14.8875C8.3625 14.925 7.40375 15.0487 6.5225 15.245ZM6.66 18.09C6.37904 17.7226 6.12901 17.3325 5.9125 16.9237C5.68228 16.4881 5.48141 16.0375 5.31125 15.575C4.79704 15.7403 4.29638 15.945 3.81375 16.1875C4.62781 17.0025 5.59583 17.649 6.66 18.09ZM4.93125 14.385C4.60672 13.1565 4.42345 11.895 4.385 10.625H1.2725C1.38846 12.2877 1.97937 13.8821 2.975 15.2188C3.5625 14.8963 4.21875 14.6163 4.93125 14.385ZM13.3413 18.09C14.4049 17.6493 15.3712 17.0032 16.185 16.1888C15.7028 15.9463 15.2025 15.7415 14.6888 15.5763C14.5185 16.0383 14.3177 16.4885 14.0875 16.9237C13.8714 17.3325 13.6218 17.7226 13.3413 18.09ZM10.625 14.8863V18.6538C11.4625 18.3988 12.2937 17.6287 12.9838 16.335C13.1625 16 13.3287 15.635 13.4775 15.245C12.5395 15.0393 11.5847 14.9184 10.625 14.8863ZM15.0688 14.385C15.7812 14.6163 16.4375 14.8963 17.025 15.2188C18.0206 13.8821 18.6115 12.2877 18.7275 10.625H15.615C15.5765 11.895 15.3933 13.1565 15.0688 14.385ZM18.7275 9.375C18.6115 7.71233 18.0206 6.11791 17.025 4.78125C16.4375 5.10375 15.7812 5.38375 15.0688 5.615C15.3788 6.765 15.5687 8.0375 15.615 9.375H18.7275ZM14.0875 3.07625C14.3088 3.49375 14.5112 3.94375 14.69 4.42375C15.2034 4.25843 15.7032 4.05365 16.185 3.81125C15.3711 2.99728 14.4048 2.35165 13.3413 1.91125C13.6138 2.265 13.8638 2.6575 14.0875 3.07625ZM13.4775 4.755C13.3355 4.38186 13.1706 4.01783 12.9838 3.665C12.2937 2.37125 11.4625 1.6025 10.625 1.34625V5.1125C11.6375 5.075 12.5962 4.95125 13.4775 4.755Z",
    fill: "currentColor"
  })
}));

var IconTarget = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: jsx("path", {
    d: "M17.639 13.0256L17.0114 12.8566L17.639 13.0256ZM14.5335 17.4515L14.1611 16.9187L14.5335 17.4515ZM4.41055 16.5618L3.95093 17.0214L4.41055 16.5618ZM2.12461 11.6621L1.47711 11.719V11.719L2.12461 11.6621ZM7.94677 3.33334L7.77779 2.70569L7.94677 3.33334ZM12.1943 4.05025C12.5365 4.15865 12.9018 3.96909 13.0102 3.62687C13.1186 3.28464 12.9291 2.91933 12.5868 2.81093L12.1943 4.05025ZM18.0623 8.09127C17.9416 7.7532 17.5696 7.57703 17.2316 7.69777C16.8935 7.81852 16.7173 8.19046 16.8381 8.52853L18.0623 8.09127ZM14.5001 10.9721L13.8501 10.9681V10.9721H14.5001ZM13.7417 13.4722L14.2822 13.8333L13.7417 13.4722ZM6.81821 14.1541L6.35859 14.6137L6.81821 14.1541ZM5.58667 11.85L6.22418 11.7232L5.58667 11.85ZM5.84274 9.25009L6.44327 9.49883L5.84274 9.25009ZM7.50012 7.23057L7.139 6.69012L7.50012 7.23057ZM10.0002 6.47219V7.12221L10.0042 7.12218L10.0002 6.47219ZM10.7333 7.1899C11.0858 7.25823 11.4268 7.02794 11.4952 6.67551C11.5635 6.32309 11.3332 5.982 10.9808 5.91367L10.7333 7.1899ZM15.0415 9.90686C14.9671 9.55567 14.6221 9.33129 14.2709 9.40569C13.9197 9.48009 13.6953 9.8251 13.7697 10.1763L15.0415 9.90686ZM10.5406 9.51254C10.2867 9.76638 10.2867 10.1779 10.5406 10.4318C10.7944 10.6856 11.206 10.6856 11.4598 10.4318L10.5406 9.51254ZM14.4767 4.23399L14.0171 3.77438C13.8952 3.89627 13.8267 4.0616 13.8267 4.23399H14.4767ZM16.7384 1.97217H17.3884C17.3884 1.70927 17.2301 1.47225 16.9872 1.37164C16.7443 1.27104 16.4647 1.32665 16.2788 1.51255L16.7384 1.97217ZM16.7384 4.23399H16.0884C16.0884 4.59297 16.3795 4.88399 16.7384 4.88399V4.23399ZM19.0002 4.23399L19.4598 4.6936C19.6457 4.5077 19.7013 4.22813 19.6007 3.98524C19.5001 3.74235 19.2631 3.58399 19.0002 3.58399V4.23399ZM16.7384 6.49581V7.14581C16.9108 7.14581 17.0762 7.07732 17.1981 6.95542L16.7384 6.49581ZM17.0114 12.8566C16.568 14.5035 15.5589 15.9416 14.1611 16.9187L14.9059 17.9842C16.5541 16.8321 17.7439 15.1364 18.2667 13.1946L17.0114 12.8566ZM14.1611 16.9187C12.7633 17.8959 11.0661 18.3496 9.36714 18.2003L9.25333 19.4953C11.2565 19.6713 13.2578 19.1363 14.9059 17.9842L14.1611 16.9187ZM9.36714 18.2003C7.66821 18.0509 6.07612 17.3082 4.87017 16.1022L3.95093 17.0214C5.37287 18.4434 7.25012 19.3192 9.25333 19.4953L9.36714 18.2003ZM4.87017 16.1022C3.66421 14.8963 2.92143 13.3042 2.77212 11.6052L1.47711 11.719C1.65316 13.7223 2.52898 15.5995 3.95093 17.0214L4.87017 16.1022ZM2.77212 11.6052C2.62281 9.9063 3.07652 8.20906 4.05364 6.81125L2.98816 6.06643C1.83603 7.7146 1.30106 9.71583 1.47711 11.719L2.77212 11.6052ZM4.05364 6.81125C5.03076 5.41344 6.4689 4.40434 8.11574 3.96099L7.77779 2.70569C5.836 3.22844 4.14029 4.41827 2.98816 6.06643L4.05364 6.81125ZM8.11574 3.96099C9.46198 3.59857 10.8774 3.63313 12.1943 4.05025L12.5868 2.81093C11.0341 2.31911 9.36518 2.27834 7.77779 2.70569L8.11574 3.96099ZM16.8381 8.52853C17.3333 9.91496 17.3968 11.4249 17.0114 12.8566L18.2667 13.1946C18.7212 11.5064 18.6462 9.72603 18.0623 8.09127L16.8381 8.52853ZM13.8501 10.9721C13.8501 11.7336 13.6243 12.4779 13.2013 13.1111L14.2822 13.8333C14.8481 12.9864 15.1501 11.9907 15.1501 10.9721H13.8501ZM13.2013 13.1111C12.7782 13.7442 12.177 14.2376 11.4735 14.529L11.971 15.7301C12.912 15.3403 13.7163 14.6802 14.2822 13.8333L13.2013 13.1111ZM11.4735 14.529C10.77 14.8204 9.99589 14.8967 9.24907 14.7481L8.99546 16.0231C9.99445 16.2219 11.0299 16.1199 11.971 15.7301L11.4735 14.529ZM9.24907 14.7481C8.50225 14.5996 7.81626 14.2329 7.27783 13.6945L6.35859 14.6137C7.07883 15.334 7.99646 15.8244 8.99546 16.0231L9.24907 14.7481ZM7.27783 13.6945C6.73941 13.1561 6.37273 12.4701 6.22418 11.7232L4.94916 11.9769C5.14787 12.9758 5.63836 13.8935 6.35859 14.6137L7.27783 13.6945ZM6.22418 11.7232C6.07563 10.9764 6.15187 10.2023 6.44327 9.49883L5.24222 9.00135C4.85243 9.94238 4.75045 10.9779 4.94916 11.9769L6.22418 11.7232ZM6.44327 9.49883C6.73466 8.79535 7.22812 8.19407 7.86124 7.77103L7.139 6.69012C6.29209 7.256 5.63201 8.06032 5.24222 9.00135L6.44327 9.49883ZM7.86124 7.77103C8.49436 7.34799 9.23871 7.12219 10.0002 7.12219V5.82219C8.9816 5.82219 7.98591 6.12423 7.139 6.69012L7.86124 7.77103ZM10.0042 7.12218C10.2495 7.12064 10.4937 7.14344 10.7333 7.1899L10.9808 5.91367C10.6571 5.85091 10.3273 5.82012 9.99608 5.82221L10.0042 7.12218ZM13.7697 10.1763C13.8247 10.436 13.8518 10.7014 13.8501 10.9681L15.1501 10.9762C15.1524 10.6161 15.1158 10.2576 15.0415 9.90686L13.7697 10.1763ZM11.4598 10.4318L14.9363 6.95544L14.0171 6.03618L10.5406 9.51254L11.4598 10.4318ZM15.1267 6.49581V4.23399H13.8267V6.49581H15.1267ZM14.9363 4.6936L17.1981 2.43178L16.2788 1.51255L14.0171 3.77438L14.9363 4.6936ZM16.0884 1.97217V4.23399H17.3884V1.97217H16.0884ZM16.7384 4.88399H19.0002V3.58399H16.7384V4.88399ZM18.5406 3.77438L16.2788 6.0362L17.1981 6.95542L19.4598 4.6936L18.5406 3.77438ZM16.7384 5.84581H14.4767V7.14581H16.7384V5.84581ZM10.6002 10.9721C10.6002 11.3035 10.3316 11.5721 10.0002 11.5721V12.8721C11.0495 12.8721 11.9002 12.0215 11.9002 10.9721H10.6002ZM10.0002 11.5721C9.66881 11.5721 9.4002 11.3035 9.4002 10.9721H8.1002C8.1002 12.0215 8.95088 12.8721 10.0002 12.8721V11.5721ZM9.4002 10.9721C9.4002 10.6408 9.66881 10.3722 10.0002 10.3722V9.07218C8.95088 9.07218 8.1002 9.9228 8.1002 10.9721H9.4002ZM10.0002 10.3722C10.3316 10.3722 10.6002 10.6408 10.6002 10.9721H11.9002C11.9002 9.9228 11.0495 9.07218 10.0002 9.07218V10.3722Z",
    fill: "currentColor"
  })
}));

var IconUpload = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M10 12.2859L10 2.91089",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M13.5356 6.03589L10.0001 2.50036L6.46458 6.03589",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M2.5 11.8755V14.688C2.5 15.7235 3.33947 16.563 4.375 16.563H15.625C16.6605 16.563 17.5 15.7235 17.5 14.688V11.8755",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  })]
}));

var IconDownload = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M10 2.5L10 11.875",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M6.46436 8.75L9.99989 12.2855L13.5354 8.75",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M2.5 11.8752V14.6877C2.5 15.7233 3.33947 16.5627 4.375 16.5627H15.625C16.6605 16.5627 17.5 15.7233 17.5 14.6877V11.8752",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  })]
}));

var IconFiles = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M13.5548 6.7539C13.6049 6.80356 13.6332 6.87122 13.6332 6.94181V18.9083C13.6332 19.0544 13.5148 19.1727 13.3688 19.1727H2.26439C2.11837 19.1727 2 19.0544 2 18.9083V4.63109C2 4.48507 2.11837 4.3667 2.26439 4.3667H11.0341C11.1038 4.3667 11.1706 4.39418 11.2201 4.44318L13.5548 6.7539Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M13.6741 15.806H16.736C16.882 15.806 17.0003 15.6877 17.0003 15.5416V3.57511C17.0003 3.50452 16.9721 3.43686 16.9219 3.3872L14.5873 1.07648C14.5378 1.02748 14.4709 1 14.4013 1H5.63158C5.48556 1 5.36719 1.11837 5.36719 1.26439V4.29215",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M10.2998 4.64526V7.64526H13.7998",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  })]
}));

var IconFolder = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("path", {
    d: "M17.3607 6.83834H11.6663C11.3277 6.83834 11.003 6.70385 10.7636 6.46444L9.437 5.13782C9.1976 4.89841 8.8729 4.76392 8.53433 4.76392H3.87709C3.01784 4.76392 2.32129 5.46047 2.32129 6.31974V15.6547C2.32129 16.5139 3.01784 17.2105 3.87709 17.2105H17.3607C18.22 17.2105 18.9165 16.5139 18.9165 15.6547V8.39416C18.9165 7.53489 18.22 6.83834 17.3607 6.83834Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M17.3607 6.83834H11.6663C11.3277 6.83834 11.003 6.70385 10.7636 6.46444L9.437 5.13782C9.1976 4.89841 8.8729 4.76392 8.53433 4.76392H3.87709C3.01784 4.76392 2.32129 5.46047 2.32129 6.31974V15.6547C2.32129 16.5139 3.01784 17.2105 3.87709 17.2105H17.3607C18.22 17.2105 18.9165 16.5139 18.9165 15.6547V8.39416C18.9165 7.53489 18.22 6.83834 17.3607 6.83834Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  })]
}));

var IconFolderAdd = GenIcon(jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }), jsx("path", {
    d: "M22 11V8.375C22 7.33945 21.1605 6.5 20.125 6.5H13.0392C12.774 6.5 12.5196 6.39464 12.3321 6.20711L10.4 4.275V4.275C10.2239 4.09892 9.98511 4 9.73609 4H9.6H3.875C2.83945 4 2 4.83945 2 5.875V17.125C2 18.1605 2.83945 19 3.875 19H14",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M16 16H22",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M19 19L19 13",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  })]
}));

var IconCamera = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M19.1668 15.8353C19.1668 16.2773 18.9912 16.7012 18.6787 17.0138C18.3661 17.3264 17.9422 17.502 17.5002 17.502H2.50016C2.05814 17.502 1.63421 17.3264 1.32165 17.0138C1.00909 16.7012 0.833496 16.2773 0.833496 15.8353V6.66862C0.833496 6.22659 1.00909 5.80267 1.32165 5.49011C1.63421 5.17755 2.05814 5.00195 2.50016 5.00195H5.8335L7.50016 2.50195H12.5002L14.1668 5.00195H17.5002C17.9422 5.00195 18.3661 5.17755 18.6787 5.49011C18.9912 5.80267 19.1668 6.22659 19.1668 6.66862V15.8353Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M9.99984 14.1686C11.8408 14.1686 13.3332 12.6762 13.3332 10.8353C13.3332 8.99434 11.8408 7.50195 9.99984 7.50195C8.15889 7.50195 6.6665 8.99434 6.6665 10.8353C6.6665 12.6762 8.15889 14.1686 9.99984 14.1686Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconPhotos = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: [jsx("path", {
    d: "M1.25 15.3087L5.46123 10.536L7.98797 12.9223L11.357 8.94507L15.5682 13.7178",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  }), jsx("rect", {
    x: "1.25",
    y: "1.78613",
    width: "14.3182",
    height: "14.3182",
    rx: "1.11364",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M6.72705 5.76343C6.72705 6.59186 6.05548 7.26343 5.22705 7.26343C4.39862 7.26343 3.72705 6.59186 3.72705 5.76343C3.72705 4.935 4.39862 4.26343 5.22705 4.26343C6.05548 4.26343 6.72705 4.935 6.72705 5.76343Z",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("path", {
    d: "M15.568 5.80127H17.6362C18.2512 5.80127 18.7498 6.29986 18.7498 6.91491V18.1725C18.7498 18.7875 18.2512 19.2861 17.6362 19.2861H5.54528C4.93023 19.2861 4.43164 18.7875 4.43164 18.1725V16.1043",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  })]
}));

var IconVideo = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: jsx("path", {
    d: "M14 6.54541L17.3791 4.85585C18.1238 4.48351 19 5.02502 19 5.8576V14.2332C19 15.0658 18.1238 15.6073 17.3791 15.235L14 13.5454M3 16.0459H12C13.1046 16.0459 14 15.1505 14 14.0459V6.0459C14 4.94133 13.1046 4.0459 12 4.0459H3C1.89543 4.0459 1 4.94133 1 6.0459V14.0459C1 15.1505 1.89543 16.0459 3 16.0459Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  })
}));

var IconDrawings = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M6.94461 5.5896V12.6339M13.0557 7.51076V14.555M13.565 17.5435L18.5302 15.4627C18.7223 15.3829 18.8838 15.2596 18.9963 15.1066C19.1089 14.9537 19.1679 14.7774 19.1668 14.5977V3.94167C19.1668 3.77796 19.1168 3.61698 19.0217 3.47401C18.9266 3.33103 18.7894 3.21081 18.6233 3.12476C18.4572 3.0387 18.2676 2.98966 18.0725 2.9823C17.8774 2.97494 17.6833 3.0095 17.5087 3.08269L13.565 4.73404C13.406 4.80102 13.2306 4.83591 13.0527 4.83591C12.8747 4.83591 12.6993 4.80102 12.5403 4.73404L7.45387 2.60283C7.29479 2.53617 7.11939 2.50146 6.94155 2.50146C6.76371 2.50146 6.58831 2.53617 6.42924 2.60283L1.46702 4.68366C1.27593 4.76374 1.11535 4.887 1.0034 5.03954C0.89146 5.19208 0.832612 5.36781 0.833506 5.54691V16.203C0.833556 16.3667 0.883513 16.5277 0.978635 16.6706C1.07376 16.8136 1.21089 16.9338 1.37701 17.0199C1.54313 17.1059 1.73273 17.155 1.92781 17.1623C2.12289 17.1697 2.31698 17.1351 2.49165 17.0619L6.43535 15.4106C6.59431 15.3436 6.76975 15.3087 6.94766 15.3087C7.12558 15.3087 7.30102 15.3436 7.45998 15.4106L12.5465 17.5452C12.7056 17.6118 12.881 17.6464 13.0588 17.6464C13.2366 17.6464 13.412 17.6118 13.5711 17.5452L13.565 17.5435Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconPaperClip = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M18.9758 9.43839L10.9501 17.4644C9.96684 18.4476 8.6333 19 7.24282 19C5.85234 19 4.51881 18.4476 3.53559 17.4644C2.55237 16.4811 2 15.1476 2 13.7571C2 12.3665 2.55237 11.033 3.53559 10.0497L11.5614 2.02375C12.2169 1.36825 13.1059 1 14.0329 1C14.9599 1 15.8489 1.36825 16.5044 2.02375C17.1598 2.67924 17.5281 3.56829 17.5281 4.4953C17.5281 5.42231 17.1598 6.31135 16.5044 6.96685L8.46983 14.9928C8.14209 15.3206 7.69758 15.5047 7.23409 15.5047C6.77059 15.5047 6.32608 15.3206 5.99834 14.9928C5.6706 14.6651 5.48648 14.2206 5.48648 13.7571C5.48648 13.2935 5.6706 12.849 5.99834 12.5213L13.4128 5.11537",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconFileZip = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M4.99984 18.3332H15.8332C16.2934 18.3332 16.6665 17.9601 16.6665 17.4998V7.01168C16.6665 6.79067 16.5787 6.57871 16.4224 6.42243L11.9106 1.91058C11.7543 1.7543 11.5423 1.6665 11.3213 1.6665H10.4165H4.99984C4.5396 1.6665 4.1665 2.0396 4.1665 2.49984V17.4998C4.1665 17.9601 4.5396 18.3332 4.99984 18.3332Z",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("path", {
    d: "M11.6665 1.6665V5.83317C11.6665 6.29341 12.0396 6.6665 12.4998 6.6665H16.6665",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("line", {
    x1: "7.3165",
    y1: "1.6665",
    x2: "7.3165",
    y2: "3.33317",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("line", {
    x1: "7.3165",
    y1: "5",
    x2: "7.3165",
    y2: "6.66667",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("line", {
    x1: "7.3165",
    y1: "8.33325",
    x2: "7.3165",
    y2: "9.99992",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("line", {
    x1: "8.15",
    y1: "3.33325",
    x2: "8.15",
    y2: "4.99992",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("line", {
    x1: "8.15",
    y1: "6.6665",
    x2: "8.15",
    y2: "8.33317",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("line", {
    x1: "8.15",
    y1: "10",
    x2: "8.15",
    y2: "11.6667",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("rect", {
    x: "6.9165",
    y: "11.9998",
    width: "2",
    height: "2.66667",
    stroke: "currentColor",
    strokeWidth: "1.3"
  })]
}));

var IconFileEdit = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M7.32103 17.2944C6.13347 17.2944 4.64675 17.2944 3.74317 17.2944C3.29259 17.2944 2.92822 16.9291 2.92822 16.4785V1.79337C2.92822 1.3428 3.29348 0.977539 3.74406 0.977539H9.04694H9.93276C10.1491 0.977539 10.3566 1.06349 10.5096 1.2165L14.9267 5.63363C15.0797 5.78663 15.1657 5.99373 15.1657 6.2101C15.1657 6.58841 15.1657 7.22564 15.1657 7.81087",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M10.2705 0.977783V5.05699C10.2705 5.50757 10.6358 5.87283 11.0863 5.87283H15.1655",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("path", {
    d: "M10.9297 16.1963L10.459 18.5496L12.8123 18.0789L18.9311 11.9605L17.0484 10.0779L10.9297 16.1963Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("line", {
    y1: "-0.65",
    x2: "2.66245",
    y2: "-0.65",
    transform: "matrix(0.707123 0.70709 -0.707123 0.70709 14.9028 12.5779)",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("path", {
    d: "M5.85693 8.78735H11.714",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M5.85693 11.7158H9.76166",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconImageSquare = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: [jsx("path", {
    d: "M2 17.2824L6.70588 11.9504L9.52941 14.6164L13.2941 10.1731L18 15.505",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  }), jsx("rect", {
    x: "2",
    y: "2.17822",
    width: "16",
    height: "15.9958",
    rx: "1.0666",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M8.12045 6.62033C8.12045 7.54583 7.36999 8.29609 6.44426 8.29609C5.51852 8.29609 4.76807 7.54583 4.76807 6.62033C4.76807 5.69484 5.51852 4.94458 6.44426 4.94458C7.36999 4.94458 8.12045 5.69484 8.12045 6.62033Z",
    stroke: "currentColor",
    strokeWidth: "1.3"
  })]
}));

var IconVideoSquare = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  children: [jsx("path", {
    d: "M17.2 3.15356H2.8C2.35817 3.15356 2 3.51174 2 3.95357V16.9C2 17.3418 2.35817 17.7 2.8 17.7H17.2C17.6418 17.7 18 17.3418 18 16.9V3.95356C18 3.51174 17.6418 3.15356 17.2 3.15356Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M2 7.15356H18",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10"
  }), jsx("path", {
    d: "M3 3.09766L6.75401 7.09766",
    stroke: "currentColor",
    strokeWidth: "1.3397",
    strokeMiterlimit: "10"
  }), jsx("path", {
    d: "M8 3.09766L11.7462 7.09766",
    stroke: "currentColor",
    strokeWidth: "1.3397",
    strokeMiterlimit: "10"
  }), jsx("path", {
    d: "M13 3.09766L16.754 7.09766",
    stroke: "currentColor",
    strokeWidth: "1.3397",
    strokeMiterlimit: "10"
  }), jsx("path", {
    d: "M4.91064 11.1523H15.0897",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M4.91064 14.0691H10.724",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  })]
}));

var IconUser = GenIcon(jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    d: "M1.5 18.4258L1.79952 16.8452C2.15336 15.02 3.16741 13.3704 4.66549 12.183C6.16357 10.9958 8.05104 10.3457 10 10.346C11.9513 10.3464 13.8406 10.9986 15.339 12.189C16.8374 13.3794 17.85 15.0326 18.2005 16.8607L18.5 18.4412M14.6385 5.91298C14.6385 8.3528 12.5618 10.3307 9.99996 10.3307C7.43815 10.3307 5.36139 8.3528 5.36139 5.91298C5.36139 3.47316 7.43815 1.49531 9.99996 1.49531C12.5618 1.49531 14.6385 3.47316 14.6385 5.91298Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconUserGroup = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M0.999023 15.3598C1.0026 13.6489 1.6837 12.0091 2.89324 10.7994C4.10279 9.58958 5.74225 8.90836 7.45281 8.90479C7.85174 8.90478 8.24689 8.94165 8.63368 9.0135",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M11.4882 4.74772C11.4882 2.61022 9.75569 0.877441 7.61859 0.877441C5.48149 0.877441 3.74902 2.61022 3.74902 4.74772C3.74902 6.88521 5.48149 8.61799 7.61859 8.61799C7.91345 8.61799 8.20062 8.58501 8.47659 8.52252",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M6.20312 19.2172C6.20671 17.504 6.88967 15.8622 8.10213 14.652C9.3146 13.4418 10.9575 12.7622 12.6704 12.7622C14.381 12.7658 16.0205 13.447 17.23 14.6568C18.4395 15.8665 19.1206 17.5063 19.1242 19.2172",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M12.603 12.368C14.7401 12.368 16.4725 10.6352 16.4725 8.49772C16.4725 6.36022 14.7401 4.62744 12.603 4.62744C10.4659 4.62744 8.7334 6.36022 8.7334 8.49772C8.7334 10.6352 10.4659 12.368 12.603 12.368Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconUserCheck = GenIcon(jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    d: "M12.4981 16.096C12.2443 15.8422 11.8327 15.8422 11.5789 16.0961C11.325 16.3499 11.3251 16.7615 11.5789 17.0153L12.4981 16.096ZM14.4279 18.9448L13.9683 19.4045C14.0902 19.5264 14.2555 19.5948 14.4279 19.5948C14.6003 19.5948 14.7657 19.5263 14.8875 19.4044L14.4279 18.9448ZM19.6648 14.6261C19.9187 14.3722 19.9186 13.9606 19.6647 13.7068C19.4109 13.453 18.9993 13.4531 18.7455 13.7069L19.6648 14.6261ZM1.01699 18.8801C1.01699 19.2391 1.30801 19.5301 1.66699 19.5301C2.02598 19.5301 2.31699 19.2391 2.31699 18.8801H1.01699ZM14.4992 14.062C14.6959 14.3623 15.0988 14.4462 15.3991 14.2495C15.6994 14.0528 15.7834 13.6499 15.5866 13.3496L14.4992 14.062ZM11.5789 17.0153L13.9683 19.4045L14.8875 18.4852L12.4981 16.096L11.5789 17.0153ZM14.8875 19.4044L19.6648 14.6261L18.7455 13.7069L13.9682 18.4853L14.8875 19.4044ZM12.7597 5.93655C12.7597 7.93584 11.139 9.55659 9.13963 9.55659V10.8566C11.8569 10.8566 14.0597 8.65382 14.0597 5.93655H12.7597ZM9.13963 9.55659C7.14029 9.55659 5.51952 7.93584 5.51952 5.93655H4.21952C4.21952 8.65382 6.42234 10.8566 9.13963 10.8566V9.55659ZM5.51952 5.93655C5.51952 3.93726 7.14029 2.3165 9.13963 2.3165V1.0165C6.42234 1.0165 4.21952 3.21927 4.21952 5.93655H5.51952ZM9.13963 2.3165C11.139 2.3165 12.7597 3.93726 12.7597 5.93655H14.0597C14.0597 3.21927 11.8569 1.0165 9.13963 1.0165V2.3165ZM2.31699 18.8801C2.31699 17.1699 2.76226 15.1863 3.83461 13.6503C4.88616 12.144 6.55927 11.0346 9.13968 11.0346V9.73461C6.11557 9.73461 4.05234 11.0674 2.76867 12.9061C1.50581 14.715 1.01699 16.9792 1.01699 18.8801H2.31699ZM9.13968 11.0346C11.5741 11.0346 13.3555 12.3162 14.4992 14.062L15.5866 13.3496C14.2568 11.3197 12.1027 9.73461 9.13968 9.73461V11.0346Z",
    fill: "currentColor"
  })
}));

var IconUserList = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("path", {
    d: "M1.66699 18.041C1.66699 14.5893 3.54199 9.92048 9.16699 9.92048C10.8937 9.92048 12.3223 10.4773 13.4527 11.3486M13.4527 5.66873C13.4527 7.92293 11.534 9.75029 9.16702 9.75029C6.80009 9.75029 4.88131 7.92293 4.88131 5.66873C4.88131 3.41453 6.80009 1.58714 9.16702 1.58714C11.534 1.58714 13.4527 3.41453 13.4527 5.66873Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M12.5 13.8095H12.7308M18.5 13.8095H14.6538M12.5 16.1419H12.7308M18.5 16.1419H14.6538M12.5 18.4739H12.7308M18.5 18.4739H14.6538",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var IconUserConfig = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("path", {
    d: "M1 18.5409L1.29952 16.9604C1.65336 15.135 2.66741 13.4855 4.16549 12.2982C5.66357 11.1109 7.55104 10.4609 9.5 10.461C10.9066 10.4614 12.281 10.8004 13.5 11.4355M14.1385 6.02809C14.1385 8.4679 12.0618 10.4458 9.49996 10.4458C6.93815 10.4458 4.86139 8.4679 4.86139 6.02809C4.86139 3.58827 6.93815 1.6104 9.49996 1.6104C12.0618 1.6104 14.1385 3.58827 14.1385 6.02809Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M19.1656 16.699C19.1796 16.5923 19.1935 16.4856 19.1935 16.3723C19.1935 16.259 19.1796 16.1523 19.1656 16.0456L19.9205 15.499C19.9904 15.4523 20.0044 15.359 19.9624 15.2856L19.2425 14.1323C19.2005 14.059 19.1027 14.0323 19.0258 14.059L18.1311 14.3923C17.9424 14.259 17.7397 14.1523 17.523 14.0656L17.3832 13.179C17.3832 13.099 17.3063 13.039 17.2154 13.039H15.7825C15.7398 13.0383 15.6982 13.0519 15.6649 13.0774C15.6317 13.103 15.609 13.139 15.6008 13.179L15.461 14.059C15.2443 14.139 15.0416 14.259 14.8529 14.3856L13.9582 14.0523C13.8743 14.019 13.7834 14.0523 13.7415 14.1256L13.0215 15.279C12.9796 15.359 13.0005 15.4456 13.0704 15.499L13.8254 16.0456C13.8114 16.1523 13.8044 16.2656 13.8044 16.3723C13.8044 16.4856 13.8184 16.5923 13.8323 16.699L13.0704 17.2523C13.0005 17.299 12.9866 17.3923 13.0285 17.4656L13.7485 18.619C13.7904 18.6923 13.8883 18.719 13.9651 18.6923L14.8598 18.359C15.0486 18.4923 15.2513 18.599 15.468 18.6856L15.6078 19.5656C15.6147 19.6456 15.6916 19.7056 15.7825 19.7056H17.2224C17.3133 19.7056 17.3902 19.6456 17.3972 19.5656L17.537 18.6856C17.7536 18.6056 17.9563 18.4856 18.1451 18.359L19.0398 18.6923C19.1236 18.7256 19.2145 18.6923 19.2565 18.619L19.9764 17.4656C20.0183 17.3923 20.0044 17.3056 19.9345 17.2523L19.1656 16.699ZM16.4955 17.539C15.8035 17.539 15.2373 17.019 15.2373 16.3723C15.2373 15.7256 15.8035 15.2056 16.4955 15.2056C17.1875 15.2056 17.7536 15.7256 17.7536 16.3723C17.7536 17.019 17.1945 17.539 16.4955 17.539Z",
    fill: "currentColor"
  })]
}));

var IconUserInvite = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M4.43329 10L4.43329 1.66667C4.43329 1.43655 4.61984 1.25 4.84996 1.25H15.15C15.3801 1.25 15.5666 1.43655 15.5666 1.66667V10M7.5 9.16657L7.5881 8.52927C7.69217 7.96557 7.99042 7.45613 8.43103 7.08946C8.87164 6.72279 9.42678 6.52205 10 6.52212C10.5739 6.52226 11.1296 6.72367 11.5703 7.09129C12.011 7.45891 12.3088 7.96945 12.4119 8.53403L12.5 9.16657M4.43333 2.84164L1.25 6.81664V18.75H18.75V6.81664L15.5667 2.84164M1.25 7.65004L10 14.7334L18.75 7.65004M11.5917 4.9249C11.5917 5.80396 10.8791 6.51657 10 6.51657C9.12097 6.51657 8.40835 5.80396 8.40835 4.9249C8.40835 4.04585 9.12097 3.33323 10 3.33323C10.8791 3.33323 11.5917 4.04585 11.5917 4.9249Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconHomeUserAdd = GenIcon(jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: jsx("path", {
    d: "M2.99968 5.83305L2.99968 18.333H9.99969M16.9997 5.83305L16.9997 9.49976M19.1663 7.16634L9.99967 0.833008L0.833008 7.16634M6.99967 12.9998L7.1054 12.235C7.23028 11.5586 7.58818 10.9473 8.11691 10.5072C8.64565 10.0672 9.31181 9.82636 9.99968 9.82644C10.6884 9.8266 11.3552 10.0683 11.884 10.5094C12.4129 10.9506 12.7703 11.5632 12.894 12.2407L12.9997 12.9998M12.9997 15.9998H18.9997M15.9997 12.9998V18.9998M11.9097 7.90978C11.9097 8.96464 11.0546 9.81978 9.9997 9.81978C8.94484 9.81978 8.0897 8.96464 8.0897 7.90978C8.0897 6.85491 8.94484 5.99978 9.9997 5.99978C11.0546 5.99978 11.9097 6.85491 11.9097 7.90978Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
}));

var IconCalendar = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("rect", {
    x: "1.83008",
    y: "2.26611",
    width: "15.8631",
    height: "15.8633",
    rx: "1.16667",
    stroke: "currentColor",
    strokeWidth: "1.3"
  }), jsx("line", {
    x1: "7.01182",
    y1: "0.650244",
    x2: "7.01182",
    y2: "3.8826",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "12.6783",
    y1: "0.650244",
    x2: "12.6783",
    y2: "3.8826",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "1.6665",
    y1: "6.67153",
    x2: "17.5296",
    y2: "6.67153",
    stroke: "currentColor",
    strokeWidth: "1.3"
  })]
}));

var IconCalendarDay = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("rect", {
    x: "3.5",
    y: "3.85693",
    width: "13",
    height: "13",
    rx: "0.928571",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), jsx("line", {
    x1: "7.81387",
    y1: "2.6",
    x2: "7.81387",
    y2: "5.11429",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "12.4574",
    y1: "2.6",
    x2: "12.4574",
    y2: "5.11429",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "4",
    y1: "7.4",
    x2: "17",
    y2: "7.4",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), jsx("path", {
    d: "M6 10.3999H7",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  })]
}));

var IconCalendarWeek = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("rect", {
    x: "3.5",
    y: "3.85693",
    width: "13",
    height: "13",
    rx: "0.928571",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), jsx("line", {
    x1: "7.81387",
    y1: "2.6",
    x2: "7.81387",
    y2: "5.11429",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "12.4574",
    y1: "2.6",
    x2: "12.4574",
    y2: "5.11429",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "4",
    y1: "7.4",
    x2: "17",
    y2: "7.4",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), jsx("path", {
    d: "M6 10.3999L14 10.3999",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  })]
}));

var IconCalendarMonth = GenIcon(jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("rect", {
    x: "3.5",
    y: "3.85693",
    width: "13",
    height: "13",
    rx: "0.928571",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), jsx("line", {
    x1: "7.81387",
    y1: "2.6",
    x2: "7.81387",
    y2: "5.11429",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "12.4574",
    y1: "2.6",
    x2: "12.4574",
    y2: "5.11429",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "4",
    y1: "7.4",
    x2: "17",
    y2: "7.4",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), jsx("path", {
    d: "M6 10.3999L14 10.3999",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M6 13L12 13",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round"
  })]
}));

var IconGPT = GenIcon(jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M9.37305 15.6396C9.6017 16.2553 10.0395 16.7711 10.6099 17.0969C11.1802 17.4226 11.8469 17.5375 12.4934 17.4215C13.1399 17.3055 13.7251 16.9659 14.1467 16.4622C14.5682 15.9585 14.7994 15.3227 14.7997 14.6659V10.5318L9.99948 7.85156",
    stroke: "currentColor",
    strokeWidth: "1.30919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M4.5711 12.145C4.15185 12.6509 3.92378 13.2881 3.92679 13.9451C3.92979 14.6022 4.16367 15.2373 4.58753 15.7393C5.01138 16.2414 5.59824 16.5785 6.24546 16.6916C6.89267 16.8047 7.55906 16.6867 8.12808 16.3582L11.6003 14.3308V8.77344",
    stroke: "currentColor",
    strokeWidth: "1.30919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M5.19963 6.23428C4.08677 6.04546 2.96992 6.55031 2.37228 7.58562C2.00383 8.22392 1.90396 8.98245 2.09465 9.69438C2.28534 10.4063 2.75097 11.0133 3.38914 11.382L6.79971 13.3934L11.6 10.7147",
    stroke: "currentColor",
    strokeWidth: "1.30919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M10.6259 3.82595C10.3972 3.21019 9.95947 2.69437 9.38909 2.36865C8.81871 2.04293 8.15201 1.92803 7.50552 2.04403C6.85902 2.16003 6.27385 2.49955 5.85228 3.00325C5.43071 3.50695 5.19956 4.1428 5.19922 4.79965V8.85366L9.99946 11.6139",
    stroke: "currentColor",
    strokeWidth: "1.30919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M15.4291 7.32283C15.8483 6.81692 16.0764 6.17972 16.0734 5.52266C16.0704 4.8656 15.8365 4.23051 15.4126 3.72846C14.9888 3.2264 14.4019 2.88934 13.7547 2.77621C13.1075 2.66308 12.4411 2.78109 11.8721 3.1096L8.3999 5.13701V10.6944",
    stroke: "currentColor",
    strokeWidth: "1.30919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M14.8002 13.1747C15.9131 13.3636 17.0299 12.8587 17.6276 11.8234C17.996 11.1851 18.0959 10.4266 17.9052 9.71466C17.7145 9.00273 17.2489 8.39569 16.6107 8.02703L13.1641 6.01562L8.3999 8.7519",
    stroke: "currentColor",
    strokeWidth: "1.30919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
}));

var modalBody = 'styles_modalBody__1lz75ahe';
var modalDialog = createRuntimeFn({
  defaultClassName: 'styles_modalDialog__1lz75ah3',
  variantClassNames: {
    centered: {
      true: 'styles_modalDialog_centered_true__1lz75ah4'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var modalDim = 'styles_modalDim__1lz75ah2';
var modalFooter = 'styles_modalFooter__1lz75ahf';
var modalHeader = createRuntimeFn({
  defaultClassName: 'styles_modalHeader__1lz75ah6',
  variantClassNames: {
    color: {
      black: 'styles_modalHeader_color_black__1lz75ah7',
      mint: 'styles_modalHeader_color_mint__1lz75ah8',
      pink: 'styles_modalHeader_color_pink__1lz75ah9',
      grey: 'styles_modalHeader_color_grey__1lz75aha',
      white: 'styles_modalHeader_color_white__1lz75ahb',
      custom: 'styles_modalHeader_color_custom__1lz75ahc'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var modalHeaderCustomColor = 'var(--modalHeaderCustomColor__1lz75ah5)';
var modalIconButton = 'styles_modalIconButton__1lz75ahd';
var modalWrap = createRuntimeFn({
  defaultClassName: 'styles_modalWrap__1lz75ah0',
  variantClassNames: {
    centered: {
      true: 'styles_modalWrap_centered_true__1lz75ah1'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});

var Modal = function (props) {
  var _a;
  var visible = props.visible,
    title = props.title,
    width = props.width,
    children = props.children,
    _b = props.color,
    color = _b === void 0 ? 'white' : _b,
    _c = props.showClose,
    showClose = _c === void 0 ? true : _c,
    icons = props.icons,
    centered = props.centered,
    header = props.header,
    bodyStyle = props.bodyStyle,
    onClose = props.onClose,
    onExited = props.onExited,
    footer = props.footer,
    footerStyle = props.footerStyle;
  var nodeRef = useRef(null);
  var _color = useMemo(function () {
    switch (color) {
      case 'black':
      case 'mint':
      case 'pink':
      case 'grey':
      case 'white':
        return color;
      default:
        return 'custom';
    }
  }, [color]);
  useEffect(function () {
    if (!(document === null || document === void 0 ? void 0 : document.body)) return;
    if (visible) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
    return function () {
      document.body.style.removeProperty('overflow');
    };
  }, [visible]);
  return jsx(CSSTransition, {
    nodeRef: nodeRef,
    in: !!visible,
    timeout: 250,
    unmountOnExit: true,
    onExited: onExited,
    children: jsxs(ModalWrap, {
      ref: nodeRef,
      centered: centered,
      children: [jsx("div", {
        className: modalDim,
        onClick: onClose
      }), jsxs("div", {
        className: modalDialog({
          centered: centered
        }),
        style: {
          maxWidth: width
        },
        children: [header || jsxs("div", {
          className: modalHeader({
            color: _color
          }),
          style: assignInlineVars((_a = {}, _a[modalHeaderCustomColor] = _color === 'custom' ? color : undefined, _a)),
          children: [jsx(Box, {
            flex: "1",
            children: title
          }), !!(icons === null || icons === void 0 ? void 0 : icons.length) && jsx(Box, {
            display: "flex",
            alignItems: "center",
            children: icons.map(function (item, index) {
              return jsx("button", {
                className: modalIconButton,
                onClick: function (e) {
                  item.onClick && item.onClick(e);
                },
                children: item.icon
              }, index);
            })
          }), showClose && !!onClose && jsx("button", {
            type: "button",
            className: modalIconButton,
            onClick: onClose,
            children: jsx(IconX, {})
          })]
        }), jsx("div", {
          className: modalBody,
          style: bodyStyle,
          children: children
        }), footer && jsx("div", {
          className: modalFooter,
          style: footerStyle,
          children: footer
        })]
      })]
    })
  });
};
var ModalWrap = forwardRef(function (props, ref) {
  var children = props.children,
    centered = props.centered;
  var targetElement = document.body;
  return createPortal(jsx("div", {
    ref: ref,
    className: clsx(modalWrap({
      centered: centered
    }), 'ignore-draggable'),
    children: children
  }), targetElement);
});

var container$1 = 'Dialog_container__8yglv91';
var dialog = 'Dialog_dialog__8yglv92';
var dialogBody = 'Dialog_dialogBody__8yglv93';
var dialogContent = 'Dialog_dialogContent__8yglv94';
var dialogFooter = 'Dialog_dialogFooter__8yglv95';
var dialogTitle = 'Dialog_dialogTitle__8yglv96';
var dialogTitleIcon = 'Dialog_dialogTitleIcon__8yglv97';
var mask = 'Dialog_mask__8yglv90';

var Dialog = function (props) {
  var open = props.open,
    icon = props.icon,
    title = props.title,
    footer = props.footer,
    onClose = props.onClose,
    onDestroyed = props.onDestroyed,
    children = props.children,
    style = props.style;
  return jsx(Mask, {
    open: open,
    className: mask,
    onMaskClick: onClose,
    onDestroyed: onDestroyed,
    children: jsx("div", {
      className: container$1,
      children: jsx("div", {
        className: dialog,
        style: style,
        children: jsxs("div", {
          className: dialogBody,
          children: [title && jsxs("div", {
            className: dialogTitle,
            children: [icon && jsx("div", {
              className: dialogTitleIcon,
              children: icon
            }), jsx("div", {
              children: title
            })]
          }), children && jsx("div", {
            className: dialogContent,
            children: children
          }), !!footer && jsx("div", {
            className: dialogFooter,
            children: footer
          })]
        })
      })
    })
  });
};

var DialogContext = createContext({
  stacks: [],
  setStacks: function () {}
});
var DialogProvider = function (props) {
  var children = props.children;
  var _a = useState([]),
    stacks = _a[0],
    setStacks = _a[1];
  /**
   * stack을 제거합니다.
   * @param id
   */
  var destroyStack = function (id) {
    setStacks(function (prev) {
      return prev.filter(function (e) {
        return e.id !== id;
      });
    });
  };
  return jsxs(DialogContext.Provider, {
    value: {
      stacks: stacks,
      setStacks: setStacks
    },
    children: [children, jsx(TransitionGroup, {
      children: stacks.map(function (props) {
        return jsx(Dialog, __assign$1({}, props, {
          onDestroyed: function () {
            return destroyStack(props.id);
          }
        }), props.id);
      })
    })]
  });
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function parse(uuid) {
  if (!validate(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;

    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = parse(namespace);
    }

    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return unsafeStringify(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

v35('v3', 0x30, md5);

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

v35('v5', 0x50, sha1);

var theme = {
  spacing: {
    '2': 'var(--spacing-2)',
    '4': 'var(--spacing-4)',
    '8': 'var(--spacing-8)',
    '10': 'var(--spacing-10)',
    '12': 'var(--spacing-12)',
    '14': 'var(--spacing-14)',
    '16': 'var(--spacing-16)',
    '18': 'var(--spacing-18)',
    '20': 'var(--spacing-20)',
    '24': 'var(--spacing-24)',
    '32': 'var(--spacing-32)',
    '48': 'var(--spacing-48)',
    '64': 'var(--spacing-64)',
    xs: 'var(--spacing-xs)',
    sm: 'var(--spacing-sm)',
    md: 'var(--spacing-md)',
    lg: 'var(--spacing-lg)',
    xl: 'var(--spacing-xl)',
    xxl: 'var(--spacing-xxl)'
  },
  color: {
    primary: {
      '50': 'var(--color-primary-50)',
      '100': 'var(--color-primary-100)',
      '200': 'var(--color-primary-200)',
      '300': 'var(--color-primary-300)',
      '400': 'var(--color-primary-400)',
      '500': 'var(--color-primary-500)',
      '600': 'var(--color-primary-600)',
      '700': 'var(--color-primary-700)',
      '800': 'var(--color-primary-800)',
      '900': 'var(--color-primary-900)',
      '950': 'var(--color-primary-950)'
    },
    zinc: {
      '50': 'var(--color-zinc-50)',
      '100': 'var(--color-zinc-100)',
      '200': 'var(--color-zinc-200)',
      '300': 'var(--color-zinc-300)',
      '400': 'var(--color-zinc-400)',
      '500': 'var(--color-zinc-500)',
      '600': 'var(--color-zinc-600)',
      '700': 'var(--color-zinc-700)',
      '800': 'var(--color-zinc-800)',
      '900': 'var(--color-zinc-900)',
      '950': 'var(--color-zinc-950)'
    },
    gray: {
      '50': 'var(--color-gray-50)',
      '80': 'var(--color-gray-80)',
      '100': 'var(--color-gray-100)',
      '200': 'var(--color-gray-200)',
      '300': 'var(--color-gray-300)',
      '400': 'var(--color-gray-400)',
      '500': 'var(--color-gray-500)',
      '600': 'var(--color-gray-600)',
      '700': 'var(--color-gray-700)',
      '750': 'var(--color-gray-750)',
      '800': 'var(--color-gray-800)',
      '900': 'var(--color-gray-900)'
    },
    red: {
      '50': 'var(--color-red-50)',
      '100': 'var(--color-red-100)',
      '200': 'var(--color-red-200)',
      '300': 'var(--color-red-300)',
      '400': 'var(--color-red-400)',
      '500': 'var(--color-red-500)',
      '600': 'var(--color-red-600)',
      '700': 'var(--color-red-700)',
      '800': 'var(--color-red-800)',
      '900': 'var(--color-red-900)',
      '950': 'var(--color-red-950)'
    },
    yellow: {
      '50': 'var(--color-yellow-50)',
      '100': 'var(--color-yellow-100)',
      '200': 'var(--color-yellow-200)',
      '300': 'var(--color-yellow-300)',
      '400': 'var(--color-yellow-400)',
      '500': 'var(--color-yellow-500)',
      '600': 'var(--color-yellow-600)',
      '700': 'var(--color-yellow-700)',
      '800': 'var(--color-yellow-800)',
      '900': 'var(--color-yellow-900)',
      '950': 'var(--color-yellow-950)'
    },
    green: {
      '50': 'var(--color-green-50)',
      '100': 'var(--color-green-100)',
      '200': 'var(--color-green-200)',
      '300': 'var(--color-green-300)',
      '400': 'var(--color-green-400)',
      '500': 'var(--color-green-500)',
      '600': 'var(--color-green-600)',
      '700': 'var(--color-green-700)',
      '800': 'var(--color-green-800)',
      '900': 'var(--color-green-900)',
      '950': 'var(--color-green-950)'
    },
    blue: {
      '50': 'var(--color-blue-50)',
      '100': 'var(--color-blue-100)',
      '200': 'var(--color-blue-200)',
      '300': 'var(--color-blue-300)',
      '400': 'var(--color-blue-400)',
      '500': 'var(--color-blue-500)',
      '600': 'var(--color-blue-600)',
      '700': 'var(--color-blue-700)',
      '800': 'var(--color-blue-800)',
      '900': 'var(--color-blue-900)',
      '950': 'var(--color-blue-950)'
    },
    purple: {
      '50': 'var(--color-purple-50)',
      '100': 'var(--color-purple-100)',
      '200': 'var(--color-purple-200)',
      '300': 'var(--color-purple-300)',
      '400': 'var(--color-purple-400)',
      '500': 'var(--color-purple-500)',
      '600': 'var(--color-purple-600)',
      '700': 'var(--color-purple-700)',
      '800': 'var(--color-purple-800)',
      '900': 'var(--color-purple-900)',
      '950': 'var(--color-purple-950)'
    },
    text: {
      '300': 'var(--color-text-300)',
      '500': 'var(--color-text-500)',
      '600': 'var(--color-text-600)',
      '700': 'var(--color-text-700)',
      '800': 'var(--color-text-800)',
      primary: 'var(--color-text-primary)',
      secondary: 'var(--color-text-secondary)',
      caption: 'var(--color-text-secondary)',
      description: 'var(--color-text-description)',
      description2: 'var(--color-text-description2)',
      disabled: 'var(--color-text-disabled)',
      translation: 'var(--color-text-translation)',
      info: 'var(--color-text-info)',
      success: 'var(--color-text-success)',
      danger: 'var(--color-text-danger)',
      '01': 'var(--color-text-01)',
      '02': 'var(--color-text-02)',
      '03': 'var(--color-text-03)'
    },
    feedback: {
      danger: 'var(--color-feedback-danger)',
      warning: 'var(--color-feedback-warning)',
      success: 'var(--color-feedback-success)',
      info: 'var(--color-feedback-info)',
      neutral: 'var(--color-feedback-neutral)'
    },
    button: {
      red: 'var(--color-button-red)',
      yellow: 'var(--color-button-yellow)',
      green: 'var(--color-button-green)',
      primary: 'var(--color-button-primary)',
      blue: 'var(--color-button-blue)',
      neutral: 'var(--color-button-neutral)',
      white: 'var(--color-button-white)',
      mint: 'var(--color-button-mint)'
    },
    background: {
      gray: 'var(--color-background-gray)',
      grayBold: 'var(--color-background-gray-bold)',
      disabled: 'var(--color-background-disabled)'
    },
    border: {
      muted: 'var(--color-border-muted)',
      normal: 'var(--color-border-normal)',
      bold: 'var(--color-border-bold)'
    }
  },
  font: {
    body: 'var(--font-body)',
    size: {
      '8': 'var(--font-size-8)',
      '10': 'var(--font-size-10)',
      '12': 'var(--font-size-12)',
      '13': 'var(--font-size-13)',
      '14': 'var(--font-size-14)',
      '15': 'var(--font-size-15)',
      '16': 'var(--font-size-16)',
      '18': 'var(--font-size-18)',
      '20': 'var(--font-size-20)',
      '22': 'var(--font-size-22)',
      '24': 'var(--font-size-24)',
      '32': 'var(--font-size-32)',
      '48': 'var(--font-size-48)',
      xs: 'var(--font-size-xs)',
      sm: 'var(--font-size-sm)',
      md: 'var(--font-size-md)',
      lg: 'var(--font-size-lg)',
      xl: 'var(--font-size-xl)',
      xxl: 'var(--font-size-xxl)'
    }
  },
  borderRadius: {
    sm: 'var(--border-radius-sm)',
    md: 'var(--border-radius-md)',
    lg: 'var(--border-radius-lg)',
    xl: 'var(--border-radius-xl)'
  },
  input: {
    size: {
      sm: 'var(--input-size-sm)',
      md: 'var(--input-size-md)',
      lg: 'var(--input-size-lg)'
    }
  }
};

var DialogConfirmButton = function (props) {
  var children = props.children,
    color = props.color,
    onClick = props.onClick;
  var _a = useState(false),
    isLoading = _a[0],
    setIsLoading = _a[1];
  var handleConfirm = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setIsLoading(true);
            return [4 /*yield*/, onClick()];
          case 1:
            _a.sent();
            setIsLoading(false);
            return [2 /*return*/];
        }
      });
    });
  };

  return jsx(Button, {
    color: color,
    variant: "filled",
    onClick: handleConfirm,
    loading: isLoading,
    children: children
  });
};

var useDialog = function () {
  var setStacks = useContext(DialogContext).setStacks;
  var _a = useState([]),
    myStacksIds = _a[0],
    setMyStacksIds = _a[1];
  /**
   * 언마운트 시 생성한 stack을 모두 제거합니다.
   */
  useEffect(function () {
    return function () {
      setStacks(function (prev) {
        return prev.filter(function (stack) {
          return !myStacksIds.includes(stack.id);
        });
      });
    };
  }, []);
  /**
   * stack을 추가합니다.
   * @param stack
   */
  var addStack = function (stack) {
    var newStack = __assign$1(__assign$1({
      open: true
    }, stack), {
      onClose: function () {
        var _a;
        (_a = stack.onClose) === null || _a === void 0 ? void 0 : _a.call(stack);
        closeDialog(stack.id);
      }
    });
    setStacks(function (prev) {
      return __spreadArray(__spreadArray([], prev, true), [newStack], false);
    });
    setMyStacksIds(function (prev) {
      return __spreadArray(__spreadArray([], prev, true), [stack.id], false);
    });
  };
  /**
   * dialog를 닫습니다.
   * @param id
   */
  var closeDialog = function (id) {
    setStacks(function (prev) {
      return prev.map(function (stack) {
        if (stack.id !== id) return stack;
        return __assign$1(__assign$1({}, stack), {
          open: false
        });
      });
    });
  };
  var show = function (config) {
    var id = v4();
    addStack(__assign$1({
      id: id
    }, config));
  };
  var alert = function (props) {
    var _a = props.icon,
      icon = _a === void 0 ? jsx(IconInfoCircle, {
        color: theme.color.primary[500]
      }) : _a,
      title = props.title,
      message = props.message,
      _b = props.okText,
      okText = _b === void 0 ? '확인' : _b,
      onOk = props.onOk;
    var id = v4();
    var handleCancel = function () {
      closeDialog(id);
    };
    var handleOk = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, onOk === null || onOk === void 0 ? void 0 : onOk()];
            case 1:
              _a.sent();
              closeDialog(id);
              return [2 /*return*/];
          }
        });
      });
    };

    return addStack({
      id: id,
      icon: icon,
      title: title,
      children: message,
      onClose: handleCancel,
      footer: jsx(Fragment, {
        children: jsx(DialogConfirmButton, {
          color: "primary",
          onClick: handleOk,
          children: okText
        })
      })
    });
  };
  var confirm = function (props) {
    var _a = props.icon,
      icon = _a === void 0 ? jsx(IconInfoCircle, {
        color: theme.color.primary[500]
      }) : _a,
      title = props.title,
      message = props.message,
      _b = props.okText,
      okText = _b === void 0 ? '확인' : _b,
      onOk = props.onOk,
      _c = props.cancelText,
      cancelText = _c === void 0 ? '취소' : _c,
      onCancel = props.onCancel,
      _d = props.closeOnMask,
      closeOnMask = _d === void 0 ? true : _d,
      onMaskClick = props.onMaskClick;
    var id = v4();
    var handleCancel = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, onCancel === null || onCancel === void 0 ? void 0 : onCancel()];
            case 1:
              _a.sent();
              closeDialog(id);
              return [2 /*return*/];
          }
        });
      });
    };

    var handleClickMask = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, onMaskClick === null || onMaskClick === void 0 ? void 0 : onMaskClick()];
            case 1:
              _a.sent();
              if (closeOnMask) {
                closeDialog(id);
              }
              return [2 /*return*/];
          }
        });
      });
    };

    var handleConfirm = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, onOk()];
            case 1:
              _a.sent();
              closeDialog(id);
              return [2 /*return*/];
          }
        });
      });
    };

    return addStack({
      id: id,
      icon: icon,
      title: title,
      children: message,
      onClose: handleClickMask,
      footer: jsxs(Fragment, {
        children: [jsx(Button, {
          onClick: handleCancel,
          children: cancelText
        }), jsx(DialogConfirmButton, {
          color: "primary",
          onClick: handleConfirm,
          children: okText
        })]
      })
    });
  };
  var danger = function (props) {
    var _a = props.icon,
      icon = _a === void 0 ? jsx(IconInfoCircle, {
        color: theme.color.red[500]
      }) : _a,
      title = props.title,
      message = props.message,
      _b = props.okText,
      okText = _b === void 0 ? '확인' : _b,
      onOk = props.onOk,
      _c = props.cancelText,
      cancelText = _c === void 0 ? '취소' : _c,
      onCancel = props.onCancel;
    var id = v4();
    var handleCancel = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, onCancel === null || onCancel === void 0 ? void 0 : onCancel()];
            case 1:
              _a.sent();
              closeDialog(id);
              return [2 /*return*/];
          }
        });
      });
    };

    var handleConfirm = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, onOk()];
            case 1:
              _a.sent();
              closeDialog(id);
              return [2 /*return*/];
          }
        });
      });
    };

    return addStack({
      id: id,
      icon: icon,
      title: title,
      children: message,
      onClose: handleCancel,
      footer: jsxs(Fragment, {
        children: [jsx(Button, {
          onClick: handleCancel,
          children: cancelText
        }), jsx(DialogConfirmButton, {
          color: "danger",
          onClick: handleConfirm,
          children: okText
        })]
      })
    });
  };
  var dialog = {
    show: show,
    alert: alert,
    confirm: confirm,
    danger: danger
  };
  return dialog;
};

var popoverAnimated = 'styles_popoverAnimated__5mquza1';
var popoverContent = 'styles_popoverContent__5mquza4';
var popoverFloating = 'styles_popoverFloating__5mquza0';
var popoverInner = 'styles_popoverInner__5mquza2';
var popoverTitle = 'styles_popoverTitle__5mquza3';

var ARROW_WIDTH$2 = 10;
var ARROW_HEIGHT$2 = 6;
var Popover = function (props) {
  var _a = props.trigger,
    trigger = _a === void 0 ? 'hover' : _a,
    title = props.title,
    content = props.content,
    children = props.children,
    _b = props.placement,
    placement = _b === void 0 ? 'top' : _b,
    open = props.open,
    onOpenChange = props.onOpenChange,
    delay = props.delay,
    _c = props.arrow,
    arrow$1 = _c === void 0 ? true : _c,
    style = props.style;
  var _d = useState(false),
    _open = _d[0],
    setOpen = _d[1];
  var arrowRef = useRef(null);
  var floatingOpen = useMemo(function () {
    if (typeof open !== 'undefined') return open;
    return _open;
  }, [open, _open]);
  function handleFloatingOpenChange(value) {
    if (onOpenChange && typeof open !== 'undefined') {
      onOpenChange(value);
    } else {
      setOpen(value);
    }
  }
  var _e = useFloating({
      open: floatingOpen,
      onOpenChange: handleFloatingOpenChange,
      placement: placement,
      middleware: [flip({
        padding: 12
      }), shift({
        padding: 12
      }), offset(12), arrow({
        element: arrowRef.current,
        padding: 20
      })],
      whileElementsMounted: autoUpdate
    }),
    refs = _e.refs,
    floatingStyles = _e.floatingStyles,
    context = _e.context;
  /**
   * 📖 전환 애니메이션 처리
   */
  var _f = useTransitionStatus(context, {
      duration: 150
    }),
    isMounted = _f.isMounted,
    status = _f.status;
  var focus = useFocus(context, {
    enabled: trigger === 'focus'
  });
  var hover = useHover(context, {
    enabled: trigger === 'hover',
    delay: __assign$1({
      open: 0,
      close: 100
    }, delay),
    handleClose: safePolygon({
      blockPointerEvents: true
    })
  });
  var click = useClick(context, {
    enabled: trigger === 'click',
    keyboardHandlers: false
  });
  var dismiss = useDismiss(context);
  var _g = useInteractions([click, hover, focus, dismiss]),
    getReferenceProps = _g.getReferenceProps,
    getFloatingProps = _g.getFloatingProps;
  var triggerElement = cloneElement(children, __assign$1({
    ref: refs.setReference
  }, getReferenceProps({
    onClick: function (e) {
      var _a, _b;
      (_b = (_a = children.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
      handleFloatingOpenChange(!floatingOpen);
    }
  })));
  return jsxs(Fragment, {
    children: [triggerElement, jsx(FloatingPortal, {
      children: isMounted && jsx(FloatingFocusManager, {
        context: context,
        modal: false,
        initialFocus: -1,
        children: jsx("div", __assign$1({
          className: popoverFloating,
          ref: refs.setFloating,
          style: __assign$1(__assign$1({}, floatingStyles), {
            zIndex: 4000
          })
        }, getFloatingProps(), {
          children: jsxs("div", {
            className: popoverAnimated,
            "data-placement": placement,
            "data-status": status,
            children: [arrow$1 && jsx(FloatingArrow, {
              ref: arrowRef,
              context: context,
              width: ARROW_WIDTH$2,
              height: ARROW_HEIGHT$2,
              fill: "white",
              tipRadius: 2,
              stroke: theme.color.zinc[200],
              strokeWidth: 1
            }), jsxs("div", {
              className: popoverInner,
              style: style,
              children: [title && jsx("div", {
                className: popoverTitle,
                children: title
              }), content && jsx("div", {
                className: popoverContent,
                children: content
              })]
            })]
          })
        }))
      })
    })]
  });
};

var popconfirmAnimated = 'Popconfirm_popconfirmAnimated__79eure1';
var popconfirmFloating = 'Popconfirm_popconfirmFloating__79eure0';
var popconfirmInner = 'Popconfirm_popconfirmInner__79eure2';
var popconfirmTitle = 'Popconfirm_popconfirmTitle__79eure3';

var ARROW_WIDTH$1 = 14;
var ARROW_HEIGHT$1 = 8;
var Popconfirm = function (props) {
  var _a, _b, _c, _d;
  var title = props.title,
    children = props.children,
    _e = props.placement,
    placement = _e === void 0 ? 'top' : _e,
    open = props.open,
    onOpenChange = props.onOpenChange,
    onOk = props.onOk,
    onCancel = props.onCancel,
    _f = props.okText,
    okText = _f === void 0 ? '네' : _f,
    _g = props.cancelText,
    cancelText = _g === void 0 ? '아니오' : _g,
    okButtonProps = props.okButtonProps,
    cancelButtonProps = props.cancelButtonProps,
    style = props.style;
  var _h = useState(false),
    _open = _h[0],
    setOpen = _h[1];
  var _j = useState(false),
    isLoading = _j[0],
    setIsLoading = _j[1];
  var arrowRef = useRef(null);
  var floatingOpen = useMemo(function () {
    if (typeof open !== 'undefined') return open;
    return _open;
  }, [open, _open]);
  function handleFloatingOpenChange(value) {
    if (!value) {
      setIsLoading(false);
    }
    if (onOpenChange && typeof open !== 'undefined') {
      onOpenChange(value);
    } else {
      setOpen(value);
    }
  }
  var _k = useFloating({
      open: floatingOpen,
      onOpenChange: handleFloatingOpenChange,
      placement: placement,
      middleware: [flip(), shift(), offset(12), arrow({
        element: arrowRef.current,
        padding: 20
      })],
      whileElementsMounted: autoUpdate
    }),
    refs = _k.refs,
    floatingStyles = _k.floatingStyles,
    context = _k.context,
    middlewareData = _k.middlewareData;
  var arrowX = (_b = (_a = middlewareData.arrow) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 0;
  var arrowY = (_d = (_c = middlewareData.arrow) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : 0;
  var transformX = arrowX + ARROW_WIDTH$1 / 2;
  var transformY = arrowY + ARROW_HEIGHT$1;
  var _l = useTransitionStyles(context, {
      duration: 200,
      initial: {
        opacity: 0,
        transform: 'scale(0.9)'
      },
      common: function (_a) {
        var side = _a.side;
        return {
          transformOrigin: {
            top: "".concat(transformX, "px calc(100% + ").concat(ARROW_HEIGHT$1, "px)"),
            bottom: "".concat(transformX, "px ").concat(-ARROW_HEIGHT$1, "px"),
            left: "calc(100% + ".concat(ARROW_HEIGHT$1, "px) ").concat(transformY, "px"),
            right: "".concat(-ARROW_HEIGHT$1, "px ").concat(transformY, "px")
          }[side]
        };
      },
      open: {
        opacity: 1,
        transform: 'scale(1)'
      }
    }),
    isMounted = _l.isMounted,
    styles = _l.styles;
  var click = useClick(context, {
    keyboardHandlers: false
  });
  var dismiss = useDismiss(context);
  var _m = useInteractions([click, dismiss]),
    getReferenceProps = _m.getReferenceProps,
    getFloatingProps = _m.getFloatingProps;
  var trigger = cloneElement(children, __assign$1({
    ref: refs.setReference
  }, getReferenceProps({
    onClick: children.props.onClick ? children.props.onClick : function () {
      return handleFloatingOpenChange(!floatingOpen);
    }
  })));
  var handleOk = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setIsLoading(true);
            return [4 /*yield*/, onOk()];
          case 1:
            _a.sent();
            handleFloatingOpenChange(false);
            return [2 /*return*/];
        }
      });
    });
  };

  var handleCancel = function () {
    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    handleFloatingOpenChange(false);
  };
  return jsxs(Fragment, {
    children: [trigger, jsx(FloatingPortal, {
      children: isMounted && jsx(FloatingFocusManager, {
        context: context,
        modal: false,
        initialFocus: -1,
        children: jsx("div", __assign$1({
          className: popconfirmFloating,
          ref: refs.setFloating,
          style: __assign$1(__assign$1({}, floatingStyles), {
            zIndex: 4000
          })
        }, getFloatingProps(), {
          children: jsxs("div", {
            className: popconfirmAnimated,
            style: styles,
            children: [jsx(FloatingArrow, {
              ref: arrowRef,
              context: context,
              width: 14,
              height: 8,
              fill: "white",
              tipRadius: 3
            }), jsxs("div", {
              className: popconfirmInner,
              style: style,
              children: [title && jsx("div", {
                className: popconfirmTitle,
                children: title
              }), jsxs(Box, {
                display: "flex",
                justifyContent: "flex-end",
                gap: "8",
                children: [jsx(Button, __assign$1({
                  style: {
                    minWidth: 90
                  },
                  onClick: handleCancel
                }, cancelButtonProps, {
                  children: cancelText
                })), jsx(Button, __assign$1({
                  color: "primary",
                  variant: "filled",
                  style: {
                    minWidth: 90
                  },
                  loading: isLoading,
                  onClick: handleOk
                }, okButtonProps, {
                  children: okText
                }))]
              })]
            })]
          })
        }))
      })
    })]
  });
};

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */

var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);
  function PolishedError(code) {
    var _this;
    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }
    return _assertThisInitialized(_this);
  }
  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV

  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}
function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;
  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }
  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }
  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}
function convertToHex(red, green, blue) {
  return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }
  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }
  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare

function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */
function hslToColorString(color) {
  if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
    if (color.alpha && typeof color.alpha === 'number') {
      return hsla({
        hue: color.hue,
        saturation: color.saturation,
        lightness: color.lightness,
        alpha: color.alpha
      });
    }
    return hsl({
      hue: color.hue,
      saturation: color.saturation,
      lightness: color.lightness
    });
  }
  throw new PolishedError(45);
}

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */

function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = parseToRgb(color);
  var color1 = _extends$1({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });
  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends$1({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  }); // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method

  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
  };
  return rgba(mixedColor);
} // prettier-ignore

var curriedMix = /*#__PURE__*/curry
/* ::<number | string, string, string, string> */(mix);
var mix$1 = curriedMix;

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends$1({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });
  return rgba(colorWithAlpha);
} // prettier-ignore

var curriedTransparentize = /*#__PURE__*/curry
/* ::<number | string, string, string> */(transparentize);
var curriedTransparentize$1 = curriedTransparentize;

var avatar = 'Avatar_avatar__1gozkcd2';
var avatarColor = 'var(--avatarColor__1gozkcd1)';
var avatarImg = 'Avatar_avatarImg__1gozkcd3';
var avatarSize = 'var(--avatarSize__1gozkcd0)';

var Avatar = forwardRef(function (props, ref) {
  var _a;
  var _b;
  var name = props.name,
    src = props.src,
    _c = props.size,
    size = _c === void 0 ? 40 : _c,
    _d = props.gap,
    gap = _d === void 0 ? 4 : _d,
    style = props.style,
    onClick = props.onClick;
  var nameRef = useRef(null);
  var _e = useState(size),
    avatarChildWidth = _e[0],
    setAvatarChildWidth = _e[1];
  var computedColor = useMemo(function () {
    if (!name) return '';
    if (src) return '';
    var hslColor = parseToHsl(textToColor(name));
    return hslToColorString(__assign$1(__assign$1({}, hslColor), {
      saturation: 0.6,
      lightness: 0.4
    }));
  }, [name]);
  useEffect(function () {
    var _a, _b;
    if (!((_a = nameRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth)) return;
    setAvatarChildWidth((_b = nameRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth);
  }, [(_b = nameRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth]);
  var calcScale = useMemo(function () {
    var avatarMinimumBoundary = size - gap * 2;
    if (avatarChildWidth > avatarMinimumBoundary) {
      return avatarMinimumBoundary / avatarChildWidth;
    }
    return 1;
  }, [name, size, gap, avatarChildWidth]);
  var renderChild = function () {
    if (src) return jsx("img", {
      className: avatarImg,
      src: src,
      alt: name
    });
    if (name) {
      return jsx("span", {
        ref: nameRef,
        style: {
          transform: "scale(".concat(calcScale, ")"),
          whiteSpace: 'nowrap'
        },
        children: name.slice(0, 10)
      });
    }
    return jsxs("svg", {
      width: "38",
      height: "38",
      viewBox: "0 0 38 38",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        d: "M29.0463 32C28.9686 32 28.8918 31.9847 28.8201 31.955C28.7484 31.9253 28.6832 31.8817 28.6284 31.8269C28.5735 31.772 28.5299 31.7068 28.5002 31.6351C28.4705 31.5634 28.4553 31.4866 28.4553 31.409C28.3915 28.9214 27.3749 26.5534 25.6153 24.7939C23.8558 23.0344 21.4878 22.0177 19.0003 21.9539C16.514 22.0216 14.1482 23.0394 12.3895 24.7982C10.6308 26.5569 9.61289 28.9227 9.54526 31.409C9.54526 31.4866 9.52997 31.5634 9.50027 31.6351C9.47057 31.7068 9.42704 31.772 9.37216 31.8269C9.31728 31.8817 9.25213 31.9253 9.18042 31.955C9.10872 31.9847 9.03187 32 8.95426 32C8.79769 31.9997 8.64762 31.9373 8.537 31.8265C8.42639 31.7157 8.36426 31.5655 8.36426 31.409C8.43903 28.6117 9.5836 25.9496 11.5623 23.971C13.5409 21.9923 16.203 20.8477 19.0003 20.7729C24.7003 20.7729 29.3173 25.5 29.6363 31.409C29.6363 31.5655 29.5741 31.7157 29.4635 31.8265C29.3529 31.9373 29.2028 31.9997 29.0463 32Z",
        fill: "#C4C4C4"
      }), jsx("path", {
        d: "M19.0002 6C17.5977 6 16.2267 6.41588 15.0606 7.19505C13.8945 7.97422 12.9857 9.08168 12.449 10.3774C11.9123 11.6731 11.7718 13.0989 12.0454 14.4744C12.319 15.8499 12.9944 17.1134 13.9861 18.1051C14.9778 19.0968 16.2413 19.7721 17.6168 20.0457C18.9923 20.3194 20.4181 20.1789 21.7138 19.6422C23.0095 19.1055 24.117 18.1967 24.8961 17.0305C25.6753 15.8644 26.0912 14.4935 26.0912 13.091C26.0912 11.2104 25.3441 9.40673 24.0143 8.07691C22.6845 6.74709 20.8808 6 19.0002 6ZM19.0002 19C17.8315 19 16.689 18.6534 15.7173 18.0042C14.7456 17.3549 13.9882 16.432 13.541 15.3523C13.0937 14.2725 12.9767 13.0844 13.2047 11.9382C13.4327 10.792 13.9955 9.73909 14.8219 8.91271C15.6483 8.08632 16.7012 7.52354 17.8474 7.29554C18.9936 7.06754 20.1817 7.18456 21.2615 7.6318C22.3412 8.07903 23.264 8.83641 23.9133 9.80814C24.5626 10.7799 24.9092 11.9223 24.9092 13.091C24.9092 14.6582 24.2866 16.1611 23.1785 17.2693C22.0703 18.3774 20.5673 19 19.0002 19Z",
        fill: "#C4C4C4"
      })]
    });
  };
  return jsx("div", {
    ref: ref,
    className: avatar,
    style: __assign$1(__assign$1(__assign$1({}, assignInlineVars((_a = {}, _a[avatarColor] = computedColor, _a[avatarSize] = "".concat(size, "px"), _a))), style), {
      cursor: !onClick ? undefined : 'pointer'
    }),
    onClick: function (e) {
      if (!onClick) return;
      e.stopPropagation();
      onClick();
    },
    children: renderChild()
  });
});
var textToColor = function (text) {
  var hash = 0;
  for (var i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  var colour = '#';
  for (var i = 0; i < 3; i++) {
    var value = hash >> i * 8 & 0xff;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
};

var getResultIcon = function (status) {
  switch (status) {
    case 'success':
      return jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 80 80",
        fill: "none",
        children: [jsx("path", {
          d: "M74 39.9999C74 58.7776 58.7777 73.9999 40 73.9999C21.2223 73.9999 6 58.7776 6 39.9999C6 21.2223 21.2223 5.99994 40 5.99994C58.7777 5.99994 74 21.2223 74 39.9999Z",
          stroke: "#50C329",
          strokeWidth: "4"
        }), jsx("path", {
          d: "M28 39.1111L36.0672 48L52 32",
          stroke: "#50C329",
          strokeWidth: "4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case 'warning':
      return jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 80 80",
        fill: "none",
        children: [jsx("path", {
          d: "M74 39.9999C74 58.7776 58.7777 73.9999 40 73.9999C21.2223 73.9999 6 58.7776 6 39.9999C6 21.2223 21.2223 5.99994 40 5.99994C58.7777 5.99994 74 21.2223 74 39.9999Z",
          stroke: "#FCBA16",
          strokeWidth: "4"
        }), jsx("path", {
          d: "M40 27V44",
          stroke: "#FCBA16",
          strokeWidth: "4",
          strokeLinecap: "round"
        }), jsx("rect", {
          x: "38",
          y: "49",
          width: "4",
          height: "5",
          rx: "2",
          fill: "#FCBA16"
        })]
      });
    case 'wait':
      return jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 80 80",
        fill: "none",
        children: [jsx("path", {
          d: "M74 40C74 58.7776 58.7777 73.9999 40 73.9999C21.2223 73.9999 6 58.7776 6 40C6 21.2223 21.2223 6 40 6C58.7777 6 74 21.2223 74 40Z",
          stroke: "#FCBA16",
          strokeWidth: "4"
        }), jsx("path", {
          d: "M40 24V42L52 50",
          stroke: "#FCBA16",
          strokeWidth: "4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case 'loading':
      return jsx(Spinner, {
        color: "primary.500"
      });
    case 'error':
      return jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 80 80",
        fill: "none",
        children: [jsx("path", {
          d: "M74 39.9999C74 58.7776 58.7777 73.9999 40 73.9999C21.2223 73.9999 6 58.7776 6 39.9999C6 21.2223 21.2223 5.99994 40 5.99994C58.7777 5.99994 74 21.2223 74 39.9999Z",
          stroke: "#FF6661",
          strokeWidth: "4"
        }), jsx("path", {
          d: "M30 50.0008L50 29.9999M50 50.0008L30 29.9999",
          stroke: "#FF6661",
          strokeWidth: "4",
          strokeLinecap: "round"
        })]
      });
    case 'empty':
      return jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 80 80",
        fill: "none",
        children: [jsx("path", {
          d: "M55.2367 26.9754C55.4264 27.1632 55.5332 27.4191 55.5332 27.6861V72.9464C55.5332 73.4987 55.0855 73.9464 54.5332 73.9464H12.5332C11.9809 73.9464 11.5332 73.4987 11.5332 72.9464V18.9464C11.5332 18.3941 11.9809 17.9464 12.5332 17.9464H45.7028C45.9663 17.9464 46.2191 18.0504 46.4063 18.2357L55.2367 26.9754Z",
          stroke: "#BFBFBF",
          strokeWidth: "4",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), jsx("path", {
          d: "M24.5 58.0007L42.5 40M42.5 58.0007L24.5 40",
          stroke: "#BFBFBF",
          strokeWidth: "4",
          strokeLinecap: "round"
        }), jsx("path", {
          d: "M55.6858 61.2131H67.2666C67.8189 61.2131 68.2666 60.7654 68.2666 60.2131V14.9528C68.2666 14.6858 68.1598 14.4299 67.97 14.2421L59.1397 5.50239C58.9525 5.31708 58.6997 5.21313 58.4362 5.21313H25.2666C24.7143 5.21313 24.2666 5.66085 24.2666 6.21313V17.6648",
          stroke: "#BFBFBF",
          strokeWidth: "4",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), jsx("path", {
          d: "M44 19V30H56",
          stroke: "#BFBFBF",
          strokeWidth: "4",
          strokeLinejoin: "round"
        })]
      });
    case 'info':
    default:
      return jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 80 80",
        fill: "none",
        children: [jsx("path", {
          d: "M74 39.9999C74 58.7776 58.7777 73.9999 40 73.9999C21.2223 73.9999 6 58.7776 6 39.9999C6 21.2223 21.2223 5.99994 40 5.99994C58.7777 5.99994 74 21.2223 74 39.9999Z",
          stroke: theme.color.primary[500],
          strokeWidth: "4"
        }), jsx("path", {
          d: "M40 27V44",
          stroke: theme.color.primary[500],
          strokeWidth: "4",
          strokeLinecap: "round"
        }), jsx("rect", {
          x: "38",
          y: "49",
          width: "4",
          height: "5",
          rx: "2",
          fill: theme.color.primary[500]
        })]
      });
  }
};

var container = 'Result_container__9d8ovk0';
var resultExtra = createRuntimeFn({
  defaultClassName: 'Result_resultExtra__9d8ovkc',
  variantClassNames: {
    size: {
      large: 'Result_resultExtra_size_large__9d8ovkd',
      medium: 'Result_resultExtra_size_medium__9d8ovke'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var resultIcon = createRuntimeFn({
  defaultClassName: 'Result_resultIcon__9d8ovk1',
  variantClassNames: {
    size: {
      large: 'Result_resultIcon_size_large__9d8ovk2',
      medium: 'Result_resultIcon_size_medium__9d8ovk3'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var resultSubTitle = createRuntimeFn({
  defaultClassName: 'Result_resultSubTitle__9d8ovk9',
  variantClassNames: {
    size: {
      large: 'Result_resultSubTitle_size_large__9d8ovka',
      medium: 'Result_resultSubTitle_size_medium__9d8ovkb'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var resultTitle = createRuntimeFn({
  defaultClassName: 'Result_resultTitle__9d8ovk4',
  variantClassNames: {
    size: {
      large: 'Result_resultTitle_size_large__9d8ovk5',
      medium: 'Result_resultTitle_size_medium__9d8ovk6'
    },
    empty: {
      true: 'Result_resultTitle_empty_true__9d8ovk7',
      false: 'Result_resultTitle_empty_false__9d8ovk8'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});

var Result = function (props) {
  var _a = props.status,
    status = _a === void 0 ? 'info' : _a,
    _b = props.size,
    size = _b === void 0 ? 'large' : _b,
    icon = props.icon,
    title = props.title,
    subTitle = props.subTitle,
    children = props.children,
    style = props.style;
  var displayIcon = useMemo(function () {
    if (icon) return icon;
    return getResultIcon(status);
  }, [status, icon]);
  return jsxs("div", {
    className: container,
    style: style,
    children: [jsx("div", {
      className: resultIcon({
        size: size
      }),
      children: displayIcon
    }), jsx("div", {
      className: resultTitle({
        size: size,
        empty: status === 'empty'
      }),
      children: title
    }), jsx("div", {
      className: resultSubTitle({
        size: size
      }),
      children: subTitle
    }), jsx("div", {
      className: resultExtra({
        size: size
      }),
      children: children
    })]
  });
};

var tooltipAnimated = 'Tooltip_tooltipAnimated__1pch7my1';
var tooltipBox = 'Tooltip_tooltipBox__1pch7my2';
var tooltipFloating = 'Tooltip_tooltipFloating__1pch7my0';

var ARROW_WIDTH = 12;
var ARROW_HEIGHT = 6;
var Tooltip = function (props) {
  var _a, _b, _c, _d;
  var _e = props.trigger,
    trigger = _e === void 0 ? 'hover' : _e,
    title = props.title,
    children = props.children,
    _f = props.placement,
    placement = _f === void 0 ? 'top' : _f,
    open = props.open,
    onOpenChange = props.onOpenChange,
    _g = props.arrow,
    arrow$1 = _g === void 0 ? true : _g,
    _h = props.offset,
    offset$1 = _h === void 0 ? 4 : _h,
    className = props.className,
    style = props.style;
  var _j = useState(false),
    _open = _j[0],
    setOpen = _j[1];
  var arrowRef = useRef(null);
  var floatingOpen = useMemo(function () {
    if (typeof open !== 'undefined') return open;
    return _open;
  }, [open, _open]);
  function handleFloatingOpenChange(value) {
    if (onOpenChange && typeof open !== 'undefined') {
      onOpenChange(value);
    } else {
      setOpen(value);
    }
  }
  var _k = useFloating({
      open: floatingOpen,
      onOpenChange: handleFloatingOpenChange,
      placement: placement,
      middleware: [flip(), shift(), offset(arrow$1 ? 12 : offset$1), arrow({
        element: arrowRef.current,
        padding: 20
      })],
      whileElementsMounted: autoUpdate
    }),
    refs = _k.refs,
    floatingStyles = _k.floatingStyles,
    context = _k.context,
    middlewareData = _k.middlewareData;
  var arrowX = (_b = (_a = middlewareData.arrow) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 0;
  var arrowY = (_d = (_c = middlewareData.arrow) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : 0;
  var transformX = arrowX + ARROW_WIDTH / 2;
  var transformY = arrowY + ARROW_HEIGHT;
  var _l = useTransitionStyles(context, {
      duration: 200,
      initial: {
        opacity: 0,
        transform: 'scale(0.98)'
      },
      common: function (_a) {
        var side = _a.side;
        return {
          transformOrigin: {
            top: "".concat(transformX, "px calc(100% + ").concat(ARROW_HEIGHT, "px)"),
            bottom: "".concat(transformX, "px ").concat(-ARROW_HEIGHT, "px"),
            left: "calc(100% + ".concat(ARROW_HEIGHT, "px) ").concat(transformY, "px"),
            right: "".concat(-ARROW_HEIGHT, "px ").concat(transformY, "px")
          }[side]
        };
      },
      open: {
        opacity: 1,
        transform: 'scale(1)'
      }
    }),
    isMounted = _l.isMounted,
    styles = _l.styles;
  var focus = useFocus(context, {
    enabled: trigger === 'focus'
  });
  var hover = useHover(context, {
    enabled: trigger === 'hover',
    handleClose: title ? safePolygon({
      blockPointerEvents: true
    }) : undefined
  });
  var click = useClick(context, {
    enabled: trigger === 'click',
    keyboardHandlers: false
  });
  var dismiss = useDismiss(context);
  var _m = useInteractions([click, hover, focus, dismiss]),
    getReferenceProps = _m.getReferenceProps,
    getFloatingProps = _m.getFloatingProps;
  var triggerElement = cloneElement(children, __assign$1({
    ref: refs.setReference
  }, getReferenceProps({
    onClick: function (e) {
      var _a, _b;
      (_b = (_a = children.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
      handleFloatingOpenChange(!floatingOpen);
    }
  })));
  return jsxs(Fragment, {
    children: [triggerElement, jsx(FloatingPortal, {
      children: isMounted && title && jsx(FloatingFocusManager, {
        context: context,
        modal: false,
        initialFocus: -1,
        children: jsx("div", __assign$1({
          className: tooltipFloating,
          ref: refs.setFloating,
          style: __assign$1(__assign$1({}, floatingStyles), {
            zIndex: 4000
          })
        }, getFloatingProps(), {
          children: jsxs("div", {
            className: tooltipAnimated,
            style: styles,
            children: [arrow$1 && jsx(FloatingArrow, {
              ref: arrowRef,
              context: context,
              width: ARROW_WIDTH,
              height: ARROW_HEIGHT,
              fill: theme.color.zinc[700],
              tipRadius: 2
            }), jsx("div", {
              className: clsx(tooltipBox, className),
              style: style,
              children: title
            })]
          })
        }))
      })
    })]
  });
};

var paginationButton = createRuntimeFn({
  defaultClassName: 'Pagination_paginationButton__3kwgq31',
  variantClassNames: {
    active: {
      true: 'Pagination_paginationButton_active_true__3kwgq32'
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var paginationContainer = 'Pagination_paginationContainer__3kwgq30';
var paginationEllipsis = 'Pagination_paginationEllipsis__3kwgq34';

var Pagination = function (props) {
  var _a = props.offset,
    offset = _a === void 0 ? 0 : _a,
    _b = props.limit,
    limit = _b === void 0 ? 10 : _b,
    _c = props.total,
    total = _c === void 0 ? 0 : _c,
    onPageChange = props.onPageChange,
    _d = props.maxPageLength,
    maxPageLength = _d === void 0 ? 5 : _d;
  var _total = total || 0;
  var _limit = limit || 10;
  var _offset = offset || 0;
  var totalPages = Math.ceil(_total / _limit);
  var page = Math.floor(_offset / _limit) + 1;
  var handlePageChange = function (newPage) {
    if (newPage !== page && newPage >= 1 && newPage <= totalPages) {
      onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange((newPage - 1) * _limit);
    }
  };
  var getPageNumbers = function () {
    var pageNumbers = [];
    var startPage, endPage;
    if (totalPages <= maxPageLength) {
      startPage = 1;
      endPage = totalPages;
    } else {
      var pagesToShowOnLeft = Math.floor((maxPageLength - 1) / 2);
      var pagesToShowOnRight = maxPageLength - 1 - pagesToShowOnLeft;
      if (page <= pagesToShowOnLeft + 1) {
        startPage = 1;
      } else if (page + pagesToShowOnRight >= totalPages) {
        startPage = totalPages - maxPageLength + 1;
      } else {
        startPage = page - pagesToShowOnLeft;
      }
      endPage = startPage + maxPageLength - 1;
    }
    for (var i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };
  var renderPageNumbers = function () {
    var pages = getPageNumbers();
    var lastPageFromCurrent = totalPages - page;
    var pageButtons = pages.map(function (pageNumber) {
      return jsx("button", {
        className: paginationButton({
          active: pageNumber === page
        }),
        onClick: function () {
          return handlePageChange(pageNumber);
        },
        children: pageNumber
      }, pageNumber);
    });
    var showEndEllipsis = totalPages > maxPageLength && lastPageFromCurrent > 2;
    return jsxs(Fragment, {
      children: [page > 3 && totalPages > maxPageLength && jsxs(Fragment, {
        children: [jsx("button", {
          type: "button",
          className: paginationButton(),
          onClick: function () {
            return handlePageChange(1);
          },
          children: "1"
        }), jsx(PaginationEllipsis, {
          onClick: function () {
            return handlePageChange(Math.max(page - 5, 1));
          },
          disabled: page === 1
        })]
      }), pageButtons, showEndEllipsis && jsxs(Fragment, {
        children: [jsx(PaginationEllipsis, {
          onClick: function () {
            return handlePageChange(Math.min(page + 5, totalPages));
          },
          disabled: page === totalPages
        }), jsx("button", {
          type: "button",
          className: paginationButton(),
          onClick: function () {
            return handlePageChange(totalPages);
          },
          children: totalPages
        })]
      })]
    });
  };
  return jsxs("div", {
    className: paginationContainer,
    children: [jsx("button", {
      type: "button",
      className: paginationButton(),
      onClick: function () {
        return handlePageChange(page - 1);
      },
      disabled: page === 1,
      children: jsx(IconChevronLeft, {})
    }), renderPageNumbers(), jsx("button", {
      type: "button",
      className: paginationButton(),
      onClick: function () {
        return handlePageChange(page + 1);
      },
      disabled: page === totalPages,
      children: jsx(IconChevronRight, {})
    })]
  });
};
var PaginationEllipsis = function (props) {
  return jsx("div", __assign$1({
    className: paginationEllipsis
  }, props, {
    children: jsxs("svg", {
      width: "18",
      height: "4",
      viewBox: "0 0 18 4",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("circle", {
        cx: "2",
        cy: "2",
        r: "2",
        fill: "#D9D9D9"
      }), jsx("circle", {
        cx: "9",
        cy: "2",
        r: "2",
        fill: "#D9D9D9"
      }), jsx("circle", {
        cx: "16",
        cy: "2",
        r: "2",
        fill: "#D9D9D9"
      })]
    })
  }));
};

var toastAnimationWrap = 'Toast_toastAnimationWrap__16hstrxa';
var toastContainer = 'Toast_toastContainer__16hstrx0';
var toastDialog = createRuntimeFn({
  defaultClassName: 'Toast_toastDialog__16hstrx2',
  variantClassNames: {
    type: {
      neutral: 'Toast_toastDialog_type_neutral__16hstrx3',
      info: 'Toast_toastDialog_type_info__16hstrx4',
      success: 'Toast_toastDialog_type_success__16hstrx5',
      error: 'Toast_toastDialog_type_error__16hstrx6',
      warning: 'Toast_toastDialog_type_warning__16hstrx7',
      normal: 'Toast_toastDialog_type_normal__16hstrx8'
    }
  },
  defaultVariants: {
    type: 'neutral'
  },
  compoundVariants: []
});
var toastIcon = 'Toast_toastIcon__16hstrx9';
var toastList = 'Toast_toastList__16hstrx1';

var Toast = function (props) {
  var message = props.message,
    type = props.type,
    _a = props.duration,
    duration = _a === void 0 ? 1500 : _a,
    onDestory = props.onDestory,
    icon = props.icon;
  useEffect(function () {
    setTimeout(function () {
      onDestory();
    }, duration);
  }, [duration]);
  var _icon = useMemo(function () {
    if (icon) return icon;
    switch (type) {
      case 'error':
      case 'warning':
      case 'normal':
        return jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          children: [jsx("path", {
            d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
            stroke: "white",
            strokeWidth: "1.5"
          }), jsx("path", {
            d: "M10.8996 13.2027H9.09961V14.9498H10.8996V13.2027Z",
            fill: "white"
          }), jsx("path", {
            d: "M10.8996 5.0498H9.09961V11.7471H10.8996V5.0498Z",
            fill: "white"
          })]
        });
      default:
        return jsx("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: jsx("path", {
            d: "M3 9L7.70588 14L17 5",
            stroke: "currentColor",
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })
        });
    }
  }, [type, icon]);
  return jsx("div", {
    className: toastAnimationWrap,
    children: jsxs("div", {
      className: toastDialog({
        type: type
      }),
      children: [jsx("div", {
        className: toastIcon,
        children: _icon
      }), jsx("span", {
        children: message
      })]
    })
  });
};

var ToastContext = createContext({
  stacks: [],
  addStack: function () {}
});
var ToastProvider = function (props) {
  var children = props.children;
  var _a = useState([]),
    stacks = _a[0],
    setStacks = _a[1];
  var handleDestoryStack = function (id) {
    setStacks(function (prev) {
      return prev.filter(function (item) {
        return item.id !== id;
      });
    });
  };
  var addStack = function (data) {
    setStacks(function (prev) {
      return __spreadArray([data], prev, true);
    });
  };
  return jsxs(ToastContext.Provider, {
    value: {
      stacks: stacks,
      addStack: addStack
    },
    children: [children, createPortal(jsx("div", {
      className: toastContainer,
      children: jsx(TransitionGroup, {
        className: toastList,
        children: stacks.map(function (item) {
          return jsx(CSSTransition, {
            timeout: 250,
            classNames: "toast",
            children: jsx(Toast, __assign$1({}, item, {
              onDestory: function () {
                handleDestoryStack(item.id);
              }
            }))
          }, item.id);
        })
      })
    }), document.body)]
  });
};

var useToast = function () {
  var addStack = useContext(ToastContext).addStack;
  var createHandler = function (type) {
    var handler = function (message, option) {
      addStack({
        id: v4(),
        type: type,
        message: message,
        duration: option === null || option === void 0 ? void 0 : option.duration,
        visible: true,
        icon: option === null || option === void 0 ? void 0 : option.icon
      });
    };
    return handler;
  };
  var success = createHandler('success');
  var info = createHandler('info');
  var warning = createHandler('warning');
  var error = createHandler('error');
  var neutral = createHandler('neutral');
  var normal = createHandler('normal');
  return {
    success: success,
    info: info,
    warning: warning,
    error: error,
    neutral: neutral,
    normal: normal
  };
};

/**
 * 주입된 메인 컬러를 분석하여 10단계의 명도를 가진 팔레트를 생성합니다.
 * @param {string} mainColor
 * @returns {ColorPalette}
 */
function generatePalette(mainColor) {
  var mainHsl = parseToHsl(mainColor);
  var darkWeight = {
    50: 0,
    100: 0,
    200: 0,
    300: 0,
    400: 0,
    500: 0,
    600: 0.1333,
    700: 0.3451,
    800: 0.5098,
    900: 0.6275,
    950: 0.7
  };
  // Transparency values for steps below 400
  var transparencyLevels = {
    50: 0.95,
    100: 0.8,
    200: 0.5,
    300: 0.3,
    400: 0.1
  };
  return Object.entries(darkWeight).reduce(function (palette, _a) {
    var key = _a[0],
      weight = _a[1];
    // Apply transparency for steps below 500
    var alpha = parseInt(key) < 500 ? transparencyLevels[parseInt(key)] : 1;
    if (alpha === 1) {
      palette[key] = mix$1(weight, 'black', hsl(mainHsl));
    } else {
      palette[key] = curriedTransparentize$1(alpha, hsl(mainHsl));
    }
    return palette;
  }, {});
}

export { Avatar, Box, Button, Checkbox, CheckboxGroup, Dialog, DialogConfirmButton, DialogContext, DialogProvider, Flex, IconArrowDown, IconArrowUp, IconBasket, IconBell, IconBoardCheck, IconBoardDolar, IconBox, IconBulb, IconCalendar, IconCalendarDay, IconCalendarMonth, IconCalendarWeek, IconCamera, IconChat, IconCheck, IconChevronDown, IconChevronLeft, IconChevronRight, IconChevronUp, IconClockCircle, IconClose, IconCloseCircle, IconCompany, IconCompanyConfig, IconCooperation, IconDashboard, IconDelete, IconDocumentCheck, IconDownload, IconDrawings, IconEdit, IconEquipment, IconExclamationCircle, IconExit, IconEye, IconEyeInvisible, IconFileEdit, IconFileZip, IconFiles, IconFolder, IconFolderAdd, IconFullscreen, IconFullscreenExit, IconGPT, IconGallery, IconGlobe, IconHardHat, IconHistory, IconHome, IconHomeUserAdd, IconImageSquare, IconInfoCircle, IconList, IconLiveChat, IconMap, IconMaterial, IconMenu, IconMinus, IconMoney, IconMore, IconMove, IconNoticeBoard, IconPaperClip, IconPhotos, IconPlus, IconPoint, IconProjectList, IconRandom, IconReceipt, IconReport, IconRotate, IconSearch, IconSend, IconSettings, IconShare, IconStopCircle, IconSwap, IconTarget, IconUpload, IconUser, IconUserCheck, IconUserConfig, IconUserGroup, IconUserInvite, IconUserList, IconVideo, IconVideoSquare, IconWeather, IconX, Input, Mask, Modal, Pagination, Popconfirm, Popover, Radio, Result, Select, Spinner, Switch, Tag, ToastContext, ToastProvider, Tooltip, border, borderRadius, contract, flex, generatePalette, space, sprinkles, text, textEllipsis, useDialog, useToast };
//# sourceMappingURL=index.js.map
